import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
  ChangeDetectorRef,
  HostListener
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { ConfirmDialog } from './confirmdialog';
import * as moment from 'moment';
import { CountrycheckComponent } from './countrycheck/countrycheck.component';
import { SatellogicWarningComponent } from './satellogic-warning/satellogic-warning.component';
// import { WarningPopup } from './warning-popup/warning-popup';
// import { SensorpreviewComponent } from './sensorpreview/sensorpreview.component';
import { CAPELLA_MODES, CONFIG_VALUES, formatCurrency, OPERATORS, polarization, RF_RADIUS, SENSOR_BAND_DATA, BUFFER_AMT, VALUE_ADDED_DATA_PRODUCTS, feedsConfig } from 'src/app/services/constants';
import { PopupService } from 'src/app/services/popup.service';
import { ReactionToiWarningService } from 'src/app/services/reaction-toi-warning.service';
import { ComponentType } from '@angular/cdk/portal';
import { OperatorPopupComponent } from './operator-popup/operator-popup.component';
import { VoyageCreditPurchaseComponent } from './voyage-credit-purchase/voyage-credit-purchase.component';
import { VesselFinderCreditPurchaseComponent } from './vesselfinder-credit-purchase/vesselfinder-credit-purchase.component';
import { VoyageCreditInfoComponent } from 'src/app/components/shared/voyage-credit-info/voyage-credit-info.component';
import { VesselFinderCreditInfoComponent } from 'src/app/components/shared/vesselfinder-credit-info/vesselfinder-credit-info.component';
import { DataService } from 'src/app/services/data.service';
import { UtilsService } from 'src/app/services/utils.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import * as Cesium from 'cesium';
import { MatSelect } from '@angular/material/select';
import { RequiredPopupComponent } from './required-popup/required-popup.component';
import { MatTabGroup } from '@angular/material/tabs';
import { SessionTrackerService } from 'src/app/services/session-tracker.service';
import { PosthogService } from 'src/app/services/posthog.service';
var geoParse = require('wellknown');
import { firstValueFrom, Subscription } from 'rxjs';
import { PreviewGeojsonLeafletMapComponent } from './preview-geojson-leaflet-map/preview-geojson-leaflet-map';
import { PreviewGeojsonComponent } from './previewgeojson/previewgeojson.component';
import { AdvanceSettingsComponent, AgreeComponent, ConfirmPopupComponent, PreviescreenComponent, SensorpreviewComponent, WarningPopup,  applySatelliteVuResolutionConstraints, applyUmbraModeConstraints, findMatchingUmbraScanMode, getSatelliteVuBandsTooltip, getUmbraScenePrice, isUmbraScanMode, validateSelectedUmbraScanLength } from '../shared';
import { WarningPopupComponent } from '../collections/warning-popup/warning-popup.component';
import { generateIceyeSubdailyRecurrence } from 'src/app/shared/utils/iceye-subdaily-recurrence.util';
import {
  cancellationPolicySentence,
  formatCancellationPolicyEntries,
  ModeSelectionContext,
  OperatorStrategyFactory,
} from 'src/app/services/operators';
import { buildRecurringWeekDates } from 'src/app/shared/utils/recurring-week-dates.util';
interface WaterCheckResponse {
  water: boolean;
  latitude: string;
  longitude: string;
}

interface WeatherCostResponse {
  weather_ex_cost?: number;
  weather_ex_point?: number;
  [key: string]: any;
}

@Component({
  selector: 'app-taskcost',
  templateUrl: './taskcost.component.html',
  styleUrls: ['./taskcost.component.scss'],
})
export class TaskcostComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('mySelects') mySelects: MatSelect;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  @Output() resetTasking = new EventEmitter<any>();
   @Output() clearSensorCost = new EventEmitter<any>();
  @Input() target: any;
  sensors: any;
  SensorsTypes: any;
  totalAmount: number;
  currency: any;
  currencySign: any;
  currentUser: any;
  subscription: any;
  SENSORS: any[];
  AVAILABLESENSORS: any = [];
  FILTEREDSENSORS: any[];
  selectedSensorTypes: string;
  allComplete: boolean;
  dataSource: any;
  isAISSensor: boolean = false;
  displayedColumns: string[] = [
    'operator',
    'band',
    'preview',
    'sattarcking',
    'mode',
    'resolution',
    'swath',
    'area_calculated',
    'cloudcovers',
    'ONA',
    'unitcost',
    'holdback',
    'advance',
    'cost',
    'opportunity',
    'footprint',
    'clientInfo',
    'eula',
  ];
  selectedSensors: any[] = [];
  selctedCollectMode: any = [];
  selectedLatency: any = [];
  selectedCost: any[] = [];
  selectedHoldBack: any = [];
  selectedONA: any = [];
  selectedMode: any = [];
  tooltip: any[];
  totalAOI: any;
  taskparams: any;
  isAllSensors = false;
  isNightSensor = false;
  isDailySubdaily = false;
  isOpportunitySensors:boolean = false;
  isObfuscatedSensors:boolean = false;
  isAllSensorTypesChecked: boolean = false;
  isBulkSensorTypesLoading: boolean = false;
  latency = new FormControl();
  cloudcover = new FormControl();
  collectmode = new FormControl();
  errorMsg: any;
  valid = false;
  agreeTnC = true;
  enable: boolean = false;
  modeName: string;
  cloudFactor = 1;
  ONAFactor = 1;
  holdBack = 1;
  userDetails: any;
  tooltipValue: any;
  readonly geosatTaskingWindowCostTooltip = 'The cost shown for each tier is an add-on cost to the tasking cost calculated using the unit cost applied to the selected area';
  resolutionTooltip: boolean = false;
  expectedAge: any;
  tooltipDisabled: boolean = true;
  detailsText: any = '';
  private sensorSortBaseline: any[] = [];
  satCapeEnable: boolean;
  capellaEnable: boolean;
  capellaRecurrent: boolean;
  @Output() childEvent = new EventEmitter();
  @Output() childDataEvent = new EventEmitter();
  @Output() resetData = new EventEmitter();
  @Output() resetRFData = new EventEmitter();
  @Output() resetSpireData = new EventEmitter();

  selectedItems: any[] = [];
  selectedLatencyKey: any = [];
  demoView: boolean = false;
  OPERATOR: any;
  showColumn: boolean = true;
  selectedSensorList: any[] = [];
  nameONA: string = 'ONA/Look/Grazing Angle';
  spot: boolean = false;
  strip: boolean = false;
  noOfMonths: any = 1;
  feasible: boolean = false;
  collectionTime: boolean = false;
  collectionStart: any;
  collectionEnd: any;
  uniqueNamesData: any = [];
  selectedObservationSensorTypes: string[] = [];
  observationSensorTypeOption: any = [];
  previousSensorType: any = [];
  tnqSensorDisabled: boolean = true;
  tipAndQSelectedRows: [] = [];
  tipAndQSelected: boolean = false;
  getSensorObj: any = [];
  isTipAndCueRule: boolean;
  isTipAndCue: boolean = false;
  captureMode: string;
  darkTheme: boolean = false;
  tooltipImagePath: string;
  isDailySubdailySensorTooltip: string;
  qualitySticker: string;
  orbitImage: string;
  maskImage: string;
  cpcAndAllocated: boolean = false;
  advanceSettingsImage: string;
  operatorsEula: any;
  taskPoint: number = 0;
  multiPointsCoveredArea: number = 0;
  showLooks: boolean = false;
  showSwath: boolean = false;
  totalTaskNumber = 0;
  dem_calculation = true;
  superResolutions: any = [];
  enable_sr_calculation = true;
  selectedItemsByGroup: { [key: string]: any[] } = {};
  actionProviders = ['DEM', 'DSM', 'DTM'];
  lband: boolean = false;
  lbandOnly: boolean = false;
  singleCircle: any;
  initialSelection: any[] = [];
  rfSignals: boolean = false;
  isDurationChanging: boolean = false;
  columnResolution: string = 'Resolution';
  tripleHeader:boolean = false;
  aisOnly: boolean = true;
  resolutionColumnTooltip: string = 'Image pixel resolution';
  enable_indices_calculation = false;
  @ViewChild('vadpselect') vadpSelect!: MatSelect;
  polarization: any;
  onaTooltip: string;
  private originalClose: (() => void) | null = null; // Correctly typed function
  noOfWeeks: number = 1;
  bandInfoTooltip: any;
  selectedOperator: any;
  selectedSARBandType: any;
  selectedInSARBandType: any;
  taskTierPref: string = 'high';
  cueingSensors: any;
  tippingSensors: any;
  taskingSensors: any;
  cueingSensorTypes: string[] = [];
  tippingSensorTypes: string[] = [];
  selectedTabIndex: number = 0;
  tipAndCueSensorTypesLoading: boolean = false;
  selectedTippingSensors: any[] = [];
  selectedCueingSensors: any[] = [];
  spotMode: string = "SPOT";
  stripMode: string = "STRIP";
  isArea:boolean = false;
  tooltipminLength: string = '';
  no_of_insarScenes:number = 0;
  totalSceneCount:number = 0;
  aoiOnly: string = "AOI";
  poiOnly: string = "POI";
  aoiAndPoi: string = "POI & AOI";
  taskContext: any;
  defaultUmbraPol = 'VV';
  defaultCapellaPol = 'HH';
  uslPopup: boolean = false;
  feedInfoTooltip:any
  marginValueExist: boolean = false;
  tipAndCue = 'Tip-and-Cue';
  cueingVal = 'Cueing';
  isCueing:boolean = false;
  cueingArea:any = '';
  derivedMinArea: any = 0;
  derivedAreaCalc: any ;
  vesselLocation = 'Vessel location';
  rfLocation = 'RF location';
  stripHundred = 'stripmap_100';
  noOfusers :any []= [];
  isUslBroValidated : boolean = false;
  broUnitCost : any = [];

  @ViewChild('reactionToiWrapper') private reactionToiWrapper?: ElementRef<HTMLElement>;
  @ViewChild('reactionToiBanner') private reactionToiBanner?: ElementRef<HTMLElement>;

  private reactionToiBannerMarginLeft = 0;
  private reactionToiBannerMarginRight = 0;

  private afterAllDialogsClosedSub?: Subscription;

  // Inline warning banner (replaces popup spam for Reaction Time > TOI)
  reactionToiWarning: {
    visible: boolean;
    message: string;
    pinned: boolean;
    pinnedTop: number;
    pinnedLeft: number;
    pinnedWidth: number;
    placeholderHeight: number;
  } = {
    visible: false,
    message: '',
    pinned: false,
    pinnedTop: 0,
    pinnedLeft: 0,
    pinnedWidth: 0,
    placeholderHeight: 0,
  };
  /** Original look angle of custom ONA options, captured before the first Advanced Settings save. */
  private customOnaOriginals = new WeakMap<any, { key: any; minONA: any; maxONA: any }>();
  constructor(
    private elementRef: ElementRef,
    private authService: AuthService,
    private userService: UserService,
    private apiService: ApiService,
    private dialog: MatDialog,
    private popupService: PopupService,
    private reactionToiWarningService: ReactionToiWarningService,
    private localStorageService: DataService,
    private utilsService: UtilsService,
    private cdRef: ChangeDetectorRef,
    private sessionTracker: SessionTrackerService,
    private posthogService: PosthogService,
    private operatorStrategyFactory: OperatorStrategyFactory
  ) {
    this.OPERATOR = OPERATORS;
    this.polarization = polarization;
    this.authService.user.subscribe((user) => (this.currentUser = user));
    if (this.currentUser?.id) {
      this.userDetails = this.currentUser;
      this.cpcAndAllocated =
        this.userDetails?.cpc && this.userDetails?.allocated;
    }
    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme
        ? '../../../assets/images/union-dark.svg'
        : '../../../assets/images/union.svg';
      this.isDailySubdailySensorTooltip = this.darkTheme
        ? '../../../assets/images/eye_tracking_dark.png'
        : '../../../assets/images/eye_tracking.png';
      this.orbitImage = this.darkTheme
        ? '../../../assets/images/orbit-dark.png'
        : '../../../assets/images/orbit.png';
      this.maskImage = this.darkTheme
        ? '../../../assets/images/mask-dark.png'
        : '../../../assets/images/mask.png';
      this.advanceSettingsImage = this.darkTheme
        ? '../../../assets/images/advance-dark.png'
        : '../../../assets/images/advance.png';
        this.qualitySticker = this.darkTheme ? '../../../assets/images/qualitySticker.svg' : '../../../assets/images/qualitySticker.svg';
    });
  }

  ngOnDestroy(): void {
    this.afterAllDialogsClosedSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.errorMsg = undefined;
    this.currency = environment.payCurrency;
    this.currencySign = environment.payCurrencySign;
    this.totalAmount = 0;
    this.demoView = environment.demoView === 'true';
    // Safety net: some selection flows open async dialogs and then programmatically
    // uncheck sensors on close. Refresh the Reaction-vs-TOI banner after any dialog closes.
    this.afterAllDialogsClosedSub = this.dialog.afterAllClosed.subscribe(() => {
      setTimeout(() => this.warnReactionTimeVsToiForSelectedSensors());
    });
    }

  dismissReactionToiWarning(): void {
    this.reactionToiWarning.visible = false;
    this.resetReactionToiPinning();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.updateReactionToiPinnedState();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateReactionToiPinnedState(true);
  }

  private resetReactionToiPinning(): void {
    this.reactionToiWarning.pinned = false;
    this.reactionToiWarning.placeholderHeight = 0;
    this.reactionToiWarning.pinnedTop = 0;
    this.reactionToiWarning.pinnedLeft = 0;
    this.reactionToiWarning.pinnedWidth = 0;
    this.reactionToiBannerMarginLeft = 0;
    this.reactionToiBannerMarginRight = 0;
  }

  private getFixedHeaderHeight(): number {
    const headerEl =
      (document.querySelector('.main-content header') as HTMLElement | null) ??
      (document.querySelector('header') as HTMLElement | null);
    return headerEl?.offsetHeight ?? 0;
  }

  private getPaddingTopPx(el: HTMLElement): number {
    const paddingTop = window.getComputedStyle(el).paddingTop;
    const parsed = parseFloat(paddingTop);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private updateReactionToiPinnedState(forceRecalcDimensions: boolean = false): void {
    if (!this.reactionToiWarning.visible) {
      return;
    }

    const wrapperEl = this.reactionToiWrapper?.nativeElement;
    const bannerEl = this.reactionToiBanner?.nativeElement;
    if (!wrapperEl || !bannerEl) {
      return;
    }

    const fixedHeaderHeight = this.getFixedHeaderHeight();
    const wrapperPaddingTop = this.getPaddingTopPx(wrapperEl);

    const wrapperRect = wrapperEl.getBoundingClientRect();
    const shouldPin = wrapperRect.top <= fixedHeaderHeight;
    const wasPinned = this.reactionToiWarning.pinned;

    if (!shouldPin) {
      if (wasPinned) {
        this.resetReactionToiPinning();
        this.cdRef.detectChanges();
      }
      return;
    }

    if (!wasPinned) {
      const bannerStyle = window.getComputedStyle(bannerEl);
      this.reactionToiBannerMarginLeft = parseFloat(bannerStyle.marginLeft) || 0;
      this.reactionToiBannerMarginRight = parseFloat(bannerStyle.marginRight) || 0;
    }

    if (!wasPinned || forceRecalcDimensions) {
      const marginLeft = this.reactionToiBannerMarginLeft;
      const marginRight = this.reactionToiBannerMarginRight;

      const bannerHeight = bannerEl.getBoundingClientRect().height;
      this.reactionToiWarning.placeholderHeight = bannerHeight + wrapperPaddingTop;
      this.reactionToiWarning.pinnedTop = fixedHeaderHeight + wrapperPaddingTop;
      this.reactionToiWarning.pinnedLeft = wrapperRect.left + marginLeft;
      this.reactionToiWarning.pinnedWidth = Math.max(
        0,
        wrapperRect.width - marginLeft - marginRight
      );
    }

    if (!wasPinned) {
      this.reactionToiWarning.pinned = true;
      this.cdRef.detectChanges();
    } else if (forceRecalcDimensions) {
      this.cdRef.detectChanges();
    }
  }

  private updateReactionToiWarningBanner(changedRow?: any, changedLatency?: any): void {
    const rawToiLeadHours = this.reactionToiWarningService.getRelevantToiLeadHours(this.target);
    if (rawToiLeadHours == null) {
      this.reactionToiWarning.visible = false;
      this.resetReactionToiPinning();
      return;
    }

    // If the TOI starts today (or already started), treat lead time as 0 hours.
    // This avoids accidentally suppressing the warning due to time-zone / midnight defaults.
    const toiLeadHours = Math.max(0, rawToiLeadHours);
    const message = this.reactionToiWarningService.getInlineWarningMessage();

    const rowsToCheck: any[] = [];
    if (changedRow && this.isRowSelectedForReactionToiWarning(changedRow) && changedLatency) {
      rowsToCheck.push({ row: changedRow, latency: changedLatency });
    }
    for (const row of this.AVAILABLESENSORS || []) {
      if (!this.isRowSelectedForReactionToiWarning(row) || !row?.selectedLatencyKey) continue;
      if (changedRow && row === changedRow) continue;
      rowsToCheck.push({ row, latency: row.selectedLatencyKey });
    }

    this.reactionToiWarning.message = message;

    let shouldShow = false;
    for (const item of rowsToCheck) {
      if (
        this.reactionToiWarningService.exceedsToi({
          row: item.row,
          selectedLatency: item.latency,
          targetOpenWindow: this.target?.openWindow,
          toiLeadHours,
        })
      ) {
        shouldShow = true;
        break;
      }
    }

    this.reactionToiWarning.visible = shouldShow;
    this.cdRef.detectChanges();

    if (!shouldShow) {
      this.resetReactionToiPinning();
      return;
    }

    // After the banner renders, compute pinning geometry for window scroll.
    setTimeout(() => this.updateReactionToiPinnedState(true));
  }

  chkTaskInput(newtask: any) {
    let project: any = newtask.project || undefined;
    let taskname: any = newtask.taskname || undefined;
    let geoJson: any = JSON.stringify(newtask.geoJSON) || undefined;
    const err: any = [];
    if (!project) err.push('Project Name');
    if (!taskname) err.push('Task Name');
    if (!geoJson) err.push('Target POI/AOI');
    if (project && taskname && geoJson.includes('P')) {
      this.valid = true;
    } else {
      this.valid = false;
    }
    this.errorMsg = 'Please check Tasking Details for valid ' + err.join(', ');
  }

  async initializeData(sort : boolean = false) {
    this.satCapeEnable = false;
    this.capellaEnable = false;
  

    if (
      this.target.selectedOption === 1 &&
      this.target?.repeatOption > 3 &&
      this.target?.repeatOption < 7 &&
      this.target?.subDailyCount > 1
    ) {
      this.satCapeEnable = true;
    } else if (
      this.target.selectedOption === 1 &&
      this.target?.repeatOption === 7
    ) {
      this.capellaEnable = true;
    }

    let i = 0,
      areacalc = 0,
      minArea = 0;
    this.tooltip = [];
    const targetArea = this.target.area;
    let selectedTaskingPrice: any, selectedHistoricalPrice: any;
    if(!this.FILTEREDSENSORS.length && (this.isAllSensors || this.isNightSensor ||this.isDailySubdaily || this.isOpportunitySensors || this.isObfuscatedSensors)){
      this.AVAILABLESENSORS = [];
    }
    this.FILTEREDSENSORS.forEach(async (sensor: any, i) => {
      const target = this.target.area === 0 || this.target.area === null ? 'POI' : 'AOI';

        
      this.sortLatencyByTierPref(sensor);
      if (sensor?.key === OPERATORS.SATELLOGIC && sensor.latency.some(item => item.key === "standard")) {
        let priceArray = sensor?.pricing;

        if (priceArray) {
          // Filter out "rush" from latency array if target is "AOI"
          if (target === "AOI") {
            sensor.latency = sensor.latency.filter(item => (item.key !== "rush" && item.key !== "emergency"));
          }
        }
      }
      this.selectedLatency[i] = sensor?.latency[0]?.name;
      this.selectedLatencyKey[i] = sensor?.latency[0];
      
      if (sensor.name) {
        if (targetArea === 0 || (sensor?.key === OPERATORS.SATELLOGIC && sensor?.collection_mode?.length === 1)) {
          if (targetArea < sensor.minareaspot)
            this.totalAOI = sensor.minareaspot;
          minArea = sensor.minareaspot;
        } else {
          if (targetArea < sensor.minareastrip)
            this.totalAOI = sensor.minareastrip;
          minArea = sensor.minareastrip;
        }

        if (sensor.areacalc) {
          areacalc = sensor.areacalc;
        } else {
          areacalc = 0;
        }
        const cloudC: any = [];
        for (var key in sensor.cloudcover) {
          cloudC.push({ key, value: sensor.cloudcover[key] });
        }

        let cloudcovers: any,
          selectedModes: any = [],
          modeSelected: any = [];
        let SZA: any,
          AC: any,
          selectedHoldBackOption: any,
          selectedCC: any,
          cloudcover: any;
        let defaultAzimuthAngleMax: any,
          defaultAzimuthAngleMin: any,
          defaultGrazingAngleMax: any,
          defaultGrazingAngleMin: any,
          defaultPolarization: any;

        if (sensor?.cloudcover) {
          cloudcovers = cloudC;
          cloudcover = cloudC[0].key;
          selectedCC = cloudC[0].key;
        }

        let cloudcovernew: any, defaultMinTooltip: any, defaultMinArea: any;
        if (sensor?.cloudcover) cloudcovernew = sensor.cloudcover;
        let collectmodes: any;
        if (sensor.collectmodes) collectmodes = sensor.collectmodes;
        if (sensor?.resolution || sensor.rf_services) {      
          if(sensor?.key === OPERATORS.USL && sensor?.name === "BRO"){
             var selectedResolution = sensor?.rf_services[0];
          }else{
          var selectedResolution = sensor?.resolution[0];
          }

          if((sensor?.key === OPERATORS.AT21 || sensor?.key === OPERATORS.GHG || sensor?.key === OPERATORS.ECURS || sensor?.key === OPERATORS.ECURS_L) && sensor.resolution?.length > 1) {
            sensor.resolution.forEach((res, index) => {
              res.disable = index !== 0; // Set disable = true for all except the first element
            });
          }
          if (((sensor?.key === OPERATORS.STE || sensor?.key === OPERATORS.STE_TELEOS) && sensor.resolution?.length > 1 && sensor?.sensor === 'SAR' && this.target.area === 0) || 
          (sensor?.key === OPERATORS.ISI && sensor.resolution?.length > 1) || (sensor?.key === OPERATORS.CAPELLA && sensor.resolution?.length > 1)) {
            sensor.resolution[1].disable = true;
            sensor.resolution[0].disable = false;
          }

          if (((sensor?.key === OPERATORS.STE || sensor?.key === OPERATORS.STE_TELEOS) && sensor.resolution?.length > 1 && sensor?.sensor === 'SAR' && this.target.area > 0)) {
            sensor.resolution[0].disable = true;
            selectedResolution = sensor.resolution[1];
          }

          if ((sensor?.key === OPERATORS.SYNSPECTIVE && sensor.resolution?.length > 1 && sensor?.sensor === 'SAR')) {
            sensor.resolution[0].disable = true;
            selectedResolution = sensor.resolution[1];
            sensor.resolution[1].disable = false;
          }

        }
        if (sensor?.collection_mode?.length > 0) {
          selectedModes.push(sensor?.collection_mode[0]);
          modeSelected.push(sensor?.collection_mode[0]);
          if (
            (sensor?.key === OPERATORS.BLACKSKY || sensor?.key === OPERATORS.OSK) &&
            selectedModes[0].sceneSize
          ) {
            minArea = sensor?.key === OPERATORS.OSK && this.target.area > 0 ? sensor?.minareastrip : selectedModes[0].sceneSize;
          }

          if (this.target.area > 0 && (sensor?.key === OPERATORS.SATELLOGIC) && 
            sensor?.collection_mode?.length > 1) {
            selectedModes = [];
            modeSelected = [];
            selectedModes.push(sensor?.collection_mode[1]);
            modeSelected.push(sensor?.collection_mode[1]);
            defaultMinTooltip = sensor?.collection_mode[1]?.minTooltip;
            defaultMinArea = sensor?.collection_mode[1]?.value;
          } else if (
            this.target.area > 0 &&
            sensor?.key === OPERATORS.KOMPSAT &&
            sensor?.sensor === 'MSI'
          ) {
            selectedModes = [];
            modeSelected = [];
            selectedModes.push(sensor?.collection_mode[3]);
            modeSelected.push(sensor?.collection_mode[3]);
            defaultMinTooltip = sensor?.collection_mode[3]?.minTooltip;
            defaultMinArea = sensor?.collection_mode[3]?.value;
          } else if (
            sensor?.key === OPERATORS.GHG &&
            (this.target?.multiTarget?.length > 2 && this.multiPointsCoveredArea <= 144)
          ) {
            selectedModes = [];
            modeSelected = [];
            selectedModes.push(sensor?.collection_mode[1]);
            modeSelected.push(sensor?.collection_mode[1]);
            defaultMinTooltip = sensor?.collection_mode[1]?.minTooltip;
            defaultMinArea = sensor?.collection_mode[1]?.value;
          } else if (
            this.target.area > 0 &&
            (sensor?.key === OPERATORS.SDS || sensor?.key === OPERATORS.ORBVIEW) &&
            sensor?.sensor === 'MSI' &&
            sensor?.collection_mode?.length > 0
          ) {
            selectedModes = [];
            modeSelected = [];
            const matchedMode = sensor.collection_mode.find(
              (mode: any) => mode?.captureMode?.toLowerCase().includes('strip')
            ) ?? sensor.collection_mode[0];
            selectedModes.push(matchedMode);
            modeSelected.push(matchedMode);
            defaultMinTooltip = matchedMode?.minTooltip;
            defaultMinArea = matchedMode?.value;
          } else if (this.target.area > 0 && (sensor?.key === OPERATORS.ECURS || sensor?.key === OPERATORS.ECURS_L) && 
            sensor?.collection_mode?.length > 1) {              
            selectedModes = [];
            modeSelected = [];
            const matchedMode = sensor?.collection_mode.find(mode => mode.key.includes('StripMap'));
            if (matchedMode) {              
              selectedModes.push(matchedMode);
              modeSelected.push(matchedMode);
              defaultMinTooltip = matchedMode?.minTooltip;
              defaultMinArea = matchedMode?.value;
            } else {
              selectedModes.push(sensor?.collection_mode[0]);
              modeSelected.push(sensor?.collection_mode[0]);
              defaultMinArea = sensor?.collection_mode[0]?.value;
              defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
            }
          } else if (sensor?.key === OPERATORS.GEOSAT && sensor?.collection_mode?.length > 1) {
            const matchedMode = this.getDefaultCollectionMode(sensor, sensor?.collection_mode);

            if (matchedMode) {
              selectedModes = [matchedMode];
              modeSelected = [matchedMode];
              defaultMinTooltip = matchedMode?.minTooltip;
              defaultMinArea = matchedMode?.value;
            }
          } else if (this.target.area > 0 && sensor?.key === OPERATORS.STE_TELEOS &&
              sensor?.collection_mode?.length > 1) {
              this.getCustomTooltip(sensor?.collection_mode);
              defaultMinArea = sensor?.collection_mode[0]?.value;
              defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
              this.isArea = true;
              sensor.selectedONA = sensor.ONA[1].key;
              sensor.selectedONAOption = sensor.ONA[1];
              this.resetOna(sensor, this.stripMode);
          } else if (sensor?.key === OPERATORS.ICEYE && sensor?.collection_mode?.length > 0) {
            const matchedMode = this.getDefaultCollectionMode(sensor, sensor?.collection_mode);
            if (matchedMode) {
              selectedModes = [matchedMode];
              modeSelected = [matchedMode];
              defaultMinTooltip = matchedMode?.minTooltip;
              defaultMinArea = matchedMode?.value;
            } else {
              defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
              defaultMinArea = sensor?.collection_mode[0]?.value;
            }
          } else if (
            sensor?.key === OPERATORS.UMBRA &&
            this.target?.multiTarget?.length === 2
          ) {
            try {
              const _pt1 = this.utilsService.extractCoordinates(this.target.multiTarget[0]);
              const _pt2 = this.utilsService.extractCoordinates(this.target.multiTarget[1]);
              const _distKm = this.utilsService.calculateDistance(_pt1.lat, _pt1.lng, _pt2.lat, _pt2.lng);
              const matchedMode = findMatchingUmbraScanMode(sensor.collection_mode, _distKm);
              if (matchedMode && isUmbraScanMode(sensor, [matchedMode])) {
                selectedModes = [matchedMode];
                modeSelected = [matchedMode];
                defaultMinArea = matchedMode?.value;
                defaultMinTooltip = matchedMode?.minTooltip;
              } else {
                defaultMinArea = sensor?.collection_mode[0]?.value;
                defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
              }
            } catch (e) {
              defaultMinArea = sensor?.collection_mode[0]?.value;
              defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
            }
          } else {
            defaultMinArea = sensor?.collection_mode[0]?.value;
            defaultMinTooltip = sensor?.collection_mode[0]?.minTooltip;
          }
        }
        if (sensor?.key === 'STE' && sensor.sensor != 'SAR') {
          if (this.target.selectedOption === 0 || this.target.selectedOption === 3) {
            cloudcover = '';
            selectedCC = '';
          }
        } else if (
          this.isTipAndCueRule &&
          sensor?.key === OPERATORS.SATELLOGIC
        ) {
          cloudcover = '';
          selectedCC = '';
        }
        if (sensor?.ONA?.length > 0 || sensor?.onaWithResolution?.length > 0  ) {
          let filteredSensors =sensor?.onaWithResolution? sensor?.onaWithResolution?.filter((item: any) => item.default === true):sensor?.ONA;
          if (sensor?.onaWithResolution && (!filteredSensors || filteredSensors.length === 0)) {
            // Some strategy flows do not mark any ONA row as default; fall back to first available option.
            filteredSensors = sensor?.onaWithResolution;
          }
          var selectedONAOption;
          if (sensor?.key === OPERATORS.STE_TELEOS && this.isArea) {
            selectedONAOption = sensor?.onaWithResolution ?  filteredSensors[0]:sensor?.ONA[1];
          } else {
            selectedONAOption = sensor?.onaWithResolution ?  filteredSensors[0]:sensor?.ONA[0];
          }
          var uniqueOnaArray =sensor?.onaWithResolution? this.getUniqueOnaArray( sensor?.onaWithResolution):sensor.ONA;
     
          if(selectedONAOption && !selectedONAOption?.key && sensor?.onaWithResolution){
            selectedONAOption.key=selectedONAOption?.ona
            sensor.selectedONA =selectedONAOption.ona?selectedONAOption?.ona:selectedONAOption?.key
            selectedONAOption.value =selectedONAOption.onaUplift? selectedONAOption?.onaUplift:selectedONAOption?.value;
            sensor.selectedONAOption = selectedONAOption;
            sensor.ONAFactor =  selectedONAOption.value ;          
         if( sensor.resolution.length<2 && sensor?.onaWithResolution)
          if(selectedONAOption?.resolution ){
         
            let newResoution:any= {key:"0",value:selectedONAOption.resolution,originalResolution :selectedONAOption.forResolution}
            if (sensor?.key !== OPERATORS.GEOSAT) {
              newResoution.bands = selectedONAOption?.bands ?? sensor.resolution[0]?.bands;
            }
            if(selectedONAOption?.mode_value){
              newResoution.mode_value= selectedONAOption?.mode_value;
            }
            sensor.resolution =[newResoution];
            sensor.selectedResolution =  newResoution
          }
           if( sensor.resolution.length > 1 && sensor?.onaWithResolution){
            const resolutionArray = this.createResolutionArray(sensor?.onaWithResolution,  sensor.selectedONA,sensor.resolution,sensor.key);
            sensor.resolution = resolutionArray;
            selectedResolution = resolutionArray[0];
          }
        }

          if (selectedONAOption) {
            sensor.selectedONA = selectedONAOption?.ona ? selectedONAOption?.ona : selectedONAOption?.key;
            sensor.selectedONAOption = selectedONAOption;
            sensor.selectedItem = selectedONAOption;
            sensor.ONAFactor = selectedONAOption?.onaUplift ? selectedONAOption?.onaUplift : selectedONAOption?.value;
          }
        }        

        if (sensor?.SZA?.length > 0) {
          SZA = sensor?.SZA[0];
        }
        if (sensor?.AC?.length > 0) {
          AC = sensor?.AC[0];
        }
        if (sensor?.holdback?.length > 0) {
          selectedHoldBackOption = sensor?.holdback[0];
        }

        if (sensor?.key === OPERATORS.STE_TELEOS && !this.isArea) {
          sensor.selectedONA =  sensor.ONA[0].key;
          sensor.ONA[0].enabled = true;
        }

        if (sensor?.key === OPERATORS.UMBRA) {
          defaultAzimuthAngleMax = sensor?.targetAzimuthAngleMax;
          defaultAzimuthAngleMin = sensor?.targetAzimuthAngleMin;
          defaultGrazingAngleMax = sensor?.targetGrazingAngleMax;
          defaultGrazingAngleMin = sensor?.targetGrazingAngleMin;
          defaultPolarization = sensor?.sarPolarization?.find(p => p.value === this.defaultUmbraPol)?.value
            ?? sensor?.sarPolarization?.[0]?.value;
        }
        if (sensor?.key === OPERATORS.CAPELLA) {
          defaultPolarization = sensor?.sarPolarization?.find(p => p.value === this.defaultCapellaPol)?.value
            ?? sensor?.sarPolarization?.[0]?.value;
        }

        if (sensor?.key === OPERATORS.LBAND) {
          for (let i = 0; i < sensor.signal_of_interest.length; i++) {
            sensor.signal_of_interest[i].isAudio = false;
          }
        }
        if (sensor?.key === OPERATORS.WYVERN) {
            sensor.numberOfBands = sensor.band_options[0].no_of_bands;
            sensor.tooltip = sensor.band_options[0].tooltip;
        }

        if (sensor?.key === OPERATORS.ESPER || sensor?.key === OPERATORS.OSK) {
          sensor.numberOfBands = sensor.band_options[0].no_of_bands;
        }

        if (!sensor.numberOfBands && sensor?.band_options?.length > 0) {
          sensor.numberOfBands = sensor.band_options[0].no_of_bands;
        }
        if (sensor?.key === OPERATORS.SDS || sensor?.key === OPERATORS.ORBVIEW) {
          sensor.sourceCode = sensor.sourceCode;
        }


        const deliveytime_stand = new Date().setDate(
          new Date().getDate() + sensor.latency_standard
        );
        const defaultLatency = [],
          latencySTE: any = [],
          latency: any = [];
        let unitcost = 0;
        if (sensor?.key === 'Capella') {
          if (
            this.target.freqOption === 'Weekly' ||
            this.target.freqOption === 'Monthly'
          )
            this.capellaRecurrent = true;
          else this.capellaRecurrent = false;
        }
        if (sensor?.key === OPERATORS.CLYDE) {
          let totalAOIInMillion = targetArea / 1000000;

          let selectedKey = Object.keys(sensor?.pricing).find(
            (key) => totalAOIInMillion <= Number(key)
          );
          if (!selectedKey) {
            selectedKey = Object.keys(sensor.pricing).sort(
              (a: any, b: any) => b - a
            )[0];
          }
          let selectedhistoricalKey = Object.keys(sensor?.historicalPricing).find(
            (key) => totalAOIInMillion <= Number(key)
          );
          if (!selectedhistoricalKey) {
            selectedhistoricalKey = Object.keys(sensor.historicalPricing).sort(
              (a: any, b: any) => b - a
            )[0];
          }
      
          selectedTaskingPrice = {
            data: {
              selectedKey,
              price: sensor.pricing[selectedKey],
            },
          };
          
          selectedHistoricalPrice = {
            data: {
              selectedhistoricalKey,
              price: sensor.historicalPricing[selectedhistoricalKey],
            },
          }; 
         }

        for (let j = 0; j < sensor.latency.length; j++) {
          let selected = false;
          var calCost = sensor.latency[j]?.unitcost;
          var unitCost = sensor.latency[j]?.unitcost;
          if (sensor?.key === OPERATORS.UMBRA) {
            if (sensor.resolution) {
              var calCost = sensor.resolution[0]?.cost;
              var unitCost = sensor.resolution[0]?.cost;
            }
          }
          if (sensor?.key === OPERATORS.CLYDE) {
            var calCost = selectedTaskingPrice.data.price;
            var unitCost = selectedTaskingPrice.data.price;         
           }

           if (sensor?.key === OPERATORS.AXELSPACE && this.currentUser.id != CONFIG_VALUES.AxelCustomerId) {
            let unitPrice: any = this.getAxelPrice(targetArea, sensor.pricing);
            var calCost = unitPrice;
            var unitCost = unitPrice;
          }

          // `??`, not truthiness: an operator whose response time is a phrase
          // rather than a duration states mode: "" and gets no comparator in
          // front of it. Voyage Radar's "Immediate" is the first — under a
          // truthiness check its empty mode read as absent and the column
          // rendered "<= Immediate".
          var mode: any = sensor.latency[j]?.mode ?? '<=';
          if (this.currentUser?.channelPrice) {
            var calCost = sensor.channelPrice[sensor.latency[j]]?.unitcost;
            var unitCost = sensor.channelPrice[sensor.latency[j]]?.unitcost;
          }
          latency.push({
            name: sensor.latency[j]?.name,
            unitcost: unitCost,
            cost: calCost,
            latency: sensor.latency[j]?.latency,
            selected: selected,
            mode: mode,
            sensor: sensor.name,
            collectionWindow: sensor.latency[j]?.collectionWindow,
            taskingwindow: sensor.latency[j]?.taskingwindow,
            key: sensor.latency[j]?.key,
            sla: sensor.latency[j]?.sla,
            // Preserve upliftCost for operators like GEOSAT that use mode-based pricing
            upliftCost: sensor.latency[j]?.upliftCost,
            reactionUpliftCost: sensor.latency[j]?.reactionUpliftCost,
            responseUpliftCost: sensor.latency[j]?.responseUpliftCost,
            taskingWindowCost: (sensor.latency[j]?.reactionUpliftCost ?? 0) + (sensor.latency[j]?.responseUpliftCost ?? 0),
          });
        }

        let STElatency: any = [];
        if (sensor?.key === OPERATORS.STE || sensor?.key === OPERATORS.STE_TELEOS) {
          latencySTE.push(latency);
          STElatency = JSON.parse(JSON.stringify(latencySTE));
        }

        if (sensor?.key === OPERATORS.OSK) {
          let area = target === 'POI' ? 'poi' : 'aoi';
        
          if (sensor.pricing_unit) {
              sensor.pricingUnit = sensor.pricing_unit[area];              
          }
        }

        let taskcost;
        // Initialize cost from first collection mode for Consteller operator
        if (sensor?.key === OPERATORS.CONSTELLR && selectedModes?.length > 0 && selectedModes[0]?.cost) {
          taskcost = selectedModes[0].cost;
        }
        const existId = this.AVAILABLESENSORS.filter(el => {
          if (this.target.taskStrategy === 'Tip-and-Cue') {
            return sensor?.sensorId === el?.sensorId && sensor?.tabIndex === el?.tabIndex;
          } else
          return sensor?.sensorId === el?.sensorId;
        });
        const satIds = sensor?.satIds ? sensor?.satIds.map(obj => obj.id) : [];
        const initialSensorTooltip = this.getInitialSensorTooltip(
          sensor,
          selectedModes,
        );
        if (existId.length === 0) {
          let hasSelectedTypes = false;
          hasSelectedTypes = this.SensorsTypes.some(type => type.selected === true);
          if ((this.selectedSensorTypes || (this.isAllSensors && !hasSelectedTypes) || (this.isDailySubdaily && !hasSelectedTypes) || (this.isOpportunitySensors && !hasSelectedTypes) || (this.isObfuscatedSensors && !hasSelectedTypes)) && sensor?.name != 'TripleSat' && sensor?.name != 'Daily Vision 75' 
            && sensor?.name != 'Daily Vision Wide' && sensor?.name != 'Jilin'
          ) {
            if (sensor.enabled) {
              const tooltip = sensor;
              this.AVAILABLESENSORS.push({
                name: sensor.name,
                ...(sensor.rf_services ? { rf_services: sensor.rf_services } : { resolution: sensor.resolution }),
                unit: sensor.pricingUnit ? sensor.pricingUnit : sensor.costunit ,
                isObfuscated: sensor?.isObfuscated,
                high_cadence: sensor?.high_cadence,
                cadence_value: sensor?.cadence_value,
                pricingUnit: sensor.pricingUnit ? sensor.pricingUnit : sensor.costunit,
                type: sensor?.type,
                unitcost: unitcost,
                // The TOI, carried on the row so a per-DURATION operator can
                // price itself. AISstream is the first: it is billed per day of
                // stream (operator doc `costunit: "day"`), so its strategy needs
                // the window rather than the area. `AisstreamOperatorStrategy`
                // derives the day count from these two — see `streamDaysForToi`,
                // which mirrors the same calculation in the backend's
                // `controllers/budget.js`.
                //
                // On the ROW rather than read from `this.target` inside the
                // strategy, because a strategy is handed nothing but the row
                // (`UnitCostCalculationArgs` is `{ sensorRow, latencyIndx }`) —
                // the same reason WeatherEx's refresh count is written here.
                openWindow: this.target?.openWindow,
                closeWindow: this.target?.closeWindow,
                sensor: sensor.sensor,
                sensortype: sensor.sensortype,
                minarea: minArea,
                areacalc: areacalc,
                area_calculated: this.totalAOI,
                tooltip: tooltip,
                cloudcovers: cloudcovers,
                cloudcover: cloudcover,
                cloudnew: cloudcovernew,
                collectmodes: collectmodes,
                defaultLatency: defaultLatency,
                latency: latency,
                selectedCost: taskcost,
                selectedCC: selectedCC,
                selectedLatency: this.selectedLatency[i],
                selectedLatencyKey: this.selectedLatencyKey[i],
                cost: taskcost,
                enabled: sensor.enabled,
                ONA: uniqueOnaArray ? uniqueOnaArray:sensor.ONA,
                selectedONA: sensor?.selectedONA,
                selectedItem: sensor?.selectedItem,
                holdback: sensor.holdback,
                collection_mode: this.sortedWeatherExCollectionMode(sensor),
                country: sensor.country,
                selectedModes: selectedModes,
                selectedONAOption: selectedONAOption,
                ONAFactor: sensor?.ONAFactor,
                sensorTooltip: initialSensorTooltip,
                sensorDesc: sensor?.sensordesc,
                rushCloudCover: false,
                key: sensor?.key,
                operatorEmail: sensor?.operatorEmail,
                modeType: sensor?.multiplemode === true || sensor?.multiplemode === 'true' || sensor?.key === OPERATORS.WEATHEREX,
                modeSelected: modeSelected,
                satIds: satIds,
                SZA: SZA,
                AC: AC,
                selectedResolution: selectedResolution,
                selectedResolutionValue: selectedResolution?.value,
                sarPolarization: sensor?.sarPolarization,
                sarOrbitDirection: sensor?.sarOrbitDirection,
                productAnciallary: sensor?.productAnciallary,
                satelliteName: sensor?.satelliteName,
                collectionCost: sensor?.collection_cost,
                selectedHoldBackOption: selectedHoldBackOption,
                feasibility: sensor?.feasibility,
                tooltipValue: defaultMinTooltip,
                selectedAnciallary: '',
                selectedOrbitDirection: '',
                selectedPolarization: '',
                siteData: sensor?.siteData,
                collectionunit: sensor.pricingUnit ? sensor.pricingUnit : sensor.collectionunit,
                tnqSensorDisabled: true,
                minimumArea: defaultMinArea,
                captureMode: '',
                STElatency: STElatency,
                defaultPolarization: defaultPolarization,
                defaultAzimuthAngleMax: defaultAzimuthAngleMax,
                defaultAzimuthAngleMin: defaultAzimuthAngleMin,
                defaultGrazingAngleMax: defaultGrazingAngleMax,
                defaultGrazingAngleMin: defaultGrazingAngleMin,
                pricing: sensor?.pricing,
                cancelPolicy: sensor?.cancel_policy,
                onaWithResolution: sensor?.onaWithResolution,
                imageryname: sensor?.imageryname,
                selectedTaskingPrice: selectedTaskingPrice,
                selectedHistoricalPrice: selectedHistoricalPrice,
                apiCreditActions: sensor?.apiCreditActions,
                // Voyage Radar purchase bounds, straight off the operator doc.
                // resolveCreditBounds() supplies defaults when absent, so these
                // stay undefined for every other operator.
                minApiCredits: sensor?.minApiCredits,
                maxApiCredits: sensor?.maxApiCredits,
                sensorId:sensor?.sensorId,
                valAddedArray: sensor.valueAddedOption,
                valueAddedAction: this.formatvalueAddedOption(sensor, selectedModes, selectedResolution),
                superResolutions: this.setSuperResolutions(sensor),
                signal_of_interest:  sensor?.key === OPERATORS.USL ?   selectedModes : this.setSignalOfInterest(sensor?.signal_of_interest),
                collection_duration: sensor?.collection_duration,
                updateFrequency: sensor?.updateFrequency,
                indicesArray: this.setIndices(sensor,selectedResolution),
                no_imagery_country: sensor?.no_imagery_country,
                obfuscateName: sensor?.obfuscateName,
                displayName: (this.currentUser.obfuscated && sensor.obfuscateName) ? sensor.obfuscateName : sensor.name,
                sarOrbitType: sensor?.sarOrbitType,
                bitDepth: sensor?.bitDepth,
                sensorBands: sensor?.bands,
                bandOptions: sensor?.band_options,
                numberOfBands: sensor?.numberOfBands,
                supportedTarget: this.checkSupportedTarget(sensor),
                aoi: sensor?.aoi,
                poi: sensor?.poi,
                imageLength: sensor?.image_length,
                tabIndex: sensor?.tabIndex,
                selectedTnqSensorType: sensor?.tipAndCueSensorType,
                informationFeeds: sensor?.informationfeeds,
                sourceCode: sensor?.sourceCode,
                minDurationDays: sensor?.minDurationDays,
                refreshRates: sensor?.refreshRates ?? null,
                selectedRefreshRate: sensor?.refreshRates?.[0] ?? null,
                minDurationHours : sensor?.minDurationHours ?? null,
                minStartHours : sensor?.minStartHours ?? null,
                maxEndDays : sensor?.maxEndDays ?? null,
                blockedSubDailyCounts : sensor?.blockedSubDailyCounts ?? null,
              });

              this.applySatelliteVuInitConstraints(this.AVAILABLESENSORS.length - 1);

              // For Umbra ScanSAR: apply mode-specific resolution disabling and cost via modeOption
              {
                const _newIndx = this.AVAILABLESENSORS.length - 1;
                const _newRow = this.AVAILABLESENSORS[_newIndx];
                const _isScan = isUmbraScanMode(_newRow, _newRow.selectedModes);
                if (_isScan) {
                  await this.modeOption(_newRow.selectedModes[0], _newIndx, _newRow);
                  // modeOption sets selectedModes to a single object at the end; restore to array so isUmbraScanMode(row) continues to work
                  if (!Array.isArray(this.AVAILABLESENSORS[_newIndx].selectedModes)) {
                    this.AVAILABLESENSORS[_newIndx].selectedModes = [this.AVAILABLESENSORS[_newIndx].selectedModes];
                  }
                  this.AVAILABLESENSORS[_newIndx].modeResetValue = this.AVAILABLESENSORS[_newIndx].selectedModes[0] ?? null;
                  this.cdRef.detectChanges();
                }
              }

              // WeatherEx: start with no modes selected; user must pick from the dropdown.
              if (sensor?.key === OPERATORS.WEATHEREX) {
                const _wxIndx = this.AVAILABLESENSORS.length - 1;
                const _wxRow  = this.AVAILABLESENSORS[_wxIndx];
                _wxRow.selectedModes  = [];
                _wxRow.modeSelected   = [];
                _wxRow.modeResetValue = [];
                _wxRow.selectedMode   = '';
                // Hide ocean-specific variables when the task is on land (not over open water), for both POI and AOI.
                if (!this.target?.openWater) {
                  const weatherMeta = this.apiService.weatherVariables;
                  _wxRow.collection_mode = (_wxRow.collection_mode || []).filter((mode: any) => {
                    const meta = weatherMeta.find((m: any) => m.key === mode.key);
                    return !meta?.hideIfPoiOnLand;
                  });
                }
              }

            } else {
              const tooltip = {
                name: sensor.name,
                resolution: sensor.resolution,
                unit: sensor.costunit,
                type: sensor?.type,
                unitcost: sensor.unitcost,
                sensor: sensor.sensor,
                sensortype: sensor.sensortype,
                sensorTooltip: initialSensorTooltip,
                sensorDesc: sensor?.sensordesc,
              };
              this.AVAILABLESENSORS.push({
                isObfuscated: sensor?.isObfuscated,
                high_cadence: sensor?.high_cadence,
                cadence_value: sensor?.cadence_value,
                name: sensor.name,
                resolution: sensor.resolution,
                sensor: sensor.sensor,
                sensortype: sensor.sensortype,
                tooltip: tooltip,
                enabled: sensor.enabled,
                sensorTooltip: initialSensorTooltip,
                sensorDesc: sensor?.sensordesc,
                selectedModes: selectedModes,
                collection_mode: this.sortedWeatherExCollectionMode(sensor),
                selectedONA: sensor?.selectedONA,
                selectedItem: sensor?.selectedItem,
                selectedONAOption: selectedONAOption,
                ONAFactor: sensor?.ONAFactor,
                type: sensor?.type,
                satIds: satIds,
                key: sensor?.key,
                operatorEmail: sensor?.operatorEmail,
                modeType: sensor?.multiplemode === true || sensor?.multiplemode === 'true',
                selectedLatency: this.selectedLatency[i],
                selectedLatencyKey: this.selectedLatencyKey[i],
                modeSelected: modeSelected,
                SZA: SZA,
                AC: AC,
                selectedResolution: selectedResolution,
                selectedResolutionValue: selectedResolution?.value,
                sarPolarization: sensor?.sarPolarization,
                sarOrbitDirection: sensor?.sarOrbitDirection,
                productAnciallary: sensor?.productAnciallary,
                satelliteName: sensor?.satelliteName,
                selectedHoldBackOption: selectedHoldBackOption,
                feasibility: sensor?.feasibility,
                tooltipValue: defaultMinTooltip,
                selectedAnciallary: '',
                selectedOrbitDirection: '',
                selectedPolarization: '',
                siteData: sensor?.siteData,
                collectionunit: sensor?.collectionunit,
                minimumArea: defaultMinArea,
                STElatency: STElatency,
                defaultPolarization: defaultPolarization,
                defaultAzimuthAngleMax: defaultAzimuthAngleMax,
                defaultAzimuthAngleMin: defaultAzimuthAngleMin,
                defaultGrazingAngleMax: defaultGrazingAngleMax,
                defaultGrazingAngleMin: defaultGrazingAngleMin,
                pricing: sensor?.pricing,
                cancelPolicy: sensor?.cancel_policy,
                imageryname: sensor?.imageryname,
                selectedTaskingPrice: selectedTaskingPrice,
                selectedHistoricalPrice: selectedHistoricalPrice,
                apiCreditActions: sensor?.apiCreditActions,
                // Voyage Radar purchase bounds, straight off the operator doc.
                // resolveCreditBounds() supplies defaults when absent, so these
                // stay undefined for every other operator.
                minApiCredits: sensor?.minApiCredits,
                maxApiCredits: sensor?.maxApiCredits,
                sensorId:sensor?.sensorId,
                valAddedArray: sensor.valueAddedOption,
                valueAddedAction: this.formatvalueAddedOption(sensor, selectedModes, selectedResolution),
                superResolutions: this.setSuperResolutions(sensor),
                updateFrequency: sensor?.updateFrequency,
                no_imagery_country: sensor?.no_imagery_country,
                obfuscateName: sensor?.obfuscateName,
                displayName: (this.currentUser.obfuscated && sensor.obfuscateName) ? sensor.obfuscateName : sensor.name,
                sarOrbitType: sensor?.sarOrbitType,
                sensorBands: sensor?.bands,
                bandOptions: sensor?.band_options,
                numberOfBands: sensor?.numberOfBands,
                supportedTarget: this.checkSupportedTarget(sensor),
                aoi: sensor?.aoi,
                poi: sensor?.poi,
                imageLength: sensor?.image_length,
                tabIndex: sensor?.tabIndex,
                selectedTnqSensorType: sensor?.tipAndCueSensorType,
                informationFeeds: sensor?.informationfeeds,
                sourceCode: sensor?.sourceCode,
                minDurationDays: sensor?.minDurationDays
              });

              this.applySatelliteVuInitConstraints(this.AVAILABLESENSORS.length - 1);
            }
          }
        }
        
        this.AVAILABLESENSORS.forEach((sensor, index) => {
          if (!sort && sensor?.selectedTaskingTier) return
          if (Array.isArray(sensor.latency)) {
            const strategy = this.operatorStrategyFactory.getStrategy(sensor?.key);
            strategy?.syncLatencyCosts?.(sensor);

            this.sortLatencyByTierPref(sensor);        
            let defaultLatency = sensor.latency[0];
            let foundMatch = false;
        
            for (let j = 0; j < sensor.latency.length; j++) {
              const latencyItem = sensor.latency[j];
              const latencyKey = latencyItem?.key;        
              if (
                sensor.key === OPERATORS.SATELLOGIC &&
                (latencyKey === 'emergency') &&
                this.target?.openWater
              ) {
                defaultLatency = latencyItem;
                foundMatch = true;
                break;
              }
        
              if (
                sensor.key === OPERATORS.CAPELLA &&
                latencyKey === 'recurrent' &&
                this.target.selectedOption === 1 &&
                this.target.freqOption !== 'Days'
              ) {
                defaultLatency = latencyItem;
                foundMatch = true;
                break;
              }

              if (
                sensor.key === OPERATORS.GOKTURK &&
                latencyKey != 'rush' &&
                this.target.selectedOption !== 0 &&
                this.target.selectedOption !== 3
              ) {
                defaultLatency = latencyItem;
                foundMatch = true;
                break;
              }
              if (
                sensor.key === OPERATORS.GOKTURK &&
                latencyKey === 'rush' &&
                (this.target.selectedOption === 0 || this.target.selectedOption === 3)
              ) {
                defaultLatency = latencyItem;
                foundMatch = true;
                break;
              }
        
              if (
                (sensor.key === 'STE' || sensor?.key === OPERATORS.STE_TELEOS) &&
                latencyKey === 'standard' &&
                this.target.selectedOption !== 0 &&
                this.target.selectedOption !== 3
              ) {
                defaultLatency = latencyItem;
                foundMatch = true;
                break;
              }        
              
            }
        
            // Set selected values
            if (!this.shouldDisableTier(defaultLatency, sensor)) {
            this.selectedLatency[index] = defaultLatency?.name;
            this.selectedLatencyKey[index] = defaultLatency;
            sensor.selectedLatency = defaultLatency?.name;
            sensor.selectedLatencyKey = defaultLatency;
            sensor.selectedTaskingTierPrefrence = defaultLatency?.key; // Use key to match <mat-option [ngValue]="key">
            sensor.isUserSelection = false;

            // GEOSAT: compute selectedCost using the chosen default latency.
            if (sensor.key === OPERATORS.GEOSAT) {
              this.recalculateSelectedCostForRow(index);
            }
            }
          }
        });
        

        if((this.isAllSensors || this.isNightSensor || this.isDailySubdaily || this.isOpportunitySensors || this.isObfuscatedSensors)){
          // this.dataSource = new MatTableDataSource(
          //       this.AVAILABLESENSORS.filter(op =>
          //         this.FILTEREDSENSORS.some(fs => fs.sensorId === op.sensorId)
          //       )
          //     );
          const filteredSensors:any = [];
          this.selectedSensors = [];

          this.AVAILABLESENSORS.forEach(op => {
            const isFiltered = this.FILTEREDSENSORS.some(
              fs => fs.sensorId === op.sensorId
            );
            if (isFiltered) {

              filteredSensors.push(op);
              if (op.checked) {
                this.selectedSensors.push(op);
              }
            }
          });
          this.AVAILABLESENSORS = filteredSensors;
          this.dataSource = new MatTableDataSource(filteredSensors);
        }
        else{
          this.selectedSensors = [];

          this.AVAILABLESENSORS.forEach(op => {
            const isFiltered = this.FILTEREDSENSORS.some(
              fs => fs.sensorId === op.sensorId
            );
            if (isFiltered) {
              if (op.checked) {
                this.selectedSensors.push(op);
              }
            }
          });
          this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
        }
        this.dataSource.sort = this.sort;
        this.showSwath = this.AVAILABLESENSORS.some((s) =>
          s.collection_mode?.some((m) => m.swathWidth)
        );
        
        for (const [sensorIndex, sensors] of this.AVAILABLESENSORS.entries()) {
          if (sensors?.key === OPERATORS.GHG) {
            sensors.latency = sensors.latency.map(latencyItem => {
              const matchingMode = sensors.selectedModes[0].cost.find(mode => mode[latencyItem.key] !== undefined);
              return {
                ...latencyItem,
                cost: matchingMode ? matchingMode[latencyItem.key] : null,
                unitcost: matchingMode ? matchingMode[latencyItem.key] : null,
              };
            });
          }
          if ((sensors?.key === OPERATORS.CAPELLA || sensors?.key === OPERATORS.GOKTURK || sensor?.key === OPERATORS.BLACKSKY || sensors?.key === OPERATORS.SDS || (sensors?.key === OPERATORS.STE && sensors?.sensor === 'MSI'
            && sensors.selectedResolution.value.includes('Bundle')
          ) || (sensors?.key === OPERATORS.ECURS || sensors?.key === OPERATORS.ECURS_L)) && sensors?.latency) {
            let pricingArray= sensors.selectedModes[0]?.pricing;
            for (const latencyItem of sensors.latency) {
              const key = latencyItem.key;
              if (pricingArray && pricingArray.hasOwnProperty(key)) {
                const newCost = Number(pricingArray[key]);
                latencyItem.cost = newCost;
                latencyItem.unitcost = newCost;
              }
            }
          }

          if (sensors?.key === OPERATORS.USL) {
            let priceArray = sensor?.collection_cost;            
            let subdailyCount = this.target.subDailyCount || 1;
            if (sensor?.name === 'BRO') {

              let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
              let enddate = moment(this.target.closeWindow).utcOffset(0, true).format();

              let days_difference = this.getDateDifferenceInDays(startdate, enddate);
              const priceArray = sensor?.collection_cost;
              if(days_difference > 365 ) {
                this.broUnitCost = sensor?.year_based_pricing;
                const isSubDailyValid = this.target.freqOption === 'Sub-daily' && this.checkAcquisition();

                const isDaily = this.target.freqOption === 'Daily';

                if(isSubDailyValid || isDaily) {
                  this.isUslBroValidated = true;
                  let baseCost = 0;
                  
                  let cost = this.calculateBroPrice(days_difference, subdailyCount);
                  for (const latencyItem of sensors.latency) {

                    if (latencyItem.key === 'standard') {
                      baseCost = cost;
                    } else if (latencyItem.key === 'priority' || latencyItem.key === 'rush') {
                      baseCost = cost * 1.5;
                    }
                    latencyItem.unitcost = Number(baseCost);
                    latencyItem.cost = Number(baseCost);
                    
                  }                  
                }
              }else if (priceArray) {
                for (const latencyItem of sensors.latency) {
                  for (const pricingItem of priceArray) {
                    if (latencyItem.key === pricingItem.latency) {
                      latencyItem.cost = Number(pricingItem.cost);
                      latencyItem.unitcost = Number(pricingItem.cost);
                      break;
                    }
                  }
                }
              }
            }
            else if (priceArray) {
              for (const latencyItem of sensors.latency) {
                for (const pricingItem of priceArray) {
                  if (
                    latencyItem.key === pricingItem.latency &&
                    pricingItem.unit === subdailyCount
                  ) {
                    latencyItem.cost = Number(pricingItem.cost);
                    latencyItem.unitcost = Number(pricingItem.cost);
                    break;
                  }
                }
              }              
            }                       
          }

          if (sensors?.key === OPERATORS.SATELLOGIC) {
            let priceArray = sensor?.pricing;

            if (priceArray) {
              for (const latencyItem of sensors.latency) {
                const key = latencyItem.key;                
                if (priceArray[target] !== undefined) {
                  if (priceArray[target][key] !== undefined) {
                    latencyItem.cost = priceArray[target][key];
                    latencyItem.unitcost = priceArray[target][key];
                  }
                }
              }
            }
          }

          if (sensors?.key === OPERATORS.ESPER) {
            let priceArray = sensors?.pricing;
            let bands = 50;

            if (priceArray) {              
              for (const latencyItem of sensors.latency) {
                const key = latencyItem.key;
                latencyItem.cost = priceArray[key][bands];
                latencyItem.unitcost = priceArray[key][bands];
            }            
          }
        }
          
        if (sensors?.key === OPERATORS.OSK) {
          let priceArray = sensor?.pricing;
          let area = target;

          if (priceArray) {              
            for (const latencyItem of sensors.latency) {
              const key = latencyItem.key;                
              if (priceArray[key] !== undefined) {
                if (priceArray[key][area] !== undefined) {
                  latencyItem.cost = priceArray[key][area];
                  latencyItem.unitcost = priceArray[key][area];
                }
              }
            }
          }
        }

        if(sensors?.key === OPERATORS.ORBVIEW){
            let pricingArray = sensors.selectedResolution?.pricing;
            if (sensors.latency) {
              for (const latencyItem of sensors.latency) {
                const key = this.normalizeOrbviewPricingKey(latencyItem.key);
                if (pricingArray && Object.prototype.hasOwnProperty.call(pricingArray, key)) {
                  const newCost = Number(pricingArray[key]);
                  latencyItem.cost = newCost;
                  latencyItem.unitcost = newCost;
                }
              }
            }
          }

          this.taskingOption(sensors.selectedLatency, sensorIndex, sensors, 1);
        }
      }      
    });    
   
  }
  getTextLength(captureMode: string, productLevel: string): number {
    const captureModeLength = captureMode ? captureMode.length : 0;
    const productLevelLength = productLevel ? productLevel.length : 0;
    return captureModeLength + (productLevel ? productLevelLength + 3 : 0); // Adding 3 for ' ()'
  }
  
  createResolutionArray(data, selectedOna,resolution,key) {
    // Initialize the result array and a counter for the auto-increment key
    let result :any= [];
    let counter = 1;

    // Loop through the original data
    data?.forEach((item, index) => {
        // Check if the current item's 'ona' matches the selected 'ona'
        if (item.ona === selectedOna) {
          const matchingResolution = resolution.find(
            (res) => (res.value === item.forResolution || res?.originalResolution === item.forResolution)
          );
          
            // Push the new object with auto-increment key and forResolution value to the result array
            const resolutionOption: any = { key: counter, value: item.resolution , order:item.order,originalResolution :item.forResolution, onaUplift:item.onaUplift,
              multiplier: matchingResolution?.multiplier, combinedResolution: item?.combinedResolution ? item?.combinedResolution : matchingResolution?.combinedResolution
            };
            if (key !== OPERATORS.GEOSAT) {
              resolutionOption.bands = item?.bands?? matchingResolution?.bands;
            }
            result.push(resolutionOption);
            // Increment the counter
            counter++;
        }
    });   
    result.sort((a, b) => a.order - b.order);
    if (result?.length > 1  && key !== OPERATORS.AXELSPACE) {
      result[1].disable = true;
    }
    return result;
}
getUniqueOnaArray(data:any) {
  // Initialize an empty Set to keep track of unique 'ona' values
  const uniqueOna = new Set();
  // Initialize the result array
  const result:any = [];

  // Loop through the original data
  data.forEach(item => {
      // If the 'ona' value is not in the Set, add it to the Set and the result array
      if (!uniqueOna.has(item.ona)) {
          uniqueOna.add(item.ona);
          result.push(item);
      }
  });
  result.sort((a, b) => b.default - a.default);
  return result;
}
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
  }

  shouldHideCollectionMode(row: any): boolean {
    return row?.key === OPERATORS.OSK && Number(this.target?.area) > 0;
  }

  private getBaseDisplayedColumns(): string[] {
    return [
      'operator',
      'location',
      'band',
      'preview',
      'sattarcking',
      'mode',
      'resolution',
      'swath',
      'area_calculated',
      'cloudcovers',
      'ONA',
      'unitcost',
      'holdback',
      'advance',
      'cost',
      'opportunity',
      'footprint',
      'clientInfo',
      'eula',
    ];
  }

  private resetTableDefaults(): void {
    this.nameONA = 'ONA/Look/Grazing Angle';
    this.showColumn = true;
    this.lbandOnly = false;
    this.columnResolution = 'Resolution';
    this.aisOnly = true;
    this.tripleHeader = false;
    this.resolutionColumnTooltip =
      'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    this.onaTooltip =
      'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +
      '\n' +
      'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
      '\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';

    this.displayedColumns = this.getBaseDisplayedColumns();
  }

  private isSarFamilySensor(sensorType: string): boolean {
    return ['SAR', 'InSAR', 'ScanSAR'].includes(sensorType);
  }

  private isNonImagingSensor(sensorType: string): boolean {
    return ['AIS', 'Weather', 'RF- comms'].includes(sensorType);
  }

  private getImagingResolutionTooltip(sensorTypes: string[]): string {
    const hasSarFamily = sensorTypes.some((sensorType) =>
      this.isSarFamilySensor(sensorType)
    );
    const hasOtherImaging = sensorTypes.some(
      (sensorType) =>
        !this.isNonImagingSensor(sensorType) &&
        !this.isSarFamilySensor(sensorType)
    );

    if (hasSarFamily && hasOtherImaging) {
      return 'Spatial or pixel/Azimuth resolution';
    }

    if (hasSarFamily) {
      return 'Azimuth resolution';
    }

    if (hasOtherImaging) {
      return 'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    }

    return '';
  }

  private updateResolutionColumnMeta(sensorTypes: string[]): void {
    const uniqueSensorTypes = [...new Set(sensorTypes || [])];
    const hasRF = uniqueSensorTypes.includes('RF- comms');
    const hasAIS = uniqueSensorTypes.includes('AIS');
    const hasWeather = uniqueSensorTypes.includes('Weather');
    const imagingResolutionTooltip = this.getImagingResolutionTooltip(uniqueSensorTypes);
    const hasImaging = !!imagingResolutionTooltip;

    const weatherTooltip = 'Grid spatial resolution/ Temporal refresh rate';
    const aisTooltip = 'Signal update frequency';
    const rfTooltip = 'The scope of RF service';

    let heading = 'Resolution';

    if (hasWeather) {
      if (hasImaging) {
        heading = hasRF
          ? 'Resolution/\u00a0Update\u00a0Frequency/\u200BRF\u00a0Service'
          : 'Resolution/\u00a0Update\u00a0Frequency';
      } else if (hasRF) {
        heading = hasAIS
          ? 'RF\u00a0Service/\u200BResolution/\u00a0Update\u00a0Frequency'
          : 'Resolution/\u00a0Update\u00a0Frequency/\u200BRF\u00a0Service';
      } else {
        heading = 'Resolution/\u00a0Update\u00a0Frequency';
      }
    } else if (hasImaging) {
      if (hasRF && hasAIS) {
        heading = 'Resolution/\u200BRF\u00a0Service/\u200BUpdate\u00a0Frequency';
      } else if (hasRF) {
        heading = 'Resolution/\u200BRF\u00a0Service';
      } else if (hasAIS) {
        heading = 'Resolution/\u200BUpdate\u00a0Frequency';
      } else {
        heading = 'Resolution';
      }
    } else if (hasRF) {
      heading = hasAIS ? 'RF\u00a0Service/\u200BUpdate\u00a0Frequency' : 'RF\u00a0Service';
    } else if (hasAIS) {
      heading = 'Update\u00a0Frequency';
    }

    const headingParts = heading.split('/');
    const tooltipParts: string[] = [];
    let weatherAdded = false;
    let aisAdded = false;
    let rfAdded = false;
    let imagingAdded = false;

    headingParts.forEach((part) => {
      const cleanPart = part.replace(/[\u200B\u00a0]/g, ' ').trim();
      if (cleanPart === 'RF Service' && hasRF && !rfAdded) {
        tooltipParts.push(rfTooltip);
        rfAdded = true;
        return;
      }

      if (cleanPart === 'Resolution') {
        if (hasImaging && !imagingAdded) {
          tooltipParts.push(imagingResolutionTooltip);
          imagingAdded = true;
          return;
        }

        if (hasWeather && !weatherAdded) {
          tooltipParts.push(weatherTooltip);
          weatherAdded = true;
          return;
        }
      }

      if (cleanPart === 'Update Frequency') {
        if (hasWeather && hasImaging && !weatherAdded) {
          tooltipParts.push(weatherTooltip);
          weatherAdded = true;
        }

        if (hasAIS && !aisAdded) {
          tooltipParts.push(aisTooltip);
          aisAdded = true;
        }
      }
    });

    this.columnResolution = heading;
    this.resolutionColumnTooltip =
      tooltipParts.join('/') ||
      'Spatial or pixel resolution, depending on ground sample distance (GSD) or re-sampled';
    this.tripleHeader = headingParts.length >= 3;
    this.aisOnly = headingParts.length <= 1;
  }

  onSensorTypeChange(sensor: any, i: number): void {
    this.resetSorting();
    this.handleSensorSelectionChange(sensor);
    this.updateAllComplete(sensor, i, 0);
  }

  onAllSensorTypesChange(checked: boolean): void {
    if (this.isBulkSensorTypesLoading) {
      return;
    }

    if (!Array.isArray(this.SensorsTypes)) {
      this.isAllSensorTypesChecked = false;
      return;
    }
    if (!checked) {
      this.selectedSensorList = []
    }
    this.isBulkSensorTypesLoading = true;

    // Let Angular render the loading state before synchronous bulk processing begins.
    setTimeout(() => {
      try {
        let changedSensor: any = null;
        let changedIndex = -1;

        this.SensorsTypes.forEach((sensor, index) => {
          const isDisabled = this.currentUser?.pointsEligible && sensor?.value === 'AIS';
          if (isDisabled || sensor?.selected === checked) {
            return;
          }

          sensor.selected = checked;

          if (checked && sensor?.name) {
            this.selectedSensorList.push(sensor.name);
          }

          this.selectedSARBandType = 'All';
          this.selectedInSARBandType = 'All';
          this.handleSensorSelectionChange(sensor);

          // Defer heavy rebuild until all sensor type states are updated.
          changedSensor = sensor;
          changedIndex = index;
        });

        // Use type=1 to bypass per-sensor SAR/InSAR band popup when selecting all.
        // Run once after bulk updates to prevent repeated expensive table rebuilds.
        if (changedSensor && changedIndex > -1) {
          this.updateAllComplete(changedSensor, changedIndex, 1);
        }

        this.syncAllSensorTypesCheckbox();
      } finally {
        this.isBulkSensorTypesLoading = false;
      }
    }, 0);
  }

  private syncAllSensorTypesCheckbox(): void {
    if (!Array.isArray(this.SensorsTypes) || !this.SensorsTypes.length) {
      this.isAllSensorTypesChecked = false;
      return;
    }

    const eligibleSensorTypes = this.SensorsTypes.filter(
      (sensor) => !(this.currentUser?.pointsEligible && sensor?.value === 'AIS')
    );

    this.isAllSensorTypesChecked =
      eligibleSensorTypes.length > 0 &&
      eligibleSensorTypes.every((sensor) => sensor?.selected);
  }

  updateAllComplete(e: any, i: number,type: number) {
    this.resetTableDefaults();

    if ((e?.name === 'SAR' || e?.name === 'InSAR') && type == 0) {
      if(e.name === 'SAR') this.selectedSARBandType = null;
      else if (e.name === 'InSAR') this.selectedInSARBandType = null;
    }

    if (e.selected) {
      if ((e?.name === 'SAR' || e?.name === 'InSAR') && type == 0 && this.target.taskStrategy !== "Tip-and-Cue" ) {
          // Dynamically get unique tooltip values for SAR sensors
          let bands = this.SENSORS
          .filter(sensor => sensor.sensortype === e.name && sensor.tooltip) // Get only SAR sensors with tooltip
          .map(sensor => sensor.tooltip) // Extract tooltip values
          .filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates
          .sort((a, b) => a.localeCompare(b)); // Sort alphabetically
          
          if (bands?.length > 1) {
            bands.push("All");
            const dialog = this.dialog.open(OperatorPopupComponent, {
              minWidth: '50%',
              backdropClass: 'blurred',
              disableClose: true,
              data: { bands: bands, sensorType: e.name, type: 'bandFilter'
               },
            });

            dialog.afterClosed().subscribe((result) => {
              if (result != 'close') {
                if(e.name === 'SAR') this.selectedSARBandType = result;
                else if (e.name === 'InSAR') this.selectedInSARBandType = result;
               if (!this.selectedSensorList.includes(e?.name)) {
                 this.selectedSensorList.push(e?.name);
               }
              this.loadSensorDetails(i,e);
              this.syncAllSensorTypesCheckbox();
              } else {
                e.selected = false;
                this.SensorsTypes.forEach((type, index) => {
                  type[i] = false;
                });
                this.syncAllSensorTypesCheckbox();
              }

           });
          } else {
            if (!this.selectedSensorList.includes(e?.name)) {
              this.selectedSensorList.push(e?.name);
            }
            this.loadSensorDetails(i,e);
            this.syncAllSensorTypesCheckbox();
          }
      } else {
        if (!this.selectedSensorList.includes(e?.name)) {
          this.selectedSensorList.push(e?.name);
        }
        this.loadSensorDetails(i,e);
        this.syncAllSensorTypesCheckbox();
      }
    } else {
      const index = this.selectedSensorList.findIndex(
        (selectedItem) => selectedItem === e.name
      );
      this.selectedSensorList.splice(index, 1);
      this.selectedSensors = [];
      this.loadSensorDetails(i,e);

      this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked && operator.key === OPERATORS.LBAND && e.name === 'RF- comms') {          
          this.resetRFData.emit();
        } else if (operator.checked && operator.key === OPERATORS.SPIRE && e.name === 'AIS') {
          this.resetSpireData.emit();
        }
      });
      this.syncAllSensorTypesCheckbox();
    }
  }

  rebuildTable(filteredSensors:any) {
      this.resetTableDefaults();
  
      // let selectedSensorList:any = [];
      // filteredSensors.filter((sensor:any)=>{
      //   selectedSensorList.push(sensor.sensortype);
      // })
      const selectedSensorList: string[] = (filteredSensors || []).reduce(
        (acc: string[], sensor: any) => {
          const sensorType = sensor?.sensortype;
          if (
            typeof sensorType === 'string' &&
            sensorType.length > 0 &&
            !acc.includes(sensorType)
          ) {
            acc.push(sensorType);
          }
          return acc;
        },
        []
      );
  
      if (
        selectedSensorList?.length === 1 &&
        selectedSensorList[0] === 'MSI'
      ) {
        this.nameONA = 'ONA';
        this.onaTooltip =
          'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
      }
  
      if (
        selectedSensorList?.length === 1 &&
        (selectedSensorList.includes('SAR') ||
          selectedSensorList.includes('InSAR'))
      ) {
        this.nameONA = 'Look/Grazing Angle';
        this.onaTooltip =
          'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
          '\n' +
          'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
        this.showColumn = false;
  
        this.displayedColumns = [
          'operator',
          'location',
          'band',
          'preview',
          'sattarcking',
          'mode',
          'resolution',
          'swath',
          'area_calculated',
          'ONA',
          'unitcost',
          'holdback',
          'advance',
          'cost',
          'opportunity',
          'footprint',
          'clientInfo',
          'eula',
        ];
      } else if (
        selectedSensorList?.length === 2 &&
        selectedSensorList.includes('SAR') &&
        selectedSensorList.includes('InSAR')
      ) {
        this.nameONA = 'Look/Grazing Angle';
        this.onaTooltip =
          'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +
          '\n' +
          'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
        this.showColumn = false;
  
        this.displayedColumns = [
          'operator',
          'location',
          'band',
          'preview',
          'sattarcking',
          'mode',
          'resolution',
          'swath',
          'area_calculated',
          'ONA',
          'unitcost',
          'holdback',
          'advance',
          'cost',
          'opportunity',
          'footprint',
          'clientInfo',
          'eula',
        ];
      } else if (
        selectedSensorList.includes('SAR') ||
        selectedSensorList.includes('InSAR')
      ) {
        this.nameONA = 'ONA/Look/Grazing Angle';
        this.onaTooltip = 'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +'\n' +
        'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +'\n' +
        'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
        this.showColumn = true;
            this.displayedColumns = ['operator','location', 'band', 'preview','sattarcking', 'mode', 'resolution', 'swath', 'area_calculated', 'cloudcovers',
              'ONA', 'unitcost', 'holdback', 'advance', 'cost', 'opportunity', 'footprint', 'clientInfo', 'eula'];    
      }
      else {
        this.nameONA = 'ONA';
        this.onaTooltip =
          'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
      }
  
      if (
        (selectedSensorList.includes('Stereo') ||
          selectedSensorList.includes('MSI') || selectedSensorList.includes('HSI') ||
           selectedSensorList.includes('TIR')) &&
        !this.currentUser.allocated 
        && this.hasFeature(VALUE_ADDED_DATA_PRODUCTS)
      ) {
        const modifiedColumns = [...this.displayedColumns];
        const modeIndex = modifiedColumns.indexOf('mode');
        modifiedColumns.splice(modeIndex + 1, 0, 'dem');
        this.displayedColumns = modifiedColumns;
      }
  
  
  
      if (selectedSensorList.includes('SAR')) {
        this.showLooks = true;
        const resolutionIndex = this.displayedColumns.indexOf('resolution');
        if (resolutionIndex !== -1) {
          this.displayedColumns.splice(resolutionIndex + 1, 0, 'looks');
        }
      }

      if (selectedSensorList.includes('RF- comms')) {
        this.lband = true;
        const resolutionIndex = this.displayedColumns.indexOf('resolution');
        if (resolutionIndex !== -1) {
          this.displayedColumns.splice(
            resolutionIndex + 1,
            0,
            'signalOfInterest'
          );
        }
      }

      this.updateResolutionColumnMeta(selectedSensorList);
  
      if (selectedSensorList.includes('HSI')) {
        const modifiedColumns = [...this.displayedColumns];
        const modeIndex = modifiedColumns.indexOf('location');
        modifiedColumns.splice(modeIndex + 1, 0, 'bandOption');
        this.displayedColumns = modifiedColumns;
      }
      
      // this.initializeData();
    }

  loadSensorDetails(i,e) {
    if (
      this.selectedSensorList?.length === 1 &&
      this.selectedSensorList[0] === 'MSI'
    ) {
      this.nameONA = 'ONA';
      this.onaTooltip = 'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
    }

    if (this.target.taskStrategy === 'Tip-and-Cue') {
      this.displayedColumns = this.getBaseDisplayedColumns();
    } else if (
      this.selectedSensorList?.length === 1 &&
      (this.selectedSensorList.includes('SAR') ||
        this.selectedSensorList.includes('InSAR'))
    ) {
      this.nameONA = 'Look/Grazing Angle';
      this.onaTooltip = 'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +'\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = false;
      if (this.target.taskStrategy === 'Tip-and-Cue') {
        this.displayedColumns = [
          'operator',
          'location',
          'band',
          'preview',
          'sattarcking',
          'mode',
          'resolution',
          'swath',
          'area_calculated',
          'ONA',
          'unitcost',
          'holdback',
          'advance',
          'cost',
          'opportunity',
          'footprint',
          'clientInfo',
          'eula',
        ];
      } else {
          this.displayedColumns = ['operator','location', 'band', 'preview','sattarcking', 'mode', 'resolution', 'swath', 'area_calculated',
            'ONA', 'unitcost', 'holdback', 'advance', 'cost', 'opportunity', 'footprint', 'clientInfo', 'eula'];
        }
    } else if (
      this.selectedSensorList?.length === 2 &&
      this.selectedSensorList.includes('SAR') &&
      this.selectedSensorList.includes('InSAR')
    ) {
      this.nameONA = 'Look/Grazing Angle';
      this.onaTooltip = 'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +'\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = false;
      if (this.target.taskStrategy === 'Tip-and-Cue') {
        this.displayedColumns = [
          'operator',
          'location',
          'band',
          'preview',
          'sattarcking',
          'mode',
          'resolution',
          'swath',
          'area_calculated',
          'ONA',
          'unitcost',
          'holdback',
          'advance',
          'cost',
          'opportunity',
          'footprint',
          'clientInfo',
          'eula',
        ];
      } else {
          this.displayedColumns = ['operator', 'location', 'band', 'preview','sattarcking', 'mode', 'resolution', 'swath', 'area_calculated',
            'ONA', 'unitcost', 'holdback', 'advance', 'cost', 'opportunity', 'footprint','clientInfo', 'eula'];
        }
    } else if (
      this.selectedSensorList.includes('SAR') ||
      this.selectedSensorList.includes('InSAR')
    ) {
      this.nameONA = 'ONA/Look/Grazing Angle';
      this.onaTooltip = 'ONA: Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.' +'\n' +
      'Look Angle: The angle between the sensor’s line of sight and the Earth’s surface’s vertical direction (nadir).' +'\n' +
      'Grazing Angle: The angle between the sensor beam’s contact angle and the Earth’s surface.';
      this.showColumn = true;
      if (this.target.taskStrategy === 'Tip-and-Cue') {
        this.displayedColumns = [
          'operator',
          'location',
          'band',
          'preview',
          'sattarcking',
          'mode',
          'resolution',
          'swath',
          'area_calculated',
          'cloudcovers',
          'ONA',
          'unitcost',
          'holdback',
          'advance',
          'cost',
          'opportunity',
          'footprint',
          'clientInfo',
          'eula',
        ];
      } else {
          this.displayedColumns = ['operator','location', 'band', 'preview','sattarcking', 'mode', 'resolution', 'swath', 'area_calculated', 'cloudcovers',
            'ONA', 'unitcost', 'holdback', 'advance', 'cost', 'opportunity', 'footprint', 'clientInfo', 'eula'];
        }
    }  
    else  {
      this.nameONA = 'ONA';
      this.onaTooltip = 'Off Nadir Angle is the degree or range to which the camera onboard a satellite can be tilted while imaging to capture a large area.';
    }

    if(((this.selectedSensorList.includes('Stereo') && this.target.selectedOption !== 1) 
      || this.selectedSensorList.includes('MSI') || this.selectedSensorList.includes('HSI') || this.selectedSensorList.includes('TIR')) 
      && (!this.currentUser.allocated && (this.target?.taskStrategy === 'User Initiated' || this.target?.taskStrategy === 'Sensor Type Based')) && this.hasFeature(VALUE_ADDED_DATA_PRODUCTS)) {
        
      const modifiedColumns = [...this.displayedColumns];
      const modeIndex = modifiedColumns.indexOf('mode');
      modifiedColumns.splice(modeIndex + 1, 0, 'dem');
      this.displayedColumns = modifiedColumns;
    }

    if (this.selectedSensorList.includes('SAR')) {
      this.showLooks = true;
      const resolutionIndex = this.displayedColumns.indexOf('resolution');
      if (resolutionIndex !== -1) {
        this.displayedColumns.splice(resolutionIndex + 1, 0, 'looks');
      }
    }

    if (this.selectedSensorList.includes('RF- comms')) {
      this.lband = true;
      const resolutionIndex = this.displayedColumns.indexOf('resolution');
      if (resolutionIndex !== -1) {
        this.displayedColumns.splice(resolutionIndex + 1, 0, 'signalOfInterest');
      }
    }

    this.updateResolutionColumnMeta(this.selectedSensorList);

    if (this.selectedSensorList.includes('HSI')) {

      const modifiedColumns = [...this.displayedColumns];
      const modeIndex = modifiedColumns.indexOf('location');
      modifiedColumns.splice(modeIndex + 1, 0, 'bandOption');
      this.displayedColumns = modifiedColumns;
    }

    let hasSelectedTypes = false;
    hasSelectedTypes = this.SensorsTypes.some(type => type.selected === true);
    if (this.target?.taskStrategy !== 'Tip-and-Cue' && !hasSelectedTypes) {
      this.isAllSensors = false;
      this.isDailySubdaily = false;
      this.isOpportunitySensors = false;
      this.isObfuscatedSensors = false;
      this.isNightSensor = false;
      this.dataSource = new MatTableDataSource([]);
      this.selectedSensors = [];
      this.AVAILABLESENSORS = [];
      this.warnReactionTimeVsToiForSelectedSensors();
      return;
    }

    this.selectedSensorTypes = '';
    this.FILTEREDSENSORS = [];    

    if (this.target?.taskStrategy === 'Tip-and-Cue') {
      const tippingTypes = new Set(this.tippingSensorTypes || []);
      const cueingTypes = new Set(this.cueingSensorTypes || []);
      const unionTypes = Array.from(new Set([...(this.tippingSensorTypes || []), ...(this.cueingSensorTypes || [])]));
      this.selectedSensorTypes = unionTypes.length ? `${unionTypes.join('/')}/` : '';
      const existKey = (sensor: any) => `${sensor?.sensorId ?? ''}|${sensor?.tabIndex ?? ''}|${sensor?.key ?? ''}|${sensor?.name ?? ''}|${sensor?.sensortype ?? ''}`;
      const existing = new Set<string>();

      this.SENSORS.forEach((sensor) => {
        const tabIndex = sensor?.tabIndex;
        const typeSelected =
          (tabIndex === 0 && tippingTypes.has(sensor?.sensortype)) ||
          (tabIndex === 1 && cueingTypes.has(sensor?.sensortype));
        if (!typeSelected) return;

        // Apply extra filter if SAR or InSAR
        if (
          (sensor?.sensortype === 'SAR' && this.selectedSARBandType && this.selectedSARBandType !== 'All' && this.selectedSARBandType !== sensor?.tooltip) ||
          (sensor?.sensortype === 'InSAR' && this.selectedInSARBandType && this.selectedInSARBandType !== 'All' && this.selectedInSARBandType !== sensor?.tooltip)
        ) {
          return;
        }

        const key = existKey(sensor);
        if (existing.has(key)) return;
        existing.add(key);

        if (this.isAllSensors) {
          if (!sensor.enabled) {
            this.FILTEREDSENSORS.push(sensor);
          }
        } else if (this.isDailySubdaily) {
          if (sensor.high_cadence) {
            this.FILTEREDSENSORS.push(sensor);
          }
        } else {
          if (sensor.enabled) {
            this.FILTEREDSENSORS.push(sensor);
          }
        }
      });
    } else {
    this.SensorsTypes.forEach((type, index) => {      
      if (this.SensorsTypes[index].selected === true  || !hasSelectedTypes) {
          !hasSelectedTypes ? (this.selectedSensorTypes = '') : (this.selectedSensorTypes += type.value + '/');
        this.SensorsTypes[i].selected = e.selected;
        this.SENSORS.forEach((sensor) => {          
            if ((type.value === sensor.sensortype || !hasSelectedTypes) && (sensor?.tabIndex === undefined || sensor.tabIndex === this.selectedTabIndex)) {
            // Apply extra filter if SAR or InSAR
              if (
                (type.value === 'SAR' && this.selectedSARBandType && this.selectedSARBandType !== 'All' && this.selectedSARBandType !== sensor?.tooltip) ||
                (type.value === 'InSAR' && this.selectedInSARBandType && this.selectedInSARBandType !== 'All' && this.selectedInSARBandType !== sensor?.tooltip)
              ) {
              return; // Skip this sensor if the selected band doesn't match the tooltip
            }

            const existId = this.FILTEREDSENSORS.findIndex(
              (ele) => JSON.stringify(ele) === JSON.stringify(sensor)
            );
            if (existId === -1) {
              if (this.isAllSensors) {
                  if (!sensor.enabled) {
                this.FILTEREDSENSORS.push(sensor);
                }
                } else if (this.isDailySubdaily) {
                  if (sensor.high_cadence) {
                this.FILTEREDSENSORS.push(sensor);
                }
              }else if (this.isOpportunitySensors) {
                if(sensor.feasibility){
                this.FILTEREDSENSORS.push(sensor);
                }
              }else if (this.isObfuscatedSensors) {
                if(sensor.isObfuscated){
                this.FILTEREDSENSORS.push(sensor);
                }
              }else if (this.isNightSensor) {
                if(sensor.nightvision){
                this.FILTEREDSENSORS.push(sensor);
                }
              } else {
                  if (sensor.enabled) {
                  this.FILTEREDSENSORS.push(sensor);
              }
            }
          }
            }
        });
      }
    });
    }

    this.initializeData();
    if (!e.selected) {
      let AVAILABLESENSORSFilter;

      if (this.target.taskStrategy === 'Tip-and-Cue') {
        let tab1Sensors = this.AVAILABLESENSORS.filter(sensor => sensor.tabIndex === 0);
        let tab2Sensors = this.AVAILABLESENSORS.filter(sensor => sensor.tabIndex === 1);

        if (this.selectedTabIndex === 0) {          
          tab1Sensors = tab1Sensors.filter(
          (el) => (e.value !== el.sensortype )
          );
          this.selectedTippingSensors = this.selectedTippingSensors.filter(
          (el) => (e.value !== el.sensortype )
          );
        } else {
          tab2Sensors = tab2Sensors.filter(
          (el) => (e.value !== el.sensortype)
          );
          this.selectedCueingSensors = this.selectedCueingSensors.filter(
          (el) => (e.value !== el.sensortype )
          );
        }
        
        this.selectedSensors = [
          ...this.selectedTippingSensors,
          ...this.selectedCueingSensors,
        ];
        
        const combinedSensors = [...tab1Sensors, ...tab2Sensors];
        AVAILABLESENSORSFilter = combinedSensors;
      } else {
        AVAILABLESENSORSFilter = this.AVAILABLESENSORS.filter(
        (el) => this.isAllSensors && el.enabled === false ? el : this.isDailySubdaily && el.high_cadence === true ? el : this.isOpportunitySensors && el.feasibility === true ? el : this.isObfuscatedSensors && el.isObfuscated === true ? el : e.value !== el.sensortype
      );
      }
      this.selectedSensorList.length == 0 ? this.rebuildTable(AVAILABLESENSORSFilter) : '';
      this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.dataSource.sort = this.sort;
      this.showSwath = this.AVAILABLESENSORS.some((s) =>
        s.collection_mode?.some((m) => m.swathWidth)
      );
    }
    else{
      this.selectedSensors = [];
      this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
    }

    // In Tip-and-Cue workflow, FILTEREDSENSORS is not the source for the table,
    // so do not clear the table based on FILTEREDSENSORS being empty.
    if (this.target?.taskStrategy !== 'Tip-and-Cue') {
    if (this.FILTEREDSENSORS.length === 0) {
      this.dataSource = undefined;

      // this.dataSource = new MatTableDataSource([]);
    } else {
      this.FILTEREDSENSORS.sort(function (a, b) {
        return -(a.enabled - b.enabled);
      });
    }
    }
    this.clickHandler();
  }

  private setExclusiveCapabilityToggle(activeToggle: 'night' | 'dailySubdaily' | 'upcoming' | 'opportunity' | 'obfuscated' | null): void {
    this.isNightSensor = activeToggle === 'night';
    this.isDailySubdaily = activeToggle === 'dailySubdaily';
    this.isAllSensors = activeToggle === 'upcoming';
    this.isOpportunitySensors = activeToggle === 'opportunity';
    this.isObfuscatedSensors = activeToggle === 'obfuscated';
  }

  toggleAll() {
    if (this.isAllSensors) {
      this.setExclusiveCapabilityToggle('upcoming');
    }

    this.FILTEREDSENSORS = [];
    this.AVAILABLESENSORS = [];
    this.selectedSensors = [];

    let hasSelectedTypes = false;
    hasSelectedTypes = this.SensorsTypes.some(type => type.selected === true);

    if(!this.isAllSensors && !hasSelectedTypes){
      this.dataSource = new MatTableDataSource([]);
      this.selectedSensors = [];
      this.warnReactionTimeVsToiForSelectedSensors();
      return;
    }
    this.SensorsTypes.forEach((type, index) => {
      if (this.SensorsTypes[index].selected === true || !hasSelectedTypes) {
        !hasSelectedTypes ? this.selectedSensorTypes = '' : this.selectedSensorTypes += type.value + '/';
        this.SENSORS.forEach((sensor) => {
          if (type.value === sensor.sensortype || !hasSelectedTypes) {
            if ((type.value === 'SAR' && this.selectedSARBandType && this.selectedSARBandType !== 'All' && this.selectedSARBandType !== sensor?.tooltip) 
              || (type.value === 'InSAR' && this.selectedInSARBandType && this.selectedInSARBandType !== 'All' && this.selectedInSARBandType !== sensor?.tooltip)) {
              return; // Skip this sensor if the selected band doesn't match the tooltip
            }

            if (!this.isAllSensors) {
              if (sensor.sensortype === 'MSI' && sensor.enabled) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.sensortype != 'MSI' && sensor.enabled)
                this.FILTEREDSENSORS.push(sensor);
            } else {
              if (
                sensor.sensortype === 'MSI' &&
                !sensor.enabled
              ) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (!sensor.enabled && sensor.sensortype != 'MSI')
                this.FILTEREDSENSORS.push(sensor);
            }
          }
        });
      }
    });
    this.FILTEREDSENSORS.sort(function (a, b) {
      return -(a.enabled - b.enabled);
    });
    this.initializeData();
    if (this.isAllSensors) {
      const AVAILABLESENSORSFilter = this.AVAILABLESENSORS.filter(
        (el) => el.enabled === false
      );
      this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.dataSource.sort = this.sort;
    }
  }

  toggleDailySubdaily(){
    if (this.isDailySubdaily) {
      this.setExclusiveCapabilityToggle('dailySubdaily');
    }

    this.FILTEREDSENSORS = [];
    // this.AVAILABLESENSORS = [];
    this.selectedSensors = [];

    let hasSelectedTypes = false;
    hasSelectedTypes = this.SensorsTypes.some(type => type.selected === true);

    if(!this.isDailySubdaily && !hasSelectedTypes){
      this.dataSource = new MatTableDataSource([]);
      this.AVAILABLESENSORS = [];
      // this.selectedSensors = [];
      this.warnReactionTimeVsToiForSelectedSensors();
      return;
    }
    this.SensorsTypes.forEach((type, index) => {
      if (this.SensorsTypes[index].selected === true || !hasSelectedTypes) {
        !hasSelectedTypes ? this.selectedSensorTypes = '' : this.selectedSensorTypes += type.value + '/';
        this.SENSORS.forEach((sensor) => {
          if (type.value === sensor.sensortype || !hasSelectedTypes) {
            if ((type.value === 'SAR' && this.selectedSARBandType && this.selectedSARBandType !== 'All' && this.selectedSARBandType !== sensor?.tooltip) 
              || (type.value === 'InSAR' && this.selectedInSARBandType && this.selectedInSARBandType !== 'All' && this.selectedInSARBandType !== sensor?.tooltip)) {
              return; // Skip this sensor if the selected band doesn't match the tooltip
            }

            if (!this.isDailySubdaily) {
              if (sensor.sensortype === 'MSI' && sensor.enabled) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.sensortype != 'MSI' && sensor.enabled)
                this.FILTEREDSENSORS.push(sensor);
            } else {
              if (
                sensor.sensortype === 'MSI' &&
                sensor.high_cadence
              ) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.high_cadence && sensor.sensortype != 'MSI')
                this.FILTEREDSENSORS.push(sensor);
            }
          }
        });
      }
    });
    this.FILTEREDSENSORS.sort(function (a, b) {
      return -(a.enabled - b.enabled);
    });
    this.initializeData();
    if (this.isDailySubdaily) {
      this.selectedSensors = [];
      const AVAILABLESENSORSFilter = this.AVAILABLESENSORS.filter(
        (el) => el.high_cadence === true
      );
      this.rebuildTable(AVAILABLESENSORSFilter);
      this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
       this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.dataSource.sort = this.sort;
    }
    else{
      this.selectedSensors = [];
      // this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
       this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
    }
  }
  
  toggleOpportunitySensors(){
    if (this.isOpportunitySensors) {
      this.setExclusiveCapabilityToggle('opportunity');
    }

    this.FILTEREDSENSORS = [];
    this.selectedSensors = [];

    let hasSelectedTypes = false;
    hasSelectedTypes = this.SensorsTypes.some(type => type.selected === true);

    if(!this.isOpportunitySensors && !hasSelectedTypes){
      this.dataSource = new MatTableDataSource([]);
      this.AVAILABLESENSORS = [];
      return;
    }
    this.SensorsTypes.forEach((type, index) => {
      if (this.SensorsTypes[index].selected === true || !hasSelectedTypes) {
        !hasSelectedTypes ? this.selectedSensorTypes = '' : this.selectedSensorTypes += type.value + '/';
        this.SENSORS.forEach((sensor) => {
          if (type.value === sensor.sensortype || !hasSelectedTypes) {
            if ((type.value === 'SAR' && this.selectedSARBandType && this.selectedSARBandType !== 'All' && this.selectedSARBandType !== sensor?.tooltip) 
              || (type.value === 'InSAR' && this.selectedInSARBandType && this.selectedInSARBandType !== 'All' && this.selectedInSARBandType !== sensor?.tooltip)) {
              return; // Skip this sensor if the selected band doesn't match the tooltip
            }

            if (!this.isOpportunitySensors) {
              if (sensor.sensortype === 'MSI' && sensor.enabled) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.sensortype != 'MSI' && sensor.enabled)
                this.FILTEREDSENSORS.push(sensor);
            } else {
              if (
                sensor.sensortype === 'MSI' &&
                sensor.feasibility
              ) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.feasibility && sensor.sensortype != 'MSI')
                this.FILTEREDSENSORS.push(sensor);
            }
          }
        });
      }
    });
    this.FILTEREDSENSORS.sort(function (a, b) {
      return -(a.enabled - b.enabled);
    });
    this.initializeData();
    
    if (this.isOpportunitySensors) {
      this.selectedSensors = [];
      const AVAILABLESENSORSFilter = this.AVAILABLESENSORS.filter(
        (el) => el.feasibility === true
      );
      this.rebuildTable(AVAILABLESENSORSFilter);
      this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
       this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.dataSource.sort = this.sort;
    }
    else{
      this.selectedSensors = [];
       this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
    }
  }

  toggleObfuscatedSensors(){
    if (this.isObfuscatedSensors) {
      this.setExclusiveCapabilityToggle('obfuscated');
    }

    this.FILTEREDSENSORS = [];
    this.selectedSensors = [];

    let hasSelectedTypes = false;
    hasSelectedTypes = this.SensorsTypes.some(type => type.selected === true);

    if(!this.isObfuscatedSensors && !hasSelectedTypes){
      this.dataSource = new MatTableDataSource([]);
      this.AVAILABLESENSORS = [];
      return;
    }
    this.SensorsTypes.forEach((type, index) => {
      if (this.SensorsTypes[index].selected === true || !hasSelectedTypes) {
        !hasSelectedTypes ? this.selectedSensorTypes = '' : this.selectedSensorTypes += type.value + '/';
        this.SENSORS.forEach((sensor) => {
          if (type.value === sensor.sensortype || !hasSelectedTypes) {
            if ((type.value === 'SAR' && this.selectedSARBandType && this.selectedSARBandType !== 'All' && this.selectedSARBandType !== sensor?.tooltip) 
              || (type.value === 'InSAR' && this.selectedInSARBandType && this.selectedInSARBandType !== 'All' && this.selectedInSARBandType !== sensor?.tooltip)) {
              return; // Skip this sensor if the selected band doesn't match the tooltip
            }

            if (!this.isObfuscatedSensors) {
              if (sensor.sensortype === 'MSI' && sensor.enabled) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.sensortype != 'MSI' && sensor.enabled)
                this.FILTEREDSENSORS.push(sensor);
            } else {
              if (
                sensor.sensortype === 'MSI' &&
                sensor.isObfuscated
              ) {
                this.FILTEREDSENSORS.push(sensor);
              } else if (sensor.isObfuscated && sensor.sensortype != 'MSI')
                this.FILTEREDSENSORS.push(sensor);
            }
          }
        });
      }
    });
    this.FILTEREDSENSORS.sort(function (a, b) {
      return -(a.enabled - b.enabled);
    });
    this.initializeData();
    if (this.isObfuscatedSensors) {
      this.selectedSensors = [];
      const AVAILABLESENSORSFilter = this.AVAILABLESENSORS.filter(
        (el) => el.isObfuscated === true
      );
      this.rebuildTable(AVAILABLESENSORSFilter);
      this.AVAILABLESENSORS = AVAILABLESENSORSFilter;
       this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      this.dataSource.sort = this.sort;
    }
    else{
      this.selectedSensors = [];
       this.AVAILABLESENSORS.forEach((operator) => {
        if (operator.checked) this.selectedSensors.push(operator);
      });
    }
  }

  toggleNightSensors() {
    if (this.isNightSensor) {
      this.setExclusiveCapabilityToggle('night');
    }

    this.resetSorting();
    this.FILTEREDSENSORS = [];
    // this.AVAILABLESENSORS = [];
    this.selectedSensors = [];
    this.selectedSensorList = [];
    this.selectedSensorTypes = '';

    let hasSelectedTypes = false;
    hasSelectedTypes = this.SensorsTypes.some((type) => type.selected === true);

    this.SensorsTypes.forEach((type, index) => {
      const isDisabled = this.currentUser?.pointsEligible && type?.value === 'AIS';
      if (isDisabled) {
        return;
      }

      if (this.SensorsTypes[index].selected === true || !hasSelectedTypes) {
        this.selectedSensorTypes += type.value + '/';
        if (type?.name && !this.selectedSensorList.includes(type.name)) {
          this.selectedSensorList.push(type.name);
        }

        this.SENSORS.forEach((sensor) => {
          const matchesSensorType = type.value === sensor.sensortype;
          const matchesNightFilter = this.isNightSensor ? !!sensor.nightvision : sensor.enabled;

          if (matchesSensorType && matchesNightFilter) {
            if (
              (type.value === 'SAR' &&
                this.selectedSARBandType &&
                this.selectedSARBandType !== 'All' &&
                this.selectedSARBandType !== sensor?.tooltip) ||
              (type.value === 'InSAR' &&
                this.selectedInSARBandType &&
                this.selectedInSARBandType !== 'All' &&
                this.selectedInSARBandType !== sensor?.tooltip)
            ) {
              return;
            }

            this.FILTEREDSENSORS.push(sensor);
          }
        });
      }
    });

    if (!this.FILTEREDSENSORS.length) {
      this.dataSource = new MatTableDataSource([]);
      this.warnReactionTimeVsToiForSelectedSensors();
      return;
    }

    this.FILTEREDSENSORS.sort(function (a, b) {
      return -(a.enabled - b.enabled);
    });

    this.syncAllSensorTypesCheckbox();
    this.initializeData();
    this.clickHandler();
  }

  async ccChange(cCover: any, indx: number, row: any) {
    if (cCover) {
      const ccFactor = this.AVAILABLESENSORS[indx]?.cloudnew[cCover];
      this.cloudFactor = ccFactor;
      this.AVAILABLESENSORS[indx].selectedCC = cCover;
      this.AVAILABLESENSORS[indx].cloudFactor = ccFactor;
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
      );

      if (idx > -1) {
        this.calculateUnitcost(indx,idx);
      }
    }
  }

  async ONAOption(cCover: any, indx: number, row: any, type: any) {
    if(cCover) {
      if (type === 1 && row?.key === OPERATORS.CAPELLA && cCover?.category !== 'custom') {
        this.restoreCustomLookAngle(this.AVAILABLESENSORS[indx]);
      }
      if(!cCover?.key){
        cCover.key =cCover.ona? cCover.ona:cCover.key;
        cCover.value =cCover.value? cCover.value:cCover.onaUplift;
      }
      if(cCover?.ona && type === 1){
       if( this.AVAILABLESENSORS[indx].resolution.length<2 ){
      
        let newResoution:any= {key:"0",value:cCover.resolution,originalResolution :cCover.forResolution}
        if (row?.key !== OPERATORS.GEOSAT) {
          newResoution.bands = cCover?.bands ?? this.AVAILABLESENSORS[indx].resolution[0]?.bands;
        }
        if(cCover?.mode_value){
          newResoution.mode_value= cCover?.mode_value;
        }
        this.AVAILABLESENSORS[indx].resolution =[newResoution] 
        this.AVAILABLESENSORS[indx].selectedResolution =newResoution
             
         }
         if( this.AVAILABLESENSORS[indx].resolution.length>1){

          const resolutionArray = this.createResolutionArray(this.AVAILABLESENSORS[indx]?.onaWithResolution,  cCover?.ona,this.AVAILABLESENSORS[indx].resolution, this.AVAILABLESENSORS[indx].key);
          this.AVAILABLESENSORS[indx].resolution=resolutionArray;
          this.AVAILABLESENSORS[indx].selectedResolution =resolutionArray[0];
          this.AVAILABLESENSORS[indx].selectedResolutionValue =resolutionArray[0]?.value;
            if (row?.key !== OPERATORS.GEOSAT) {
              this.AVAILABLESENSORS[indx].modeResetValue =null;
              this.AVAILABLESENSORS[indx].selectedModes = [row?.collection_mode[0]];
              this.AVAILABLESENSORS[indx].modeSelected = [row?.collection_mode[0]];
            }

          if ((row?.key === OPERATORS.STE && row?.sensor === 'MSI')) {
            this.resetCost(row,this.AVAILABLESENSORS[indx].selectedResolution,indx);
          }
        }
       
      }
     
      const ccFactor = cCover.value;
      this.ONAFactor = ccFactor;
      this.AVAILABLESENSORS[indx].selectedONA = cCover.ona? cCover.ona:cCover.key;
      this.AVAILABLESENSORS[indx].selectedONAOption = cCover;
      this.AVAILABLESENSORS[indx].ONAFactor = ccFactor;
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
      );

      if (idx > -1) {
        this.calculateUnitcost(indx,idx);
      }
    }

    if ((row.key === OPERATORS.HEAD) || row.key === OPERATORS.GOKTURK || (row.key === OPERATORS.AT21) || row?.key === OPERATORS.GHG || row?.key === OPERATORS.ECURS || row?.key === OPERATORS.ECURS_L || row?.key === OPERATORS.GEOSAT) {
      this.resetResolution(this.AVAILABLESENSORS[indx].selectedModes[0],indx,row?.key);
    }

    this.syncSensorTooltip(indx);
  }

  async modeChange(cMode: any, indx: number, row: any) {
    const cmFactor = this.SENSORS[indx].collectmodes[cMode];
    this.selctedCollectMode[indx] = cMode;
    const idx = this.SENSORS[indx].latency.findIndex(
      (elem) => elem.cost === this.SENSORS[indx].selectedCost
    );
    this.SENSORS[indx].latency[0].cost = Math.round(
      cmFactor * this.SENSORS[indx].defaultLatency[0].cost
    );
    this.SENSORS[indx].latency[1].cost = Math.round(
      cmFactor * this.SENSORS[indx].defaultLatency[1].cost
    );
    this.SENSORS[indx].latency[2].cost = Math.round(
      cmFactor * this.SENSORS[indx].defaultLatency[2].cost
    );

    if (idx > -1) {
      this.SENSORS[indx].selectedCost = Math.round(
        this.SENSORS[indx].latency[idx].cost
      );
    }

    this.SENSORS[indx].cost = parseInt(
      this.SENSORS[indx].selectedCost.toString()
    );
    this.SENSORS[indx].checked = true;
    await this.getTotalCost(true, indx, row);
  }
  async toggleSelect(checked: boolean) {
    this.SENSORS.forEach((sensor, indx) => {
      if (sensor.enabled) {
        this.SENSORS[indx].checked = checked;
      }
    });
  }
  async taskingOption(latency: any, rowIndx: number, row: any, type: number, userClick : boolean = false) {
    if (userClick){
      row.isUserSelection = true;
      this.AVAILABLESENSORS[rowIndx].selectedTaskingTier = true;
    }      
    if(row?.latency) {
    // Don't clear validation-driven disablement during automatic initialization.
    // Only allow clearing `prevent` when the user explicitly clicks a tier.
    if (userClick && this.AVAILABLESENSORS[rowIndx].prevent === true) {
      this.AVAILABLESENSORS[rowIndx].prevent = false;
      this.AVAILABLESENSORS[rowIndx].checked = false;
    }
    const latencyFilter = row?.latency.filter((el: any) => el.name === latency);
    const latencyKey = latencyFilter?.[0];
    if (!latencyKey) return;

    if (
      row?.key === OPERATORS.AT21 &&
      userClick &&
      row?.checked
    ) {
      const shouldProceed = await this.shouldProceedWithAt21TierWarning(
        row,
        latencyKey
      );

      if (!shouldProceed) {
        this.AVAILABLESENSORS[rowIndx].blockedAt21TierSelection = latency;
        this.AVAILABLESENSORS[rowIndx].selectedTaskingTierPrefrence =
          this.AVAILABLESENSORS[rowIndx].selectedLatency;
        return;
      }

      this.AVAILABLESENSORS[rowIndx].blockedAt21TierSelection = null;
    }

    const startDate: any = new Date(
      moment(this.target.openWindow).utc().format()
    );
    const endDate: any = new Date(
      moment(this.target.closeWindow).utc().format()
    );
    const start = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    const end = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );
    const differenceInTime: number = endDate.getTime() - startDate.getTime();
    const differenceInDays: number = Math.floor(
      differenceInTime / (1000 * 60 * 60 * 24)
    );
    const utcTime = moment.utc().format('YYYY-MM-DD HH:mm:ss');
    const timeDiffrence: any =
      (startDate.getTime() - new Date(utcTime).getTime()) / 3600 / 1000;

    if (userClick && this.isRowSelectedForReactionToiWarning(row)) {
      this.warnReactionTimeVsToiForSelectedSensors(row, latencyKey);
    }

    if (
      latencyKey.key === 'rush' ||
      latencyKey.key === 'RR' ||
      latencyKey.key === 'emergency' ||
      (latencyKey.key === 'priority' && (row?.key === OPERATORS.STE && row.sensor != 'SAR'))
    ) {
      this.AVAILABLESENSORS[rowIndx].rushCloudCover = true;
      this.AVAILABLESENSORS[rowIndx].selectedCC = '';
    }
    else {
      if (this.AVAILABLESENSORS[rowIndx]?.cloudcovers) {
        this.AVAILABLESENSORS[rowIndx].selectedCC = this.AVAILABLESENSORS[rowIndx]?.cloudcovers[0]?.key;
        this.AVAILABLESENSORS[rowIndx].cloudValue = null;
      }
      this.AVAILABLESENSORS[rowIndx].rushCloudCover = false;
      this.ccChange(this.AVAILABLESENSORS[rowIndx].selectedCC, rowIndx, 'row');
    }

    if (latencyKey.key === 'priority' && row.key === OPERATORS.BLACKSKY) {
      this.AVAILABLESENSORS[rowIndx].selectedCC = '100%';
      this.AVAILABLESENSORS[rowIndx].cloudValue = null;
    } else if (latencyKey.key != 'standard' && type != 0 && (row.key === OPERATORS.STE && row.sensor === 'MSI')) {
      this.AVAILABLESENSORS[rowIndx].selectedCC = this.AVAILABLESENSORS[rowIndx]?.cloudcovers[4]?.key;
      this.AVAILABLESENSORS[rowIndx].cloudValue = null;
    }

    if (this.FILTEREDSENSORS[rowIndx]?.checked)
      this.FILTEREDSENSORS[rowIndx].checked = true;
    this.AVAILABLESENSORS[rowIndx].selectedLatency = latency;
    this.AVAILABLESENSORS[rowIndx].selectedLatencyKey = latencyKey;
    this.AVAILABLESENSORS[rowIndx].latency.forEach((elem, i) => {
      if (elem.name === latency) {
        this.AVAILABLESENSORS[rowIndx].cost =
          this.AVAILABLESENSORS[rowIndx].latency[i].unitcost;
        this.AVAILABLESENSORS[rowIndx].unitcost =
          this.AVAILABLESENSORS[rowIndx].latency[i].unitcost;
        //if(this.AVAILABLESENSORS[rowIndx].key !== OPERATORS.SPIRE) {
        this.AVAILABLESENSORS[rowIndx].selectedCost =
          this.AVAILABLESENSORS[rowIndx].latency[i].unitcost;
        //}
        this.AVAILABLESENSORS[rowIndx].latency[i].selected = true;
      } else this.AVAILABLESENSORS[rowIndx].latency[i].selected = false;
    });

    if (row?.key === OPERATORS.WYVERN) {
      this.AVAILABLESENSORS[rowIndx].selectedHoldBackOption =
        row?.holdback.filter(
          (value) => value.type === row.selectedLatencyKey.key
        )[0];
      this.AVAILABLESENSORS[rowIndx].holdBackValue = null;
      for (const [index, item] of row.latency.entries()) {
        let key = this.target?.intent?.intent_key + '_' + item.key;
        if (row?.pricing.hasOwnProperty(key)) {
          item.cost = row.pricing[key];
          item.unitcost = row.pricing[key];
        }
      }
      this.AVAILABLESENSORS[rowIndx].latency = row.latency;
      if (latencyKey.key === 'priority')
        this.AVAILABLESENSORS[rowIndx].minarea = 50;
      else this.AVAILABLESENSORS[rowIndx].minarea = 100;
    }

    this.holdBackOption(
      this.AVAILABLESENSORS[rowIndx].selectedHoldBackOption,
      rowIndx,
      row
    );
    this.ONAOption(
      this.AVAILABLESENSORS[rowIndx].selectedONAOption,
      rowIndx,
      row,
      0
    );

    const idx = this.AVAILABLESENSORS[rowIndx].latency.findIndex(
      (elem) => elem.name === this.AVAILABLESENSORS[rowIndx].selectedLatency
    );

    if (idx > -1) {
      this.calculateUnitcost(rowIndx,idx);
    }

    if (row?.key === OPERATORS.CAPELLA && differenceInDays < 1 && row.selectedLatencyKey.key === 'rush' && type === 0) {
      const message = `${row?.displayName} ${row?.sensor} requires a minimum one day window for rush tasking. Any lesser, it may be rejected. Please provide a minimum of one day time of interest (TOI).`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    }

    else if (row?.key === OPERATORS.CAPELLA && differenceInDays < 7 && row.selectedLatencyKey.key === 'standard' && type === 0) {
      const message = `${row?.displayName} ${row?.sensor} requires a minimum seven day window for standard tasking. Any lesser, it may be rejected. Please provide a minimum of seven day time of interest (TOI).`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    }

    else if (row?.key === OPERATORS.CAPELLA && differenceInDays < 3 && row.selectedLatencyKey.key === 'priority' && type === 0) {
      const message = `${row?.displayName} ${row?.sensor} requires a minimum three day window for priority tasking. Any lesser, it may be rejected. Please provide a minimum of three day time of interest (TOI).`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    }

    else if (row?.key === OPERATORS.USL && this.target.area > 0 && timeDiffrence < 48 && row?.selectedTaskingTierPrefrence == 'standard' && row?.sensorSelected) {
      const toiMessage = `The time of interest (TOI) start is within 48 hrs of the submission time. This is marginal for the standard tasking tier. There is a risk of rejection by the operator. Please increase the lead time, if possible.`;
      const toiDialogRef = this.popupService.openPopup(WarningPopup, toiMessage, '', '50%');
    }

  }
  }

  async holdBackOption(cCover: any, indx: number, row: any) {
    if (cCover) {
      const ccFactor = cCover?.value;
      this.holdBack = ccFactor;
      this.AVAILABLESENSORS[indx].selectedHoldBack = cCover?.key;
      this.AVAILABLESENSORS[indx].selectedHoldBackOption = cCover;
      this.AVAILABLESENSORS[indx].ccFactor = ccFactor;
      this.AVAILABLESENSORS[indx].holdbackFactor = ccFactor;
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
      );

      if (idx > -1) {
        this.calculateUnitcost(indx,idx);
      }
    }
  }

  async modeOption(productMode: any, indx: number, row: any) {
    row.valueAddedOption = [];
    row.indices = [];
    if (row?.key === OPERATORS.CAPELLA) {
      let mode = CAPELLA_MODES[productMode?.mode_type];
      if (this.AVAILABLESENSORS[indx].prevent === true) {
        this.AVAILABLESENSORS[indx].prevent = false;
        this.AVAILABLESENSORS[indx].checked = false;
      }

      if (row.tabIndex !== 1 && this.getArea(row, 'AOI') > 0 && mode === 'POI'
      ) {
        const message = `${row?.displayName} ${row?.sensor} has different modes of collection based on whether the location
        is an area of interest (AOI) or point of interest (POI). Stripmap_100 is used for AOI,
        and all the other modes are used for POI.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
          dialogRef.afterClosed().subscribe(() => {
            this.AVAILABLESENSORS.forEach((operator, idx) => {
              if (idx === indx) {
              this.AVAILABLESENSORS[idx].checked = false;
              this.selectedSensors = [];
              this.AVAILABLESENSORS.forEach((operator, idx) => {
                if (operator.checked) {
                  this.selectedSensors.push(operator);
                }
              });
              this.clickHandler();
            }
          });
        });
      } else if (row.tabIndex !== 1 && this.getArea(row, 'POI') === 0 && mode === 'AOI'
      ) {
        const message = `${row?.displayName} ${row?.sensor} has different modes of collection based on whether the location
        is an area of interest (AOI) or point of interest (POI). Stripmap_100 is used for AOI,
        and all the other modes are used for POI.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
        dialogRef.afterClosed().subscribe(() => {
          this.AVAILABLESENSORS.forEach((operator, idx) => {
            if (idx === indx) {
              this.AVAILABLESENSORS[idx].checked = false;
        this.selectedSensors = [];
        this.AVAILABLESENSORS.forEach((operator) => {
          if (operator.checked) this.selectedSensors.push(operator);
        });
        this.clickHandler();
          }
        });
        });
      }
      if((this.isCueing || row.tabIndex === 1)  && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation) && row?.sensorSelected) {
        let minArea = this.getMinimumArea(row);
        await this.getCueingTarget(row,minArea,'mode');
      }
    }

    if (row?.key === OPERATORS.GHG) {
      if (this.AVAILABLESENSORS[indx].prevent === true) {
        this.AVAILABLESENSORS[indx].prevent = false;
        this.AVAILABLESENSORS[indx].checked = false;
      }

      this.checkTargetLocation().then(result => {
        switch (result) {
          case 'water':
            if (productMode.productLevel.includes('Onshore')) {
              this.AVAILABLESENSORS.forEach((operator, idx) => {
                if (idx === indx) {
                  this.AVAILABLESENSORS[idx].checked = false;
                  this.AVAILABLESENSORS[idx].prevent = true;
                }
              });

              const message = `${row?.displayName} ${row?.sensor} has different products based on whether the tasked area is over open waters or land. 
              Please change your product choice or change the location of your task.`;
              this.popupService.openPopup(WarningPopup, message, '', '50%');

              this.selectedSensors = [];
              this.AVAILABLESENSORS.forEach((operator) => {
                if (operator.checked) this.selectedSensors.push(operator);
              });
              this.clickHandler();
            }
            break;
          case 'land':
            if (productMode.productLevel.includes('Offshore')) {
              this.AVAILABLESENSORS.forEach((operator, idx) => {
                if (idx === indx) {
                  this.AVAILABLESENSORS[idx].checked = false;
                  this.AVAILABLESENSORS[idx].prevent = true;
                }
              });

              const message = `${row?.displayName} ${row?.sensor} has different products based on whether the tasked area is over open waters or land. 
              Please change your product choice or change the location of your task.`;
              this.popupService.openPopup(WarningPopup, message, '', '50%');

              this.selectedSensors = [];
              this.AVAILABLESENSORS.forEach((operator) => {
                if (operator.checked) this.selectedSensors.push(operator);
              });
              this.clickHandler();
            }
            break;
          case 'both':
            this.AVAILABLESENSORS.forEach((operator, idx) => {
              if (idx === indx) {
                this.AVAILABLESENSORS[idx].checked = false;
                this.AVAILABLESENSORS[idx].prevent = true;
              }
            });

            const message = `${row?.displayName} ${row?.sensor} has different products based on whether the tasked area is over open waters or land. 
            Please change your product choice or change the location of your task.`;
            this.popupService.openPopup(WarningPopup, message, '', '50%');

            this.selectedSensors = [];
            this.AVAILABLESENSORS.forEach((operator) => {
              if (operator.checked) this.selectedSensors.push(operator);
            });
            this.clickHandler();
            break;
          default:
            console.error('Unexpected result:', result);
        }
      });
    }

    this.resolutionTooltip = true;
    this.AVAILABLESENSORS[indx].selectedModes = [];
    if (productMode?.isCaptureMode && !productMode?.isProductLevel) {
      this.AVAILABLESENSORS[indx].selectedMode = productMode.captureMode;
    } else if (productMode?.isProductLevel && !productMode?.isCaptureMode) {
      this.AVAILABLESENSORS[indx].selectedMode = productMode.productLevel;
    } else if (productMode?.isProductLevel && productMode?.isCaptureMode) {
      this.AVAILABLESENSORS[indx].selectedMode =
        productMode.captureMode + ' (' + productMode.productLevel + ')';
    }

    if (
      row?.key === OPERATORS.AT21
    ) {
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (productMode?.productLevel === 'L1') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Bundle')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
          } else {
            items.disable = true;
          }
        }
      } else if (
        productMode?.productLevel === 'L4'
      ) {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.value.includes('Pan-sharpened')) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }  
      } else {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.value.includes('Both')) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }
      }

      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
      );

      if (idx > -1) {
        this.calculateUnitcost(indx,idx);
      }
    }

    else if (
      ((row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS) && row?.sensor === 'SAR')
    ) {
      let currentSensor: any;
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (productMode?.mode === 'PSPOT' ||  productMode?.mode == this.spotMode) {
        this.AVAILABLESENSORS[indx].resolution[1].disable = true;
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
        if(productMode?.mode === this.spotMode) {
          this.AVAILABLESENSORS[indx].selectedONA = this.AVAILABLESENSORS[indx].ONA[0].key;
          this.AVAILABLESENSORS[indx].selectedONAOption = this.AVAILABLESENSORS[indx].ONA[0];
          currentSensor = this.AVAILABLESENSORS[indx];
          this.resetOna(currentSensor, this.spotMode);
        }
      } else if (
        productMode?.mode === 'PSTRIP' ||  productMode?.mode == this.stripMode
      ) {
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].resolution[0].disable = true;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[1];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[1].value;
        if(productMode?.mode === this.stripMode) {
          this.AVAILABLESENSORS[indx].selectedONA = this.AVAILABLESENSORS[indx].ONA[1].key;
          this.AVAILABLESENSORS[indx].selectedONAOption = this.AVAILABLESENSORS[indx].ONA[1];
          currentSensor = this.AVAILABLESENSORS[indx];
          this.resetOna(currentSensor, this.stripMode);
        } 
      } else {
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
      }
    }
    else if (
      (row?.key === OPERATORS.SYNSPECTIVE && row?.sensor === 'SAR')
    ) {      
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (
        productMode?.key === 'Area'
      ) { 
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].resolution[1].disable = true;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
      } else {
        this.AVAILABLESENSORS[indx].resolution[0].disable = true;
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[1];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[1].value;
      }
    }

    else if (
      (row?.key === OPERATORS.ISI && row?.sensor === 'Stereo')
    ) {      
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      if (
        productMode?.key != 'Bundle'
      ) { 
        this.AVAILABLESENSORS[indx].resolution[0].disable = false;
        this.AVAILABLESENSORS[indx].resolution[1].disable = true;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[0].value;
      } else {
        this.AVAILABLESENSORS[indx].resolution[0].disable = true;
        this.AVAILABLESENSORS[indx].resolution[1].disable = false;
        this.AVAILABLESENSORS[indx].selectedResolution =
          this.AVAILABLESENSORS[indx].resolution[1];
        this.AVAILABLESENSORS[indx].selectedResolutionValue =
          this.AVAILABLESENSORS[indx].resolution[1].value;
      }
    }

    if (
      row?.key === OPERATORS.CAPELLA
    ) {
      if (productMode?.mode_type === 'spotlight_ultra') {
        this.AVAILABLESENSORS[indx].selectedResolutionData = null;
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 1) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
          } else {
            items.disable = true;
          }
        }

      } else if (productMode?.mode_type === 'spotlight') {
        this.AVAILABLESENSORS[indx].selectedResolutionData = null;

        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 2) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
          } else {
            items.disable = true;
          }
        }
      }
    }

    this.AVAILABLESENSORS[indx].selectedModes = productMode;
    this.getTooltip(productMode, indx, row);
    const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
      (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
    );
    if (productMode?.length) {
      this.spot = false;
      this.strip = false;
      if (productMode[0]?.key.includes('Spot') && (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS)) {
        this.spot = true;
      } else if (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS) {
        this.strip = true;
      }

      this.AVAILABLESENSORS[indx].selectedMode = productMode[0].key;

      if (productMode[0]?.isCaptureMode && !productMode[0]?.isProductLevel) {
        this.AVAILABLESENSORS[indx].selectedMode = productMode[0].captureMode;
      } else if (
        productMode[0]?.isProductLevel &&
        !productMode[0]?.isCaptureMode
      ) {
        this.AVAILABLESENSORS[indx].selectedMode = productMode[0].productLevel;
      } else if (
        productMode[0]?.isProductLevel &&
        productMode[0]?.isCaptureMode
      ) {
        this.AVAILABLESENSORS[indx].selectedMode =
          productMode[0].captureMode + ' (' + productMode[0].productLevel + ')';
      } else if (row?.key === OPERATORS.WEATHEREX) {
        this.AVAILABLESENSORS[indx].selectedMode = productMode
          .map((m: any) => m?.name || m?.key)
          .join(', ');
        this.fetchWeatherExQuote(indx, this.AVAILABLESENSORS[indx]);
      }

      this.getTooltip(productMode[0], indx, row);
    } else if (productMode.length === 0) {
      this.spot = false;
      this.strip = false;
      this.getTooltip(row?.collection_mode[0], indx, row);
      this.AVAILABLESENSORS[indx].selectedModes = [];
      if (row?.key === OPERATORS.WEATHEREX) {
        // All modes deselected: clear display, reset cost, and uncheck sensor. Do NOT call quote endpoint.
        this.AVAILABLESENSORS[indx].selectedMode = '';
        this.AVAILABLESENSORS[indx].modeResetValue = [];
        this.AVAILABLESENSORS[indx].quotedUnitPrice = null;
        this.AVAILABLESENSORS[indx].unitcost = 0;
        this.AVAILABLESENSORS[indx].selectedCost = 0;
        if (Array.isArray(this.AVAILABLESENSORS[indx].latency) && this.AVAILABLESENSORS[indx].latency[0]) {
          this.AVAILABLESENSORS[indx].latency[0].cost = 0;
          this.AVAILABLESENSORS[indx].latency[0].unitcost = 0;
        }
        if (this.AVAILABLESENSORS[indx].checked) {
          this.AVAILABLESENSORS[indx].checked = false;
          this.AVAILABLESENSORS[indx].sensorSelected = false;
          this.uncheckSensorInTipAndCue(indx);
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
          this.clickHandler();
        }
        this.cdRef.detectChanges();
      } else {
        this.AVAILABLESENSORS[indx].selectedModes =
          this.AVAILABLESENSORS[indx].modeSelected;
      }
    } else {
      this.AVAILABLESENSORS[indx].selectedModes = [];
      this.AVAILABLESENSORS[indx].selectedModes.push(productMode);
    }

    if (row?.key === OPERATORS.UMBRA) {
      const { isUmbraScan, looks } = applyUmbraModeConstraints(
        this.AVAILABLESENSORS[indx],
        productMode,
      );

      // When productMode is a string key (from dropdown ngValue binding), selectedModes was set to
      // that string at line 2965. Resolve it to the full mode object so selectedModes[0].value works.
      if (!Array.isArray(this.AVAILABLESENSORS[indx].selectedModes)) {
        const modeKey = this.AVAILABLESENSORS[indx].selectedModes;
        const fullMode = typeof modeKey === 'string'
          ? (row.collection_mode?.find((m: any) => m.key === modeKey) ?? null)
          : modeKey;
        this.AVAILABLESENSORS[indx].selectedModes = fullMode ? [fullMode] : [];
      }

      if (isUmbraScan && this.target) {
        const currentLengthKm = this.target.stripSettings?.lengthKm ?? null;
        if (row.checked && currentLengthKm != null) {
          const validation = validateSelectedUmbraScanLength(
            currentLengthKm,
            productMode,
            row?.collection_mode,
          );

          if (!validation.valid) {
            const message = `Your current strip length (${currentLengthKm.toFixed(2)} km) is outside the valid range for ${validation.modeLabel}. Please update your map points to fit within this range.`;
            const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
            dialogRef.afterClosed().subscribe(() => {
              this.uncheckSensorInTipAndCue(indx);
            });
          }
        }
      }

      if (!isUmbraScan && this.target) {
        this.target.stripValidRange = null;
      }

      let sceneSize = this.AVAILABLESENSORS[indx].selectedModes[0].value;
      this.AVAILABLESENSORS[indx].numberOfLooks = looks;

      const umbraPrice = isUmbraScan
        ? getUmbraScenePrice(this.AVAILABLESENSORS[indx].selectedResolution, sceneSize)
        : this.AVAILABLESENSORS[indx].selectedResolution?.sceneSizePricing[sceneSize][looks];

      row.latency[0].cost = umbraPrice;
      row.latency[0].unitcost = umbraPrice;
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[0].name, indx, row, 1);
    }

    if (row?.key === OPERATORS.ICEYE) {
      const iceyeStrategy = this.operatorStrategyFactory.getStrategy(row.key);
      iceyeStrategy?.applyResolutionConstraints?.(this.AVAILABLESENSORS[indx], productMode);
      iceyeStrategy?.syncLatencyCosts?.(row);
      const resolvedLatency = iceyeStrategy?.resolveActiveLatency?.(row);
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(resolvedLatency?.name ?? row.latency[0]?.name, indx, row, 1);
    }

    if (row?.key === OPERATORS.BLACKSKY || row?.key === OPERATORS.OSK) {
      if (productMode.sceneSize)
        this.AVAILABLESENSORS[indx].minarea = row?.key === OPERATORS.OSK && this.target.area > 0 ? row?.minareastrip : productMode.sceneSize;
    }

    if (row?.key === OPERATORS.GHG) {
      const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
        (item) => item.selected === true
      );
      row.latency = row.latency.map(latencyItem => {
        const matchingMode = row.selectedModes[0].cost.find(mode => mode[latencyItem.key] !== undefined);
        return {
          ...latencyItem,
          cost: matchingMode ? matchingMode[latencyItem.key] : null,
          unitcost: matchingMode ? matchingMode[latencyItem.key] : null,
        };
      });
        this.AVAILABLESENSORS[indx].latency = row.latency;
        this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    }

    if(row?.key === OPERATORS.STE && row?.sensor === 'MSI') {
      this.resetCost(row,this.AVAILABLESENSORS[indx].selectedResolution,indx)
    }

    if (row?.key === OPERATORS.CAPELLA || row?.key === OPERATORS.BLACKSKY || row?.key === OPERATORS.GOKTURK || row?.key === OPERATORS.SDS
      || row?.key === OPERATORS.ECURS ||  row?.key === OPERATORS.ECURS_L
    ) {
      let pricingArray= row.selectedModes[0]?.pricing;
      const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
        (item) => item.selected === true
      );
      for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
        const key = latencyItem.key;
        if (pricingArray && pricingArray.hasOwnProperty(key)) {
          const newCost = Number(pricingArray[key]);
          latencyItem.cost = newCost;
          latencyItem.unitcost = newCost;
        }
      }

      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    }

    let minimumArea: any;
    if ((row.unit.includes('scene') || row.unit === 'week' || row.unit === 'day') && row.key != OPERATORS.BLACKSKY) {
      if (row.tooltipValue) {
        minimumArea = this.extractAndCalculateValues(row.tooltipValue);
        this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
      } else if (row.minimumArea) {
        minimumArea = this.extractAndCalculateValues(row.minimumArea);
        this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
      }
    } else {
      minimumArea = row.minarea;
      this.AVAILABLESENSORS[indx].minimumAreaSize = minimumArea;
    }

    if (row?.key === OPERATORS.ICEYE && productMode?.minArea != null) {
      this.AVAILABLESENSORS[indx].minimumAreaSize = productMode.minArea;
      this.AVAILABLESENSORS[indx].minimumArea = productMode.value;
    }

    if((row?.key === OPERATORS.HEAD) || row?.key === OPERATORS.GOKTURK || row?.key === OPERATORS.GHG || row?.key === OPERATORS.ECURS || row?.key === OPERATORS.ECURS_L || row?.key === OPERATORS.SATELLOGIC || row?.key === OPERATORS.SATELLITEVU_VANZYL || row?.key === OPERATORS.GEOSAT) {

      // GEOSAT: mode selection drives ONA. Snap to the selected mode's default
      // supported ONA BEFORE resetResolution runs so the ONA-filtered resolution
      // list stays aligned with the selected mode.
      if (row?.key === OPERATORS.GEOSAT) {
        const geosatStrategy = this.operatorStrategyFactory.getStrategy(OPERATORS.GEOSAT) as any;
        const defaultOna: string | null = geosatStrategy?.getDefaultOnaForMode?.(productMode, this.AVAILABLESENSORS[indx]) ?? null;
        if (defaultOna && this.AVAILABLESENSORS[indx].selectedONA !== defaultOna) {
          const onaOptions: any[] = this.AVAILABLESENSORS[indx].ONA ?? [];
          const targetOna = onaOptions.find((o: any) => (o.ona ?? o.key) === defaultOna);
          if (targetOna) {
            this.AVAILABLESENSORS[indx].selectedONA = defaultOna;
            this.AVAILABLESENSORS[indx].selectedONAOption = targetOna;
            this.AVAILABLESENSORS[indx].selectedItem = targetOna;
            this.AVAILABLESENSORS[indx].ONAFactor = Number(targetOna.onaUplift ?? targetOna.value ?? 1);
            const resolutionArray = this.createResolutionArray(
              this.AVAILABLESENSORS[indx].onaWithResolution,
              defaultOna,
              this.AVAILABLESENSORS[indx].resolution,
              row.key
            );
            if (resolutionArray.length > 0) {
              this.AVAILABLESENSORS[indx].resolution = resolutionArray;
            }
          }
        }
      }

      this.resetResolution(productMode,indx,row?.key);

      // GEOSAT: keep unit cost in sync after resolution constraints are applied.
      if (row?.key === OPERATORS.GEOSAT) {
        this.recalculateSelectedCostForRow(indx);
      }

      // SatelliteVu: mode can change selected resolution; keep unit cost in sync.
      if (row?.key === OPERATORS.SATELLITEVU_VANZYL) {
        const latencyIdx = this.AVAILABLESENSORS[indx].latency.findIndex(
          (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
        );
        if (latencyIdx > -1) {
          this.calculateUnitcost(indx, latencyIdx);
        }
      }
    }

    this.showSwath = this.AVAILABLESENSORS.some((s) =>
      s.selectedModes?.[0]?.swathWidth
    );
    this.syncSensorTooltip(indx);
    if (row?.key === OPERATORS.OSK && this.target.area === 0) {
      if(productMode?.key === "scan_mode") {
        this.AVAILABLESENSORS[indx].selectedCost = row?.pricing?.standard?.POI_scan_mode;
        this.AVAILABLESENSORS[indx].unitcost = row?.pricing?.standard?.POI_scan_mode;
        } else{
          this.AVAILABLESENSORS[indx].selectedCost = row?.pricing?.standard?.POI;
          this.AVAILABLESENSORS[indx].unitcost = row?.pricing?.standard?.POI;
         }
           if (
          this.AVAILABLESENSORS[indx].userCost > 0 &&
          this.AVAILABLESENSORS[indx].selectedCost > 0
        ) {
              this.AVAILABLESENSORS[indx].selectedCost = Number(
                (
                  this.AVAILABLESENSORS[indx].selectedCost *
                  this.AVAILABLESENSORS[indx].userCost
                ).toFixed(2)
              );
      }

      for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
        
        const key = latencyItem.key;
        let mode_key = this.AVAILABLESENSORS[indx].selectedModes[0]?.key;

          const newCost = mode_key == 'scan_mode' ? Number(row?.pricing[key]?.POI_scan_mode) : Number(row?.pricing?.[key]?.POI);
          latencyItem.cost = newCost;
          latencyItem.unitcost = newCost;

      }
    }

    if (row?.key === OPERATORS.CONSTELLR) {
      // Extract cost directly from productMode object
      const modeCost = productMode?.cost;
      if (modeCost !== undefined && modeCost !== null) {
        this.AVAILABLESENSORS[indx].selectedCost = modeCost;
        this.AVAILABLESENSORS[indx].unitcost = modeCost;

        // Update all latency items with the same cost from the selected mode
        if (this.AVAILABLESENSORS[indx].latency && this.AVAILABLESENSORS[indx].latency.length > 0) {
          for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
            latencyItem.cost = modeCost;
            latencyItem.unitcost = modeCost;
          }
        }
      }
    }
    
    if (idx > -1 && this.getModeResolutionPrice(this.AVAILABLESENSORS[indx], this.AVAILABLESENSORS[indx].selectedResolution) != null) {
      const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
        (item) => item.selected === true
      );
       this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
      this.calculateUnitcost(indx, idx);
    }

    

    this.resetValueAddedDropdown(indx, row);
  }

  private recalculateSelectedCostForRow(indx: number): void {
    const row = this.AVAILABLESENSORS?.[indx];
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    if (strategy) {
      strategy.recalculateSelectedCost(row);
      return;
    }

    if (!Array.isArray(row?.latency) || row.latency.length === 0) return;

    let latencyIdx = row.latency.findIndex((elem: any) => elem?.name === row?.selectedLatency);
    if (latencyIdx < 0) {
      latencyIdx = row.latency.findIndex((elem: any) => elem?.selected === true);
    }
    if (latencyIdx < 0) latencyIdx = 0;

    this.calculateUnitcost(indx, latencyIdx);
  }

  async resetOna(currentSensor: any, mode: string){
    if (mode === this.spotMode){
      currentSensor.ONA[0].enabled = true;
      currentSensor.ONA[1].enabled = false;
    } else {
      currentSensor.ONA[0].enabled = false;
      currentSensor.ONA[1].enabled = true;
      if(currentSensor?.collection_mode)
        this.getCustomTooltip(currentSensor?.collection_mode);
    }
  }

  getCustomTooltip(collectionMode: any) {
    collectionMode?.forEach(eachMode => {
      const sceneText = `\nThe maximum length is ${eachMode.scene_width}`;
      if (eachMode.mode === this.stripMode) {
        if (!eachMode.minTooltip?.includes(sceneText)) {
          eachMode.minTooltip = `${eachMode.minTooltip ? eachMode.minTooltip + '. ' : ''}${sceneText}km`;
        }
      }
    });
  }

  private sortedWeatherExCollectionMode(sensor: any): any[] {
    const cm: any[] = sensor?.collection_mode ?? [];
    if (sensor?.key !== OPERATORS.WEATHEREX) return cm;
    const order = this.apiService.weatherVariables.map((v: any) => v.key);
    return [...cm].sort((a, b) => {
      const ai = order.indexOf(a.key);
      const bi = order.indexOf(b.key);
      return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
    });
  }

  // ---------------------------------------------------------------------------
  // WeatherEx dynamic quote pricing
  // ---------------------------------------------------------------------------

  /**
   * Is the target being tasked a point rather than an area?
   *
   * Read off the WKT, the same signal the operator strategies are given, so the
   * blocker that decides whether Voyage Radar may be selected and the credit
   * catalogue the purchase modal then prices cannot disagree about the shape.
   * `POINT` also matches `MULTIPOINT` — deliberate, since both are point work.
   */
  private isPointTargetTasked(): boolean {
    return !!this.target?.geoJSON?.includes('POINT');
  }

  /**
   * "What is a credit?", from the info icon beside Voyage Radar's unit cost —
   * the same dialog, opened the same way, as on the sensor preview. The two
   * screens show the same price in the same column, so the explanation behind
   * it has to be reachable from both; a buyer who never opens the preview would
   * otherwise meet "per credit" with nothing to compare it against.
   *
   * The row is passed whole and the dialog reads its own fields off it — the
   * `{ selectedRow }` contract the purchase dialog takes. Deliberately NOT
   * filtered by target shape: this is the whole catalogue, and narrowing it here
   * would hide an endpoint from someone still deciding what to task.
   */
  openVoyageCreditInfo(row: any) {
    this.dialog.open(VoyageCreditInfoComponent, {
      width: '620px',
      maxWidth: '94vw',
      backdropClass: 'blurred',
      data: { selectedRow: row },
    });
  }

  /** Same as openVoyageCreditInfo above, for the VesselFinder catalogue. */
  openVesselFinderCreditInfo(row: any) {
    this.dialog.open(VesselFinderCreditInfoComponent, {
      width: '620px',
      maxWidth: '94vw',
      backdropClass: 'blurred',
      data: { selectedRow: row },
    });
  }

  /** Build the POST body for /tasks/weatherex/quote from the current target and sensor row. */
  private buildWeatherExQuotePayload(target: any, sensorRow: any): object {
    const isAoi = target?.area != null && target.area !== 0;
    const modes: any[] = Array.isArray(sensorRow.selectedModes) ? sensorRow.selectedModes : [];
    return {
      target: JSON.stringify(geoParse(target.geoJSON)),
      openWindow: moment(target.openWindow).utcOffset(0, true).format(),
      closeWindow: moment(target.closeWindow).utcOffset(0, true).format(),
      collectionMode: modes,
      refreshRate: sensorRow.selectedRefreshRate?.value ?? null,
      ...(isAoi ? { resolution: sensorRow.selectedResolution?.value ?? sensorRow.selectedResolution ?? null } : {}),
    };
  }

  /** Fetch a live price quote for the WeatherEx sensor row and apply it. */
  private async fetchWeatherExQuote(idx: number, sensorRow: any): Promise<void> {
    // Do not call the quote endpoint when no modes are selected.
    if (!Array.isArray(sensorRow.selectedModes) || sensorRow.selectedModes.length === 0) return;
    sensorRow.quoteLoading = true;
    try {
      const payload = this.buildWeatherExQuotePayload(this.target, sensorRow);
      const res: any = await this.apiService.getWeatherExQuote(payload).toPromise();
      sensorRow.quotedUnitPrice = res?.data?.charged_price_usd ?? null;
    } catch {
      sensorRow.quotedUnitPrice = null;
    } finally {
      sensorRow.quoteLoading = false;
      this.calculateUnitcost(idx, 0);
      this.cdRef.detectChanges();
    }
  }

  private applySatelliteVuInitConstraints(indx: number) {
    const row = this.AVAILABLESENSORS?.[indx];
    const mode = row?.selectedModes?.[0];
    if (!mode) return;

    // GEOSAT and SatVu go through resetResolution because they need additional
    // post-constraint work (recalculateSelectedCostForRow, value-added resets) that
    // lives outside the strategy. They require mode.resolution to be present.
    if (row?.key === OPERATORS.SATELLITEVU_VANZYL || row?.key === OPERATORS.GEOSAT) {
      if (!mode?.resolution) return;
      this.resetResolution(mode, indx, row.key);
      if (row?.key === OPERATORS.GEOSAT) {
        this.syncSensorTooltip(indx);
        return;
      }
      this.syncSensorTooltip(indx);
      if (row?.selectedResolution) {
        row.valueAddedAction = this.filterValueAddedData(row);
      }
      return;
    }

    // Generic path: let the strategy apply resolution constraints if it supports them.
    // The strategy encapsulates whether it uses distance, resolution, or any other field.
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    strategy?.applyResolutionConstraints?.(row, mode);
    if (row?.key === OPERATORS.ICEYE && mode?.minArea != null) {
      row.minimumAreaSize = mode.minArea;
    }
  }

  private sortLatencyByTierPref(sensor: any): void {
    if (!Array.isArray(sensor.latency)) return;
    const getSortCost = (item: any): number => sensor?.key === OPERATORS.GEOSAT
      ? (item.taskingWindowCost ?? ((item.reactionUpliftCost ?? 0) + (item.responseUpliftCost ?? 0)))
      : item.unitcost;
    if (this.taskTierPref === 'low') {
      sensor.latency.sort((a: any, b: any) => getSortCost(a) - getSortCost(b));
    } else if (this.taskTierPref === 'high') {
      sensor.latency.sort((a: any, b: any) => getSortCost(b) - getSortCost(a));
    }
  }

  private getInitialSensorTooltip(sensor: any, selectedModes: any[]): string {
    if (sensor?.key === OPERATORS.GEOSAT) {
      return selectedModes?.[0]?.bands ?? '';
    }

    return sensor?.tooltip ?? '';
  }

  private syncSensorTooltip(
    indx: number,
    resolution: any = this.AVAILABLESENSORS?.[indx]?.selectedResolution,
  ): void {
    const row = this.AVAILABLESENSORS?.[indx];
    if (!row) return;

    if (row?.key === OPERATORS.GEOSAT) {
      row.sensorTooltip = row?.selectedModes?.[0]?.bands ?? '';
      return;
    }

    if (row?.key === OPERATORS.SATELLITEVU_VANZYL) {
      const mode = row?.selectedModes?.[0];
      const combinedBandsTooltip = getSatelliteVuBandsTooltip(row, mode);
      if (combinedBandsTooltip) {
        row.sensorTooltip = combinedBandsTooltip;
        return;
      }
    }

    if (resolution?.bands) {
      row.sensorTooltip = resolution.bands;
    }
  }

  resetResolution(productMode,indx,operatorKey) {
    this.AVAILABLESENSORS[indx].selectedResolutionData = null;
    let item = this.AVAILABLESENSORS[indx];
    if ((productMode?.key === 'L3C' && operatorKey === OPERATORS.HEAD && item.sensor != 'HSI') || 
        (productMode?.productLevel === 'L2B' && operatorKey === OPERATORS.GOKTURK && productMode?.key.includes('pan_sharpened'))) {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('Pan-sharpened')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
        } else {
          items.disable = true;
        }
      }
    } else if ((productMode?.key === 'L3D' && operatorKey === OPERATORS.HEAD)) {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('TCI')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
        } else {
          items.disable = true;
        }
      }
    } else if ((productMode?.key != 'L3D' && operatorKey === OPERATORS.HEAD && item.sensor === 'HSI')) {      
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('TCI')) {
          items.disable = true;
        } else {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = item.resolution[1];
          this.AVAILABLESENSORS[indx].selectedResolutionValue = item.resolution[1].value
        }
      }
    } else if (operatorKey === OPERATORS.AT21) {
      if (productMode?.productLevel === 'L1') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value.includes('Bundle')) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
          } else {
            items.disable = true;
          }
        }
      } else if (
        productMode?.productLevel === 'L4'
      ) {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.value.includes('Pan-sharpened')) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }  
      } else {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.value.includes('Both')) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }
      }
    } else if (operatorKey === OPERATORS.ECURS || operatorKey === OPERATORS.ECURS_L) {
      if (productMode?.resolution) {
        const productResolutions = productMode.resolution;
        for (const [index, items] of this.AVAILABLESENSORS[indx].resolution.entries()) {
          // Check if the resolution exactly matches any value in productMode.resolution
          let isMatched = false;

          for (const res of productResolutions) {
            if (items.value === res) {
              isMatched = true;
              break;
            }
          }

          if (isMatched) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
          } else {
            items.disable = true;
          }
        }
      }
      
      else if (productMode?.mode === 'SL') {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.key === 1) {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
          } else {
            items.disable = true;
          }
        }
      } else if (
        productMode?.mode === 'SM'
      ) {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.key === 2) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }  
      } else if (
        productMode?.mode === 'NSS'
      ) {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.key === 3) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }  
      } else {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.key === 4) {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }
      }
    } else if (operatorKey === OPERATORS.GHG) {
      if (productMode?.productLevel.includes('Onshore')) {
        for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
          if (items.value === '25m') {
            items.disable = false;
            this.AVAILABLESENSORS[indx].selectedResolution = items;
            this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
          } else {
            items.disable = true;
          }
        }
      } else if (
        productMode?.productLevel.includes('Offshore')
      ) {
          for (const [index, items] of this.AVAILABLESENSORS[
            indx
          ].resolution.entries()) {
            if (items.value === '30-80m') {
              items.disable = false;
              this.AVAILABLESENSORS[indx].selectedResolution = items;
              this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
            } else {
              items.disable = true;
            }
          }  
      }
    } else if (operatorKey === OPERATORS.SATELLOGIC &&  item?.sensor === 'MSI') { // based on resolution value in product mode
      this.AVAILABLESENSORS[indx].selectedResolutionData = null;
      for (const [index, items] of this.AVAILABLESENSORS[
          indx
        ].resolution.entries()) {
        if (items.value.includes(productMode.resolution[0])) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
        } else {
          items.disable = true;
        }
      } 
    } else if (operatorKey === OPERATORS.GEOSAT) {
      // Geosat: constrain resolution options based on selected mode's allowed resolution list.
      const strategy = this.operatorStrategyFactory.getStrategy(operatorKey);
      strategy?.applyResolutionConstraints?.(this.AVAILABLESENSORS[indx], productMode);
      // Update tier costs using strategy (mode.unitCost + tier.upliftCost)
      this.recalculateSelectedCostForRow(indx);
    } else if (operatorKey === OPERATORS.SATELLITEVU_VANZYL) {
      // SatelliteVu_VanZyl (HydroSat/TIR) - Reset resolution based on mode
      applySatelliteVuResolutionConstraints(this.AVAILABLESENSORS[indx], productMode);
    } else if( (productMode?.key === 'spot_L3A_pan_sharpened' || productMode?.key === 'strip_L3A_pan_sharpened' || productMode?.key ==='tristereo_L3A_pan_sharpened'
      || productMode?.key === 'stereo_L3A_pan_sharpened') && operatorKey === OPERATORS.GOKTURK && 
      (item?.sensor === 'MSI' || item?.sensor === 'Stereo' || item?.sensor === 'Tristereo')) {
        for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('Pan-sharpened')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value;
        } else {
          items.disable = true;
        }
      } 
    } else {
      for (const [index, items] of this.AVAILABLESENSORS[
        indx
      ].resolution.entries()) {
        if (items.value.includes('Bundle')) {
          items.disable = false;
          this.AVAILABLESENSORS[indx].selectedResolution = items;
          this.AVAILABLESENSORS[indx].selectedResolutionValue = items.value
        } else {
          items.disable = true;
        }
      }
    }
    this.resetValueAddedDropdown(indx, this.AVAILABLESENSORS[indx]);
  }

  async resolutionChange(resolution: any, indx: number, row: any) {
    if (row?.key === OPERATORS.WEATHEREX) {
      this.AVAILABLESENSORS[indx].selectedResolution = resolution;
      this.AVAILABLESENSORS[indx].selectedResolutionValue = resolution?.value;
      this.fetchWeatherExQuote(indx, this.AVAILABLESENSORS[indx]);
      return;
    }

    if (row?.key === OPERATORS.UMBRA) {
      const isUmbraScan = isUmbraScanMode(row);
      this.AVAILABLESENSORS[indx].selectedLooks = null;
      let sceneSize = this.AVAILABLESENSORS[indx].selectedModes[0].value;
      let looks = resolution?.numberOfLooks?.[0];
      this.AVAILABLESENSORS[indx].numberOfLooks = looks;

      if (!isUmbraScan && sceneSize === 'SAR Video' && Array.isArray(this.AVAILABLESENSORS[indx].selectedResolution?.numberOfLooks)) {
        for (const [index, item] of this.AVAILABLESENSORS[
          indx
        ].selectedResolution.numberOfLooks.entries()) {
          if (item === 'x5') {
            this.AVAILABLESENSORS[indx].selectedLooks = item;
            this.AVAILABLESENSORS[indx].numberOfLooks = item;
            looks = item;
          }
        }
      }

      const umbraPrice = isUmbraScan
        ? getUmbraScenePrice(resolution, sceneSize)
        : resolution?.sceneSizePricing[sceneSize][looks];
      row.latency[0].cost = umbraPrice;
      row.latency[0].unitcost = umbraPrice;
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[0].name, indx, row,1);
    }

    if ((row?.key === OPERATORS.STE && row?.sensor === 'MSI') || (row?.key === OPERATORS.USL && row.name === 'BRO')) {
      this.resetCost(row,resolution,indx);
    }

    this.AVAILABLESENSORS[indx].selectedResolution = resolution;
    this.AVAILABLESENSORS[indx].selectedResolutionValue = resolution.value;
    if (row?.key === OPERATORS.UMBRA && isUmbraScanMode(row)) {
      this.AVAILABLESENSORS[indx].selectedResolutionData = resolution;
    }

    const selectedLatencyIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
      (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
    );

    if (selectedLatencyIndex > -1 && this.getModeResolutionPrice(this.AVAILABLESENSORS[indx], resolution) != null) {
      const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
        (item) => item.selected === true
      );
       this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
      this.calculateUnitcost(indx, selectedLatencyIndex);
    }

    // GEOSAT: resolution has unitCost; update latency prices + selected cost.
    if (row?.key === OPERATORS.GEOSAT) {
      this.recalculateSelectedCostForRow(indx);
    }
    
    this.syncSensorTooltip(indx, resolution);

    if(row?.key === OPERATORS.AXELSPACE || row?.key ===OPERATORS.AT21 || row?.key === OPERATORS.SDS || row?.key === OPERATORS.ORBVIEW) {
      const idx = this.AVAILABLESENSORS[indx].latency.findIndex(
        (elem) => elem.name === this.AVAILABLESENSORS[indx].selectedLatency
      );     

      if (idx > -1) {
        this.calculateUnitcost(indx,idx);
      }
    }

    this.resetValueAddedDropdown(indx, row);
  }

  refreshRateChange(rate: any, indx: number, row: any): void {
    this.AVAILABLESENSORS[indx].selectedRefreshRate = rate;
    if (row?.key === OPERATORS.WEATHEREX) {
      this.fetchWeatherExQuote(indx, this.AVAILABLESENSORS[indx]);
    }
  }

  resetCost(row,resolution,indx) {
    const selectedIndex = this.AVAILABLESENSORS[indx].latency.findIndex(
      (item) => item.selected === true
    );

    if (((row.key === OPERATORS.STE ||row.key === OPERATORS.STE_TELEOS) && resolution.value.includes('Bundle')
    )) {
      let pricingArray= this.AVAILABLESENSORS[indx].selectedModes[0]?.pricing;
      for (const latencyItem of this.AVAILABLESENSORS[indx].latency) {
        const key = latencyItem.key;
        if (pricingArray.hasOwnProperty(key)) {
          const newCost = Number(pricingArray[key]);
          latencyItem.cost = newCost;
          latencyItem.unitcost = newCost;
        }
      }
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    } else if (row?.key === OPERATORS.STE && row?.sensor === 'MSI'
      && resolution.value.includes('Pan-sharpened')) {
        let costSTE = this.AVAILABLESENSORS[indx].STElatency[0];
        row.latency[0].cost = costSTE[0].cost;
        row.latency[0].unitcost = costSTE[0].unitcost;
        row.latency[1].cost = costSTE[1].cost;
        row.latency[1].unitcost = costSTE[1].unitcost;
        this.taskingOption(row.latency[selectedIndex].name, indx, row, 1);
    }
    else if (row?.key === OPERATORS.USL && row.name === 'BRO') {
      let latency = row.latency;
      let subdailyCount = this.target.subDailyCount || 1;
      let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
      let enddate = moment(this.target.closeWindow).utcOffset(0, true).format();

      let days_difference = this.getDateDifferenceInDays(startdate, enddate);

      let baseStandard = 0;//resolution.pricing.standard;

      if(days_difference > 365 ) {
        const isSubDailyValid = this.target.freqOption === 'Sub-daily' && this.checkAcquisition();

        const isDaily = this.target.freqOption === 'Daily';

        if (isSubDailyValid || isDaily) {
          const price = this.calculateBroPrice(days_difference, subdailyCount, resolution.key);
          baseStandard = price;
        }
      }
      else{
        baseStandard = resolution.pricing.standard;
      }

      latency.forEach((item: any) => {
        let baseCost = 0;

        if (item.name === 'standard') {
          baseCost = baseStandard;
        } else if (item.name === 'priority' || item.name === 'rush') {
          baseCost = baseStandard * 1.5;
        }

        item.unitcost = Number(baseCost);
        item.cost = Number(baseCost);

        if (item.selected) {
          this.AVAILABLESENSORS[indx].selectedCost = item.cost;
          this.AVAILABLESENSORS[indx].unitcost = item.unitcost;
        }
      });
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    // Convert values to comparable types
    const aValue = typeof a === 'string' ? parseFloat(a) : a;
    const bValue = typeof b === 'string' ? parseFloat(b) : b;

    // Handle cases where one value is NaN (string couldn't be converted to number)
    if (isNaN(aValue) && !isNaN(bValue)) {
      return isAsc ? 1 : -1; // Strings come after numbers
    }
    if (!isNaN(aValue) && isNaN(bValue)) {
      return isAsc ? -1 : 1; // Numbers come before strings
    }

    // Both values are either numbers or strings, compare them
    return (aValue < bValue ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareArrays(
    array1: any[],
    array2: any[],
    property: string,
    isAsc: boolean
  ): number | string {
    // Compare the arrays by the specified property
    for (let i = 0; i < Math.min(array1.length, array2.length); i++) {
      const value1 = (array1[i]?.[property] ?? '').toString();
      const value2 = (array2[i]?.[property] ?? '').toString();
      const numericValue1 = value1.match(/\d+(\.\d+)?/g);
      const numericValue2 = value2.match(/\d+(\.\d+)?/g);

      const comparisonResult =
        numericValue1 && numericValue2
          ? parseFloat(numericValue1[0]) - parseFloat(numericValue2[0])
          : value1.localeCompare(value2, undefined, {
              sensitivity: 'base',
              numeric: true,
            });

      if (comparisonResult !== 0) {
        return comparisonResult * (isAsc ? 1 : -1);
      }
    }

    // If all compared elements are equal, compare the lengths of the arrays
    return (array1.length - array2.length) * (isAsc ? 1 : -1);
  }

  private operatorLabel(row: any): string {
  const displayName = (this.currentUser?.obfuscated && row.obfuscateName) ? row.obfuscateName : row.name;
  const sensor = row.sensor ?? '';
  return `${displayName ?? ''} ${sensor}`.trim();
  }

  private compareStr(a: any, b: any, isAsc: boolean) {
    const A = (a ?? '').toString();
    const B = (b ?? '').toString();
    const res = A.localeCompare(B, undefined, { sensitivity: 'base', numeric: true });
    return isAsc ? res : -res;
  }

  private hasSameRowSet(a: any[], b: any[]): boolean {
    if (a.length !== b.length) {
      return false;
    }

    const setA = new Set(a);
    return b.every((item) => setA.has(item));
  }

  private getResolutionSortArray(row: any): { value: string }[] {
    const selectedResolution =
      row?.selectedResolutionValue ||
      row?.selectedResolution?.value ||
      row?.resolution?.[0]?.value ||
      row?.rf_services?.[0]?.value;
    const refreshRate = row?.selectedRefreshRate?.value || row?.updateFrequency;

    const values = [selectedResolution, refreshRate]
      .filter((value) => !!value)
      .map((value) => ({ value: this.getResolutionLabel(value) }));

    return values.length ? values : [{ value: '' }];
  }

  sortData(sort: Sort) {
    const data = this.AVAILABLESENSORS.slice();
    if (!sort.active || sort.direction === '') {
      const restoreBaseline =
        this.sensorSortBaseline.length > 0 &&
        this.hasSameRowSet(this.sensorSortBaseline, data);
      this.AVAILABLESENSORS = restoreBaseline
        ? this.sensorSortBaseline.slice()
        : data;
      this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
      return;
    }

    if (sort.direction === 'asc') {
      this.sensorSortBaseline = data.slice();
    }

    this.AVAILABLESENSORS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'operator':
          const aLabel = this.operatorLabel(a);
          const bLabel = this.operatorLabel(b);
          return this.compareStr(aLabel, bLabel, isAsc);
        case 'resolution':
          return this.compareArrays(
            this.getResolutionSortArray(a),
            this.getResolutionSortArray(b),
            'value',
            isAsc,
          );
        case 'area_calculated':
          return this.compare(a.minarea, b.minarea, isAsc);
        default:
          return 0;
      }
    });
    this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
  }

  private getRecurringDaysPayload(): string[] | null {
    if (this.target?.selectedOption !== 1 || this.target?.freqOption !== 'Days') {
      return null;
    }

    return Array.isArray(this.target?.recurringDays)
      ? [...this.target.recurringDays]
      : [];
  }

  private isIceyeSubDailyRecurrenceApplicable(selectedSensors: any[]): boolean {
    if (this.target?.selectedOption !== 1 || (this.target?.freqOption !== 'Sub-daily' && this.target?.freqOption !== 'Daily') || ![1, 2, 3, 4].includes(this.target?.subDailyCount)) {
      return false;
    }
    return (
      Array.isArray(selectedSensors) &&
      selectedSensors.some((sensor: any) => sensor?.operatorKey === OPERATORS.ICEYE)
    );
  }

  submit(feasibility: boolean) {
    let click = true;
    let selectedSensors: any = [],
      newTaskParams = {};
    let id = -1;
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let cueingTarget = '';
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate = moment(this.target.closeWindow).utcOffset(0, true).format();
    let time_difference =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    let totalTaskNumber = 0;
    let userTimezone = this.utilsService.getUserTimezone(this.currentUser);

    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Fortnightly') {
        no_of_repeats = Math.ceil(days_difference / 14);
        this.expectedAge = '14 days, 00:00:00';
      } else if (this.target.freqOption === 'Number of collections') {
        no_of_repeats = this.getNumberOfCollections();
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      } else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.freqOption === 'Days') {
        const weekDates = buildRecurringWeekDates(
          this.target?.openWindow,
          this.target?.closeWindow,
          Array.isArray(this.target.recurringDays) ? this.target.recurringDays : []
        );
        no_of_weeks = weekDates.length;
        no_of_repeats = weekDates.reduce((sum, week) => sum + (Object.values(week)[0] as string[]).length, 0);
        this.expectedAge = '1 day, 00:00:00';
      } else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }

    const submissionDate: any = new Date();
    const timeDifference =
      new Date(enddate).getTime() - new Date(submissionDate).getTime();
    let dayDifference = (timeDifference / (1000 * 60 * 60 * 24));

    this.AVAILABLESENSORS.forEach((sensor, index) => {
      if (sensor.checked) {
        if (sensor?.key === OPERATORS.ECURS_L) {
          sensor.minimumAreaSize = sensor?.selectedModes[0]?.minareastrip;
        }
        this.cueingArea = '';
        if(sensor.tabIndex === 1 && this.target.taskStrategy === this.tipAndCue && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation)) {
        let locationType = 'Both';
        if (sensor.supportedTarget == this.poiOnly)
          locationType = 'Point'
        else if(sensor.supportedTarget == this.aoiOnly)
          locationType = 'Polygon'
          let observationInterest = this.target.observationTypeCue == "Point" ? 'POI' : 'AOI';
          
          if ((sensor.supportedTarget == this.aoiAndPoi || sensor.supportedTarget == this.poiOnly || this.target.observationTypeCue == locationType))
             {
            cueingTarget = geoParse(this.target.geoJSONCue);
            this.cueingArea = this.target.areaCue;
            const cueArea = Number(this.target?.areaCue ?? 0);
            const minArea = Number(this.derivedMinArea ?? 0);
            this.derivedAreaCalc = cueArea < minArea ? this.derivedMinArea : this.target.areaCue;
          } else {
            cueingTarget = geoParse(this.target.derviedGeoJSON);
            this.cueingArea = this.target.derivedArea;
            this.derivedAreaCalc = this.target.derivedArea;
            if (this.target.derviedGeoJSON.includes('POINT'))
               this.derivedAreaCalc = this.derivedMinArea;
          }
        }
        id += 1;
        let sensordata: any;
        if (sensor.sensortype === 'SAR' || sensor.sensortype === 'InSAR' || sensor.sensortype === 'ScanSAR' || sensor.key === OPERATORS.CONSTELLR) {
          let inSarStatus = false;
          let insarCost = sensor.selectedCost;
          if((sensor.key === OPERATORS.ECURS || sensor.key === OPERATORS.ECURS_L) && sensor.sensortype === 'InSAR' && sensor.noOfInsar) {
            inSarStatus = true;
            this.no_of_insarScenes = sensor.noOfInsar;
            let perCost = sensor.selectedCost/2;
            insarCost = this.no_of_insarScenes  * perCost;
            this.totalSceneCount = this.no_of_insarScenes;
          }
          if (this.getAreaInSubmit(sensor) < sensor.minimumAreaSize) {
            const calculatedCost = parseFloat((insarCost * no_of_repeats).toFixed(2));
            const safeCost = Number.isNaN(calculatedCost) ? 0 : calculatedCost;
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              latency: sensor.selectedLatencyKey,
              collectmode: this.selctedCollectMode[index],
              cost: safeCost,
              unitCost: safeCost,
              unit: sensor.unit,
              multiplierCost: insarCost,
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization
                ? sensor?.selectedPolarization
                : sensor?.defaultPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              orbitalPlane: sensor?.orbitalPlane,
              orbitalState: sensor?.orbitalState,
              observationDirection: sensor?.observationDirection,
              polarization: sensor?.polarization,
              numOfLooks: sensor?.numOfLooks,
              imageWidth: sensor?.imageWidth,
              imageLength: sensor?.imageLength,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              targetAzimuthAngleMin: sensor?.selectedAzimuthAngleMin ? sensor?.selectedAzimuthAngleMin : sensor?.defaultAzimuthAngleMin,
              targetAzimuthAngleMax: sensor?.selectedAzimuthAngleMax ? sensor?.selectedAzimuthAngleMax : sensor?.defaultAzimuthAngleMax,
              targetGrazingAngleMin: sensor?.selectedGrazingAngleMin ? sensor?.selectedGrazingAngleMin : sensor?.defaultGrazingAngleMin,
              targetGrazingAngleMax: sensor?.selectedGrazingAngleMax ? sensor?.selectedGrazingAngleMax : sensor?.defaultGrazingAngleMax,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              sarOrbitType: sensor?.selectedOrbitType,
              sourceCode: sensor?.sourceCode,
              sensorId: sensor?.sensorId
            };
          } else {
            let scene = Math.ceil(this.getAreaInSubmit(sensor) / sensor.minimumAreaSize);
            const calculatedCost = parseFloat((scene * insarCost * no_of_repeats).toFixed(2));
            const safeCost = Number.isNaN(calculatedCost) ? 0 : calculatedCost;
            this.totalSceneCount = this.no_of_insarScenes * scene;
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              latency: sensor.selectedLatencyKey,
              collectmode: this.selctedCollectMode[index],
              cost: safeCost,
              unitCost: safeCost,
              unit: sensor.unit,
              multiplierCost: (insarCost * scene),
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization
                ? sensor?.selectedPolarization
                : sensor?.defaultPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              orbitalPlane: sensor?.orbitalPlane,
              orbitalState: sensor?.orbitalState,
              observationDirection: sensor?.observationDirection,
              polarization: sensor?.polarization,
              numOfLooks: sensor?.numOfLooks,
              imageWidth: sensor?.imageWidth,
              imageLength: sensor?.imageLength,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              targetAzimuthAngleMin: sensor?.selectedAzimuthAngleMin ? sensor?.selectedAzimuthAngleMin : sensor?.defaultAzimuthAngleMin,
              targetAzimuthAngleMax: sensor?.selectedAzimuthAngleMax ? sensor?.selectedAzimuthAngleMax : sensor?.defaultAzimuthAngleMax,
              targetGrazingAngleMin: sensor?.selectedGrazingAngleMin ? sensor?.selectedGrazingAngleMin : sensor?.defaultGrazingAngleMin,
              targetGrazingAngleMax: sensor?.selectedGrazingAngleMax ? sensor?.selectedGrazingAngleMax : sensor?.defaultGrazingAngleMax,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              sarOrbitType: sensor?.selectedOrbitType,
              sourceCode: sensor?.sourceCode,
              sensorId: sensor?.sensorId
         
            };
          }
          if (inSarStatus) {
            sensordata.noOfScenes = this.no_of_insarScenes;
            sensordata.totalSceneCount = this.totalSceneCount;
            this.no_of_insarScenes = 0;
          }
          if (isUmbraScanMode(sensor)) {
            // Umbra Scan SAR: flat-fee per scan mode — overwrite area-based cost fields
            sensordata.cost = parseFloat((insarCost * no_of_repeats).toFixed(2));
            sensordata.unitCost = parseFloat((insarCost * no_of_repeats).toFixed(2));
            sensordata.multiplierCost = insarCost;
            sensordata.areacalc = this.target?.scanArea ?? 0;
            sensordata.isPoint = false;
            sensordata.isCalculatedAreaSmaller = false;
          }
          if (sensor.key === OPERATORS.UMBRA && !isUmbraScanMode(sensor)) {            
            if (sensor.numberOfLooks) sensordata.numberOfLooks = sensor.numberOfLooks
            else sensordata.numberOfLooks = sensor.selectedResolution.numberOfLooks[0]
          }
        } else if (sensor.sensortype === 'RF') {
          let targetLength = this.target.multiTarget?.length > 0 ? this.target.multiTarget.length : 1;
          
          if (sensor.key === OPERATORS.LBAND) {
            for (const signal of sensor?.signalsOfInterest || []) {
              if (signal.collectionDuration === 60) {
                signal.isAudio = true;
              }
            }
          }

          const calculatedArea = this.getCalculatedArea(sensor);
          const sensorAreaCalc = Number(sensor?.areacalc);
          const areaCalcToSend = Number.isFinite(+calculatedArea) ? calculatedArea:sensorAreaCalc;
          const minimumAreaSize = Number(sensor?.minimumAreaSize);
          const minimumAreaToSend = Number.isFinite(+minimumAreaSize) ? minimumAreaSize : sensorAreaCalc;

          if (this.getAreaInSubmit(sensor) < sensorAreaCalc || sensor?.key === OPERATORS.LBAND) {
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
               ...(sensor?.key === OPERATORS.USL && sensor?.name === "BRO" 
              ? { rf_services: sensor.selectedResolution } 
              : { resolution: sensor.selectedResolution }),
              latency: sensor.selectedLatencyKey,
              collectmode: this.selctedCollectMode[index],
              cost: parseFloat((sensor.selectedCost * no_of_repeats).toFixed(2)),
              unitCost: parseFloat((sensor.selectedCost * no_of_repeats).toFixed(2)),
              unit: sensor.unit,
              multiplierCost: sensor.selectedCost,
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sensorCost: sensor.selectedCost,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: minimumAreaToSend,
              isPoint: this.target.geoJSON.includes('POINT'),
              isCalculatedAreaSmaller: minimumAreaToSend > areaCalcToSend,
              areacalc: areaCalcToSend,
              signalOfInterest: sensor?.signalOfInterest,
              isAudio: sensor?.isAudio,
              noOfPoints: targetLength,
              noOfCollections: sensor?.noOfCollections,
              overlapPercentage: sensor?.overlapPercentage,
              targetPoints: this.target?.targetPoints,
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              sensorId: sensor?.sensorId
            };
          } else {
            let scene = Math.ceil(this.getAreaInSubmit(sensor) / sensorAreaCalc);
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
               ...(sensor?.key === OPERATORS.USL && sensor?.name === "BRO" 
              ? { rf_services: sensor.selectedResolution } 
              : { resolution: sensor.selectedResolution }),
              latency: sensor.selectedLatencyKey,
              collectmode: this.selctedCollectMode[index],
              cost: parseFloat((scene * sensor.selectedCost * no_of_repeats).toFixed(2)),
              unitCost: parseFloat((scene * sensor.selectedCost * no_of_repeats).toFixed(2)),
              unit: sensor.unit,
              multiplierCost: (sensor.selectedCost * scene),
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sensorCost: sensor.selectedCost,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: minimumAreaToSend,
              isPoint: this.target.geoJSON.includes('POINT'),
              isCalculatedAreaSmaller: minimumAreaToSend > areaCalcToSend,
              areacalc: areaCalcToSend,
              signalOfInterest: sensor?.signalOfInterest,
              isAudio: sensor?.isAudio,
              noOfPoints: targetLength,
              noOfCollections: sensor?.noOfCollections,
              overlapPercentage: sensor?.overlapPercentage,
              targetPoints: this.target?.targetPoints,
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              sensorId: sensor?.sensorId
            };
          }
        } else if (sensor.sensortype === 'GHG') {
          let annualCost = 0;
          let targetLength = this.target.multiTarget?.length > 0 ? this.target.multiTarget.length : 1;
          if (sensor.selectedModes[0].captureMode.includes('annual')) {
            const keyToMatch = sensor.selectedLatencyKey.key; // Extract the key
            let cost = null;

            // Find the matching cost
            for (const item of sensor.selectedModes[0].cost) {
              if (item[keyToMatch] !== undefined) {
                cost = item[keyToMatch];
                break;
              }
            }
            
            if(cost) {
              let monthlyCost = cost / 12;
              if (noOfMonths > 12) {
                if (noOfMonths % 12 === 0) {
                  annualCost = (noOfMonths / 12) * cost;
                } else {
                  annualCost = cost +
                    (noOfMonths - 12) * monthlyCost;
                }
              } else {
                annualCost = cost;
              }
            }
          } else {
            annualCost = sensor.selectedCost * noOfMonths;
          }

          if (!sensor.selectedModes[0].captureMode.includes('Complex')) {
            annualCost = annualCost * targetLength;
          }

          if (this.target.area < sensor.areacalc) {
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              cloudcover: sensor.selectedCC,
              latency: sensor.selectedLatencyKey,
              cost: parseFloat((annualCost).toFixed(2)),
              unitCost: parseFloat((annualCost).toFixed(2)),
              unit: sensor.unit,
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              noOfMonths: noOfMonths,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              sensorId: sensor?.sensorId   
            };
          } else {
            let scene = Math.ceil(this.getAreaInSubmit(sensor) / sensor.areacalc);
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              cloudcover: sensor.selectedCC,
              latency: sensor.selectedLatencyKey,
              cost: parseFloat((annualCost * scene).toFixed(2)),
              unitCost: parseFloat((annualCost * scene).toFixed(2)),
              unit: sensor.unit,
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              noOfMonths: noOfMonths,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              sensorId: sensor?.sensorId
            };
          }
        } else if (sensor?.key === OPERATORS.SPIRE) {
          let area = this.target.area;
          if (this.target.area > 0
            && this.target.targetPoints) {
            area = '10000';
          }
          sensordata = {
            taskid: id,
            name: sensor.name,
            sensor: sensor.sensor,
            sensortype: sensor.sensortype,
            resolution: sensor.selectedResolution,
            cloudcover: sensor.selectedCC,
            latency: sensor.selectedLatencyKey,
            cost: 0,
            unitCost: parseFloat((sensor.selectedCost).toFixed(2)),
            unit: sensor.unit,
            country: sensor.country,
            collectionMode: sensor.selectedModes,
            ONA: sensor.selectedONAOption,
            type: sensor?.type,
            satIds: sensor?.satIds,
            operatorKey: sensor?.key,
            operatorEmail: sensor?.operatorEmail,
            SZA: sensor?.SZA,
            AC: sensor?.AC,
            sarPolarization: sensor?.selectedPolarization,
            sarOrbitDirection: sensor?.selectedOrbitDirection,
            productAnciallary: sensor?.selectedAnciallary,
            satelliteName: sensor?.satelliteName,
            holdBack: sensor?.selectedHoldBackOption,
            supportFeasibility: sensor?.feasibility,
            siteName: sensor?.sitename,
            tnqSensorType: sensor?.selectedTnqSensorType,
            siteData: sensor?.siteData,
            captureMode: sensor?.captureMode,
            noOfUsers: sensor?.noOfUsers,
            multiplierValue: sensor?.userCost,
            noOfRefreshes: sensor?.noOfRefreshes,
            isHistorical: sensor?.isHistorical,
            noOfHistoricalData: sensor?.noOfHistoricalData,
            historicalCost: sensor?.historicalCost,
            minimumArea: sensor?.minimumAreaSize,
            isPoint: this.target.geoJSON.includes("POINT"),
            isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.target.area,
            areacalc:area,
            updateFrequency: sensor?.updateFrequency,
            obfuscateName: sensor?.obfuscateName,
            displayName: sensor.displayName
          };
        } else if (sensor?.key === OPERATORS.CLYDE) {
          sensordata = {
            taskid: id,
            name: sensor.name,
            sensor: sensor.sensor,
            sensortype: sensor.sensortype,
            resolution: sensor.selectedResolution,
            cloudcover: sensor.selectedCC,
            latency: sensor.selectedLatencyKey,
            cost: 0,
            unit: sensor.unit,
            country: sensor.country,
            collectionMode: sensor.selectedModes,
            ONA: sensor.selectedONAOption,
            type: sensor?.type,
            satIds: sensor?.satIds,
            operatorKey: sensor?.key,
            operatorEmail: sensor?.operatorEmail,
            SZA: sensor?.SZA,
            AC: sensor?.AC,
            sarPolarization: sensor?.selectedPolarization,
            sarOrbitDirection: sensor?.selectedOrbitDirection,
            productAnciallary: sensor?.selectedAnciallary,
            satelliteName: sensor?.satelliteName,
            holdBack: sensor?.selectedHoldBackOption,
            supportFeasibility: sensor?.feasibility,
            siteName: sensor?.sitename,
            tnqSensorType: sensor?.selectedTnqSensorType,
            siteData: sensor?.siteData,
            captureMode: sensor?.captureMode,
            noOfUsers: sensor?.noOfUsers,
            multiplierValue: sensor?.userCost,
            isHistorical: sensor?.isHistorical,
            minCoverageArea: sensor.selectedTaskingPrice.data.selectedKey,
            noOfMonths: noOfMonths,
            unitCost: sensor.selectedTaskingPrice.data.price,
            noOfHistoricalData: sensor?.noOfHistoricalData,
            minimumArea: sensor?.minimumArea,
            isPoint: this.target.geoJSON.includes('POINT'),
            isCalculatedAreaSmaller: sensor?.minimumArea > this.target.area,
            areacalc: this.target.area,
            historicalUnitCost: sensor?.selectedHistoricalPrice?.data.price,
            updateFrequency: sensor?.updateFrequency,
            obfuscateName: sensor?.obfuscateName,
            displayName: sensor.displayName
          };
        } else {
          if (sensor?.key === OPERATORS.BLACKSKY && this.getAreaInSubmit(sensor) === 0) {
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              cloudcover: sensor.selectedCC,
              latency: sensor.selectedLatencyKey,
              cost: parseFloat((sensor.selectedCost * no_of_repeats).toFixed(2)),
              unitCost: parseFloat((sensor.selectedCost * no_of_repeats).toFixed(2)),
              unit: sensor.unit,
              multiplierCost: sensor.selectedCost,
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              captureMode: sensor?.captureMode,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              valueAddedOption: this.formatVAR(sensor?.valueAddedOption),
              demTotalPoint: sensor?.demTotalPoint,
              demTotalPrice: sensor?.demTotalPrice,
              indices: sensor?.indices,
              super_resolution: sensor?.super_resolution,
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName
            };
          } else if (this.getAreaInSubmit(sensor) < sensor.minarea) {
            if(this.currentUser.pointsEligible && (sensor?.key === OPERATORS.SDS || sensor?.key === OPERATORS.ORBVIEW)) {
            const roundedCost = Math.round(Number(sensor?.selectedCost));
            if (Number.isFinite(roundedCost)) {
            sensor.selectedCost = roundedCost;
             }
            }
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              cloudcover: sensor.selectedCC,
              latency: sensor.selectedLatencyKey,
              cost: parseFloat(((sensor.key === OPERATORS.GEOSAT ? (sensor.taskingWindowCost ?? 0) : 0) + sensor.selectedCost * sensor.minarea * no_of_repeats).toFixed(2)),
              unitCost: parseFloat((sensor.selectedCost * sensor.minarea * no_of_repeats).toFixed(2)),
              unit: sensor.unit,
              multiplierCost: (sensor.selectedCost * sensor.minarea),
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              captureMode: sensor?.captureMode,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              valueAddedOption: this.formatVAR(sensor?.valueAddedOption),
              demTotalPoint: sensor?.demTotalPoint,
              demTotalPrice: sensor?.demTotalPrice,
              indices: sensor?.indices,
              super_resolution: sensor?.super_resolution,
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              bitDepth: sensor?.selectedbitDepth,
              sensorId: sensor?.sensorId
            };
          } else {
            sensordata = {
              taskid: id,
              name: sensor.name,
              sensor: sensor.sensor,
              sensortype: sensor.sensortype,
              resolution: sensor.selectedResolution,
              cloudcover: sensor.selectedCC,
              latency: sensor.selectedLatencyKey,
              cost: parseFloat(((sensor.key === OPERATORS.GEOSAT ? (sensor.taskingWindowCost ?? 0) : 0) + this.getCalculatedArea(sensor) * sensor.selectedCost * no_of_repeats).toFixed(2)),
              unitCost: parseFloat((this.getCalculatedArea(sensor) * sensor.selectedCost * no_of_repeats).toFixed(2)),
              unit: sensor.unit,
              multiplierCost: (sensor.selectedCost * this.getCalculatedArea(sensor)),
              country: sensor.country,
              collectionMode: sensor.selectedModes,
              ONA: sensor.selectedONAOption,
              type: sensor?.type,
              satIds: sensor?.satIds,
              operatorKey: sensor?.key,
              operatorEmail: sensor?.operatorEmail,
              SZA: sensor?.SZA,
              AC: sensor?.AC,
              sarPolarization: sensor?.selectedPolarization,
              sarOrbitDirection: sensor?.selectedOrbitDirection,
              productAnciallary: sensor?.selectedAnciallary,
              satelliteName: sensor?.satelliteName,
              holdBack: sensor?.selectedHoldBackOption,
              supportFeasibility: sensor?.feasibility,
              siteName: sensor?.sitename,
              tnqSensorType: sensor?.selectedTnqSensorType,
              siteData: sensor?.siteData,
              captureMode: sensor?.captureMode,
              noOfUsers: sensor?.noOfUsers,
              multiplierValue: sensor?.userCost,
              minimumArea: sensor?.minimumAreaSize,
              isPoint: this.target.geoJSON.includes("POINT"),
              isCalculatedAreaSmaller: sensor?.minimumAreaSize > this.getCalculatedArea(sensor),
              areacalc:this.getCalculatedArea(sensor),
              valueAddedOption: this.formatVAR(sensor?.valueAddedOption),
              demTotalPoint: sensor?.demTotalPoint,
              demTotalPrice: sensor?.demTotalPrice,
              indices: sensor?.indices,
              super_resolution: sensor?.super_resolution,
              obfuscateName: sensor?.obfuscateName,
              displayName: sensor.displayName,
              bitDepth: sensor?.selectedbitDepth,
              sensorId: sensor?.sensorId
            };
          }
        }

        if (sensor.key === OPERATORS.UMBRA && !isUmbraScanMode(sensor)) {            
          if (sensor.numberOfLooks) sensordata.numberOfLooks = sensor.numberOfLooks
          else sensordata.numberOfLooks = sensor.selectedResolution.numberOfLooks[0]
        }
        if (sensor.key === OPERATORS.WYVERN) {            
          if (sensor.numberOfBands) sensordata.numberOfBands = sensor.numberOfBands
        }
        if (sensor.key === OPERATORS.SATVU) {
          sensordata.illuminationConstraint = sensor?.illuminationConstraint;
        }
        if (sensor.key === OPERATORS.ESPER) {
          sensordata.selectedBands = sensor.selectedBands;
          sensordata.cost = sensor.selectedCost;
          sensordata.unitCost = sensor.selectedCost;
          sensordata.multiplierCost = sensor.selectedCost;
        }
        if (sensor.key === OPERATORS.PIXXEL) {
          sensordata.selectedBands = sensor.selectedBands;
        }
        if (sensor.key === OPERATORS.AZISTA) {
          sensordata.imageLength = Number(sensor.selectedImageLength);
          sensordata.minimumArea = 35 * sensordata.imageLength;
        }

        if (sensor.key === OPERATORS.OSK && this.target.area === 0) {
          sensordata.cost = sensor.selectedCost;
          sensordata.unitCost = sensor.selectedCost;
          sensordata.multiplierCost = sensor.selectedCost;
        }
        else if(sensor.key === OPERATORS.OSK && this.getAreaInSubmit(sensor) > sensor.minarea) {
          let cost = parseFloat((this.getCalculatedArea(sensor) * sensor.selectedCost * no_of_repeats).toFixed(2));
          sensordata.cost =  cost;
          sensordata.unitCost = cost;
          sensordata.multiplierCost = (sensor.selectedCost * this.getCalculatedArea(sensor));
        }
        else if(sensor.key === OPERATORS.OSK && this.getAreaInSubmit(sensor) < sensor.minareastrip) {
          sensor.unitCost = parseFloat((sensor.selectedCost * sensor.minareastrip * no_of_repeats).toFixed(2));
          sensor.unit = sensor.unit;
          sensor.multiplierCost = (sensor.selectedCost * sensor.minareastrip);
        }

        if (sensor.key === OPERATORS.SDS || sensor.key === OPERATORS.ORBVIEW) {
          sensordata.sourceCode = sensor.sourceCode;
        }

        if (sensor.key === OPERATORS.WEATHEREX) {
          if (this.target?.area != null && this.target.area !== 0) {
            sensordata.resolution = sensor.selectedResolution?.value ?? sensor.selectedResolution;
          } else {
            sensordata.resolution = null;
          }
          sensordata.noOfRefreshes = sensor.noOfRefreshes;
          sensordata.refreshRate = sensor.selectedRefreshRate?.value ?? sensor.selectedRefreshRate;
          // WeatherEx pricing is flat per-refresh — no area multiplier applies.
          // unitCost = charged_price_usd per refresh (from live quote)
          // cost     = unitCost × noOfRefreshes × no_of_repeats (total charge)
          // multiplierCost = unitCost × noOfRefreshes (pre-repeat subtotal shown in UI)
          const wxUnitPrice = Number(sensor.unitcost ?? 0);
          const wxSubtotal  = Number(sensor.selectedCost ?? 0); // unitCost × noOfRefreshes
          sensordata.unitCost      = wxUnitPrice;
          sensordata.cost          = parseFloat((wxSubtotal * no_of_repeats).toFixed(2));
          sensordata.multiplierCost = wxSubtotal;
        }
        if (sensor.key === OPERATORS.VOYAGERADAR) {
          sensordata.apiCredits      = sensor.apiCredits;
          sensordata.updateFrequency = sensor.updateFrequency;
          // Credit wallet: unitCost = USD price of ONE credit,
          // selectedCost = unitcost × apiCredits (from the strategy).
          const vrUnitPrice  = Number(sensor.unitcost ?? 0);
          const vrSubtotal   = Number(sensor.selectedCost ?? 0);
          sensordata.unitCost      = vrUnitPrice;
          sensordata.cost          = parseFloat((vrSubtotal * no_of_repeats).toFixed(2));
          sensordata.multiplierCost = vrSubtotal;
        }
        if (sensor.key === OPERATORS.VESSELFINDER) {
          // Same credit-wallet model as Voyage Radar above — see
          // VesselFinderOperatorStrategy.calculateUnitCost.
          sensordata.apiCredits      = sensor.apiCredits;
          sensordata.updateFrequency = sensor.updateFrequency;
          const vfUnitPrice = Number(sensor.unitcost ?? 0);
          const vfSubtotal  = Number(sensor.selectedCost ?? 0);
          sensordata.unitCost      = vfUnitPrice;
          sensordata.cost          = parseFloat((vfSubtotal * no_of_repeats).toFixed(2));
          sensordata.multiplierCost = vfSubtotal;
        }
        if (sensor.key === OPERATORS.AISSTREAM) {
          // FLAT PER-DAY — no area multiplier applies, the same exemption
          // WeatherEx and Voyage Radar take directly above.
          //
          // Without this block the generic assembly leaves
          // `cost = getCalculatedArea(sensor) × selectedCost × no_of_repeats`,
          // which is right for a sensor priced per sqkm and badly wrong for one
          // priced per day: a 17,853 km² AOI quoted US$ 178,528.90 for a 30-day
          // stream that should cost US$ 300. The area multiplication is the
          // DEFAULT here, so a per-duration operator has to opt out of it
          // explicitly — being absent from this list is not neutral.
          //
          //   unitCost       = USD per DAY (operator doc `costunit: "day"`)
          //   cost           = unitCost × days of TOI  (from the strategy's
          //                    selectedCost — see AisstreamOperatorStrategy)
          //   multiplierCost = the same subtotal, which is what the UI shows
          const aisUnitPrice = Number(sensor.unitcost ?? 0);
          const aisSubtotal  = Number(sensor.selectedCost ?? 0); // unitCost × days
          sensordata.unitCost       = aisUnitPrice;
          // NOT multiplied by `no_of_repeats`, unlike the two blocks above.
          // The backend's AISstream branch in `controllers/budget.js` does not
          // apply repeats either — the operator sets
          // `disallowRepeatFrequencyInput: true` and the stream simply runs for
          // the window rather than being re-tasked within it. In practice
          // repeats is always 1 here, so the two agree; if it ever is not, the
          // quote must still match the invoice.
          sensordata.cost           = parseFloat(aisSubtotal.toFixed(2));
          sensordata.multiplierCost = aisSubtotal;
        }
        if (sensor.key === OPERATORS.SATELLITEVU_VANZYL) {
          sensordata.isNightSensor = sensor.isNightSensor ?? false;
        }
        if (sensor.key === OPERATORS.CONSTELLR && sensor?.illuminationConstraint) {
          sensordata.illuminationConstraint =
            sensor.illuminationConstraint === 'day-night'
              ? 'both'
              : sensor.illuminationConstraint;
        }


        selectedSensors.push(sensordata);
      }
    });
    
      /** Adding points variable to sensors */

      selectedSensors = selectedSensors.map(sensor => {
        let tNumber = 0;
        let signalOfInterestWithTaskNumber = sensor.signalOfInterest;
        let shouldUpdateSignalOfInterest = false;
        if (this.currentUser?.allocated) {
            if (sensor.operatorKey === OPERATORS.LBAND) {
                const baseTaskNumber = Number(sensor.latency?.taskNumber ?? sensor.latency?.tasknumber ?? 1) || 1;
                const signalOfInterestLength = Array.isArray(sensor.signalOfInterest) ? sensor.signalOfInterest.length : 0;
                const noOfCollections = Number(sensor.noOfCollections) || 0;
                tNumber = baseTaskNumber * signalOfInterestLength * noOfCollections;
                if (Array.isArray(sensor.signalOfInterest)) {
                    signalOfInterestWithTaskNumber = sensor.signalOfInterest.map((signal: any) => ({
                        ...signal,
                        taskNumber: baseTaskNumber * noOfCollections,
                    }));
                    shouldUpdateSignalOfInterest = true;
                }
                this.totalTaskNumber += tNumber;
            } else if (sensor.isPoint === true) {
        tNumber = 1 * no_of_repeats;
                this.totalTaskNumber += tNumber;
            } else {
                if (sensor.unit === 'sqkm' || sensor.unit === 'scene' || sensor.unit === 'week' || sensor.unit === 'day') {
          tNumber = (Math.ceil(sensor.areacalc / sensor.minimumArea) * no_of_repeats);
                    this.totalTaskNumber += tNumber;
                }
            }
        }
        const { isNightSensor, ...sensorRest } = sensor;
        const p = this.currentUser.pointsEligible ? this.convertCostToPoints(sensorRest.cost, false) : 0;
        return {
            ...sensorRest,
            ...(shouldUpdateSignalOfInterest && { signalOfInterest: signalOfInterestWithTaskNumber }),
            point: p,
            taskNumber: tNumber,
            ...(sensorRest.operatorKey === OPERATORS.SATELLITEVU_VANZYL && { nightVision: isNightSensor ?? false }), 
        };
      });

    const uniqueNames = new Set<string>();
    this.uniqueNamesData = [];

    for (const item of selectedSensors) {
      if (!uniqueNames.has(item.operatorKey)) {
        uniqueNames.add(item.operatorKey);
        this.uniqueNamesData.push(item);
      }
    }
    for (const sensors of this.uniqueNamesData) {
      if (
        feasibility &&
        this.target.area > 0 &&
        (sensors?.operatorKey === OPERATORS.SATELLOGIC ||
          sensors?.operatorKey === OPERATORS.CAPELLA)
      ) {
        const message = `${sensors?.displayName} ${sensors?.sensor} does not support area of interest (AOI) tasking by specific opportunity`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        click = false;
        return;
      }  else if (feasibility && this.target.selectedOption === 1) {
        const message =
          'Opportunity-based tasking is only available for Specific Date, Specific Day and period tasking. Please select automated tasking if you require recurrence.';
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        click = false;
        return;
      } else if (
        feasibility &&
        sensors?.operatorKey === OPERATORS.CAPELLA &&
        (this.target.selectedOption === 0 || this.target.selectedOption === 3)
      ) {
        const message = `Opportunity-based tasking for ${sensors?.displayName} ${sensors?.sensor} is only available for period tasking. Please select automated tasking if you require recurrence, Specific Date and Specific Day.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        return;
      } else if (
        feasibility &&
        sensors?.operatorKey === OPERATORS.SATELLOGIC &&
        dayDifference > 7
      ) {
        const message = `Opportunity tasking for ${sensors?.displayName} ${sensors?.sensor} is available for the next seven days from the current date. If you require tasking for a more extended period, please select automated tasking.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        click = false;
        return;
      }
    }

    const isGHGIncluded = this.selectedSensors.some(item => item.key === OPERATORS.GHG);
    const isImagingSensorsIncluded = this.selectedSensors.some(item => (item.sensor != 'AIS' && item.sensor != 'RF' ));
    const isLBandIncluded = this.selectedSensors.some(item => (item.key === OPERATORS.LBAND));
    // VesselFinder covers the whole world, so multi-point tasks for it must still
    // go through the single newTaskSubmit call, never the multi-point endpoint.
    const isVesselFinderIncluded = this.selectedSensors.some(item => item.key === OPERATORS.VESSELFINDER);

    if (this.target?.multiTarget?.length > 1 && this.selectedSensors?.length > 1 && isGHGIncluded) {
      const message = `GHGSat Methane is currently not available together with other sensors for multi-point tasking.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      click = false;
      return
    }

    if (isImagingSensorsIncluded && isLBandIncluded && this.target?.taskStrategy !== this.tipAndCue) {
      const message = `You can only combine RF sensors with other RF sensors, such as AIS.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      click = false;
      return
    }

    if (isLBandIncluded && !this.rfSignals) {
      const message = `Please select at least one RF signal of interest from the options.`;
      this.popupService.openPopup(RequiredPopupComponent, message, '', '50%');
      click = false;
      return
    }

    const weatherExSensor = this.selectedSensors.find((item: any) => item.key === OPERATORS.WEATHEREX);
    if (weatherExSensor && (!weatherExSensor.selectedModes || weatherExSensor.selectedModes.length === 0)) {
      const message = `Please select at least one mode from the WeatherEx options.`;
      this.popupService.openPopup(RequiredPopupComponent, message, '', '50%');
      click = false;
      return;
    }

    const voyageRadarSensor = this.selectedSensors.find((item: any) => item.key === OPERATORS.VOYAGERADAR);
    if (voyageRadarSensor && !voyageRadarSensor.apiCredits) {
      // Named by its obfuscation-aware display name, never the operator key.
      const sensorLabel =
        (this.currentUser?.obfuscated && voyageRadarSensor?.obfuscateName)
          ? voyageRadarSensor.obfuscateName
          : voyageRadarSensor?.name || 'the AIS sensor';
      const message = `Please enter the number of credits for ${sensorLabel} before submitting.`;
      this.popupService.openPopup(RequiredPopupComponent, message, '', '50%');
      click = false;
      return;
    }

    const vesselFinderSensor = this.selectedSensors.find((item: any) => item.key === OPERATORS.VESSELFINDER);
    if (vesselFinderSensor && !vesselFinderSensor.apiCredits) {
      const sensorLabel =
        (this.currentUser?.obfuscated && vesselFinderSensor?.obfuscateName)
          ? vesselFinderSensor.obfuscateName
          : vesselFinderSensor?.name || 'the AIS sensor';
      const message = `Please enter the number of credits for ${sensorLabel} before submitting.`;
      this.popupService.openPopup(RequiredPopupComponent, message, '', '50%');
      click = false;
      return;
    }

    if (this.target?.multiTarget?.length > 1 && this.selectedSensors?.length > 1 && isGHGIncluded) {
      const message = `GHGSat Methane is currently not available together with other sensors for multi-point tasking.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      click = false;
      return
    }

    this.taskContext = {
      newTaskParams: newTaskParams,
      selectedSensors: selectedSensors,
      click: click,
      no_of_repeats: no_of_repeats,
      feasibility: feasibility,
      isLBandIncluded: isLBandIncluded,
      isGHGIncluded: isGHGIncluded,
      isVesselFinderIncluded: isVesselFinderIncluded,
      cueingTarget: cueingTarget
    };
    let callSubmitTask = true;
    if (this.target?.taskStrategy === 'Tip-and-Cue' && this.target?.tipAndCueBasedOn === "Rules" && this.target?.rule === "rule-3") {
      const index = selectedSensors.findIndex(sensor => sensor.tnqSensorType === 'Cueing');
      if (index != -1 ) {
      const cueingSensor = selectedSensors[index];
      let gstAmount = this.utilsService.calculateGST(cueingSensor?.cost, this.currentUser);
      let totalCueingAmount = (cueingSensor?.cost + gstAmount + BUFFER_AMT).toFixed(2);

      if (this.currentUser?.allocated) {
        // For allocated users: check remaining tasks from allocation profile
        this.apiService.getAllocation().subscribe((res: any) => {
          const allocationSensors: any[] = res?.allocations?.[0]?.sensor ?? [];
          const cueingTaskNumber = cueingSensor?.taskNumber ?? 0;

          const matchedAllocation = allocationSensors.find((a: any) => {
            const sensorMatch = a.sensor === cueingSensor.sensor;
            const operatorMatch = a.operator === cueingSensor.name;
            const resolutionMatch = a.resolution === cueingSensor.resolution?.value;
            const modeMatch = a.collection_mode?.modeKey === cueingSensor.collectionMode?.[0]?.modeKey;
            return sensorMatch && operatorMatch && resolutionMatch && modeMatch;
          });
  
          const numberToWord = (n: number): string => {
            const words = ['zero','one','two','three','four','five','six','seven','eight','nine'];
            return n < 10 ? words[n] : n.toString();
          };
          
          if (matchedAllocation && matchedAllocation.remaining_task < cueingTaskNumber) {
            const remaining = numberToWord(matchedAllocation.remaining_task);
            const needed = numberToWord(cueingTaskNumber);
            const message = `Your allocated task quota is insufficient for this tip-and-cue workflow. You have ${remaining} remaining task(s) but need ${needed}.`;
            this.popupService.openPopup(WarningPopup, message, '', '50%');
            click = false;
            return;
          }

          // Sufficient tasks — show dialog
          const tnqmessage = `We will be temporarily holding ${numberToWord(cueingTaskNumber)} task(s) for the cueing sensor. If the cueing of the sensor could not be performed, the task(s) would be returned to your account balance.`;
          const dialogRef = this.dialog.open(OperatorPopupComponent, {
            width: '41%',
            backdropClass: 'blurr',
            disableClose: true,
            data: { tnqmessage },
          });
          dialogRef.afterClosed().subscribe({
            next: (result) => {
              if (result === 'agree') {
                callSubmitTask = false;
                this.submitTask();
              } else {
                click = false;
              }
            },
            error: () => {
              const message = `Try again`;
              this.popupService.openPopup(WarningPopup, message, '', '50%');
              click = false;
            }
          });
        });
        return; // async — always return here for allocated users
      }

      // Non-allocated users: existing balance check
      if (this.userDetails?.acBalance < totalCueingAmount) {
        const message = `Your account balance is insufficient to task this tip-and-cue workflow. Please top up at least ${formatCurrency(totalCueingAmount)} before tasking again.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
        click = false;
        return;
      } else {
        let cueingAmount = (cueingSensor?.cost + gstAmount).toFixed(2);
        const tnqmessage = `We will be temporarily holding the cost of the cueing sensor, which is ${formatCurrency(parseFloat(cueingAmount))}. If the cueing of the sensor could not be performed, the amount would be returned to your account balance.`;
        const dialogRef = this.dialog.open(OperatorPopupComponent, {
          width: '41%',
          backdropClass: 'blurr',
          disableClose: true,
          data: { tnqmessage },
        });
        dialogRef.afterClosed().subscribe({
          next: (result) => {
            if (result === 'agree') {
              callSubmitTask = false;
              this.submitTask();
            } else {
              click = false;
            }
          },
          error: () => {
            const message = `Try again`;
            this.popupService.openPopup(WarningPopup, message, '', '50%');
            click = false;
          }
        });
      }
      return;
    }
    }
    if (callSubmitTask) {
      this.submitTask();
    }
    }

  submitTask() {
    let { newTaskParams, selectedSensors, click, no_of_repeats, feasibility, isLBandIncluded, isGHGIncluded, isVesselFinderIncluded, cueingTarget} = this.taskContext;
    let userTimezone = this.utilsService.getUserTimezone(this.currentUser);
    if (this.target?.taskStrategy === 'Tip-and-Cue' && selectedSensors[0]?.tnqSensorType === 'Cueing') {
      selectedSensors = selectedSensors.reverse();
    }
    const currentDate: any = new Date();

    this.totalAmount = selectedSensors.reduce((a, { cost }) => a + cost, 0);
    this.taskPoint = this.currentUser.pointsEligible ? selectedSensors.reduce((total, sensor) => {
      return total + this.convertCostToPoints(sensor.cost,false);
    }, 0) : 0;

    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['taskname'] = this.target.taskname;
    newTaskParams['purpose'] = this.target?.purposeOption;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    const hasUmbraScanSelection = selectedSensors?.some(
      (sensor) => this.isUmbraScanSarSensor(sensor)
    );
    newTaskParams['area'] = this.target.area;
    if (hasUmbraScanSelection) {
      newTaskParams['scanArea'] = Number(this.target?.scanArea ?? 0);
    }
    if (this.target.geotargets != null) {
      newTaskParams['target'] = this.target.geotargets;
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    newTaskParams['geometryCentroid'] = this.target?.geometryCentroid;
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['sensors'] = JSON.stringify(selectedSensors);
    newTaskParams['taskcost'] = this.totalAmount.toFixed(2);
    newTaskParams['taskPoints'] = this.taskPoint;
    newTaskParams['frequency'] = this.target.selectedOption;
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      if (this.target.freqOption === 'Number of collections') {
        newTaskParams['noOfRepeats'] = this.getNumberOfCollections();
      } else {
        newTaskParams['noOfRepeats'] = no_of_repeats;
      }
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else if (this.target.selectedOption === 3) {
        const specificDay = typeof this.target?.freqOption === 'string'
          ? this.target.freqOption.trim().toLowerCase()
          : '';
        newTaskParams['repeatFrequency'] = '';
        newTaskParams['specificDay'] = specificDay;
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }

    const recurringDays = this.getRecurringDaysPayload();
    if (recurringDays !== null) {
      newTaskParams['recurringDays'] = recurringDays;
      newTaskParams['recurringWeekDates'] = buildRecurringWeekDates(
        this.target?.openWindow,
        this.target?.closeWindow,
        recurringDays
      );
    }

    // ICEYE sub-daily recurrence — isolated to ICEYE only, does not affect any other operator.
    if (this.isIceyeSubDailyRecurrenceApplicable(selectedSensors)) {
      newTaskParams['recurringSubdailyDates'] = generateIceyeSubdailyRecurrence(
        this.target?.openWindow,
        this.target?.closeWindow,
        this.target?.subDailyCount
      );
    }

    newTaskParams['mode'] = this.target.mode;
    newTaskParams['expected_age'] = this.expectedAge;
    newTaskParams['circleCordinates'] = this.target.circleCordinates;

    newTaskParams['openWindow'] = moment(this.target.openWindow)
      .utcOffset(0, true)
      .format();
    newTaskParams['closeWindow'] = moment(this.target.closeWindow)
      .utcOffset(0, true)
      .format();

      newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
      .tz(userTimezone)
      .format();
    
    newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
      .tz(userTimezone)
      .format();
      
    newTaskParams['projectid'] = this.target?.projectId;
    newTaskParams['feasibilityTask'] = feasibility;
    newTaskParams['collectionStart'] = this.collectionStart;
    newTaskParams['collectionEnd'] = this.collectionEnd;
    newTaskParams['taskStrategy'] = this.target?.taskStrategy;
    newTaskParams['tipAndCueBasedOn'] = this.target?.tipAndCueBasedOn;
    newTaskParams['observation'] = this.target?.observation;
    newTaskParams['rule'] = this.target?.rule;
    newTaskParams['intent'] = this.target?.intent;
    newTaskParams['cloudCover'] = this.target?.cloudCover;
    newTaskParams['openWater'] = this.target?.openWater
    newTaskParams['totalTaskNumber'] = this.totalTaskNumber;
    newTaskParams['taskSubStrategy'] = this.target?.taskSubStrategy;
    newTaskParams['feeds'] = this.target?.feeds;
    newTaskParams['observationData'] = this.target?.observationData;
    if(cueingTarget !== '') {
      newTaskParams['cueingTarget'] = JSON.stringify(cueingTarget);
    }

    if(this.target?.taskStrategy == "Help Select Sensor(s)"){
      newTaskParams['useCase'] = this.target?.useCase;
      newTaskParams['useCaseDescription'] = this.target?.useCaseDescription;
    }
     newTaskParams['isReTask'] = this.target?.isRetask;
    if (this.target?.sendParentTaskId) {
      newTaskParams['parentTaskId'] = this.target?.parentTaskId;
    }
    if (click) {
      this.valid = false;
      this.enable = true;

      if (this.singleCircle && this.target?.multiTarget?.length === 3 && isLBandIncluded){
        let newTarget = this.groupPointsByOverlap(JSON.parse(newTaskParams['target']));
        newTaskParams['target'] = JSON.stringify(newTarget);
      }
      if (!isVesselFinderIncluded && ((this.target?.multiTarget?.length > 1 && !isGHGIncluded && !isLBandIncluded) || (this.target?.multiTarget?.length > 1 && isLBandIncluded && !this.singleCircle)
       || (this.singleCircle && this.target?.multiTarget?.length === 3 && isLBandIncluded))) {
        this.validateSmallBoatFeedsBeforeSubmit(newTaskParams).then((canProceed) => {
          if (!canProceed) {
            this.enable = false;
            return;
          }
          this.apiService.multiPoiTaskSubmit(newTaskParams).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            let taskid;
            taskid = res?.taskid;
            const dialogRef = this.dialog.open(ConfirmDialog, {
              backdropClass: 'blurr', disableClose: true,
              data: { taskid: taskid, taskname: this.target.taskname, response: res, type: 'normal' },
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result === 'Done') {
                this.resetTasking.emit('Reset');
              }
            });
          }
        }, (error: any) => {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '50%', backdropClass: 'blurred', disableClose: true,
            data: { message: "fail" }
          });
        });
        });
      } else {
        this.validateSmallBoatFeedsBeforeSubmit(newTaskParams).then((canProceed) => {
          if (!canProceed) {
            this.enable = false;
            return;
          }
          this.apiService.newTaskSubmit(newTaskParams).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            let data = JSON.parse(res?.response);
            let taskid;
            let sensorList = this.matchUUIDs(newTaskParams['sensors'], data);
            newTaskParams['sensors'] = JSON.stringify(sensorList);
            if (data && data.length > 0) {
              taskid = res?.taskid;
              newTaskParams['taskId'] = taskid;
              this.apiService
                .genCollection(
                  this.currentUser.id,
                  this.currentUser.email,
                  newTaskParams
                )
                .subscribe((response: any) => {
                  const generatedTaskId = response?.id;
                });
            }
            const dialogRef = this.dialog.open(ConfirmDialog, {
              backdropClass: 'blurr',
              disableClose: true,
              data: {
                taskid: taskid,
                taskname: this.target.taskname,
                response: res,
                type: 'normal',
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result === 'Done') {
                this.resetTasking.emit('Reset');
              }
            });
          }
        }, (error: any) => {
          let errorMessage = error?.error?.msg === 'Allocation Failed' ? 'Allocation Failed' : 'fail';
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '50%', backdropClass: 'blurred', disableClose: true,
            data: { message: errorMessage, response: error?.error?.descripton }
          });
          this.enable = false;
        });
        });
      }
    }
    const taskType = feasibility ? 'Opportunity' : 'Automated';
    const duration = this.sessionTracker.getSessionDuration();
    let sessionDurationFormatted = '';
    if (duration) {
      const totalSeconds = Math.floor(duration / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;    
      sessionDurationFormatted = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    const eventName = taskType === 'Opportunity' ? 'Opportunity-Tasking' : 'Automated-Tasking';
    this.posthogService.capture(eventName, {
      method: 'standard',
      message: `${this?.currentUser?.email} initiated ${taskType} tasking after ${sessionDurationFormatted} s. `,
      email: this?.currentUser?.email,
      country:this.currentUser?.country || 'Not Found',
      sessionTime:sessionDurationFormatted
    });
  }

  clearSensorCostDetails() {
    this.selectedSensorTypes = '';
    this.selectedSensorList= [];
    this.selectedSensors= [];
     this.clearSensorCost.emit(false);

  }

  /**
   * Validate if any selected small-boat feed has weather cost
   * Only shows popup and blocks submit if weather confirmation is needed
   */
  private async validateSmallBoatFeedsBeforeSubmit(newTaskParams: any): Promise<boolean> {
    let activeFeedName = '';
    try {
      const rawFeeds = newTaskParams?.feeds || this.target?.feeds || [];
      const feeds = Array.isArray(rawFeeds) ? rawFeeds : (rawFeeds ? [rawFeeds] : []);
      if (!feeds || feeds.length === 0) {
        return true; // No feeds selected, proceed
      }
      let sensorId: string | null = null;
      let collectionModeValue: string | null = null;
      if (newTaskParams?.sensors) {
        try {
          const parsedSensors = typeof newTaskParams.sensors === 'string'
            ? JSON.parse(newTaskParams.sensors)
            : newTaskParams.sensors;

          if (Array.isArray(parsedSensors) && parsedSensors.length > 0) {
            // Find sensor with tnqSensorType === 'Tipping' (or fallback to first sensor if not found)
            const tippingSensor = parsedSensors.find(
              (s: any) => s?.tnqSensorType === 'Tipping'
            ) || parsedSensors[0];

            sensorId = tippingSensor?.sensorId || null;

            // Handle collectionMode whether it's an array or an object
            const collMode = tippingSensor?.collectionMode;
            if (Array.isArray(collMode)) {
              collectionModeValue = collMode[0]?.value || null;
            }
          }
        } catch {
          sensorId = null;
          collectionModeValue = null;
        }
      }

      const smallBoatFeedsNeedingWeatherCheck = feeds.filter((feed: any) => {
        const feedId = feed?._id || feed?.id;
        const isSmallBoat =
          (feedId && feedsConfig[feedId]?.type === 'small-boat') ||
          feed?.type === 'small-boat' ||
          feed?.name?.toLowerCase()?.includes('small boat');
        const hasWeatherIncluded = feed?.weatherIncluded === true;
        return isSmallBoat && hasWeatherIncluded;
      });

      if (smallBoatFeedsNeedingWeatherCheck.length === 0) {
        return true; // No small-boat feeds with weather cost, proceed
      }
      const customerId = newTaskParams?.customerid || null;
      for (const feed of smallBoatFeedsNeedingWeatherCheck) {
        activeFeedName = feed?.name;
        let weatherDetails: WeatherCostResponse;
        let selectedCharge: number;
        try {
          weatherDetails = await this.getWeatherCost(
            newTaskParams?.target,
            feed,
            newTaskParams?.taskId || null,
            sensorId,
            collectionModeValue,
            newTaskParams?.openWindow || null,
            newTaskParams?.closeWindow || null,
            customerId
          );

          this.attachWeatherChargeToFeed(newTaskParams, feed, weatherDetails);
          selectedCharge = this.currentUser?.pointsEligible
            ? Number(weatherDetails?.weather_ex_point || 0)
            : Number(weatherDetails?.weather_ex_cost || 0);
        } catch (weatherCostError) {
          const feedName = feed?.name || rawFeeds?.name;
          this.popupService.openAlert(
            `Unable to validate weather cost for ${feedName}. Please try again.`,
            'warning'
          );
          return false;
        }

        if (selectedCharge && selectedCharge > 0) {
          const confirmed = await this.showWeatherCostPopup(weatherDetails, feed);
          if (!confirmed) {            // 5. Safely handle removing feed if user declines (works whether feeds is an array or a single object)
            if (newTaskParams?.feeds) {
              const targetFeedId = feed?._id || feed?.id;
              if (Array.isArray(newTaskParams.feeds)) {
                newTaskParams.feeds = newTaskParams.feeds.filter((f: any) => {
                  const fId = f?._id || f?.id;
                  return fId && targetFeedId ? fId !== targetFeedId : f !== feed;
                });
              } else {
                const fId = newTaskParams.feeds?._id || newTaskParams.feeds?.id;
                if ((fId && targetFeedId && fId === targetFeedId) || newTaskParams.feeds === feed) {
                  newTaskParams.feeds = null;
                }
              }
            }
            return false; // Block submit
          }
        }
      }

      return true; // All weather checks passed, proceed
    } catch (error) {
      console.error('Weather validation error:', error);
      this.popupService.openAlert(
        `Unable to validate weather cost for ${activeFeedName}. Please try again.`,
        'warning'
      );
      return false;
    }
  }

  private attachWeatherChargeToFeed(newTaskParams: any, selectedFeed: any, weatherDetails: WeatherCostResponse): void {
    if (!newTaskParams?.feeds) {
      return;
    }

    const selectedFeedId = selectedFeed?._id || selectedFeed?.id;
    const weatherPoint = Number(weatherDetails?.weather_ex_point || 0);
    const weatherCost = Number(weatherDetails?.weather_ex_cost || 0);

    const applyCharge = (feed: any) => {
      if (!feed) {
        return;
      }

      if (this.currentUser?.pointsEligible) {
        feed.weather_ex_point = weatherPoint;
        if (feed.weather_ex_cost !== undefined) {
          delete feed.weather_ex_cost;
        }
      } else {
        feed.weather_ex_cost = weatherCost;
        if (feed.weather_ex_point !== undefined) {
          delete feed.weather_ex_point;
        }
      }
    };

    if (Array.isArray(newTaskParams.feeds)) {
      const matchedFeed = newTaskParams.feeds.find((feed: any) => {
        const feedId = feed?._id || feed?.id;
        return selectedFeedId && feedId ? feedId === selectedFeedId : feed === selectedFeed;
      });

      if (matchedFeed) {
        applyCharge(matchedFeed);
      }
      return;
    }

    const singleFeedId = newTaskParams.feeds?._id || newTaskParams.feeds?.id;
    if ((selectedFeedId && singleFeedId && selectedFeedId === singleFeedId) || newTaskParams.feeds === selectedFeed) {
      applyCharge(newTaskParams.feeds);
    }
  }

  /**
   * Get weather cost for a specific feed
   */
  private async getWeatherCost(
    target: any,
    feed: any,
    taskId: string | null,
    sensorId: string | null,
    collectionModeValue: string | null,
    openWindow: string | null,
    closeWindow: string | null,
    customerId: string | null = null
  ): Promise<WeatherCostResponse> {
    try {
      const geoJson = typeof target === 'string' ? target : JSON.stringify(geoParse(target));
      const payload: any = {
        target: geoJson,
        feedId: feed._id || feed.id,
      };

      if (taskId) {
        payload.taskId = taskId;
      }
      if (sensorId) {
        payload.sensorId = sensorId;
      }
      if (collectionModeValue) {
        payload.collectionModeValue = collectionModeValue;
      }
      if (openWindow && closeWindow) {
        payload.openWindow = openWindow;
        payload.closeWindow = closeWindow;
      }
      if (customerId) {
        payload.customerId = customerId;
      }

      const response = (await firstValueFrom(
        this.apiService.getWeatherCost(payload)
      )) as WeatherCostResponse;
      return response || {};
    } catch (error) {
      console.error('Error fetching weather cost:', error);
      throw error;
    }
  }

  

  /**
   * Show weather cost confirmation popup
   */
  private async showWeatherCostPopup(weatherCharge: WeatherCostResponse, feed: any): Promise<boolean> {
    try {
      const selectedCharge = this.currentUser?.pointsEligible
        ? Number(weatherCharge?.weather_ex_point || 0)
        : Number(weatherCharge?.weather_ex_cost || 0);

      if (selectedCharge === 0) {
        return true;
      }

      const formattedCost = this.formatWeatherCost(weatherCharge);
      const message = `The selected feed requires weather data costing ${formattedCost} (non-refundable). The platform will add the weather cost to the feed cost if you continue to order the feed.`;

      const dialogRef = this.popupService.openAlert(
        message,
        'warning',
        [
          { text: 'No', value: 'no' },
          { text: 'Yes', value: 'yes', primary: true },
        ],
        '50%',
        { title: 'Confirmation', darkTheme: this.darkTheme }
      );

      const result = await firstValueFrom(dialogRef.afterClosed());
      return result === 'yes';
    } catch (error) {
      console.error('Error showing weather cost popup:', error);
      return false;
    }
  }

  /**
   * Format weather cost display based on points eligibility
   */
  private formatWeatherCost(weatherCharge: WeatherCostResponse): string {
    const selectedCharge = this.currentUser?.pointsEligible
      ? Number(weatherCharge?.weather_ex_point || 0)
      : Number(weatherCharge?.weather_ex_cost || 0);

    if (!selectedCharge || selectedCharge === 0) {
      return 'Free';
    }

    if (this.currentUser?.pointsEligible) {
      return `${selectedCharge} Points`;
    } else {
      return `US$ ${selectedCharge.toFixed(2)}`;
    }
  }

  matchUUIDs(selectedSensors, taskResponse) {
    let sensorList = JSON.parse(selectedSensors);

    const minLength = Math.min(sensorList.length, taskResponse.length);
    for (let i = 0; i < minLength; i++) {
      sensorList[i].uuid = taskResponse[i].uuid;
    }

    return sensorList;
  }

  extractAndCalculateValues(inputString: string): number {
    // Match decimal or integer numbers
    const numbers = inputString.match(/\d+(\.\d+)?/g);
  
    if (numbers && numbers.length >= 2) {
      const firstNumber = parseFloat(numbers[0]);
      const secondNumber = parseFloat(numbers[1]);
      return firstNumber * secondNumber;
    }
    if (numbers && numbers.length === 1) {
      return parseFloat(numbers[0]);
    }
    return 0;
  }

  applyToAllSensors(row: any, i: number) {
    if (row?.key === OPERATORS.SATELLOGIC) {
      const captureModes = row?.collection_mode?.map((mode: any) => mode.captureMode) || [];

      const hasStrip = captureModes.some(mode => mode.toLowerCase().includes('strip'));
      const hasArea = captureModes.some(mode => mode.toLowerCase().includes('area'));

      const isPOI = this.target.area === 0;
      const isAOI = this.target.area > 0;

      const rules = [
        {
          condition: () => hasStrip && !hasArea && isAOI,
          message: () => `You are allocated to task only point of interest (POI) with the ${row?.displayName} ${row?.sensor}.
                          Please place a pin or enter lng, lat to proceed.`
        },
        {
          condition: () => hasArea && !hasStrip && isPOI,
          message: () => `You are allocated to task only area of interest (AOI) with the${row?.displayName} ${row?.sensor}.
                          Please draw an area to proceed`
        }
      ];

      for (const rule of rules) {
        if (rule.condition()) {
          const dialogRef = this.popupService.openPopup(WarningPopup, rule.message(), '', '50%');
          dialogRef.afterClosed().subscribe(() => this.disableSensor(i));
          return false;
        }
      }
    }
    return true;
  }


  private disableSensor(index: number): void {
    const sensor = this.AVAILABLESENSORS[index];
    if (sensor) {
      sensor.prevent = true;
    }

    // Centralize uncheck behavior (Tip-and-Cue + non-Tip-and-Cue) and keep `selectedSensors` in sync.
    this.uncheckSensorInTipAndCue(index);

    // Sensor can be unchecked programmatically via async flows.
    // Keep banners and dependent UI (submit buttons) consistent.
    this.clickHandler();
  }

  private isRowSelectedForReactionToiWarning(row: any): boolean {
    if (!row) return false;
    if (row?.checked !== undefined) return row.checked === true;
    return row?.sensorSelected === true;
  }

  private warnReactionTimeVsToiForSelectedSensors(changedRow?: any, changedLatency?: any): void {
    // UX change: no popup spam. Show a single inline banner listing affected sensors.
    this.updateReactionToiWarningBanner(changedRow, changedLatency);
  }

  /**
   * Called when TOI changes after sensors are already selected.
   * Warns once (first matching sensor) to avoid popup spam.
   */
  handleToiChangedReactionTimeWarnings(): void {
    this.warnReactionTimeVsToiForSelectedSensors();
  }

  private showMinimumAreaWarning(
  row: any,
  index: number,
  days_Difference: any,
  baseCost: any,
  checked: boolean,
  timeDifference: any,
  formattedMinimumArea: any ) {
  let formattedDisplayMinArea =
    row?.key === OPERATORS.ECURS_L
      ? row?.selectedModes[0]?.minareastrip
      : formattedMinimumArea;

  const wyvernText =
    'The area of interest (AOI) requested is smaller than the ' +
    row?.minarea +
    ' sqkm set by the operator for the selected ' +
    row?.selectedLatencyKey?.key +
    '. Please increase the task size to more than ' +
    row?.minarea +
    ' sqkm or choose an alternative provider';

  const sdsText =
    'The area of interest (AOI) requested is smaller than the ' +
    formattedDisplayMinArea +
    ' sqkm minimum task area required by ' +
    row?.displayName +
    ' ' +
    row?.sensor +
    '. Please increase the task size to at least ' +
    formattedDisplayMinArea +
    ' sqkm or choose an alternative provider.';

  const areaMessage =
    row?.key === OPERATORS.WYVERN
      ? wyvernText
      : row?.key === OPERATORS.SDS
      ? sdsText
      : 'The ' +
        row?.displayName +
        ' ' +
        row?.sensor +
        ' has a requirement for ' +
        formattedDisplayMinArea +
        ' sqkm as the minimum task area. Please note that you will be charged for ' +
        formattedDisplayMinArea +
        ' sqkm.';

  const areaDialogRef = this.popupService.openPopup(
    WarningPopup,
    areaMessage,
    '',
    '50%'
  );

  areaDialogRef.afterClosed().subscribe(() => {
    if (row?.key === OPERATORS.WYVERN || row?.key === OPERATORS.SDS) {
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (idx === index) {
          operator.checked = false;
          operator.prevent = true;
          this.selectedSensors = this.selectedSensors.filter(
            sensor => sensor.Key !== row.operatorKey
          );
        }
      });
       this.warnReactionTimeVsToiForSelectedSensors();
    } else {
      this.openOperatorDialog(
        row,
        index,
        days_Difference,
        baseCost,
        checked,
        timeDifference
       );
     }
   });
 }


  async getTotalCost(checked: boolean, i: number, row: any) {   
    
    this.noOfusers = [];
    // `i` from the table can diverge from `AVAILABLESENSORS` indices after sorts/filters.
    // Always reconcile using the row identity so we toggle the correct sensor.
    if (row?.sensorId !== undefined && Array.isArray(this.AVAILABLESENSORS)) {
      const resolvedIndex = this.AVAILABLESENSORS.findIndex((s: any) =>
        s?.sensorId === row?.sensorId && (row?.tabIndex === undefined || s?.tabIndex === row?.tabIndex)
      );
      if (resolvedIndex > -1 && resolvedIndex !== i) {
        i = resolvedIndex;
        row = this.AVAILABLESENSORS[i];
      }
    } else if (!row && Array.isArray(this.AVAILABLESENSORS)) {
      row = this.AVAILABLESENSORS?.[i];
    }

    // The BRO sensor has unique logic that requires checking the AOI location is land inclusive before allowing selection.
    if (row?.key === OPERATORS.USL && row.name === 'BRO' && checked) {

    const locationResult = await this.checkTargetLocation();

    if (locationResult === 'land') {

      const userConfirmed = await this.openBROPopup();

      if (!userConfirmed) {
        row.checked = false;
        return;
      }
    }
  }

    // Defensive guard: disabled/prevented rows should not re-enter validation
    // even if a click event still bubbles through the template.
    if (checked && (!row?.enabled || row?.prevent)) {
      return;
    }

    if (row?.key === OPERATORS.AT21 && checked) {
      // Show the advisory before committing the checkbox state.
      this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);

      const shouldProceed = await this.shouldProceedWithAt21TierWarning(
        row,
        row?.selectedLatencyKey
      );

      if (!shouldProceed) {
        this.warnReactionTimeVsToiForSelectedSensors();
        return;
      }
    }

    this.isAISSensor = false;
    if (checked) {
      this.AVAILABLESENSORS[i].tnqSensorDisabled = false;
      this.AVAILABLESENSORS[i].sensorSelected = true;
    } else {
      // In Tip-and-Cue, `selectedTnqSensorType` is the row's fixed type (Tipping/Cueing).
      // Do not clear it on uncheck; clearing it causes subsequent validations to be skipped.
      if (this.target?.taskStrategy !== 'Tip-and-Cue') {
      this.AVAILABLESENSORS[i].selectedTnqSensorType = '';
      }
      this.AVAILABLESENSORS[i].tnqSensorDisabled = true;
      this.AVAILABLESENSORS[i].sensorSelected = false;
    }
    this.collectionTime = false;
    const countryArr: string[] = row?.country;
    let countryCheck: boolean = false;
    let minimumArea: any, formattedMinimumArea: any;
    let isCountryRestricted: boolean = false;
    var _this = this;

    countryCheck =
      countryArr.includes(this.userDetails?.country) ||
      countryArr.includes('global');
    const baseCost = this.AVAILABLESENSORS[i].unitcost;
    if(row?.no_imagery_country) {
      isCountryRestricted = row?.no_imagery_country.includes(this.target.country);
    }    

    if ((row.unit.includes('scene') || row.unit === 'week' || row.unit === 'day') && row.key != OPERATORS.BLACKSKY) {
      if (row.tooltipValue) {
        minimumArea = this.extractAndCalculateValues(row.tooltipValue);
        formattedMinimumArea = minimumArea?.toLocaleString();
        this.AVAILABLESENSORS[i].minimumAreaSize = minimumArea;
      } else if (row.minimumArea) {
        minimumArea = this.extractAndCalculateValues(row.minimumArea);
        formattedMinimumArea = minimumArea?.toLocaleString();
        this.AVAILABLESENSORS[i].minimumAreaSize = minimumArea;
      }
    } else {
      minimumArea = row.minarea;
      formattedMinimumArea = minimumArea?.toLocaleString();
      this.AVAILABLESENSORS[i].minimumAreaSize = minimumArea;
    }

    if (row?.key === OPERATORS.SDS) {
      minimumArea = 100;
      formattedMinimumArea = minimumArea.toLocaleString();
      this.AVAILABLESENSORS[i].minimumAreaSize = minimumArea;
    }

     if (checked && this.target.taskStrategy == this.tipAndCue && (row?.selectedTnqSensorType == this.cueingVal || row?.tabIndex === 1)
      && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation)) {
      this.isCueing = true;
      const targetArea = await this.getCueingTarget(row,minimumArea);
    } else {
      this.isCueing = false;
    }

    if (
      row?.key === OPERATORS.AT21 ||
      row?.key === OPERATORS.KOMPSAT ||
      row?.key === OPERATORS.ISI ||
      row?.key === OPERATORS.BLACKSKY ||
      row?.key === OPERATORS.GOKTURK ||
      row?.key === OPERATORS.CAPELLA ||
      row?.key === OPERATORS.ECURS ||
      row?.key === OPERATORS.GEOSAT ||
      row?.key === OPERATORS.PIXXEL ||
      row?.key === OPERATORS.ECURS_L||
      row?.key === OPERATORS.SDS || 
      row?.key === OPERATORS.ORBVIEW
    ) {
      this.AVAILABLESENSORS[i].selectedCost = baseCost;
      this.AVAILABLESENSORS[i].userCost = 1;
    }
    let satellogicProcess = false;
    const startDate: any = new Date(
      moment(this.target.openWindow).utc().format()
    );
    const endDate: any = new Date(
      moment(this.target.closeWindow).utc().format()
    );

    const currentDate: any = new Date(moment.utc().format('YYYY-MM-DD HH:mm:ss'));
    // For Days-frequency tasks, validate against the first recurring day's date
    // rather than the overall openWindow, which is just the task window start.
    let effectiveStartDate = startDate;
    if (
      this.target.freqOption === 'Days' &&
      Array.isArray(this.target.recurringDays) &&
      this.target.recurringDays.length > 0
    ) {
      const weekDates = buildRecurringWeekDates(
        this.target.openWindow,
        this.target.closeWindow,
        this.target.recurringDays
      );
      if (weekDates.length > 0) {
        const firstWeekDates = Object.values(weekDates[0])[0] as string[];
        if (firstWeekDates?.length > 0) {
          effectiveStartDate = new Date(firstWeekDates[0]);
        }
      }
    }

    // Strategy-driven selection blockers for migrated operators.
    if (checked) {
      const hasOtherSensorsSelected = (this.AVAILABLESENSORS || []).some(
        (s: any) => s.checked && s !== row && s.sensorId !== row?.sensorId
      );
      const hasVesselFinderSelected = (this.AVAILABLESENSORS || []).some(
        (s: any) => s.checked && s.key === OPERATORS.VESSELFINDER && s !== row
      );

      // Multi-sensor tasking is not supported for Vessel Finder AIS
      if (row?.key !== OPERATORS.VESSELFINDER && hasVesselFinderSelected) {
        const vfSensor = (this.AVAILABLESENSORS || []).find(
          (s: any) => s.checked && s.key === OPERATORS.VESSELFINDER && s !== row
        );
        const message =
          `Multi-sensor tasking is not supported for ${vfSensor?.displayName} ${vfSensor?.sensor}. Please task ${vfSensor?.displayName} ${vfSensor?.sensor} as a single sensor, or choose an alternative provider.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
        dialogRef.afterClosed().subscribe(() => this.disableSensor(i));
        return;
      }

      const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
      const selectedAreaSqkm = Number(this.getArea(row, 'AOI'));
      const minimumAreaSqkm = Number(minimumArea);
      const selectionArgs = {
        sensorRow: row,
        toiStartUtc: effectiveStartDate,
        toiEndUtc: endDate,
        taskingContext: {
          isRecurrent: this.target.selectedOption === 1,
          freqOption: this.target.freqOption,
          subDailyCount: this.target.subDailyCount,
          selectedAreaSqkm: Number.isFinite(selectedAreaSqkm) ? selectedAreaSqkm : null,
          minimumAreaSqkm: Number.isFinite(minimumAreaSqkm) ? minimumAreaSqkm : null,
          selectedOption: this.target.selectedOption,
          // Target geometry, read off the WKT — the same signal the legacy
          // per-operator rules below use, so a migrated rule keeps its exact
          // meaning. `POINT` also matches `MULTIPOINT`, hence the count.
          isPointTarget: this.isPointTargetTasked(),
          multiTargetCount: this.target?.multiTarget?.length ?? 0,
          // What the order is asking the operator to DO. Some constraints are
          // not properties of the target or of the operator alone: a shape an
          // operator serves fine as a normal collect can be one it can never
          // tip on, and only the strategy distinguishes the two.
          //
          // `tabIndex` is the tip-and-cue ROLE — 0 tipping, 1 cueing — assigned
          // where the two sensor lists are merged (`loadTipAndCueingSensors`).
          // Undefined outside tip-and-cue, which reads as false, and every rule
          // that consumes it also requires the strategy.
          taskStrategy: this.target?.taskStrategy ?? null,
          tipAndCueBasedOn: this.target?.tipAndCueBasedOn ?? null,
          isTippingSensor: row?.tabIndex === 0,
          hasOtherSensorsSelected,
          hasVesselFinderSelected,
        },
      };
      const blocker = strategy?.getSelectionBlocker?.(selectionArgs);

      if (blocker?.message) {
        if (blocker.confirm) {
          const dialogRef = this.dialog.open(ConfirmPopupComponent, {
            width: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { message: 'iceye-min-duration', confirmMessage: blocker.message },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result !== 'yes') {
              this.disableSensor(i);
            } else {
              // User agreed — show any optional informational warning.
              const warning = strategy?.getSelectionWarning?.(selectionArgs);
              if (warning?.message) {
                this.popupService.openAlert(warning.message, 'warning');
              }
            }
          });
          // No return — allow selection to proceed on Agree
        } else {
          const dialogRef = this.popupService.openPopup(
            WarningPopup,
            blocker.message,
            '',
            '50%'
          );
          if (blocker.softBlock) {
            // Recoverable failure — uncheck without setting prevent so the user can try again.
            dialogRef.afterClosed().subscribe(() => {
              this.AVAILABLESENSORS[i].checked = false;
              this.AVAILABLESENSORS[i].sensorSelected = false;
              this.resetSensor();
            });
          } else {
            dialogRef.afterClosed().subscribe(() => this.disableSensor(i));
          }
          return;
        }
      } else {
        // No blocker — show any optional informational warning.
        const warning = strategy?.getSelectionWarning?.(selectionArgs);
        if (warning?.message) {
          this.popupService.openAlert(warning.message, 'warning');
        }
      }
    }
    const utcTime = moment.utc().format('YYYY-MM-DD HH:mm:ss');
    const timeDiffrence: any =
      (effectiveStartDate.getTime() - new Date(utcTime).getTime()) / 3600 / 1000;

    // Refresh inline warning banner on both select and unselect.
    this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
    let futureDate = new Date();
    futureDate.setDate(currentDate.getDate() + 14);
    const startDateWithinRange =
      startDate >= currentDate && startDate <= futureDate;
    const endDateWithinRange = endDate >= currentDate && endDate <= futureDate;
    this.feasible = false;
    const isSameDate =
      startDate.getFullYear() === currentDate.getFullYear() &&
      startDate.getMonth() === currentDate.getMonth() &&
      startDate.getDate() === currentDate.getDate();

    const differenceInTime: number = endDate.getTime() - startDate.getTime();
    const differenceInDays: number = Math.floor(
      differenceInTime / (1000 * 60 * 60 * 24)
    );

    let start_time = moment(this.target.openWindow).utcOffset(0, true);
    // Form UTC times are stored in local Date objects; preserve the displayed UTC clock time.
    let end_time = moment(this.target.closeWindow).utcOffset(0, true);
    const enddate = moment(this.target.closeWindow).utcOffset(0, true).format();
    const clydePeriodDuration = end_time.diff(start_time, 'days', true); 

    const time_difference =
      new Date(enddate).getTime() - new Date(currentDate).getTime();
    let days_Difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));

    const start_time_difference = startDate.getTime() - new Date(currentDate).getTime(); 
    let start_days_Difference = Math.ceil(start_time_difference / (1000 * 60 * 60 * 24));
    const isSatelliteVuRecurringSelectionBlocked =
      checked &&
      row?.key === OPERATORS.SATELLITEVU_VANZYL &&
      this.target.selectedOption === 1 &&
      this.target.freqOption != 'Monthly' &&
      this.target.freqOption != 'Weekly';
    
    if (this.cpcAndAllocated && !this.applyToAllSensors(row, i)) {
      return;
    }

    // Tip-and-Cue fix: when tipping sensor changes, reset cueing sensors
    if (this.target?.taskStrategy === 'Tip-and-Cue' && checked && this.selectedTabIndex === 0) {
      this.resetCueingSensors();
    }

    // Tip-and-Cue fix: prevent selecting the same sensor with same resolution across tipping and cueing
    if (this.target?.taskStrategy === 'Tip-and-Cue' && checked) {
      const currentSensorKey = row?.key;
      const currentTabIndex = typeof row?.tabIndex === 'number' ? row.tabIndex : this.selectedTabIndex;
      const currentResolution =
        row?.selectedResolution?.value ||
        row?.selectedResolution?.key ||
        row?.selectedResolutionValue;

      // Important: do NOT rely on selectedTippingSensors/selectedCueingSensors here.
      // Those arrays can hold stale row references if AVAILABLESENSORS is rebuilt
      // while the user is completing required steps.
      const duplicateSensor = (this.AVAILABLESENSORS || []).find(
        (sensor: any) =>
          sensor?.checked === true &&
          sensor?.key === currentSensorKey &&
          sensor?.tabIndex !== currentTabIndex &&
          (
            sensor?.selectedResolution?.value === currentResolution ||
            sensor?.selectedResolution?.key === currentResolution ||
            sensor?.selectedResolutionValue === currentResolution
          )
      );

      if (duplicateSensor) {
        const existingSensorTypeLabel = duplicateSensor.tabIndex === 0 ? 'tipping' : 'cueing';
        const message = `You have already selected ${row?.displayName} ${row?.sensor} with the same resolution for ${existingSensorTypeLabel} sensor. Same sensor with same resolution cannot be selected for both tipping and cueing. Please select a different resolution or choose an alternative provider.`;
        const dialogRef = this.popupService.openPopup(WarningPopupComponent, message, 'warning', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
        });
        return;
      }
    }

    // Handle unchecking in Tip-and-Cue mode - remove from selection arrays but continue processing
    if (this.target?.taskStrategy === 'Tip-and-Cue' && !checked) {
      this.applyTipAndCueRowSelection(false, i);
    }

    if ((row?.key != OPERATORS.GHG && row?.key != OPERATORS.LBAND && row?.key != OPERATORS.CAPELLA && row?.key != OPERATORS.UMBRA &&
      row?.key != OPERATORS.SATELLOGIC && row?.key != OPERATORS.BLACKSKY && row?.key != OPERATORS.AZISTA && row?.key != OPERATORS.VESSELFINDER) && this.target?.multiTarget?.length > 1 && checked) { 

      const message = `${row?.displayName} ${row?.sensor} does not support multiple points of interest (POIs) at this time`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      this.feasible = true;
      return;
    } else if (row?.key === OPERATORS.KOMPSAT && countryCheck && checked) {
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (operator?.key === OPERATORS.KOMPSAT) {
          this.uncheckSensorInTipAndCue(idx);
          this.AVAILABLESENSORS[idx].prevent = true;
        }
      });
      const dialogRef = this.dialog.open(CountrycheckComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'countryblock', sensor: row.displayName },
      });
    } else if (row?.key === OPERATORS.GOKTURK && countryCheck && checked) {
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (operator?.key === OPERATORS.GOKTURK) {
          this.uncheckSensorInTipAndCue(idx);
          this.AVAILABLESENSORS[idx].prevent = true;
        }
      });
      const dialogRef = this.dialog.open(CountrycheckComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'countryblock', sensor: row.displayName },
      });
    } else if (row?.key != OPERATORS.KOMPSAT && row?.key != OPERATORS.GOKTURK && !countryCheck && checked) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const dialogRef = this.dialog.open(CountrycheckComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'countryblock', sensor: row.displayName },
      });
    }
    // Voyage Radar is deliberately absent here: it serves point targets, and
    // the rules that still refuse one (the operator doc's `poi` flag, and
    // multi-point) live in VoyageRadarOperatorStrategy.getSelectionBlocker,
    // which runs above and returns before this chain is reached.
    else if (row?.key === OPERATORS.SPIRE && this.target.geoJSON.includes('POINT') && checked) {
      const message = `${row?.displayName} ${row?.sensor} accepts only area of interest (AOI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CLYDE &&
      this.target.geoJSON.includes('POINT') && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only area of interest (AOI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.SPIRE || row?.key === OPERATORS.VOYAGERADAR) &&
      this.target.taskStrategy !== 'User Initiated' &&
      this.target.taskStrategy !== 'Sensor Type Based' &&
      this.target.taskStrategy !== 'AIS Included' &&
      this.target.taskStrategy !== 'Tip-and-Cue'
      && checked
    ) {
      const message = `Please choose the 'AIS included/User Initiated' tasking strategy to use this sensor.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.VESSELFINDER &&
      this.target.taskStrategy !== 'User Initiated' &&
      this.target.taskStrategy !== 'Sensor Type Based' &&
      this.target.taskStrategy !== 'AIS Included'
      && checked
    ) {
      const message = `Please choose the 'AIS included/User Initiated' tasking strategy to use this sensor.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CLYDE &&
      this.target.taskStrategy !== 'User Initiated' &&
      this.target.taskStrategy !== 'Sensor Type Based' &&
      this.target.taskStrategy !== 'AIS Included' &&
      this.target.taskStrategy !== 'Tip-and-Cue'
      && checked
    ) {
      const message = `Please choose the 'AIS included/User Initiated' tasking strategy to use this sensor.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.SPIRE || row?.key === OPERATORS.VOYAGERADAR || row?.key === OPERATORS.VESSELFINDER) &&
      (this.target.selectedOption === 1 || this.target.selectedOption === 0 || this.target.selectedOption === 3)
      && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only  orders with a period collection at this time. Recurrent, Specific Date and Specific Day orders are a future capability. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.SPIRE &&
      this.target.area > 0 &&
      this.target.area > 10000
      && !this.target.targetPoints
    ) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const message =
        'The area of interest (AOI) requested is larger than the allowed 10,000 sqkm set by the operator. Please reduce the task size to less than 10,000 sqkm or choose an alternative provider.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    } else if (
      row?.key === OPERATORS.CLYDE &&
      (this.target.selectedOption === 1 || this.target.selectedOption === 0 || this.target.selectedOption === 3)
      && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only  orders with a period collection at this time. Recurrent, Specific Date and Specific Day orders are a future capability. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CLYDE &&
      (this.target.selectedOption === 2 && clydePeriodDuration < 90)
      && checked
    ) {
        const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires time of interest (TOI) should be minimum 3 months. Please change your TOI or choose an alternative provider.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
      }

    else if ((row?.key === OPERATORS.SPIRE || row?.key === OPERATORS.AZISTA || row?.key === OPERATORS.VOYAGERADAR) && !this.isOpenWaterArea() && checked) {
      const message = `The ${row?.displayName} ${row?.sensor} can only be used for open water orders. Please change your area of interest (AOI).`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }
    
    else if (row?.key === OPERATORS.CLYDE && !this.isOpenWaterArea() && checked) {
      const message = `The ${row?.displayName} ${row?.sensor} can only be used for open water orders. Please change your area of interest (AOI).`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if ((row?.key != OPERATORS.GHG) &&
      (row?.key != OPERATORS.LBAND) &&
      (row?.key != OPERATORS.VESSELFINDER) &&
      !isUmbraScanMode(row) &&
      this.target?.multiTarget?.length > 1 &&
      (this.target.taskStrategy !== 'User Initiated' && this.target.taskStrategy !== 'Sensor Type Based' && this.target.taskStrategy !== 'Help Select Sensor(s)')) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const message = `Multiple points of interest (POIs) tasking is only available for user initiated and Help Select Sensor(s) tasking strategies at this time.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.feasible = true;
    return;
  } else if ((row?.key != OPERATORS.GHG) &&
      (row?.key != OPERATORS.LBAND) &&
      (row?.key != OPERATORS.VESSELFINDER) &&
      !isUmbraScanMode(row) &&
      this.target?.multiTarget?.length > 1 &&
      this.currentUser.pointsEligible) { 
 
      const message = `Multiple points of collection (POIs) and areas of collections (AOIs) are
      not available for points usage at this time. Please task single POI or AOI.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      this.feasible = true;
    return;
    } 

    else if(row?.key === OPERATORS.CAPELLA && start_days_Difference > 90) {
      const message = `Please reduce the number of days to the start date. The number of days from today needs to be less than 90 days.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      return;
    }

    else if(row?.key === OPERATORS.CAPELLA && differenceInDays > 30) {
      const message = `The time of interest (TOI) cannot exceed 30 days. Please limit the period.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      return;
    }

    else if ((row?.key === OPERATORS.CAPELLA || (row?.key === OPERATORS.UMBRA && !isUmbraScanMode(row)) ||
      row?.key === OPERATORS.SATELLOGIC || row?.key === OPERATORS.BLACKSKY) && (this.target?.multiTarget?.length > 3 || (this.target?.multiTarget?.length > 1 && this.selectedSensors?.length > 1)) && checked) { 
  
      const message = `Multiple points of interest (POIs) tasking is limited to three locations and two sensors.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      return;
    } else if (row?.key === OPERATORS.SATELLOGIC && timeDiffrence > 336) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      satellogicProcess = true;
      const dialogRef = this.dialog.open(SatellogicWarningComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {
          satellogicProcess: satellogicProcess,
          name: row.displayName + ' ' + row.sensor,
        },
      });
    } else if (
      row?.key === OPERATORS.SATELLOGIC &&
      this.target.selectedOption === 1 &&
      this.getArea(row) > 0
    ) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      satellogicProcess = false;
      const dialogRef = this.dialog.open(SatellogicWarningComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {
          satellogicProcess: satellogicProcess,
          name: row.displayName + ' ' + row.sensor,
        },
      });
    } else if (
      row?.key === OPERATORS.SATELLOGIC &&
      this.target.subDailyCount != 2 &&
      this.target.freqOption === 'Sub-daily' &&
      this.target.selectedOption === 1
    ) {
      const message = `${row?.displayName} ${row?.sensor} allows 2 sub-daily collection(s)  at this time. Please select an appropriate sub-daily count.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.SATELLOGIC &&
      this.getArea(row, 'POI') > 0 &&
      this.isOpenWaterArea() && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only point of interest (POI) tasks over open waters. Please choose an alternative provider for an area of interest (AOI) task.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
        });
    } else if (
      checked &&
      this.target.taskStrategy === 'Tip-and-Cue' &&
      this.target.tipAndCueBasedOn == 'Rules' &&
      this.target.rule == 'rule-3' &&
      row?.selectedTnqSensorType == 'Tipping' &&
      !row?.cloudcovers
    ) {
      const message = `Your cloud cover selection for the sensor violates your cloud cover rule. Please either change the rule value or select a sensor with cloud cover that does not violate the rule.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
      });
    } else if (
      row?.key === OPERATORS.SATELLOGIC &&
      this.getArea(row, 'AOI') > 0 && this.getArea(row, 'AOI') < 50 &&
      this.cpcAndAllocated
    ) {
      const message = `Please task with point of interest (POI) when the area is less than 50sqkm.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.SATELLOGIC &&
      this.getArea(row, 'AOI') > 0 &&
      row.selectedLatencyKey?.key === 'rush' &&
      checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support rush tasking tier with area of interest (AOI). Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CAPELLA &&
      this.target.selectedOption === 1 &&
      this.getArea(row) > 0
    ) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      satellogicProcess = false;
      const dialogRef = this.dialog.open(SatellogicWarningComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { satellogicProcess: satellogicProcess, name: row.displayName },
      });
    } else if (
      row?.key === OPERATORS.CAPELLA &&
      this.getArea(row, 'AOI') > 0 &&
      CAPELLA_MODES[row?.selectedModes[0]?.mode_type] === 'POI' && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} has different modes of collection based on whether the location
      is an area of interest (AOI) or point of interest (POI). Stripmap_100 is used for AOI,
      and all the other modes are used for POI.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CAPELLA &&
      this.getArea(row, 'POI') === 0 &&
      CAPELLA_MODES[row?.selectedModes[0]?.mode_type] === 'AOI'
    ) {
      const message = `${row?.displayName} ${row?.sensor} has different modes of collection based on whether the location
      is an area of interest (AOI) or point of interest (POI). Stripmap_100 is used for AOI,
      and all the other modes are used for POI.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.SDS || row?.key === OPERATORS.ORBVIEW || row?.key === OPERATORS.CONSTELLR) &&
      (this.target.selectedOption === 0 || this.target.selectedOption === 3) &&
      checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support Specific Date and Specific Day at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      this.target.selectedOption === 1 &&
      this.target.freqOption === 'Fortnightly' &&
      row?.key !== OPERATORS.CONSTELLR &&
      row?.key !== OPERATORS.SENTINEL &&
      checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support fortnightly recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      this.target.selectedOption === 1 &&
      this.target.freqOption === 'Number of collections' &&
      row?.key !== OPERATORS.CONSTELLR &&
      checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support Number of collections recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CONSTELLR &&
      this.target.selectedOption === 1 &&
      this.target.freqOption === 'Number of collections' &&
      !this.hasValidNumberOfCollections() &&
      checked
    ) {
      const message = `Please enter a whole number greater than or equal to 1 for Number of collections.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.CONSTELLR &&
      this.target.selectedOption === 1 &&
      (this.target.freqOption === 'Sub-daily' || this.target.freqOption === 'Days' || this.target.freqOption === 'Daily') &&
      checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} only support weekly, fortnightly, monthly and Number of collections recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if(row?.key === OPERATORS.CONSTELLR && timeDiffrence < 72) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date + 72hrs. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      return;
    } else if (row?.key === OPERATORS.CONSTELLR && differenceInDays < 7) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires time of interest (TOI) should be minimum 7 days. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if(row?.key === OPERATORS.CONSTELLR && differenceInDays > 365) {
      const message = `The time of interest (TOI) cannot exceed 365 days. Please limit the period.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
      return;
    } else if (
      row?.key === OPERATORS.CONSTELLR &&
      this.getArea(row, 'AOI') > 0 &&
      !this.utilsService.calculateMaxSwathWidth(this.getGeoJson(), 15)
      && checked
    ) {
      const message =
        'One or more sides in the area of interest (AOI) are more than 15km. Please redraw, ensuring no side is greater than 15km.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');

      // Block selection for all CONSTELLR rows and keep `selectedSensors` consistent.
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (operator?.key === OPERATORS.CONSTELLR) {
          this.uncheckSensorInTipAndCue(idx);
          this.AVAILABLESENSORS[idx].prevent = true;
        }
      });
      return;
     } else if (
      row?.key === OPERATORS.CONSTELLR &&
      checked
    ) {
      const finalizeConstellrSelection = () => {
        this.AVAILABLESENSORS[i].noOfCollections = this.getNumberOfCollections();
        this.AVAILABLESENSORS[i].checked = true;
        this.tipAndCueSelection(true, i);
        if (this.target?.taskStrategy !== 'Tip-and-Cue') {
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
        }
        for (const sensors of this.selectedSensors) {
          if (!sensors.feasibility) {
            this.feasible = true;
          }
        }
        this.clickHandler();
        this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
      };

      const cancelConstellrSelection = () => {
        this.uncheckSensorInTipAndCue(i);
        if (this.target?.taskStrategy !== 'Tip-and-Cue') {
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
        }
        this.clickHandler();
        this.warnReactionTimeVsToiForSelectedSensors();
      };

      const illuminationDialog = this.dialog.open(OperatorPopupComponent, {
        minWidth: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {
          selectedRow: row,
          operatorKey: row?.key,
          type: 'constellrIllumination',
        },
      });

      illuminationDialog.afterClosed().subscribe((result) => {
        if (result !== 'close') {
          this.AVAILABLESENSORS[i].illuminationConstraint = result?.illuminationConstraint;
          finalizeConstellrSelection();
        } else {
          cancelConstellrSelection();
        }
      });
    } else if (
      row?.key === OPERATORS.AT21 &&
      (this.target.selectedOption === 1 || this.target.selectedOption === 0 || this.target.selectedOption === 3)
      && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only  orders with a period collection at this time. Recurrent, Specific Date and Specific Day orders are a future capability. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.SDS &&
      this.getArea(row, 'AOI') > 0 &&
      this.getArea(row, 'AOI') < 100 &&
      checked
    ) {
      this.showMinimumAreaWarning(
        row,
        i,
        days_Difference,
        baseCost,
        checked,
        timeDiffrence,
        formattedMinimumArea
      );
    } else if (
      (row?.key === OPERATORS.AT21 || row?.key === OPERATORS.ORBVIEW) &&
      this.getArea(row, 'AOI') > 0 &&
      !this.utilsService.calculateMinSwathWidth(this.getGeoJson())
      && checked
    ) {
      const message =
        'Each line in the area of interest (AOI) must be 5km minimum long. Please redraw your AOI.';
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
    }

    else if (row?.key === OPERATORS.USL && timeDiffrence < 12 && checked) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start time to be current date + 12hrs. Please change your time of interest (TOI) or choose an alternative provider.`;

      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }
    else if (
      row?.key === OPERATORS.UMBRA &&
      end_time.valueOf() - Date.now() > 7 * 24 * 60 * 60 * 1000
    ) {
      const message = `The ${row?.displayName} ${row?.sensor} can only be tasked in the next seven days. Please ensure your time of interest (TOI) is within seven days from today.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }
    else if (isUmbraScanMode(row) && checked && this.target.geoJSON?.includes('POLYGON')) {
      const message = `${row?.displayName} ${row?.sensor} accepts only point of interest (POI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }

    else if (isUmbraScanMode(row) && checked && !this.target.geoJSON?.includes('POLYGON')) {
      if (this.target.selectedOption === 1) {
        const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
        return;
      }

      const pointCount = this.target?.multiTarget?.length ?? 0;

      if (pointCount !== 2) {
        const message = `${row?.displayName} ${row?.sensor} requires exactly two points to create the strip. Please place two points and try again.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
        return;
      }

      const pt1 = this.utilsService.extractCoordinates(this.target.multiTarget[0]);
      const pt2 = this.utilsService.extractCoordinates(this.target.multiTarget[1]);
      const distanceKm = this.utilsService.calculateDistance(pt1.lat, pt1.lng, pt2.lat, pt2.lng);
      const validation = validateSelectedUmbraScanLength(
        distanceKm,
        row?.selectedModes?.[0],
        row?.collection_mode,
      );

      if (!validation.valid) {
        const message = `Your current strip length (${distanceKm.toFixed(2)} km) is outside the valid range for ${validation.minLen}-${validation.maxLen}km. Please update your map points to fit within this range.`;
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
        });
        return;
      }

      // Valid: 2 points, distance in range — perform standard selection
      this.AVAILABLESENSORS[i].checked = true;
      if (this.target?.taskStrategy === 'Tip-and-Cue') {
        this.tipAndCueSelection(true, i);
      } else {
        this.selectedSensors = [];
        this.AVAILABLESENSORS.forEach((operator) => {
          if (operator.checked) this.selectedSensors.push(operator);
        });
        for (const sensors of this.selectedSensors) {
          if (!sensors.feasibility) {
            this.feasible = true;
          }
        }
      }
      this.clickHandler();
      this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
    } else if ((row?.key === OPERATORS.UMBRA || row?.key === OPERATORS.AZISTA ) && this.getArea(row, 'AOI') > 0 && checked && !this.isCueing) {
      const message = `${row?.displayName} ${row?.sensor} accepts only point of interest (POI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.UMBRA|| row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS || row?.key === OPERATORS.AZISTA || row?.key === OPERATORS.ORBVIEW || row?.key === OPERATORS.SDS) &&
      this.target.selectedOption === 1 && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.HEAD &&
      this.getArea(row, 'AOI') > 0 &&
      !this.utilsService.calculateMinSwathWidth(this.getGeoJson())
      && checked
    ) {
      const message =
        'Each line in the area of interest (AOI) must be 5km minimum long. Please redraw your AOI.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');

      // Block selection for all HEAD rows and keep `selectedSensors` consistent.
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (operator?.key === OPERATORS.HEAD) {
          this.uncheckSensorInTipAndCue(idx);
          this.AVAILABLESENSORS[idx].prevent = true;
        }
      });
      return;
     } else if (row?.key === OPERATORS.HEAD && this.getArea(row, 'AOI') > 0 && row?.name === 'Video' && checked) {
      const message = `${row?.displayName} accepts only point of interest (POI) orders. Please change to a lng/lat and try again.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.HEAD && isSameDate && row?.name === 'Video') {
      const message = `We are unable to accept this task as ${row?.displayName} requires start date to be current date+1. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.HEAD &&
      this.target.selectedOption === 1 && row?.name === 'Video'
    ) {
      const message = `${row?.displayName} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.HEAD && isSameDate && row?.name != 'Video') {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date+1. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.HEAD &&
      this.target.selectedOption === 1 && row?.name != 'Video'
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.STE && this.target?.polygon && !this.isCueing) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} does not accept polygon. Please change your area of interest (AOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.STE || row?.key !== OPERATORS.STE_TELEOS) &&
      row?.key !== OPERATORS.SENTINEL &&
      row?.key !== OPERATORS.ICEYE && row?.key !== OPERATORS.UMBRA &&
      timeDiffrence < 24 &&
      (
        row?.sensortype === 'SAR' ||
        ((row?.key === OPERATORS.ECURS || row?.key === OPERATORS.ECURS_L) && row?.sensortype === 'InSAR')
      )
    ) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date + 24hrs. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.STE &&
      timeDiffrence < 48 &&
      row?.sensortype != 'SAR'
    ) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date + 48hrs. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS) &&
      this.target.subDailyCount > 2 &&
      this.target.freqOption === 'Sub-daily' &&
      this.target.selectedOption === 1
    ) {
      const message = `${row?.displayName} ${row?.sensor} allows 2 sub-daily collection(s) at this time. Please select an appropriate sub-daily count.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS)&&
      !this.utilsService.isLatitudeInRange(this.target, -13, 13, this.isCueing)
    ) {
      const message = `${row?.displayName} ${row?.sensor} cannot be tasked outside the latitude range between -13 and 13. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }

    else if (row?.key === OPERATORS.KOMPSAT && checked && 
    ((this.getOverOpenWater() && this.getCountry() === 'South China Sea') ||
    (!this.getOverOpenWater() && this.getCountry() != this.currentUser.country))) {
      // const message = this.getRestrictionMessage();
      const message = `You are only authorised to task over your country as the area of interest (AOI). Please change your point of interest (POI) or AOI and try again.`
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.KOMPSAT &&
      this.target.selectedOption === 1 && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.KOMPSAT && isSameDate && checked) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date+1. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.USL && checked && (this.target.area === 0 || (this.target.targetPoints && this.target.taskStrategy == this.tipAndCue))) {
      const message = `${row?.displayName} ${row?.sensor} accepts only area of interest (AOI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.USL &&
      (this.target.subDailyCount === 7 || 
        this.target.subDailyCount === 5
      )
      && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} not allows 5 and 7 sub-daily collection(s)  at this time. Please select an appropriate sub-daily count.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.ISI && this.target.selectedOption === 1 && checked) {
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.ISI && timeDiffrence < 24 && checked) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date + 24hrs. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.ISI &&
      !this.utilsService.isLatitudeInRange(this.target, -42, 42, this.isCueing) && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} cannot be tasked outside the latitude range between -42 and 42. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.AXELSPACE &&
      this.target.selectedOption === 1
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }

    else if ((row?.key === OPERATORS.AXELSPACE || row?.key === OPERATORS.PIXXEL) && (this.target.selectedOption === 0 || this.target.selectedOption === 3)) {
      const message = `${row?.displayName} ${row?.sensor} does not support Specific Date and Specific Day at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }
    else if (row?.key === OPERATORS.AXELSPACE && this.target.area === 0 && !this.isCueing) {
      const message = `${row?.displayName} ${row?.sensor} accepts only area of interest (AOI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.AXELSPACE && isSameDate) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date+1. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.AXELSPACE &&
      (endDateWithinRange === false || startDateWithinRange === false)
    ) {
      const message = `${row?.displayName} ${row?.sensor} requires the time of interest (TOI) to be 14 days or less from the current date. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }

    else if (row?.key === OPERATORS.AXELSPACE && this.getArea(row, 'AOI') > 0 && this.getArea(row, 'AOI') < 100) {
      const message = 'The ' + row?.displayName + ' ' + row?.sensor + '  has a requirement for 100 sqkm as the minimum task area. Your area of interest (AOI) is less than 100 sqkm. Kindly increase the size of the polygon or choose an alternative provider.';
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }
    
    else if (row?.key === OPERATORS.AXELSPACE && (this.getArea(row, 'AOI') > 250000)) {
      const message = 'The area of interest (AOI) must be within 500 km each in length and width.';
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }

    else if (row?.key === OPERATORS.GHG && this.target.freqOption != 'Monthly' && this.target.selectedOption === 1) {
      const message = `${row?.displayName} ${row?.sensor} only support monthly recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (isSatelliteVuRecurringSelectionBlocked) {
      const message = `${row?.displayName} ${row?.sensor} only support weekly and monthly recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });

    } else if (row?.key === OPERATORS.GHG && differenceInDays < 30) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires time of interest (TOI) should be minimum 30 days. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.GHG && (this.target.selectedOption === 0 || this.target.selectedOption === 3)) {
      const message = `${row?.displayName} ${row?.sensor} does not support Specific Date and Specific Day at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.HEAD &&
      this.getArea(row, 'AOI') > 0 &&
      this.getArea(row, 'AOI') < minimumArea
    ) {
      const message =
        'The ' +
        row?.displayName +
        ' ' +
        row?.sensor +
        '  has a requirement for ' +
        formattedMinimumArea +
        ' sqkm as the minimum task area. Your area of interest (AOI) is less than ' +
        formattedMinimumArea +
        ' sqkm. Kindly increase the size of the polygon or choose an alternative provider.';
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
    } else if (
      row?.key === OPERATORS.HEAD &&
      this.getArea(row, 'POI') === 0 &&
      (endDateWithinRange === false || startDateWithinRange === false)
      && row?.name === 'Video'
    ) {
      const message = `${row?.displayName} requires the time of interest (TOI) to be 14 days or less from the current date. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.HEAD &&
      this.getArea(row, 'POI') === 0 &&
      (endDateWithinRange === false || startDateWithinRange === false)
      && row?.name != 'Video'
    ) {
      const message = `${row?.displayName} ${row?.sensor} requires the time of interest (TOI) to be 14 days or less from the current date. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.BLACKSKY && this.getArea(row, 'AOI') > 0 && checked) {
      const message = `${row?.displayName} ${row?.sensor} accepts only point of interest (POI) orders. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.BLACKSKY &&
      this.target.freqOption === 'Sub-daily' &&
      this.target.selectedOption === 1 &&
      this.target.subDailyCount > 4 && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} allows 4 sub-daily collection(s)  at this time. Please select or revisit number accordingly.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.BLACKSKY &&
      this.target.freqOption === 'Sub-daily' &&
      this.target.selectedOption === 1 &&
      differenceInDays < 7 && checked
    ) {
      const message = `The sub-daily tasking option for ${row?.displayName} ${row?.sensor} is only available for a minimum of seven days. Please choose an alternative provider if you require sub-daily tasking for less than seven days.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.AZISTA && days_Difference > 10 && checked
    ) {
      const message = `The ${row?.displayName} ${row?.sensor} can only be tasked in the next ten days. Please ensure your time of interest (TOI) is within ten days from today.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } 
    else if(row?.key === OPERATORS.AZISTA && checked) {
      const dialog = this.dialog.open(OperatorPopupComponent, {
        minWidth: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { selectedRow: row, operatorKey: row?.key, type: 'imageLength'
         },
      });

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          this.AVAILABLESENSORS[i].imageryLength = result.key;
          this.tooltipminLength = 'Strip : 35km x ' + result.key.toString().replace(/\s+/g, '');
          this.AVAILABLESENSORS[i].checked = true;
          this.tipAndCueSelection(true, i);
          let updatedPrice = Number(this.AVAILABLESENSORS[i].holdbackFactor)*result.price;
          this.AVAILABLESENSORS[i].selectedCost = updatedPrice;
          this.AVAILABLESENSORS[i].unitcost = result.price;
          this.AVAILABLESENSORS[i].cost = updatedPrice;
          this.AVAILABLESENSORS[i].latency[0].unitcost = result.price;
          this.AVAILABLESENSORS[i].latency[0].cost = result.price;
          this.AVAILABLESENSORS[i].selectedImageLength = result.value;
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
          for (const sensors of this.selectedSensors) {
            if (!sensors.feasibility) {
              this.feasible = true;
            }
          }
          this.clickHandler();

          // Selection finalized after async modal.
          this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
        } else {
          this.uncheckSensorInTipAndCue(i);

          // Async cancel: sensor unselected after getTotalCost() already returned.
          this.warnReactionTimeVsToiForSelectedSensors();
        }
      });
    }
    else if (
      (row?.key === OPERATORS.ORORATECH || row?.key === OPERATORS.WYVERN) &&
      (this.target.selectedOption === 1 || this.target.selectedOption === 0 || this.target.selectedOption === 3)
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only orders with a period collection at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.ORORATECH && days_Difference > 7) {
      const message = `The ${row?.displayName} ${row?.sensor} can only be tasked in the next seven days. Please ensure your time of interest (TOI) is within seven days from today.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }else if (
      row?.key === OPERATORS.WYVERN &&
      this.getArea(row, 'AOI') > 0 &&
      this.getArea(row, 'AOI') > 400
    ) {
      const message =
        'The area of interest (AOI) requested is larger than the allowed 400 sqkm set by the operator. Please reduce the task size to less than 400 sqkm or choose an alternative provider.';
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
    } else if (row?.key === OPERATORS.WYVERN && (timeDiffrence < 72 || differenceInDays < 30)) {
      const message = `The start of the time of interest (TOI) must be at least three days after the submission date, and the end date must be at least 30 days after the start date of the TOI. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.WYVERN &&
      this.getArea(row, 'AOI') > 0 &&
      (!this.utilsService.calculateMinSwathWidth(this.target.geoJSON) || !this.utilsService.calculateMaxSwathWidth(this.target.geoJSON))
    ) {
      const message =
        'Each line in the area of interest (AOI) must be at least 5km and no more than 25km long. Please redraw your AOI.';
        const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

        dialogRef.afterClosed().subscribe(() => {
          this.uncheckSensorInTipAndCue(i);
          this.AVAILABLESENSORS[i].prevent = true;
        });
    } else if (
      row?.key === OPERATORS.WYVERN &&
      this.checkEndDate(startDate, endDate)
    ) {
      const message = `The time of interest (TOI) end date cannot exceed 12 months from the start
      date. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
        });
    } else if (row?.key === OPERATORS.LBAND && checked && this.target.area > 0 && !this.target.targetPoints) {
 
      const message = `RF band(s) detection, such as UHF, VHF, and L-band, is a point-based (POI) task but covers a large area given the satellite's field of view. 
      Therefore, combining these signal detections with non imaging sensors is possible, provided Multi-RF is selected ahead of other sensors.`;
      // Validation: do not commit selection until user fixes the task geometry (e.g., provide POI target points).
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.uncheckSensorInTipAndCue(i);
      this.resetSensor();
      this.AVAILABLESENSORS[i].prevent = true;
      this.warnReactionTimeVsToiForSelectedSensors();
    } else if (
      row?.key === OPERATORS.LBAND &&
        (this.target.subDailyCount > 2 &&
        this.target.freqOption === 'Sub-daily' &&
        this.target.selectedOption === 1)
    ) {
      const message = `RF bands detection is possible up to two subdaily counts. Please select appropriate subdaily count.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (row?.key === OPERATORS.LBAND && this.target?.multiTarget?.length > 3) {
      const message = `The tasking of multiple points of interest (POIs) in a single task is limited to three subtasks.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } else if (
      row?.key === OPERATORS.GOKTURK &&
      this.target.selectedOption === 1 && checked
    ) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    } else if (
      row?.key === OPERATORS.GOKTURK && isCountryRestricted && checked) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const message =
        'The operator has not allowed the tasking of the sensor at the country tasked. Please continue with other sensors.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    } else if (
      row?.key === OPERATORS.GOKTURK &&
      this.getArea(row, 'AOI') > 0 &&
      !this.utilsService.calculateMinSwathWidth(this.target.geoJSON) && checked
    ) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const message =
        'Each line in the area of interest (AOI) must be 5km minimum long. Please redraw your AOI.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    } else if (
      (row?.key === OPERATORS.ECURS || row?.key === OPERATORS.ECURS_L) &&
      this.target.selectedOption === 1
    ) {
      const message = `${row?.displayName} ${row?.sensor} does not support recurrency at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    }
    else if (((row?.key === OPERATORS.PIXXEL && timeDiffrence < 24) || (row?.key === OPERATORS.PIXXEL && differenceInDays < 14)) && this.target.selectedOption === 2) {
      const message = `The start of the time of interest (TOI) must be at least one day after the submission date, and the end date must be at least 14 days after the start date of the TOI. Please change your TOI or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.AVAILABLESENSORS.forEach((operator, idx) => {
          if (idx === i) {
            this.uncheckSensorInTipAndCue(i);
            this.AVAILABLESENSORS[idx].prevent = true;
          }
        });
      });
    } else if (row?.key === OPERATORS.PIXXEL && ((this.target.freqOption === 'Sub-daily' ||  this.target.freqOption == 'Weekly' || this.target.freqOption == 'Daily') ||
      (this.target.freqOption ==='Monthly'&& clydePeriodDuration < 120))){
      const message = `${row?.displayName} ${row?.sensor} supports only monthly recurrency at this time and requires a
minimum time of interest (TOI) of four months. Please change your TOI or
choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.AVAILABLESENSORS.forEach((operator, idx) => {
          if (idx === i) {
            this.uncheckSensorInTipAndCue(i);
            this.AVAILABLESENSORS[idx].prevent = true;
          }
        });
      });
    }
    else if (row?.key === OPERATORS.SATVU && checked) {
      
      const dialog = this.dialog.open(OperatorPopupComponent, {
        minWidth: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { selectedRow: row?.key, operatorKey: OPERATORS.SATVU, type: 'illumination', illuminationOptions: [{ value: 'day', label: 'Day' }, { value: 'night', label: 'Night' }, { value: 'day-night', label: 'Both' }] },
      });

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          this.AVAILABLESENSORS[i].illuminationConstraint = result.illumination;

          // Call license API after day/night selection — same flow as SPIRE/GEOSAT.
          this.getSensorLicense(this.AVAILABLESENSORS[i].sensorId).subscribe((licResult: any) => {
            const licenseOptions = this.getLicenseOptionsFromResponse(licResult);
            this.noOfusers = licenseOptions;

            if (licenseOptions.length > 0 && !this.userDetails?.allocated) {
              const licenseDialog = this.dialog.open(OperatorPopupComponent, {
                minWidth: '50%',
                backdropClass: 'blurred',
                disableClose: true,
                data: {
                  selectedRow: row, operatorKey: row?.key, daysCount: days_Difference,
                  subscriptonAmount: row?.selectedHistoricalPrice?.data?.price, type: 'uplift',
                  noOfusers: licenseOptions,
                },
              });

              licenseDialog.afterClosed().subscribe((licenseResult) => {
                if (licenseResult != 'close') {
                  this.AVAILABLESENSORS[i].noOfUsers = licenseResult.value;
                  this.AVAILABLESENSORS[i].userCost = licenseResult.key;
                  this.AVAILABLESENSORS[i].selectedCost = Number(
                    (baseCost * licenseResult.key).toFixed(2)
                  );
                  this.AVAILABLESENSORS[i].checked = true;
                  this.tipAndCueSelection(true, i);
                  this.selectedSensors = [];
                  this.AVAILABLESENSORS.forEach((operator) => {
                    if (operator.checked) this.selectedSensors.push(operator);
                  });
                  for (const sensors of this.selectedSensors) {
                    if (!sensors.feasibility) { this.feasible = true; }
                  }
                  this.clickHandler();
                  this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
                } else {
                  this.uncheckSensorInTipAndCue(i);
                  this.warnReactionTimeVsToiForSelectedSensors();
                }
              });
            } else {
              // No license options or allocated user — proceed with normal selection.
              this.AVAILABLESENSORS[i].selectedCost = baseCost;
              this.AVAILABLESENSORS[i].checked = true;
              this.tipAndCueSelection(true, i);
              this.selectedSensors = [];
              this.AVAILABLESENSORS.forEach((operator) => {
                if (operator.checked) this.selectedSensors.push(operator);
              });
              for (const sensors of this.selectedSensors) {
                if (!sensors.feasibility) { this.feasible = true; }
              }
              this.clickHandler();
              this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
            }
          });
        } else {
          this.uncheckSensorInTipAndCue(i);

          // Async cancel: sensor unselected after getTotalCost() already returned.
          this.warnReactionTimeVsToiForSelectedSensors();
        }
      });
    } else if (
        checked && ((row?.key === OPERATORS.CAPELLA && row.collection_mode[0]?.captureMode === 'Strip' && this.getArea(row, 'AOI') > 0) || 
        (row?.key === OPERATORS.KOMPSAT &&
        ((this.getOverOpenWater() && this.getCountry() === 'South China Sea') ||
        (!this.getOverOpenWater() && this.getCountry() != this.currentUser.country)))) 
        && this.target.taskStrategy != 'Tip-and-Cue'
    ) {
      let dialog: any;

      if (row?.key === OPERATORS.CAPELLA) {
        dialog = this.dialog.open(OperatorPopupComponent, {
          minWidth: '50%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { selectedRow: row, operatorKey: row?.key, type: 'imageWidth'
           },
        });
      } else if (row?.key === OPERATORS.KOMPSAT) {
        // const message = this.getRestrictionMessage();
        const message = `You are only authorised to task over your country as the area of interest (AOI). Please change your point of interest (POI) or AOI and try again.`
        dialog = this.popupService.openPopup(WarningPopup, message, '', '50%');
      }

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          if (row?.key === OPERATORS.CAPELLA) this.AVAILABLESENSORS[i].imageWidth = result;

          if ((this.target?.intent.intent_key === 'internalUse' ||
            this.target?.intent.intent_key === 'internalAndDistribution') &&
          this.target.taskStrategy != 'Tip-and-Cue') {
            this.getSensorLicense(this.AVAILABLESENSORS[i].sensorId).subscribe((result: any) => {
              const licenseOptions = this.getLicenseOptionsFromResponse(result);
              this.noOfusers = licenseOptions;

              if (licenseOptions.length > 0 && !this.userDetails?.allocated) {

                  const dialog = this.dialog.open(OperatorPopupComponent, {
                    minWidth: '50%',
                    backdropClass: 'blurred',
                    disableClose: true,
                    data: {
                      selectedRow: row, operatorKey: row?.key, daysCount: days_Difference,
                      subscriptonAmount: row?.selectedHistoricalPrice?.data?.price, type: 'uplift',
                      noOfusers: licenseOptions
                    },
                  });

                  dialog.afterClosed().subscribe((result) => {
                    if (result != 'close') {
                      this.AVAILABLESENSORS[i].noOfUsers = result.value;
                      this.AVAILABLESENSORS[i].userCost = result.key;
                      this.AVAILABLESENSORS[i].selectedCost = Number(
                        (baseCost * result.key).toFixed(2)
                      );

                      this.AVAILABLESENSORS[i].checked = true;
  
                      this.selectedSensors = [];
                      this.AVAILABLESENSORS.forEach((operator) => {
                        if (operator.checked) this.selectedSensors.push(operator);
                      });
                      for (const sensors of this.selectedSensors) {
                        if (sensors.key === OPERATORS.SPIRE) {
                          this.isAISSensor = true;
                        }
                        if (!sensors.feasibility) {
                          this.feasible = true;
                        }
                      }

                      this.clickHandler();

                // Selection finalized after async modal(s).
                this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
                    } else {
                this.uncheckSensorInTipAndCue(i);
                // Async cancel: sensor unselected after getTotalCost() already returned.
                this.warnReactionTimeVsToiForSelectedSensors();
                    }
                  });
              }
            });
          } else {
            this.selectedSensors = [];
            this.AVAILABLESENSORS.forEach((operator) => {
              if (operator.checked) this.selectedSensors.push(operator);
            });
          }
        } else {
          this.uncheckSensorInTipAndCue(i);

          // Async cancel: sensor unselected after getTotalCost() already returned.
          this.warnReactionTimeVsToiForSelectedSensors();
        }
      });
    }
    else if (
      row?.key === OPERATORS.PIXXEL &&
      this.target.area > 0 &&
      this.target.area > 5000
      && !this.target.targetPoints
    ) {
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (idx === i) {
          this.AVAILABLESENSORS[idx].checked = false;
          this.AVAILABLESENSORS[idx].prevent = true;
        }
      });
      const message =
        'The area of interest (AOI) requested is larger than the allowed 5,000 sqkm set by the operator. Please reduce the task size to less than 5,000 sqkm or choose an alternative provider.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    }  
     else if (
      (row?.key === OPERATORS.PIXXEL && checked)
    ) {
      const dialog = this.dialog.open(AdvanceSettingsComponent, {
        minWidth: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { selectedRow: row, type: 'bandSelection' },
      });
  
      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          let items: any = [];
          items.push(row); 
          this.childDataEvent.emit(items);
          this.AVAILABLESENSORS[i].selectedBands = result;
          this.AVAILABLESENSORS[i].checked = true;

         if ((this.target?.intent?.intent_key === 'internalUse' ||
            this.target?.intent?.intent_key === 'internalAndDistribution') &&
          this.target?.taskStrategy != 'Tip-and-Cue') {
           this.getSensorLicense(this.AVAILABLESENSORS[i].sensorId).subscribe((result: any) => {
             const licenseOptions = this.getLicenseOptionsFromResponse(result);
             this.noOfusers = licenseOptions;

             if (licenseOptions.length > 0 && !this.userDetails?.allocated) {
                 const dialog = this.dialog.open(OperatorPopupComponent, {
                   minWidth: '50%',
                   backdropClass: 'blurred',
                   disableClose: true,
                   data: {
                     selectedRow: row, operatorKey: row?.key, daysCount: days_Difference,
                     subscriptonAmount: row?.selectedHistoricalPrice?.data?.price, type: 'uplift',
                     noOfusers: licenseOptions
                   },

                 });

                 dialog.afterClosed().subscribe((result) => {
                  if (row?.key === OPERATORS.PIXXEL && this.getArea(row, 'AOI') < minimumArea && checked && this.target.area > 0) {
                     this.showMinimumAreaWarning(
                     row,
                     i,
                     days_Difference,
                     baseCost,
                     checked,
                     timeDiffrence,
                     formattedMinimumArea
                      );
                       }
                   if (result != 'close') {
                     this.AVAILABLESENSORS[i].noOfUsers = result.value;
                     this.AVAILABLESENSORS[i].userCost = result.key;
                     if (!this.currentUser.pointsEligible) {
                       this.AVAILABLESENSORS[i].selectedCost = baseCost * result.key
                     }
                     else if (this.currentUser.pointsEligible) {
                       const conversionFactor = this.getConversionFactor();
                       let selectedCost = Math.round(baseCost * result.key * conversionFactor);
                       this.AVAILABLESENSORS[i].selectedCost = selectedCost / conversionFactor
                     }

                     this.AVAILABLESENSORS[i].checked = true;
                     this.selectedSensors = [];
                     this.AVAILABLESENSORS.forEach((operator) => {
                       if (operator.checked) this.selectedSensors.push(operator);
                     });
                     for (const sensors of this.selectedSensors) {
                       if (sensors.key === OPERATORS.SPIRE) {
                         this.isAISSensor = true;
                       }
                       if (!sensors.feasibility) {
                         this.feasible = true;
                       }
                     }

                     this.clickHandler();
                   } else {
                      this.uncheckSensorInTipAndCue(i);
                      this.selectedSensors = [];
                      this.AVAILABLESENSORS.forEach((operator) => {
                        if (operator.checked) this.selectedSensors.push(operator);
                      });
                      this.clickHandler();
                      this.warnReactionTimeVsToiForSelectedSensors();
                   }
                 });
             }
           });
          } else {
            this.selectedSensors = [];
            this.AVAILABLESENSORS.forEach((operator) => {
              if (operator.checked) this.selectedSensors.push(operator);
            });
          }              
        } else {
          this.uncheckSensorInTipAndCue(i);
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
          this.clickHandler();
          this.warnReactionTimeVsToiForSelectedSensors();
        }
      });
    } else if (
      row?.key === OPERATORS.PIXXEL &&
      this.target.area > 0 &&
      this.target.area > 5000
      && !this.target.targetPoints
    ) {
      this.AVAILABLESENSORS.forEach((operator, idx) => {
        if (idx === i) {
          this.AVAILABLESENSORS[idx].checked = false;
          this.AVAILABLESENSORS[idx].prevent = true;
        }
      });
      const message =
        'The area of interest (AOI) requested is larger than the allowed 5,000 sqkm set by the operator. Please reduce the task size to less than 5,000 sqkm or choose an alternative provider.';
      this.popupService.openPopup(WarningPopup, message, '', '50%');
    }
    else if (
      (row?.key === OPERATORS.SPIRE && checked) ||
      (row?.key === OPERATORS.CLYDE && checked) ||
      (row?.key === OPERATORS.GEOSAT && checked) ||
      (row?.key === OPERATORS.WEATHEREX && checked) ||
      (row?.key === OPERATORS.VOYAGERADAR && checked) ||
      (row?.key === OPERATORS.VESSELFINDER && checked) ||
      ((row?.key === OPERATORS.AT21 ||
        row?.key === OPERATORS.KOMPSAT ||
        row?.key === OPERATORS.ISI ||
        row?.key === OPERATORS.BLACKSKY ||
        row?.key === OPERATORS.GOKTURK ||
        row?.key === OPERATORS.CAPELLA ||
        row?.key === OPERATORS.PIXXEL ||
        row.key === OPERATORS.SDS || 
        row.key === OPERATORS.ORBVIEW) &&
        checked &&
        (this.target?.intent.intent_key === 'internalUse' ||
          this.target?.intent.intent_key === 'internalAndDistribution') &&
        this.target.taskStrategy != 'Tip-and-Cue')
    ) {
      this.getSensorLicense(this.AVAILABLESENSORS[i].sensorId).subscribe((result: any) => {
        const licenseOptions = this.getLicenseOptionsFromResponse(result);
        this.noOfusers = licenseOptions;

              const shouldExcludeOperators =
                checked && [OPERATORS.SPIRE, OPERATORS.CLYDE, OPERATORS.WEATHEREX, OPERATORS.VOYAGERADAR, OPERATORS.VESSELFINDER].includes(row?.key);
              if (!shouldExcludeOperators && (licenseOptions.length === 0 || this.userDetails?.allocated)) {
                this.AVAILABLESENSORS[i].checked = true;
                this.tipAndCueSelection(true, i);
                if (this.target?.taskStrategy !== 'Tip-and-Cue') {
                  this.selectedSensors = [];
                  this.AVAILABLESENSORS.forEach((operator) => {
                    if (operator.checked) this.selectedSensors.push(operator);
                  });
                }
                for (const sensors of this.selectedSensors) {
                  if (sensors.key === OPERATORS.SPIRE) {
                    this.isAISSensor = true;
                  }
                  if (!sensors.feasibility) {
                    this.feasible = true;
                  }
                }

                this.clickHandler();
                this.warnReactionTimeVsToiForSelectedSensors();
                return;
              }
              const data: any = {
                selectedRow: row,
                operatorKey: row?.key,
                daysCount: days_Difference,
                subscriptonAmount: row?.selectedHistoricalPrice?.data?.price,
                type: 'uplift',
                // Voyage Radar prices its two refresh endpoints separately, and
                // the area one is reachable only from an area task, so the
                // purchase screen still needs the shape to know whether to list
                // it. The nearby one is listed either way — its key prices the
                // endpoint rather than one gesture, and the second gesture (a
                // search around a vessel the user selects) is build steps 4-8 of
                // the nearby-vessel plan and is not built yet — so this flag
                // decides one row rather than choosing between two.
                // Ignored by every other operator's dialog.
                isPointTarget: this.isPointTargetTasked(),
              };

              if (!shouldExcludeOperators) {
                data.noOfusers = licenseOptions;
              }

              // Voyage Radar buys a credit wallet, not a refresh/user count, so
              // it gets its own dialog. Same `data` in, same result out
              // ({ apiCredits } / 'close') — the handler below is unchanged.
              // Widened to ComponentType<any>: MatDialog.open<T> infers T from
              // the argument, so a bare ternary pins T to the first branch and
              // then rejects the second.
              const creditDialogComponent: ComponentType<any> =
                row?.key === OPERATORS.VOYAGERADAR
                  ? VoyageCreditPurchaseComponent
                  : row?.key === OPERATORS.VESSELFINDER
                    ? VesselFinderCreditPurchaseComponent
                    : OperatorPopupComponent;
              const dialog = this.dialog.open(creditDialogComponent, {
                minWidth: '50%',
                backdropClass: 'blurred',
                disableClose: true,
                data,
              });


            dialog.afterClosed().subscribe((result) => {
              if (result != 'close') {
              if((row.key === OPERATORS.SDS || row.key === OPERATORS.ORBVIEW) && this.getArea(row, 'AOI') > 0 &&
                this.getArea(row, 'AOI') < minimumArea &&
                checked ){
                this.showMinimumAreaWarning(
                row,
                i,
                days_Difference,
                baseCost,
                checked,
                timeDiffrence,
                formattedMinimumArea
                );
                }
                const historicalCost = result.isHistorical ? 25 : 0;
                if (this.AVAILABLESENSORS[i].key === OPERATORS.SPIRE) {
                  this.AVAILABLESENSORS[i].noOfRefreshes = result?.refreshCount;
                  this.AVAILABLESENSORS[i].isHistorical = result?.isHistorical;
                  this.AVAILABLESENSORS[i].historicalCost = historicalCost;
                  this.AVAILABLESENSORS[i].noOfHistoricalData = result?.fetchCount;

                  if (
                    this.target.area > 0
                    && this.target.targetPoints
                  ) {
                    const pointString = this.target.targetPoints[0];
                    const geoJSON = this.convertToGeoJSON(pointString);
                    this.target.geometryCentroid = geoJSON;
                    row.centroid = this.target.targetPoints[0];
                    let items: any = [];
                    items.push(row);
                    this.childDataEvent.emit(items);
                  }
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.CLYDE) {
                  this.AVAILABLESENSORS[i].isHistorical = result?.isHistorical;
                  this.AVAILABLESENSORS[i].noOfHistoricalData = result?.daysCount;
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.WEATHEREX) {
                  this.AVAILABLESENSORS[i].noOfRefreshes = result?.refreshCount;
                  this.calculateUnitcost(i, 0);
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.VOYAGERADAR) {
                  this.AVAILABLESENSORS[i].apiCredits = result?.apiCredits;
                  this.calculateUnitcost(i, 0);
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.VESSELFINDER) {
                  this.AVAILABLESENSORS[i].apiCredits = result?.apiCredits;
                  this.calculateUnitcost(i, 0);
                  this.popupService.openPopup(
                    WarningPopupComponent,
                    'This operator uses the entire world as the coverage area and returns results globally. Your selected area of interest is inclusive, and no further action is required.',
                    'pleaseNote',
                    '50%'
                  );
                } else {
                  this.AVAILABLESENSORS[i].noOfUsers = result.value;
                  this.AVAILABLESENSORS[i].userCost = result.key;
                  if (this.AVAILABLESENSORS[i].key === OPERATORS.GEOSAT) {
                    this.recalculateSelectedCostForRow(i);
                  } else {
                    this.AVAILABLESENSORS[i].selectedCost = Number(
                      (baseCost * result.key).toFixed(2)
                    );
                  }
                }
                this.AVAILABLESENSORS[i].checked = true;
                this.tipAndCueSelection(true, i);
                if (this.target?.taskStrategy !== 'Tip-and-Cue') {
                  this.selectedSensors = [];
                  this.AVAILABLESENSORS.forEach((operator) => {
                    if (operator.checked) this.selectedSensors.push(operator);
                  });
                }
                for (const sensors of this.selectedSensors) {
                  if (sensors.key === OPERATORS.SPIRE) {
                    this.isAISSensor = true;
                  }
                  if (!sensors.feasibility) {
                    this.feasible = true;
                  }
                }

                this.clickHandler();
              } else {
                this.uncheckSensorInTipAndCue(i);
                this.selectedSensors = [];
                this.AVAILABLESENSORS.forEach((operator) => {
                  if (operator.checked) this.selectedSensors.push(operator);
                });
                this.clickHandler();
                this.warnReactionTimeVsToiForSelectedSensors();
              }
            });
      });
    } else if ((row?.key === OPERATORS.GHG && checked ) || (row?.key === OPERATORS.LBAND && checked)){
      let frequency = this.target.selectedOption;
      this.singleCircle = null;
      let numberOfRepeats = this.calculateRepeats();

      if (row?.key === OPERATORS.LBAND) {
        let items: any = [];
        items.push(row);
        this.childDataEvent.emit(items);
        this.AVAILABLESENSORS[i].overlapPercentage = this.localStorageService.getOverlapValue();
        let overlapCount = this.localStorageService.getOverlapCount();
       
        if (this.target?.multiTarget?.length === 3 && overlapCount > 1) {
          this.singleCircle = null;
          const message = `There can only be one overlapping circle per task.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          this.AVAILABLESENSORS.forEach((operator, idx) => {
            if (idx === i) {
              this.AVAILABLESENSORS[idx].checked = false;
              this.AVAILABLESENSORS[idx].prevent = true;
            }
          });
          this.AVAILABLESENSORS[i].sensorSelected = false;
          this.resetSensor();

        } else if (!row?.signalOfInterest || row?.signalOfInterest?.length === 0) {
          this.singleCircle = null;
          const message = `Please select at least one RF signal of interest from the options.`;
          this.popupService.openPopup(RequiredPopupComponent, message, '', '50%');
          // Validation: do not commit selection until at least one signal is selected.
          this.AVAILABLESENSORS[i].checked = false;
          this.AVAILABLESENSORS[i].sensorSelected = false;
          this.resetSensor();
        } else {
          this.singleCircle = false;
          this.AVAILABLESENSORS[i].checked = true;
          this.resetSensor();
          this.tipAndCueSelection(true, i);
       }
       }

      else if (row?.key === OPERATORS.GHG) {
        if (this.AVAILABLESENSORS[i].prevent === true) {
          this.AVAILABLESENSORS[i].prevent = false;
          this.AVAILABLESENSORS[i].checked = false;
        }
        this.checkTargetLocation().then(result => {
          switch (result) {
            case 'water':
              if (row?.selectedModes[0]?.productLevel.includes('Onshore')) {
                this.AVAILABLESENSORS.forEach((operator, idx) => {
                  if (idx === i) {
                    this.AVAILABLESENSORS[idx].checked = false;
                    this.AVAILABLESENSORS[idx].prevent = true;
                  }
                });
  
                const message = `${row?.displayName} ${row?.sensor} has different products based on whether the tasked area is over open waters or land. 
                Please change your product choice or change the location of your task.`;
                this.popupService.openPopup(WarningPopup, message, '', '50%');
  
                this.selectedSensors = [];
                this.AVAILABLESENSORS.forEach((operator) => {
                  if (operator.checked) this.selectedSensors.push(operator);
                });
                this.clickHandler();
              } else openPopup();
              break;
            case 'land':
              if (row?.selectedModes[0]?.productLevel.includes('Offshore')) {
                this.AVAILABLESENSORS.forEach((operator, idx) => {
                  if (idx === i) {
                    this.AVAILABLESENSORS[idx].checked = false;
                    this.AVAILABLESENSORS[idx].prevent = true;
                  }
                });
  
                const message = `${row?.displayName} ${row?.sensor} has different products based on whether the tasked area is over open waters or land. 
                Please change your product choice or change the location of your task.`;
                this.popupService.openPopup(WarningPopup, message, '', '50%');
  
                this.selectedSensors = [];
                this.AVAILABLESENSORS.forEach((operator) => {
                  if (operator.checked) this.selectedSensors.push(operator);
                });
                this.clickHandler();
              } else openPopup();
              break;
            case 'both':
              this.AVAILABLESENSORS.forEach((operator, idx) => {
                if (idx === i) {
                  this.AVAILABLESENSORS[idx].checked = false;
                  this.AVAILABLESENSORS[idx].prevent = true;
                }
              });
  
              const message = `${row?.displayName} ${row?.sensor} has different products based on whether the tasked area is over open waters or land. 
              Please change your product choice or change the location of your task.`;
              this.popupService.openPopup(WarningPopup, message, '', '50%');
  
              this.selectedSensors = [];
              this.AVAILABLESENSORS.forEach((operator) => {
                if (operator.checked) this.selectedSensors.push(operator);
              });
              this.clickHandler();
              break;
            default:
              console.error('Unexpected result:', result);
          }
        });
      } 

      function openPopup() {
        const dialog = _this.dialog.open(OperatorPopupComponent, {
          minWidth: '50%',
          backdropClass: 'blurred',
          disableClose: true,
          data: {
            selectedRow: row,
            target:
              _this.target?.multiTarget?.length > 0
                ? _this.target?.multiTarget
                : [_this.target.geoJSON],
            operatorKey: row?.key,
            frequency: frequency,
            repeatFrequency: _this.target?.freqOption,
            differenceInDays: differenceInDays,
            numberOfRepeats: numberOfRepeats
          },
        });
  
        dialog.afterClosed().subscribe((result) => {
          if (result != 'close') {
            _this.AVAILABLESENSORS[i].siteData = result.siteData;
            
             _this.AVAILABLESENSORS[i].noOfCollections = result?.numberOfCollections;

            _this.AVAILABLESENSORS[i].checked = true;
            _this.tipAndCueSelection(true, i);
            _this.selectedSensors = [];
            _this.AVAILABLESENSORS.forEach((operator) => {
              if (operator.checked) _this.selectedSensors.push(operator);
            });
            for (const sensors of _this.selectedSensors) {
              if (!sensors.feasibility) {
                _this.feasible = true;
              }
            }
            _this.clickHandler();

            // Selection finalized after async modal.
            _this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
          } else {
            _this.uncheckSensorInTipAndCue(i);
            _this.selectedSensors = [];
            _this.AVAILABLESENSORS.forEach((operator) => {
              if (operator.checked) _this.selectedSensors.push(operator);
            });
            _this.clickHandler();

            // Async cancel: sensor unselected after getTotalCost() already returned.
            _this.warnReactionTimeVsToiForSelectedSensors();
          }
        });
      }
    } else if (row?.key != OPERATORS.KOMPSAT && row?.key != OPERATORS.GOKTURK && !countryCheck && checked) {
      this.uncheckSensorInTipAndCue(i);
      this.AVAILABLESENSORS[i].prevent = true;
      const dialogRef = this.dialog.open(CountrycheckComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'countryblock', sensor: row.displayName },
      });
    } else if (
      row?.key === OPERATORS.OSK &&
      (this.target.selectedOption === 1 || this.target.selectedOption === 0 || this.target.selectedOption === 3)
      && checked
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only  orders with a period collection at this time. Recurrent, Specific Date and Specific Day orders are a future capability. Please choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
      });
    } 
    // Check if currentDate is after Tuesday 6 PM UTC
    else if (
      row?.key === OPERATORS.OSK &&
      timeDiffrence < 24 && checked
      && checked
    ) {
      const message = `We are unable to accept this task as ${row?.displayName} ${row?.sensor} requires start date to be current date + 24hrs. Please change your time of interest (TOI) or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
        this.warnReactionTimeVsToiForSelectedSensors();
      });
    } else if (
      row?.key === OPERATORS.ESPER &&
      (this.target.selectedOption === 1 || this.target.selectedOption === 0 || this.target.selectedOption === 3)
    ) {
      const message = `${row?.displayName} ${row?.sensor} accepts only orders with a period collection at this time. Please change your mode of frequency or choose an alternative provider.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
        this.warnReactionTimeVsToiForSelectedSensors();
      });
    } else if (row?.key === OPERATORS.ESPER && !this.validateDates(startDate, endDate) && checked) {
      const message = `The time of interest (TOI) can only start three days after the submission date and end 14 days after the submission date. Please change your TOI or choose an alternative provider.`;

      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(i);
        this.AVAILABLESENSORS[i].prevent = true;
        this.warnReactionTimeVsToiForSelectedSensors();
      });
    } 
    else if (
      (row?.key === OPERATORS.ESPER && checked && this.target.taskStrategy != 'Tip-and-Cue')
    ) {
      const dialog = this.dialog.open(AdvanceSettingsComponent, {
        minWidth: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { selectedRow: row, type: 'bandSelection' },
      });
  
      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          this.AVAILABLESENSORS[i].selectedBands = result;
          this.AVAILABLESENSORS[i].checked = true;
          this.tipAndCueSelection(true, i);
          this.bandPriceUpdate(row,i,result.bandCount);
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
          this.clickHandler();      

          // Selection finalized after async dialog.
          this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
        } else {
          this.uncheckSensorInTipAndCue(i);

          // Async cancel: sensor unselected after getTotalCost() already returned.
          this.warnReactionTimeVsToiForSelectedSensors();
        }
      });
    } else {
      if (!this.AVAILABLESENSORS) return;
      if (
        row?.key === OPERATORS.SATELLOGIC &&
        this.getArea(row, 'POI') === 0 &&
        this.isOpenWaterArea() && (row?.selectedResolution?.value?.includes('SR') || row?.selectedResolution?.value?.includes('GSD')) &&
        checked
      ) {
        const message = `${row?.displayName} ${row?.sensor} does not support over open waters. Please change the selected target or choose an alternative provider.`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');

        // Validation failure: do not let this selection persist.
        // Important: clear immediately so the later `AVAILABLESENSORS[i].checked = checked` does not re-select it
        // and `selectedSensors` does not keep it, which would enable submit.
        checked = false;
        this.AVAILABLESENSORS[i].checked = false;
        this.AVAILABLESENSORS[i].sensorSelected = false;
        this.AVAILABLESENSORS[i].prevent = true;

        if (this.target?.taskStrategy === 'Tip-and-Cue') {
          this.uncheckSensorInTipAndCue(i);
        } else {
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
        }

        this.clickHandler();
      } else if (
        row?.key === OPERATORS.CAPELLA &&
        differenceInDays < 7 &&
        row.selectedLatencyKey.key === 'standard' &&
        checked
      ) {
        const message = `${row?.displayName} ${row?.sensor} requires a minimum seven day window for standard tasking. Any lesser, it may be rejected. Please provide a minimum of seven day time of interest (TOI).`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
      } else if (
        row?.key === OPERATORS.CAPELLA &&
        differenceInDays < 3 &&
        row.selectedLatencyKey.key === 'priority' &&
        checked
      ) {
        const message = `${row?.displayName} ${row?.sensor} requires a minimum three day window for priority tasking. Any lesser, it may be rejected. Please provide a minimum of three day time of interest (TOI).`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
      }
      else if (row?.key === OPERATORS.CAPELLA && differenceInDays < 1 && row.selectedLatencyKey.key === 'rush' && checked) {
        const message = `${row?.displayName} ${row?.sensor} requires a minimum one day window for rush tasking. Any lesser, it may be rejected. Please provide a minimum of one day time of interest (TOI).`;
        this.popupService.openPopup(WarningPopup, message, '', '50%');
      } else if ((  // A warning popup appears, followed by the user popup to continue task if the AOI is less than minimum area.
        row?.key != OPERATORS.HEAD &&
        this.getArea(row, 'AOI') > 0 &&
        this.getArea(row, 'AOI') < minimumArea &&
        checked ) || (row?.key === OPERATORS.ECURS_L && this.getArea(row, 'AOI') > 0 && this.getArea(row, 'AOI') < row?.selectedModes[0]?.minareastrip)
      ) {
        if (row?.key === OPERATORS.USL && this.target.area > 0 && checked && timeDiffrence < 48 && row?.selectedTaskingTierPrefrence == 'standard') {
          this.uslPopup = true;
          const toiMessage = `The time of interest (TOI) start is within 48 hrs of the submission time. This is marginal for the standard tasking tier. There is a risk of rejection by the operator. Please increase the lead time, if possible.`;
          const toiDialogRef = this.popupService.openPopup(WarningPopup, toiMessage, '', '50%');
          toiDialogRef.afterClosed().subscribe(() => {
        this.showMinimumAreaWarning(
          row,
          i,
          days_Difference,
          baseCost,
          checked,
          timeDiffrence,
          formattedMinimumArea
          );
        });
        } else {
        this.showMinimumAreaWarning(
          row,
          i,
          days_Difference,
          baseCost,
          checked,
          timeDiffrence,
          formattedMinimumArea
          );

        }
      }
      if (checked) {
        this.openOperatorDialog(row, i, days_Difference, baseCost, checked, timeDiffrence);
      }

      this.AVAILABLESENSORS[i].checked = checked;
      if (this.target.taskStrategy == 'Tip-and-Cue') {
         if (checked && (row?.key === OPERATORS.CAPELLA &&
           row.collection_mode?.some(mode => mode.mode_type === this.stripHundred) && this.getArea(row, 'AOI') > 0) || 
           (row?.key === OPERATORS.KOMPSAT &&
            ((this.getOverOpenWater() && this.getCountry() === 'South China Sea') ||
            (!this.getOverOpenWater() && this.getCountry() != this.currentUser.country))))  {
          
          let dialogRef: any;
          if (row?.key === OPERATORS.CAPELLA){
          dialogRef = this.dialog.open(OperatorPopupComponent, {
            minWidth: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {
              selectedRow: row, operatorKey: row?.key, type: 'imageWidth'
            },
          });
          } else if (row?.key === OPERATORS.KOMPSAT) {
            const message = this.getRestrictionMessage();
            dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
          }

          dialogRef.afterClosed().subscribe((result) => {            
            if (result != 'close') {
              if (row?.key === OPERATORS.CAPELLA) this.AVAILABLESENSORS[i].imageWidth = result;
              if ((this.target?.intent.intent_key === 'internalUse' ||
                this.target?.intent.intent_key === 'internalAndDistribution')) {
                  userSettings();
              }
            } else {
                this.uncheckSensorInTipAndCue(i);
              this.warnReactionTimeVsToiForSelectedSensors();
            }
          });

        } else if (
          (row?.key === OPERATORS.GEOSAT && checked) ||
          (row?.key === OPERATORS.AT21 ||
            row?.key === OPERATORS.KOMPSAT ||
            row?.key === OPERATORS.ISI ||
            row?.key === OPERATORS.BLACKSKY ||
            row?.key === OPERATORS.GOKTURK ||
            row?.key === OPERATORS.CAPELLA ||
            row?.key === OPERATORS.ECURS ||
            row?.key === OPERATORS.ECURS_L ||
            row?.key === OPERATORS.PIXXEL) &&
          checked &&
          (this.target?.intent.intent_key === 'internalUse' ||
            this.target?.intent.intent_key === 'internalAndDistribution')
        ) {
          userSettings();
        } else if (
          (row?.key === OPERATORS.ESPER && checked)
        ) {
          const dialog = this.dialog.open(AdvanceSettingsComponent, {
            minWidth: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { selectedRow: row, type: 'bandSelection' },
          });

          dialog.afterClosed().subscribe((result) => {
            if (result != 'close') {
              this.AVAILABLESENSORS[i].selectedBands = result;
              this.AVAILABLESENSORS[i].checked = true;
              this.bandPriceUpdate(row, i, result.bandCount);
              this.tipAndCueSelection(true, i);
              this.clickHandler();

              this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
            } else {
             this.uncheckSensorInTipAndCue(i);
             this.warnReactionTimeVsToiForSelectedSensors();
            }
          });
        } else {          
          if (checked) {
            if (this.selectedTabIndex === 0) {
              this.selectedTippingSensors.push(this.AVAILABLESENSORS[i]);
               // Check if all tabIndex values are the same
              const isSameTabIndex = this.selectedTippingSensors.every(sensor => sensor.tabIndex === this.selectedTabIndex);
              if (this.selectedTippingSensors.length > 1 && isSameTabIndex) {
                this.selectedTippingSensors.shift();
              }
            }

            if (this.selectedTabIndex === 1) {
              this.selectedCueingSensors.push(this.AVAILABLESENSORS[i]);
              // Check if all tabIndex values are the same
              const isSameTabIndex = this.selectedCueingSensors.every(sensor => sensor.tabIndex === this.selectedTabIndex);
              if (this.selectedCueingSensors.length > 1 && isSameTabIndex) {
                this.selectedCueingSensors.shift();
              }
            }

            this.selectedSensors = [...this.selectedTippingSensors, ...this.selectedCueingSensors];
          } 

          else {
            if (this.selectedTabIndex === 0) {
              let countIndex = this.selectedTippingSensors.findIndex(
                (item) =>
                  item.sensorId === this.AVAILABLESENSORS[i].sensorId &&
                  item.tabIndex === this.AVAILABLESENSORS[i].tabIndex
              );
              if (countIndex !== -1) {
                this.selectedTippingSensors.splice(countIndex, 1);
              }
            }

            if (this.selectedTabIndex === 1) {
              let countIndex = this.selectedCueingSensors.findIndex(
                (item) =>
                  item.sensorId === this.AVAILABLESENSORS[i].sensorId &&
                  item.tabIndex === this.AVAILABLESENSORS[i].tabIndex
              );
              if (countIndex !== -1) {
                this.selectedCueingSensors.splice(countIndex, 1);
              }
            }

            this.selectedSensors = [...this.selectedTippingSensors, ...this.selectedCueingSensors];

          }

          for (const sensor of this.AVAILABLESENSORS) {
            let countIndex = this.selectedSensors.findIndex(
              (item) =>
                item.sensorId === sensor.sensorId &&
                item.tabIndex === sensor.tabIndex
            );
            if (countIndex === -1 && sensor.checked) {
              sensor.checked = false;
            }
          }
        }

        function userSettings() {
          _this.uncheckSensorInTipAndCue(i);
          _this.getSensorLicense(_this.AVAILABLESENSORS[i].sensorId).subscribe((result: any) => {
        const licenseOptions = _this.getLicenseOptionsFromResponse(result);
        _this.noOfusers = licenseOptions;

          if (licenseOptions.length > 0 && !_this.userDetails?.allocated) {

          const dialog = _this.dialog.open(OperatorPopupComponent, {
            minWidth: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: { selectedRow: row, operatorKey: row?.key,type: 'uplift',
              noOfusers: licenseOptions
             },
          });

          dialog.afterClosed().subscribe((result) => {
            if (result != 'close') {
              _this.AVAILABLESENSORS[i].noOfUsers = result.value;
              _this.AVAILABLESENSORS[i].userCost = result.key;
              if (_this.AVAILABLESENSORS[i].key === OPERATORS.GEOSAT) {
                _this.recalculateSelectedCostForRow(i);
              } else {
                _this.AVAILABLESENSORS[i].selectedCost = Number(
                  (baseCost * result.key).toFixed(2)
                );
              }
              _this.AVAILABLESENSORS[i].checked = true;
              _this.tipAndCueSelection(true, i); 

              _this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
            } else {
              _this.uncheckSensorInTipAndCue(i);
                checked = false;
              _this.warnReactionTimeVsToiForSelectedSensors();
            }
          });
        } else {
          _this.AVAILABLESENSORS[i].checked = true;
          _this.tipAndCueSelection(true, i);
          _this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
        }
      });
      }
      } else {
        this.selectedSensors = [];
        this.AVAILABLESENSORS.forEach((operator) => {
          if (operator.checked) this.selectedSensors.push(operator);
        });
      }
      this.clickHandler();
    }
     if (
      row?.key === OPERATORS.SATELLITEVU_VANZYL &&
      checked &&
      !isSatelliteVuRecurringSelectionBlocked &&
      this.target.freqOption != 'Daily' &&
      this.target.freqOption != 'Sub-daily'
    ) {
      const vanzylDialog = this.dialog.open(OperatorPopupComponent, {
        minWidth: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { operatorKey: row?.key, type: 'illumination', illuminationOptions: [{ value: 'day', label: 'Day' }, { value: 'night', label: 'Night' }] },
      });
      vanzylDialog.afterClosed().subscribe((result: any) => {
        if (result != 'close') {
          this.AVAILABLESENSORS[i].isNightSensor = result.illumination === 'night';
        } else {
          this.uncheckSensorInTipAndCue(i);
          this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
            if (operator.checked) this.selectedSensors.push(operator);
          });
          this.clickHandler();
          this.warnReactionTimeVsToiForSelectedSensors();
        }
      });
     }
    if (row?.key === OPERATORS.LBAND && !checked) {
      this.resetRFData.emit();
    }

    if (row?.key === OPERATORS.SPIRE && !checked) {
      this.resetSpireData.emit();
    }

    for (const sensors of this.selectedSensors) {
      if (sensors.key === OPERATORS.SPIRE) {
        this.isAISSensor = true;
      }
      if (!sensors.feasibility) {
        this.feasible = true;
      }
    }
  }

  private applyTipAndCueRowSelection(checked: boolean, i: number): void {
    const selectedRow = this.AVAILABLESENSORS?.[i];
    if (!selectedRow) return;

    selectedRow.sensorSelected = checked === true;

    if (checked) {
      if (this.selectedTabIndex === 0) {
        this.selectedTippingSensors.push(selectedRow);
        const isSameTabIndex = this.selectedTippingSensors.every(
          (sensor) => sensor.tabIndex === this.selectedTabIndex
        );
        if (this.selectedTippingSensors.length > 1 && isSameTabIndex) {
          this.selectedTippingSensors.shift();
        }
      }

      if (this.selectedTabIndex === 1) {
        this.selectedCueingSensors.push(selectedRow);
        const isSameTabIndex = this.selectedCueingSensors.every(
          (sensor) => sensor.tabIndex === this.selectedTabIndex
        );
        if (this.selectedCueingSensors.length > 1 && isSameTabIndex) {
          this.selectedCueingSensors.shift();
        }
      }

      this.selectedSensors = [
        ...this.selectedTippingSensors,
        ...this.selectedCueingSensors,
      ];
    } else {
      if (this.selectedTabIndex === 0) {
        const countIndex = this.selectedTippingSensors.findIndex(
          (item) =>
            item.sensorId === selectedRow.sensorId &&
            item.tabIndex === selectedRow.tabIndex
        );
        if (countIndex !== -1) {
          this.selectedTippingSensors.splice(countIndex, 1);
        }

        // Tip-and-Cue fix: unselecting tipping also resets cueing sensors
        this.resetCueingSensors();
      }

      if (this.selectedTabIndex === 1) {
        const countIndex = this.selectedCueingSensors.findIndex(
          (item) =>
            item.sensorId === selectedRow.sensorId &&
            item.tabIndex === selectedRow.tabIndex
        );
        if (countIndex !== -1) {
          this.selectedCueingSensors.splice(countIndex, 1);
        }
      }

      this.selectedSensors = [
        ...this.selectedTippingSensors,
        ...this.selectedCueingSensors,
      ];
    }

    for (const sensor of this.AVAILABLESENSORS) {
      const countIndex = this.selectedSensors.findIndex(
        (item) => item.sensorId === sensor.sensorId && item.tabIndex === sensor.tabIndex
      );
      if (countIndex === -1 && sensor.checked) {
        sensor.checked = false;
        sensor.sensorSelected = false;
      }
    }
  }

  /**
   * Tip-and-Cue fix: reset cueing sensors when tipping sensor selection changes
   */
  private resetCueingSensors(): void {
    this.selectedCueingSensors = [];

    this.AVAILABLESENSORS.forEach((sensor) => {
      if (sensor.tabIndex === 1) {
        sensor.checked = false;
        sensor.sensorSelected = false;
        sensor.tnqSensorDisabled = true;
        if (!sensor.selectedTnqSensorType) {
          sensor.selectedTnqSensorType = 'Cueing';
        }
      }
    });

    this.selectedSensors = [
      ...this.selectedTippingSensors,
      ...this.selectedCueingSensors,
    ];
  }

  /**
   * Uncheck a sensor in Tip-and-Cue mode and remove from selection arrays
   * Used when validation fails or dialog is canceled
   */
  private uncheckSensorInTipAndCue(sensorIndex: number): void {
    const sensor = this.AVAILABLESENSORS[sensorIndex];
    if (!sensor) return;

    sensor.checked = false;
    sensor.tnqSensorDisabled = true;
    sensor.sensorSelected = false;

    if (this.target?.taskStrategy === 'Tip-and-Cue') {
      // Keep the row's fixed TNQ type so validations continue to apply on re-selection.
      if (!sensor.selectedTnqSensorType) {
        sensor.selectedTnqSensorType = sensor.tabIndex === 1 ? 'Cueing' : 'Tipping';
      }

      const previousTabIndex = this.selectedTabIndex;
      if (typeof sensor.tabIndex === 'number') {
        this.selectedTabIndex = sensor.tabIndex;
      }
      this.tipAndCueSelection(false, sensorIndex);
      this.selectedTabIndex = previousTabIndex;
    } else {
      // Outside Tip-and-Cue, TNQ type is not applicable; keep payload clean.
      sensor.selectedTnqSensorType = '';

      // Many UI elements (including submit buttons) depend on `selectedSensors`.
      // When sensors are unchecked programmatically (e.g., after warnings), keep it in sync.
      this.selectedSensors = (this.AVAILABLESENSORS || []).filter((op: any) => op?.checked === true);
    }
  }

  tipAndCueSelection(checked, i) {
    if (this.target?.taskStrategy !== 'Tip-and-Cue') {
      return;
    }
    this.applyTipAndCueRowSelection(checked, i);

    // Keep Tip-and-Cue selection arrays in sync with the current table rows.
    // Without this, programmatic flows (dialogs/required steps) that rebuild
    // AVAILABLESENSORS can leave stale objects in selectedTippingSensors/
    // selectedCueingSensors, triggering false "already selected" warnings.
    this.selectedTippingSensors = (this.AVAILABLESENSORS || []).filter(
      (row: any) => row?.checked === true && row?.tabIndex === 0
    );
    this.selectedCueingSensors = (this.AVAILABLESENSORS || []).filter(
      (row: any) => row?.checked === true && row?.tabIndex === 1
    );
    this.selectedSensors = [
      ...(this.selectedTippingSensors || []),
      ...(this.selectedCueingSensors || []),
    ];

    for (const sensors of this.selectedSensors) {
      if (!sensors.feasibility) {
        this.feasible = true;
      }
    }

    this.tipAndQSelectedRows = this.AVAILABLESENSORS.filter(
      (operator) =>
        operator.checked &&
        operator.selectedTnqSensorType == ''
    );
    this.tipAndQSelected =
      this.tipAndQSelectedRows.length === 0 ? false : true;

    // Tip-and-Cue selection can programmatically uncheck rows without calling getTotalCost.
    // Refresh the inline warning banner to stay accurate.
    this.warnReactionTimeVsToiForSelectedSensors();
  }
  openOperatorDialog(row: any, i: number, days_Difference: any, baseCost: any, checked:any, timeDiffrence: any): void 
  {
    if (row?.key === OPERATORS.USL && this.target.area > 0 && checked && timeDiffrence < 48 && !this.uslPopup && row?.selectedTaskingTierPrefrence == 'standard') {
      const toiMessage = `The time of interest (TOI) start is within 48 hrs of the submission time. This is marginal for the standard tasking tier. There is a risk of rejection by the operator. Please increase the lead time, if possible.`;
      const toiDialogRef = this.popupService.openPopup(WarningPopup, toiMessage, '', '50%');
    }
    if ((row?.key === OPERATORS.SPIRE && checked) ||
        (row?.key === OPERATORS.CLYDE && checked) ||
        (row?.key === OPERATORS.GEOSAT && checked) ||
        (row?.key === OPERATORS.WEATHEREX && checked) ||
        (row?.key === OPERATORS.VOYAGERADAR && checked) ||
        (row?.key === OPERATORS.VESSELFINDER && checked) ||
        ((row?.key === OPERATORS.AT21 ||
        row?.key === OPERATORS.KOMPSAT ||
        row?.key === OPERATORS.ISI ||
        row?.key === OPERATORS.BLACKSKY ||
        row?.key === OPERATORS.GOKTURK ||
        row?.key === OPERATORS.CAPELLA ||
        row?.key === OPERATORS.ECURS ||
        row?.key === OPERATORS.ECURS_L) &&
        checked &&
        (this.target?.intent.intent_key === 'internalUse' ||
        this.target?.intent.intent_key === 'internalAndDistribution') &&
        this.target.taskStrategy != 'Tip-and-Cue')){
      this.getSensorLicense(this.AVAILABLESENSORS[i].sensorId).subscribe((result: any) => {
        const licenseOptions = this.getLicenseOptionsFromResponse(result);
        this.noOfusers = licenseOptions;

              const shouldExcludeOperators =
              checked && [OPERATORS.SPIRE, OPERATORS.CLYDE, OPERATORS.WEATHEREX, OPERATORS.VOYAGERADAR, OPERATORS.VESSELFINDER].includes(row?.key);
              if (!shouldExcludeOperators && (licenseOptions.length === 0 || this.userDetails?.allocated)) {
                this.AVAILABLESENSORS[i].checked = true;
                this.selectedSensors = [];
                this.AVAILABLESENSORS.forEach((operator) => {
                  if (operator.checked) this.selectedSensors.push(operator);
                });
                for (const sensors of this.selectedSensors) {
                  if (sensors.key === OPERATORS.SPIRE) {
                    this.isAISSensor = true;
                  }
                  if (!sensors.feasibility) {
                    this.feasible = true;
                  }
                }

                this.clickHandler();
                this.warnReactionTimeVsToiForSelectedSensors();
                return;
              }
              const data: any = {
                selectedRow: row,
                operatorKey: row?.key,
                daysCount: days_Difference,
                subscriptonAmount: row?.selectedHistoricalPrice?.data?.price,
                type: 'uplift',
                // Voyage Radar prices its two refresh endpoints separately, and
                // the area one is reachable only from an area task, so the
                // purchase screen still needs the shape to know whether to list
                // it. The nearby one is listed either way — its key prices the
                // endpoint rather than one gesture, and the second gesture (a
                // search around a vessel the user selects) is build steps 4-8 of
                // the nearby-vessel plan and is not built yet — so this flag
                // decides one row rather than choosing between two.
                // Ignored by every other operator's dialog.
                isPointTarget: this.isPointTargetTasked(),
              };

              if (!shouldExcludeOperators) {
                data.noOfusers = licenseOptions;
              }

              // Voyage Radar buys a credit wallet, not a refresh/user count —
              // same `data` in, same result out, handler below unchanged.
              const upliftDialogComponent: ComponentType<any> =
                row?.key === OPERATORS.VOYAGERADAR
                  ? VoyageCreditPurchaseComponent
                  : row?.key === OPERATORS.VESSELFINDER
                    ? VesselFinderCreditPurchaseComponent
                    : OperatorPopupComponent;
              const dialog = this.dialog.open(upliftDialogComponent, {
                minWidth: '50%',
                backdropClass: 'blurred',
                disableClose: true,
                data,
              });
            dialog.afterClosed().subscribe((result) => {
              if (result != 'close') {
                const historicalCost = result.isHistorical ? 25 : 0;
                if (this.AVAILABLESENSORS[i].key === OPERATORS.SPIRE) {
                  this.AVAILABLESENSORS[i].noOfRefreshes = result?.refreshCount;
                  this.AVAILABLESENSORS[i].isHistorical = result?.isHistorical;
                  this.AVAILABLESENSORS[i].historicalCost = historicalCost;
                  this.AVAILABLESENSORS[i].noOfHistoricalData = result?.fetchCount;

                  if (
                    this.target.area > 0
                    && this.target.targetPoints
                  ) {
                    const pointString = this.target.targetPoints[0];
                    const geoJSON = this.convertToGeoJSON(pointString);
                    this.target.geometryCentroid = geoJSON;
                    row.centroid = this.target.targetPoints[0];
                    let items: any = [];
                    items.push(row);
                    this.childDataEvent.emit(items);
                  }
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.CLYDE) {
                  this.AVAILABLESENSORS[i].isHistorical = result?.isHistorical;
                  this.AVAILABLESENSORS[i].noOfHistoricalData = result?.daysCount;
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.WEATHEREX) {
                  this.AVAILABLESENSORS[i].noOfRefreshes = result?.refreshCount;
                  this.calculateUnitcost(i, 0);
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.VOYAGERADAR) {
                  this.AVAILABLESENSORS[i].apiCredits = result?.apiCredits;
                  this.calculateUnitcost(i, 0);
                } else if (this.AVAILABLESENSORS[i].key === OPERATORS.VESSELFINDER) {
                  this.AVAILABLESENSORS[i].apiCredits = result?.apiCredits;
                  this.calculateUnitcost(i, 0);
                  this.popupService.openPopup(
                    WarningPopupComponent,
                    'This operator uses the entire world as the coverage area and returns results globally. Your selected area of interest is inclusive, and no further action is required.',
                    'pleaseNote',
                    '50%'
                  );
                } else {
                  if (this.AVAILABLESENSORS[i].sensortype == 'InSAR' && (this.AVAILABLESENSORS[i].key == OPERATORS.ECURS || this.AVAILABLESENSORS[i].key == OPERATORS.ECURS_L)) {
                    const inSARDialog = this.dialog.open(OperatorPopupComponent, {
                      minWidth: '50%',
                      backdropClass: 'blurred',
                      disableClose: true,
                      data: {
                        selectedRow: row,
                        target: this.target,
                        sensorType: this.AVAILABLESENSORS[i].sensortype,
                        operatorKey: row?.key,
                      },
                    });

                    inSARDialog.afterClosed().subscribe((result) => {
                      if (result != 'close') {
                        this.AVAILABLESENSORS[i].noOfInsar = result.numberOfScene;
                      } else {
                  this.uncheckSensorInTipAndCue(i);

                  // Async cancel: sensor unselected after dialog closes.
                  this.warnReactionTimeVsToiForSelectedSensors();
                      }
                    })

                  }
                  this.AVAILABLESENSORS[i].noOfUsers = result.value;
                  this.AVAILABLESENSORS[i].userCost = result.key;
                  if (this.AVAILABLESENSORS[i].key === OPERATORS.GEOSAT) {
                    this.recalculateSelectedCostForRow(i);
                  } else {
                    this.AVAILABLESENSORS[i].selectedCost = Number(
                      (baseCost * result.key).toFixed(2)
                    );
                  }
                }
                this.AVAILABLESENSORS[i].checked = true;
                this.tipAndCueSelection(true, i);
                this.selectedSensors = [];
                this.AVAILABLESENSORS.forEach((operator) => {
                  if (operator.checked) this.selectedSensors.push(operator);
                });
                for (const sensors of this.selectedSensors) {
                  if (sensors.key === OPERATORS.SPIRE) {
                    this.isAISSensor = true;
                  }
                  if (!sensors.feasibility) {
                    this.feasible = true;
                  }
                }

                this.clickHandler();

          // Selection finalized after async dialog.
          this.warnReactionTimeVsToiForSelectedSensors(row, row?.selectedLatencyKey);
              } else {
          this.uncheckSensorInTipAndCue(i);
                this.selectedSensors = [];
          this.AVAILABLESENSORS.forEach((operator) => {
                  if (operator.checked) this.selectedSensors.push(operator);
          });

          // Async cancel: sensor unselected after dialog closes.
          this.warnReactionTimeVsToiForSelectedSensors();
                // this.AVAILABLESENSORS.forEach((operator) => {
          //   if (operator.checked) this.selectedSensors.push(operator);
          // });
        }
            });
          // }
        // }
      }
      )
    };
  }
  convertToGeoJSON(pointString: string): string {
    // Extract coordinates from the string
    const match = pointString.match(/POINT\s*\(([-\d.]+)\s+([-\d.]+)\)/);
  
    if (!match) {
      throw new Error('Invalid POINT format');
    }
  
    // Parse the coordinates
    const longitude = parseFloat(match[1]);
    const latitude = parseFloat(match[2]);
  
    // Construct the GeoJSON object
    const geoJSON = {
      type: 'Point',
      coordinates: [longitude, latitude],
    };
  
    // Convert to JSON string
    return JSON.stringify(geoJSON);
  }

  isAreaAllowed(row: any) {
    const captureModes = row?.collection_mode?.map((mode: any) => mode.captureMode) || [];
    const hasArea = captureModes.some(mode => mode.toLowerCase().includes('area'));
    return hasArea;
  }
  
  getPlaceHolder(row: any, indx: any) {
    if (this.target.area > 0 && row?.key === OPERATORS.SATELLOGIC && (!this.cpcAndAllocated || this.isAreaAllowed(row))) {
      const modeWithArea = row.collection_mode.find(
        (mode: any) => mode.captureMode?.toLowerCase().includes('area')
      );
      return modeWithArea?.captureMode??'Area';
    } else if (row?.key === OPERATORS.GEOSAT) {
      return this.getDefaultCollectionMode(row, row?.collection_mode)?.captureMode || row.collection_mode[0]?.captureMode;
    } else if (
      this.target.area > 0 &&
      (row?.key === OPERATORS.KOMPSAT || row?.key === OPERATORS.SDS || row?.key === OPERATORS.ORBVIEW) &&
      row?.sensor === 'MSI'
    ) {
      if (row?.key === OPERATORS.SDS || row?.key === OPERATORS.ORBVIEW) {
        return row?.selectedModes?.[0]?.captureMode ?? 'Strip';
      }
      return 'Strip';
     }else if (
      row?.key === OPERATORS.GHG &&
      (this.target?.multiTarget?.length > 2 && this.multiPointsCoveredArea <= 144)
    ) {
      return row.collection_mode[1].captureMode;
    } else if (
      row?.key === OPERATORS.ECURS &&
      (this.target.area > 0)  && row?.collection_mode?.some(mode => mode.key.includes('StripMap'))
    ) {
      const matchedMode = row?.collection_mode.find(mode => mode.key.includes('StripMap'));
      return matchedMode?.captureMode ? matchedMode?.captureMode : row.collection_mode[0].captureMode;
    } else if (row?.key === OPERATORS.WEATHEREX) {
      return 'Select Modes';
    } else if (
      row.collection_mode[0]?.isCaptureMode &&
      !row.collection_mode[0]?.isProductLevel
    ) {
      return row.collection_mode[0].captureMode;
    } else if (
      row.collection_mode[0]?.isProductLevel &&
      !row.collection_mode[0]?.isCaptureMode
    ) {
      return row.collection_mode[0].productLevel;
    } else {
      if (row?.key === OPERATORS.ECURS_L && (!this.AVAILABLESENSORS[indx].selectedModes || this.AVAILABLESENSORS[indx].selectedModes.length == 0)) {
        this.AVAILABLESENSORS[indx].selectedModes = [];
        this.AVAILABLESENSORS[indx].selectedModes.push(row?.collection_mode[0]);
        this.AVAILABLESENSORS[indx].selectedResolution = this.AVAILABLESENSORS[indx].resolution[0];
        this.AVAILABLESENSORS[indx].selectedResolutionValue = this.AVAILABLESENSORS[indx].resolution[0].value;
      }
      return `${row.collection_mode[0].captureMode} (${row.collection_mode[0].productLevel})`;
    }
  }

  getTooltip(row: any, indx: any, sensor: any) {
    this.AVAILABLESENSORS[indx].tooltipValue = row?.minTooltip;
    this.AVAILABLESENSORS[indx].minimumArea = row?.value;
  }

  getModeSelectionContext(row: any): ModeSelectionContext {
    return {
      targetType: this.getArea(row, 'AOI') > 0 ? 'AOI' : 'POI',
    };
  }

  getDefaultCollectionMode(row: any, collectionModes: any[] = []) {
    if (!collectionModes?.length) {
      return null;
    }

    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    return strategy?.selectDefaultMode?.(collectionModes, this.getModeSelectionContext(row)) || null;
  }

  isOperatorModeDisabled(row: any, mode: any) {
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    return strategy?.isModeDisabled?.(mode, row, this.getModeSelectionContext(row)) || false;
  }

  isOperatorOnaDisabled(row: any, onaOption: any) {
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    return strategy?.isOnaDisabled?.(onaOption, row) || false;
  }

  onMouseOut() {
    this.tooltipDisabled = true;
    this.detailsText = '';
  }

  clickHandler() {
    this.childEvent.emit();

    // Many selection flows (including async modal success/cancel) end up calling clickHandler().
    // Keep the Reaction-vs-TOI banner consistent with final checked states.
    this.warnReactionTimeVsToiForSelectedSensors();
  }

  OpenPopup(row: any) {
    let sensorName = row?.displayName + ' ' + row.sensor;
    let resolution: any, name: any;
    if (row?.resolution) {
      if (row?.resolution[0]?.previewvalue) {
        resolution = row?.resolution[0]?.previewvalue;
      } else resolution = row?.resolution[0]?.value;
      name = row?.imageryname;
       if (row?.selectedModes[0]?.imageryname) {
        let selectedModes = row?.selectedModes[0];
        name = selectedModes?.imageryname;
        if (selectedModes?.resolution?.length > 0) {
          resolution = selectedModes.resolution[0];
        }
      }
    }
    let mode: any;
    if (row?.collection_mode) {
      if (row?.collection_mode[0]?.previewmode) {
        mode = row?.collection_mode[0].previewmode;
      } else if (row?.collection_mode[0]?.tooltip) {
        mode = row?.collection_mode[0].tooltip;
      } else mode = row?.collection_mode[0]?.captureMode;
    }
    if (row?.selectedModes[0]?.imageryname &&  row?.selectedModes[0]?.captureMode) {
      mode = row?.selectedModes[0]?.captureMode;
    }
    let height: any, width: any;
    if (row.sensor === 'Video') {
      height = '75%';
      width = '65%';
    }
    else {
      height = '85%';
      width = '60%';
    }

    this.dialog.open(SensorpreviewComponent, {
      width: width,
      height: height,
      data: {
        sensor: sensorName,
        resolution: resolution,
        imageName: name,
        mode: mode,
        operatorKey: row.key,
        sensorType: row.sensor,
        baseUrl: environment.geoServerUrl,
        sensorId: row?.sensorId
      },
      backdropClass: 'blurred',
      disableClose: true,
    });
  }

  private restoreCustomLookAngle(row: any): void {
    if (row) {
      row.customLookAngle = null;
    }
    (row?.ONA || []).forEach((ona: any) => {
      const original = this.customOnaOriginals.get(ona);
      if (original) {
        ona.key = original.key;
        ona.minONA = original.minONA;
        ona.maxONA = original.maxONA;
        this.customOnaOriginals.delete(ona);
      }
    });
  }

  OpenAdvance(row: any, index: any) {
    let imageResolution: any;

    // const openedWithOnaKey = this.AVAILABLESENSORS[index]?.selectedONA ?? this.AVAILABLESENSORS[index]?.selectedONAOption?.ona ?? this.AVAILABLESENSORS[index]?.selectedONAOption?.key;

    const dialog = this.dialog.open(AdvanceSettingsComponent, {
      minWidth: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: { selectedRow: row, type: 'advance' },
    });
    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        this.AVAILABLESENSORS[index].advanceOptions = true;
        this.AVAILABLESENSORS[index].orbitalPlane = result?.orbitalPlane;
        this.AVAILABLESENSORS[index].orbitalState = result?.orbitalState;
        this.AVAILABLESENSORS[index].observationDirection =
          result?.observationDirection;
        this.AVAILABLESENSORS[index].polarization = result?.polarization;
        this.AVAILABLESENSORS[index].imageLength = result?.imageLength;
        this.AVAILABLESENSORS[index].numOfLooks = result?.numOfLooks;
        this.AVAILABLESENSORS[index].selectedAnciallary =
          result?.productAnciallary;
        this.AVAILABLESENSORS[index].selectedOrbitDirection =
          result?.sarOrbitDirection;
        this.AVAILABLESENSORS[index].selectedPolarization =
          result?.sarPolarization;
        this.AVAILABLESENSORS[index].selectedAzimuthAngleMin =
          result?.targetAzimuthAngleMin;
        this.AVAILABLESENSORS[index].selectedAzimuthAngleMax =
          result?.targetAzimuthAngleMax;
        this.AVAILABLESENSORS[index].selectedGrazingAngleMin =
          result?.targetGrazingAngleMin;
        this.AVAILABLESENSORS[index].selectedGrazingAngleMax =
          result?.targetGrazingAngleMax;
          this.AVAILABLESENSORS[index].selectedOrbitType =
          result?.sarOrbitType;
          this.AVAILABLESENSORS[index].selectedbitDepth =
          result?.bitDepth;

        if (result?.lookAngle) {
          const openedWithOnaKey = this.AVAILABLESENSORS[index]?.selectedONA ?? this.AVAILABLESENSORS[index]?.selectedONAOption?.ona ?? this.AVAILABLESENSORS[index]?.selectedONAOption?.key;
          const sensorRow = this.AVAILABLESENSORS[index];

          const targetOnaOption = Array.isArray(sensorRow?.ONA)
            ? sensorRow.ONA.find(
                (ona: any) => (ona?.ona ?? ona?.key) === openedWithOnaKey
              )
            : null;

          if (targetOnaOption) {
            if (!this.customOnaOriginals.has(targetOnaOption)) {
              this.customOnaOriginals.set(targetOnaOption, {
                key: targetOnaOption.key,
                minONA: targetOnaOption.minONA,
                maxONA: targetOnaOption.maxONA,
              });
            }
            targetOnaOption.key = result.lookAngle.key;
            targetOnaOption.minONA = result.lookAngle.minONA;
            targetOnaOption.maxONA = result.lookAngle.maxONA;

            sensorRow.selectedONA = targetOnaOption.key;
            sensorRow.selectedONAOption = targetOnaOption;
            sensorRow.selectedItem = targetOnaOption;
            sensorRow.customLookAngle = result.lookAngle;
          } else {
            // Fallback: couldn't resolve the originally selected entry — keep previous behavior.
            sensorRow.selectedONA = result.lookAngle.key;
            sensorRow.selectedONAOption = result.lookAngle;
            sensorRow.selectedItem = result.lookAngle;
            sensorRow.customLookAngle = result.lookAngle;
          }
        }

        if (this.AVAILABLESENSORS[index].imageCost > 0) {
          this.AVAILABLESENSORS[index].selectedCost =
            this.AVAILABLESENSORS[index].selectedCost /
            this.AVAILABLESENSORS[index].imageCost;
          this.AVAILABLESENSORS[index].unitcost =
            this.AVAILABLESENSORS[index].unitcost /
            this.AVAILABLESENSORS[index].imageCost;
        }
      }
    });
  }

  shouldDisableTier(elem: any, row: any) {
    const isRepeatDays = this.target.selectedOption === 1 && this.target.freqOption === 'Days';
    const dailyRecurrentCapella = elem.sensor?.includes('Capella') && this.target.selectedOption === 1 && !isRepeatDays && elem.key != 'recurrent';
    const capellaNonRecurrent = elem.sensor?.includes('Capella') && (this.target.selectedOption != 1 || isRepeatDays) && (elem.key === 'Recurrent' || elem.key === 'recurrent');
    const subDailyRecurrent = this.capellaEnable && row.sensor != 'SAR';
    const subdailyEnable = this.satCapeEnable && row.sensor != 'SAR' && row?.key != this.OPERATOR.SATELLOGIC && row?.key != this.OPERATOR.STE && row?.key != this.OPERATOR.USL && row?.key != this.OPERATOR.BLACKSKY;
        const spesificDate = ((row?.key === this.OPERATOR.STE ||  row?.key === this.OPERATOR.STE_TELEOS) && this.target.selectedOption != 0 && this.target.selectedOption != 3 && elem.key === 'priority') || 
          (row?.key === this.OPERATOR.GOKTURK && this.target.selectedOption != 0 && this.target.selectedOption != 3 && elem.key === 'rush') || 
          (row?.key === this.OPERATOR.GOKTURK && (this.target.selectedOption === 0 || this.target.selectedOption === 3) && elem.key != 'rush');
    const openWaterRestriction = row?.key === OPERATORS.SATELLOGIC && this.target?.openWater && (elem.key != 'rush' && elem.key != 'emergency');
    let satelogicAllocationDisable = false;
    if (row?.key === OPERATORS.SATELLOGIC && this.cpcAndAllocated) {
      const modeKey = row?.selectedModes?.[0]?.key;
      const selectedMode = (row.collection_mode || []).find((m: any) => m.key === modeKey);
      if (selectedMode) {
        const allocated = selectedMode.allocatedTaskingTiers || [];
        satelogicAllocationDisable = !allocated.includes(elem.name);
      } else {
        satelogicAllocationDisable = true;
  }
    }
   return elem.cost == 0.00 || dailyRecurrentCapella || capellaNonRecurrent || (row.prevent && row?.key != OPERATORS.AT21) || subDailyRecurrent || subdailyEnable || spesificDate || openWaterRestriction || satelogicAllocationDisable;
  }

  shouldDisableResolution(item: any, row: any, index: number) {
    const disableAT21 = item.disable && row?.key === OPERATORS.AT21;
    const disableSTE =
      item.disable &&
      (row?.key === OPERATORS.STE || row?.key === OPERATORS.STE_TELEOS)&&
      row.resolution?.length >= 1 &&
      row?.sensor === 'SAR';
    const umbra = row?.key === OPERATORS.UMBRA && item.disabled;
    const disableSynspective = item.disable && row?.key === OPERATORS.SYNSPECTIVE;
    const isi = row?.key === OPERATORS.ISI && item.disable && row.resolution?.length > 1;
    const capella = row?.key === OPERATORS.CAPELLA && item.disable && row.resolution?.length > 1;
    const head = row?.key === OPERATORS.HEAD && item.disable && row.resolution?.length > 1;
    const sensor = (row?.key === OPERATORS.GOKTURK || row?.key === OPERATORS.GHG || row?.key === OPERATORS.ECURS || row?.key === OPERATORS.ECURS_L || row?.key === OPERATORS.SATELLOGIC || row?.key === OPERATORS.SATELLITEVU_VANZYL || row?.key === OPERATORS.GEOSAT || row?.key === OPERATORS.ICEYE) && item.disable && row.resolution?.length > 1;
    
    return row.prevent || disableAT21 || disableSTE || umbra || disableSynspective || isi || capella || head || sensor;
  }

  resetSorting() {
    if (this.sort) {
      this.sort.sort({ id: '', start: 'asc', disableClear: false });
    }
  }

  openEula(task: any, operator: any) {
    this.operatorsEula = {
      name: operator.displayName,
      operatorKey: operator?.key,
      resolution: operator?.resolution,
      startDate: task?.openWindow,
      endDate: task?.closeWindow,
      purpose: task?.purposeOption,
      obfuscateName: operator?.obfuscateName
    };

    const dialogRef = this.dialog.open(AgreeComponent, {
      width: '65%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        operator: this.operatorsEula,
        type: 'save',
        user: this.currentUser,
      },
    });
  }

  checkEndDate(start, end) {
    const endDate = new Date(end);
    const startDate = new Date(start);
    const oneYearFromNow = new Date(
      startDate.setFullYear(startDate.getFullYear() + 1)
    );
    return endDate > oneYearFromNow;
  }

  /**
   * Text for the cancellation tooltip beside a sensor name. The policy itself
   * lives in src/app/services/operators/cancellation-policy.ts — this method had
   * a twin in the sensor preview and a third in My Tasks, and only this copy had
   * been taught about Voyage Radar.
   */
  selections(row: any) {
    this.tooltipDisabled = false;
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    this.detailsText =
      cancellationPolicySentence(row?.key, strategy, row) ??
      formatCancellationPolicyEntries(row?.cancelPolicy);
  }

  getAxelPrice(size, pricing) {
    if (size < 100) {
      return pricing[0].unitPrice;
    }
    // else if (size >= 900) {
    //   return pricing[1].unitPrice;
    // }

    else {
      for (const range of pricing) {
        if (size >= range.minArea && (range.maxArea === undefined || size <= range.maxArea)) {
          return range.unitPrice;
        }
      }
    }
    return null;
  }


  convertCostToPoints(cost: any, includeLabel: boolean = true, row: any = {}): string | number {
    cost = parseFloat(cost);
    
    if (!this.currentUser.pointsEligible) {
        if (this.dem_calculation) {
            cost += parseFloat(row?.demTotalPrice ?? 0);
        }
        if(this.enable_indices_calculation && row?.indices)
        {
          cost += parseFloat(row?.TotalIndicesPrice ?? 0);
        }
        if (this.enable_sr_calculation && row?.super_resolution) {
          cost += parseFloat(row?.super_resolution[0]?.cost ?? 0);
        }
        return `${this.currencySign} ${this.roundNumber(cost, 2)}`;
    }

    const conversionFactor = this.getConversionFactor();
    let points = Math.round(cost * conversionFactor);

    if (this.dem_calculation) {
        points += parseFloat(row?.demTotalPoint ?? 0);
    }
    if(this.enable_indices_calculation && row?.indices)
    {
      cost += parseFloat(row?.TotalIndicesPoint ?? 0);
    }
    if (this.enable_sr_calculation && row?.TotalSRPoint) {
        points += parseFloat(row?.TotalSRPoint ?? 0);
    }
    return includeLabel ? `${points} Points` : points;
  }

  private getConversionFactor(): number {
      const parts = this.currentUser.sensorConversionFactor.split(':');
      return parseFloat(parts[1]) / parseFloat(parts[0]);
  }

  roundNumber(value: number, decimals: number): string {
    if (Number.isInteger(value)) {
      return value.toString();
    }
    return value.toFixed(decimals).replace(/\.?0+$/, '');
  }

  calculateDemTotal(row: any[], idx: any) {
    if (!row || !row.length) {
      this.AVAILABLESENSORS[idx].demTotalPrice = 0;
      this.AVAILABLESENSORS[idx].demTotalPoint = 0;
      return;
    }
  
    // Calculate total price and points for the entire row
    const demTotalPrice = row.reduce((total, curr) => total + Number(curr.cost), 0);
    const demTotalPoint = this.currentUser.pointsEligible ?
      row.reduce((total, curr) => total + Number(curr.point), 0) : 0;
  
    // Push totals into this.AVAILABLESENSORS[idx]
    this.AVAILABLESENSORS[idx].demTotalPrice = demTotalPrice;
    this.AVAILABLESENSORS[idx].demTotalPoint = demTotalPoint;
  }
  formatGroupedDem(val: any[]) {
    if ((val || []).length > 0) {
      const uniqueProviders = new Set<string>(
        val
          .filter(item => item && typeof item === 'object')
          .map(item => item.actionProvider)
      );
  
      let result = Array.from(uniqueProviders).join(', ');
      if (result.length > 10) {
        result = result.slice(0, 10) + '...';
      }
      
      return  result || undefined;
    }
    return;
  }
  
  formatGroupedDemTooltip = (val: any[]): any => {
    if (val?.length) {
      return val
        .filter(item => typeof item === 'object' && item !== null)
        .map(item => {
          return item.valueAddedDataProduct === 'indices' 
            ? `${item.actionProvider}` 
            : `${item.actionProvider} ${item.providerResolution}`;
        })
        .join(', ');
    }
    return '';
  };

  formatVAR(arr: any[]) {
    if((arr || []).length === 0)
      return {};

    const groupedDemOptions = arr.reduce((acc, curr) => {
      // Check if group already exists, if not, initialize it as an empty array
      if (!acc[curr.actionProvider]) {
        acc[curr.actionProvider] = [];
      }
      // Push current item into the corresponding group array
      acc[curr.actionProvider].push(curr);
      return acc;
    }, {});
    return groupedDemOptions;
  }

  formatvalueAddedOption(sensor:any, mode: any, resolution: any)
  {
    if(sensor.valueAddedOption)
    {
      const DxM = sensor.valueAddedOption.filter((i) => this.actionProviders.includes(i.actionProvider));
      DxM.sort((a, b) => {
        const actionA = a.actionProvider || '';
        const actionB = b.actionProvider || '';
        return actionA.localeCompare(actionB);
      });
      
      const options = DxM.filter((i) => i.sensorResolution === resolution.resolution_value || i.sensorResolution === resolution.value || i.sensorResolution === resolution?.originalResolution);
      return this.toggleValueAddedOptions(options)
    }
    return [];
  }
  updatevalueAddedOption(newValue: any[], row: any, idx: number) {
    const updatedValue = (newValue || []).filter((item, index, arr) => {
      const existingIndex = arr.findIndex(existingItem => 
        existingItem.actionProvider === item.actionProvider &&
        existingItem.ProviderName === item.ProviderName &&
        existingItem.sensorResolution === item.sensorResolution
      );
      return existingIndex === index;
    });
  
    row.valueAddedOption = updatedValue;
    this.calculateDemTotal(row.valueAddedOption, idx);
  }
  selectDxMOption(dem_item: any, row: any, group: any, idx: number): void {
    if(row.key === 'ISI' && row.selectedModes[0].key === 'Pan-sharpened')
    {
      this.AVAILABLESENSORS[idx].selectedMode = row?.collection_mode[0].key;
      this.AVAILABLESENSORS[idx].selectedModes = [];
      this.AVAILABLESENSORS[idx].modeSelected = [];
      this.AVAILABLESENSORS[idx].modeResetValue = [];
      
      this.AVAILABLESENSORS[idx].selectedModes.push(row?.collection_mode[0]);
      this.AVAILABLESENSORS[idx].modeSelected.push(row?.collection_mode[0]);
    }
    if (!this.AVAILABLESENSORS[idx].valueAddedOption) {
      this.AVAILABLESENSORS[idx].valueAddedOption = [];
    }

    // Check if the dem_item is already selected
    const isSelected = row.valueAddedOption.some(item => 
      item.actionProvider === dem_item.actionProvider &&
      item.ProviderName === dem_item.ProviderName &&
      item.sensorResolution === dem_item.sensorResolution && 
      item.providerResolution === dem_item.providerResolution
    );

    if (isSelected) {
      // If already selected, unselect it by removing from valueAddedOption
      row.valueAddedOption = row.valueAddedOption.filter((item: any) => item !== dem_item);
    } else {
      // If not selected, remove any previously selected item from the same group
      row.valueAddedOption = row.valueAddedOption.filter((item: any) => 
        item.actionProvider !== group.actionProvider
      );

      // Add the newly selected item
      row.valueAddedOption.push(dem_item);
    }

    // Update the AVAILABLESENSORS with the new selection
    this.AVAILABLESENSORS[idx].valueAddedOption = row.valueAddedOption;

    // Reset VADP and update the valueAddedOption
    this.resetVADP(row.valueAddedOption, idx);
    this.updatevalueAddedOption(row.valueAddedOption, row, idx);
  }

  filterValueAddedData(sensor:any)
  {
    if(sensor?.valAddedArray)
    {
      const options = (sensor?.valAddedArray || []).filter((i) => i.sensorResolution === sensor.selectedResolutionValue || i.sensorResolution === sensor.selectedResolution.value || i.sensorResolution === sensor.selectedResolution?.originalResolution)
      return this. toggleValueAddedOptions(options);
    }
    return [];
  }
  toggleValueAddedOptions(data:any)
  {
    let resultMap:{ actionProvider: string, items: { providerName:string, actionProvider:string, providerResolution: string, cost: string , point: string, deliveryTime: string, sensorResolution: string }[] }[] = [];
    
    data.forEach(item => {
      let actionProvider = item.actionProvider;
      item.point = this.convertCostToPoints(item.cost, false);
      
      let existingactionProvider = resultMap.find(entry => (entry || []).actionProvider === actionProvider);
      if (existingactionProvider) {
        existingactionProvider.items.push(item);
      } else {
        resultMap.push({
          actionProvider: actionProvider,
          items: [item]
        });
      }
    });
    return resultMap;
  }
  resetValueAddedDropdown(indx, row)
  {
    if(row.sensor === 'Stereo' || row.sensor === 'Tristereo') {
      this.AVAILABLESENSORS[indx].demTotalPrice = 0;
      this.AVAILABLESENSORS[indx].demTotalPoint = 0;
      const newValueAddedAction = this.filterValueAddedData(this.AVAILABLESENSORS[indx]);
      this.AVAILABLESENSORS[indx].valueAddedAction = newValueAddedAction;
      // Keep only DEM selections still valid for the new resolution
      const prevValueAddedOption = this.AVAILABLESENSORS[indx].valueAddedOption || [];
      const validResolutions = newValueAddedAction.flatMap((g: any) => g.items || []);
      this.AVAILABLESENSORS[indx].valueAddedOption = prevValueAddedOption.filter((sel: any) =>
        validResolutions.some((opt: any) => opt.actionProvider === sel.actionProvider && opt.sensorResolution === sel.sensorResolution)
      );
      this.AVAILABLESENSORS[indx].vadp = (this.AVAILABLESENSORS[indx].vadp || []).filter((item: any) =>
        item.valueAddedDataProduct === 'indices' ||
        (item || {}).actionProvider === 'Super Resolution' ||
        this.AVAILABLESENSORS[indx].valueAddedOption.includes(item)
      );
      this.calculateDemTotal(this.AVAILABLESENSORS[indx].valueAddedOption, indx);
    } else if(row.sensor === 'MSI') {
      const options = row.valAddedArray.filter((i:any) => i.sensorResolution == row.selectedResolution.resolution_value || i.sensorResolution == row.selectedResolution.value
      || i.sensorResolution == row.selectedResolution?.originalResolution);
      this.AVAILABLESENSORS[indx].indicesArray = options;
      // Keep only indices selections still valid for the new resolution
      const prevIndices = this.AVAILABLESENSORS[indx].indices || [];
      this.AVAILABLESENSORS[indx].indices = prevIndices.filter((sel: any) =>
        options.some((opt: any) => opt.actionProvider === sel.actionProvider && opt.sensorResolution === sel.sensorResolution)
      );
      this.AVAILABLESENSORS[indx].vadp = (this.AVAILABLESENSORS[indx].vadp || []).filter((item: any) =>
        item.valueAddedDataProduct !== 'indices' ||
        this.AVAILABLESENSORS[indx].indices.includes(item)
      );
      this.calculateIndicesTotal(this.AVAILABLESENSORS[indx].indices, indx);
    }
  }

  async looksChange(look: any, indx: number, row: any) {
    this.AVAILABLESENSORS[indx].numberOfLooks = look;
    if (row.key === OPERATORS.UMBRA) {
      if (isUmbraScanMode(row)) {
        return;
      }

      let sceneSize = this.AVAILABLESENSORS[indx].selectedModes[0].value;
      let looks = this.AVAILABLESENSORS[indx].numberOfLooks ? this.AVAILABLESENSORS[indx].numberOfLooks :
                  this.AVAILABLESENSORS[indx].selectedResolution.numberOfLooks[0];

      const umbraPrice =
        this.AVAILABLESENSORS[indx].selectedResolution?.sceneSizePricing[sceneSize][looks];

      row.latency[0].cost = umbraPrice;
      row.latency[0].unitcost = umbraPrice;
      this.AVAILABLESENSORS[indx].latency = row.latency;
      this.taskingOption(row.latency[0].name, indx, row, 1);
    }

  }

  // Function to handle collection duration change
  async collectionChange(data: any, idx: number, item: any, row: any) {
    // Update the collection duration of the selected signal
    if (data?.value?.value) {
      // Update the collection duration of the specific signal in the row
      const selectedSignal = row.signal_of_interest.find(signal => signal.value === item.value);
      if (selectedSignal) {
        selectedSignal.collectionDuration = data.value.value;
      }
  
      // Update the collection duration in AVAILABLESENSORS array
      const availableSignal = this.AVAILABLESENSORS[idx]?.signalsOfInterest;
      if (availableSignal && availableSignal.length > 0) {
        const signal = availableSignal.find(signal => signal.value === item.value);
        if (signal) {
          signal.collectionDuration = data.value.value;
        }
  
        // Update selected signals display text
        const signalsSelected = availableSignal.filter(sensor => {
          return Array.isArray(sensor.collection_duration) && sensor.collection_duration.length > 0;
        });
        this.AVAILABLESENSORS[idx].signalOfInterest = signalsSelected;
        this.AVAILABLESENSORS[idx].selectedSignals = signalsSelected.map(signal => signal.value).join(', ');
      }
    }
  }

  isAudioSelectionDisabled(item: any, row: any): boolean {
    return row?.prevent || (this.isAudioAllocationRestrictedUser() && !item?.audio);
  }

  getAudioTooltip(item: any): string {
    if (this.isAudioAllocationRestrictedUser() && !item?.audio) {
      return 'Your task allocation does not include audio extraction.';
    }

    if (this.currentUser?.allocated) {
      return 'The task (count) includes one or more audio files.';
    }

    return `Cost of audio recording = ${this.convertCostToPoints(item.audioCost)}. The amount will be refunded to your account if no audio is processed.`;
  }

  private isAudioAllocationRestrictedUser(): boolean {
    return !!(this.currentUser?.cpc || this.currentUser?.allocated);
  }

  // Function to handle collection duration change
  async audioChange(event: MatCheckboxChange, item: any, idx: number, row: any) {
    if(this.AVAILABLESENSORS[idx].selectedSignals) this.AVAILABLESENSORS[idx].selectedSignals = '';
    // Update the collection duration of the selected signal
    const selectedSignal = row.signal_of_interest.find(signal => signal.value === item.value);
    if (selectedSignal) {
      selectedSignal.isAudio = event.checked;
      if(event.checked) {
        selectedSignal.collectionDuration = 60;
      } else selectedSignal.collectionDuration = selectedSignal.collection_duration[0].value;
    }

    const availableSignal = this.AVAILABLESENSORS[idx]?.signalsOfInterest;
    if (availableSignal && availableSignal.length > 0) {
      const signal = availableSignal.find(signal => signal.value === item.value);
      if (signal) {
        signal.isAudio = event.checked;
        if(event.checked) {
          signal.collectionDuration = 60;
        } else signal.collectionDuration = signal.collection_duration[0].value;
      }

      // Update selected signals display text
      const signalsSelected = availableSignal.filter(sensor => {
        return Array.isArray(sensor.collection_duration) && sensor.collection_duration.length > 0;
      });
      this.AVAILABLESENSORS[idx].signalOfInterest = signalsSelected;
      this.AVAILABLESENSORS[idx].selectedSignals = signalsSelected.map(signal => signal.value).join(', ');
    }
  }

  async signalChange(event: any, idx: number, mySelect?: MatSelect) {
    event.value = event.value.filter(item => item !== undefined);

    let selectedSignals = event.value;
    this.rfSignals = true;
  
    // If selected signals array is empty, reset and exit
    if (selectedSignals.length === 0) {
      this.AVAILABLESENSORS[idx].signalOfInterest = [];
      this.AVAILABLESENSORS[idx].signalsOfInterest = [];
      this.rfSignals = false;
      return;
    }
  
    // Keep the existing `signalOfInterest` values without resetting
    if (!this.AVAILABLESENSORS[idx].signalOfInterest || !Array.isArray(this.AVAILABLESENSORS[idx].signalOfInterest)) {
      this.AVAILABLESENSORS[idx].signalOfInterest = [];
      this.AVAILABLESENSORS[idx].signalsOfInterest = [];
    }
  
    const previousSelectedSignals = [...this.AVAILABLESENSORS[idx].signalsOfInterest];
    if (
      this.AVAILABLESENSORS[idx]?.key === OPERATORS.LBAND &&
      this.target.area > 0 &&
      !this.target.targetPoints
    ) {
      const message = `RF band(s) detection, such as UHF, VHF, and L-band, is a point-based (POI) task but covers a large area given the satellite's field of view. 
      Therefore, combining these signal detections with non imaging sensors is possible, provided Multi-RF is selected ahead of other sensors.`;

      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.uncheckSensorInTipAndCue(idx);
      this.resetSensor();
      this.AVAILABLESENSORS[idx].prevent = true;
      this.warnReactionTimeVsToiForSelectedSensors();

      setTimeout(() => {
        if (mySelect) {
          this.restoreMatSelectClose();
          mySelect.value = previousSelectedSignals;
          mySelect.close();
        }
      }, 0);
      return;
    }
  
    // Check selection validity
    if (this.checkSelection(selectedSignals, idx)) {      
      selectedSignals = this.processSignals(previousSelectedSignals, selectedSignals);      
      this.AVAILABLESENSORS[idx].signalsOfInterest = selectedSignals;  
   
    } else {
      // Invalid selection: remove the newly selected item and call signalChange again
      selectedSignals = previousSelectedSignals;
      this.AVAILABLESENSORS[idx].signalsOfInterest = selectedSignals;
  
      // Set a timeout to refresh UI
      setTimeout(() => {
        if (mySelect) {
          mySelect.value = selectedSignals;
          this.signalChange({ value: selectedSignals }, idx, mySelect);
          this.restoreMatSelectClose();
          mySelect.close();
        }
      }, 0);
      return;
    }
  
    // Update selected signals for display    
    const signalsSelected =  this.AVAILABLESENSORS[idx].signalsOfInterest.filter(sensor => {
      return Array.isArray(sensor.collection_duration) && sensor.collection_duration.length > 0;
    });
    this.AVAILABLESENSORS[idx].signalOfInterest = signalsSelected;
    this.AVAILABLESENSORS[idx].selectedSignals = signalsSelected.map(signal => signal.value).join(', ');
  }

  processSignals(previousSignals: any[], newSignals: any[]): any[] {
    return newSignals.map(newSignal => {
      const matchingPrevSignal = previousSignals.find(prevSignal => prevSignal.value === newSignal.value);
      
      // Preserve the collectionDuration from the previous selection if it exists
      if (matchingPrevSignal && matchingPrevSignal.collectionDuration) {
        newSignal.collectionDuration = matchingPrevSignal.collectionDuration;
      } else if (newSignal.collection_duration && newSignal.collection_duration.length > 0 && !newSignal.collectionDuration) {
        // If no previous duration exists, use the default
        newSignal.collectionDuration = newSignal.collection_duration[0].value;
      }
  
      newSignal.checked = true;
      return newSignal;
    });
  }

checkSelection(selectedItems: any[], index: number): boolean {
   let selectedSignals = selectedItems.filter(sensor => {
    return Array.isArray(sensor.collection_duration) && sensor.collection_duration.length > 0;
  });
    // Define categories
    const gps = ['GPS L1', 'GPS L2', 'GPS L5'];
    const vhf = ['VHF'];
    const uhf = ['UHF'];
    const lBand = ['L-band (ADS-B)', 'L-band (GNSS)', 'L-band (SATCOM)'];
    const sBand = ['S-band'];
  
    // Separate signals into categories
    const selectedGPS = selectedSignals.filter(s => gps.includes(s.value));
    const selectedVHF = selectedSignals.filter(s => vhf.includes(s.value));
    const selectedUHF = selectedSignals.filter(s => uhf.includes(s.value));
    const selectedLBand = selectedSignals.filter(s => lBand.includes(s.value));
    const selectedsBand = selectedSignals.filter(s => sBand.includes(s.value));
  
    // Rule: Only one GPS signal can be selected at a time
    if (selectedGPS.length > 1) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    if (selectedSignals.length > 1 &&  selectedsBand.length >0) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
    }
    // Check for invalid combinations
    if (selectedGPS.length > 0) {
        if (selectedSignals.length > selectedGPS.length) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
    } else {
        // Validate non-GPS selections
        if (selectedVHF.length + selectedUHF.length + selectedLBand.length > 3) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
        if (selectedVHF.length > 1 || selectedUHF.length > 1 || selectedLBand.length > 1) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
    }
  
    return true;
}

  onSelectOpened(index: number) {
    if(this.AVAILABLESENSORS[index].signalOfInterest)
    this.initialSelection = [...this.AVAILABLESENSORS[index].signalOfInterest];
  }

  onSelectClosed(index: number) {
    const currentSelection = this.AVAILABLESENSORS[index].signalOfInterest;
  
    const isSelectionChanged = JSON.stringify(this.initialSelection) !== JSON.stringify(currentSelection);
  
    if (isSelectionChanged) {
    this.AVAILABLESENSORS[index].isAudio = false;
    const isVHFUHF = this.AVAILABLESENSORS[index].signalOfInterest?.some(item => (item.value === 'VHF'));
    
    if (isVHFUHF) {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {message: OPERATORS.LBAND}
      });

      dialogRef.afterClosed().subscribe(async (result) => {
        if (result === 'yes') {
          this.AVAILABLESENSORS[index].collectionDuration = 60;
          this.AVAILABLESENSORS[index].isAudio = true;
        } else {
          this.AVAILABLESENSORS[index].collectionDuration = this.AVAILABLESENSORS[index].collection_duration[0].value;
          this.AVAILABLESENSORS[index].isAudio = false;
        }
      });
    }
  }
  }

  calculateRepeats () {
    let no_of_repeats = 1;
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate = moment(this.target.closeWindow).utcOffset(0, true).format();
    let time_difference =
      new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
      } else if (this.target.freqOption === 'Fortnightly') {
        no_of_repeats = Math.ceil(days_difference / 14);
      } else if (this.target.freqOption === 'Number of collections') {
        no_of_repeats = this.getNumberOfCollections();
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
      } else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
      } else if (this.target.freqOption === 'Days') {
        const weekDates = buildRecurringWeekDates(
          this.target?.openWindow,
          this.target?.closeWindow,
          Array.isArray(this.target.recurringDays) ? this.target.recurringDays : []
        );
        no_of_repeats = weekDates.reduce((sum, week) => sum + (Object.values(week)[0] as string[]).length, 0);
      } else if (this.target.subDailyCount) {
        no_of_repeats = days_difference * this.target.subDailyCount;
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }
    return no_of_repeats;
  }

  private hasValidNumberOfCollections(): boolean {
    if (this.target?.selectedOption !== 1 || this.target?.freqOption !== 'Number of collections') {
      return true;
    }

    const numberOfCollections = Number(this.target?.noOfCollections);
    return Number.isInteger(numberOfCollections) && numberOfCollections >= 1;
  }

  private getNumberOfCollections(): number {
    if (!this.hasValidNumberOfCollections()) {
      return 1;
    }

    if (this.target?.selectedOption === 1 && this.target?.freqOption === 'Number of collections') {
      return Number(this.target?.noOfCollections);
    }

    return 1;
  }

  costToPoints(cost: number): string {
    if (this.currentUser.pointsEligible) {
      const [part1, part2] = this.currentUser.sensorConversionFactor.split(':').map(parseFloat);
      const conversionFactor = part2 / part1;
      const points = Math.round(cost * conversionFactor);
      return `${points} Points`;
    } else {
      return formatCurrency(cost);
    }
  }

  groupPointsByOverlap(points: any[]): any[][] {
    const radius = RF_RADIUS * 1000; // Convert to meters
    const standalonePoints: any[] = [];
    const overlappingGroups: any[][] = [];
    const visited = new Set<number>();
    
    // Convert all points to Cartesian3
    const cartesianPoints = points.map(point => ({
      type: point.type,
      coordinates: this.toCartesian(point.coordinates),
      originalCoordinates: point.coordinates
    }));

    for (let i = 0; i < cartesianPoints.length; i++) {
      if (visited.has(i)) continue; // Skip points already grouped

      const overlappingGroup = [cartesianPoints[i]];

      for (let j = i + 1; j < cartesianPoints.length; j++) {
        if (visited.has(j)) continue;

        // Calculate the distance between two Cartesian points
        const distance = Cesium.Cartesian3.distance(cartesianPoints[i].coordinates, cartesianPoints[j].coordinates);

        if (distance <= 2 * radius) {
          overlappingGroup.push(cartesianPoints[j]);
          visited.add(j); // Mark as visited
        }
      }

      // Group points into standalone or overlapping arrays
      if (overlappingGroup.length > 1) {
        overlappingGroups.push(overlappingGroup.map(point => ({
          type: point.type,
          coordinates: point.originalCoordinates
        })));
      } else {
        standalonePoints.push({
          type: cartesianPoints[i].type,
          coordinates: cartesianPoints[i].originalCoordinates
        });
      }
    }

    return [standalonePoints, ...overlappingGroups];
  }

  // Convert degrees to Cesium Cartesian3 coordinates
  toCartesian(coords: number[]): Cesium.Cartesian3 {
    const [longitude, latitude] = coords;
    return Cesium.Cartesian3.fromDegrees(longitude, latitude);
  }

  hasElevationModelOption(row: any): boolean {
    return !!row?.valAddedArray?.find(
      (item: any) => item?.valueAddedDataProduct === 'elevationModel',
    );
  }

  onDxMCheckboxChange(row: any, idx:number, type:any): void {
    if (!row.isDxMSelected) {
      if(!this.AVAILABLESENSORS[idx].vadp) this.AVAILABLESENSORS[idx].vadp = [];
      this.AVAILABLESENSORS[idx].vadp.push(type);
      this.AVAILABLESENSORS[idx].isDxMSelected = true;
    } else {
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter((item: any) => item !== type);
      this.AVAILABLESENSORS[idx].isDxMSelected = false;
    }
  }
  
  onSRCheckboxChange(row: any, idx:number, type:any): void {
    if (!row.isSRSelected) {
      if(!this.AVAILABLESENSORS[idx].vadp) this.AVAILABLESENSORS[idx].vadp = [];
      this.AVAILABLESENSORS[idx].vadp.push(type);
      this.AVAILABLESENSORS[idx].isSRSelected = true;
    } else {
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter((item: any) => item !== type);
      this.AVAILABLESENSORS[idx].isSRSelected = false;
    }
  }
  resetVADP(row, idx) {
    // Remove items with actionProvider in the specified list
    this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter((item: any) => 
      !this.actionProviders.includes(item.actionProvider)
    );

    row.forEach((i) => {
      this.AVAILABLESENSORS[idx].vadp.push(i)
    })
  }
  // Get selected values for a specific row
  getSelectedVadp(row: any): any[] {
    if (!row.vadp) {
      return [];
    }
  
    // Initialize arrays for special and regular values
    const specialValue = "SR";
    const vadpValue = "DxM";
    const indicesValue = "Indices";
    const filteredVadp = row.vadp.filter(item => item === specialValue);
    const regularItems = row.vadp.filter(item => item !== specialValue && (item || {}).actionProvider === 'Super Resolution');
    const DxMItems = row.vadp.filter(item => this.actionProviders.includes((item || {}).actionProvider));
    const IndicesItems = row.vadp.filter((item) => item.valueAddedDataProduct === 'indices');
    
    // Combine special value and regular items
    const updatedVadp = [specialValue, ...regularItems, vadpValue, ...DxMItems, indicesValue, ...IndicesItems];
    
    return updatedVadp;
  }

  setIndices(sensor: any, selectedResolution?: any) {
    let options = [];
    if (sensor.valueAddedOption) {
      options = sensor.valueAddedOption.filter(
        (i) => i.valueAddedDataProduct === 'indices',
      );
      if (selectedResolution && sensor.sensortype === 'MSI') {
        options = options.filter(
          (i: any) =>
            i.sensorResolution === selectedResolution?.resolution_value ||
            i.sensorResolution === selectedResolution?.value ||
            i.sensorResolution === selectedResolution?.originalResolution,
        );
      }
      options.forEach((item: any) => {
        item.point = this.convertCostToPoints(item.cost, false);
      });
    }
    return options;
  }

  private getSelectedCollectionModeKey(row: any): string | null {
    const selected = row?.modeResetValue ?? row?.selectedModes?.[0]?.key ?? row?.selectedMode;

    if (Array.isArray(selected)) {
      return selected[0] ?? null;
    }

    if (selected && typeof selected === 'object') {
      return selected.key ?? null;
    }

    return selected ?? null;
  }

  shouldEnableIndicesOption(indices: any, row: any): boolean {
    if (!indices?.productMode) {
      return true;
    }

    const selectedModeKey = this.getSelectedCollectionModeKey(row);
    return selectedModeKey === indices.productMode;
  }

  getEnabledIndicesArray(row: any): any[] {
    const indicesArray = Array.isArray(row?.indicesArray) ? row.indicesArray : [];
    if (!indicesArray.length ) {
      return [];
    }

    return indicesArray.filter((indices: any) => this.shouldEnableIndicesOption(indices, row));
  }

  private normalizeModeValue(value: any): string {
    return (value ?? '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  isValueAddedDisabled(row: any): boolean {

    const valAddedList = Array.isArray(row?.valAddedArray) ? row.valAddedArray : [];
    if (!valAddedList.length) {
      return false;
    }

    const selectedModeCandidates = [
      row?.selectedMode,
      row?.modeResetValue,
      row?.selectedModes?.[0]?.key,
      row?.selectedModes?.[0]?.captureMode,
      row?.selectedModes?.[0]?.productLevel,
      row?.selectedModes?.[0]?.captureMode && row?.selectedModes?.[0]?.productLevel
        ? `${row.selectedModes[0].captureMode} (${row.selectedModes[0].productLevel})`
        : null,
      this.getSelectedCollectionModeKey(row),
    ]
      .map((c: any) => this.normalizeModeValue(c))
      .filter((c: string) => !!c);

      const hasOnaWithResolution = Array.isArray(row?.onaWithResolution) && row.onaWithResolution.length > 0;
      const selectedResolution = hasOnaWithResolution
        ? row?.selectedResolution?.originalResolution
        : row?.selectedResolutionValue || row?.selectedResolution?.value || row?.selectedResolution?.originalResolution;

      const hasMatch = valAddedList.some((item: any) => {
        const itemMode = this.normalizeModeValue(item?.productMode);

        const resolutionMatch = hasOnaWithResolution
          ? row.onaWithResolution.some(
              (onaItem: any) => onaItem?.ona === row?.selectedONA && onaItem?.forResolution === selectedResolution
            )
          : item?.sensorResolution === selectedResolution;

        const isModeEmpty = !itemMode;

        return (
          (selectedModeCandidates.includes(itemMode) && resolutionMatch) ||
          (isModeEmpty && resolutionMatch)
        );
  });

    return !hasMatch;
  }

  onIndicesCheckboxChange(row: any, idx:number, type:any): void {
    if (!row.isIndicesSelected) {
      if(!this.AVAILABLESENSORS[idx].vadp) this.AVAILABLESENSORS[idx].vadp = [];
      this.AVAILABLESENSORS[idx].vadp.push(type);
      this.AVAILABLESENSORS[idx].isIndicesSelected = true;
    } else {
      this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter((item: any) => item !== type);
      this.AVAILABLESENSORS[idx].isIndicesSelected = false;
    }
  }
  selectIndicesOption(obj: any, row: any, idx: number): void {
    if (
      !row?.isIndicesSelected ||
      row?.prevent ||
      !this.shouldEnableIndicesOption(obj, row)
    ) {
      return;
    }

    if (!row.indices) {
        row.indices = [];
    }

    // Check if the actionProvider is already selected
    const isSelected = row.indices.some(item => item === obj);
    
    if (isSelected) {
        // If the resolution is already selected, unselect it by removing it from indices
        row.indices = row.indices.filter(item => item !== obj);
        obj.isIndices = false;

        // Remove it from AVAILABLESENSORS[idx].vadp as well
        this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(item => item !== obj);
    } else {
        // If the resolution is not selected, clear any previous selections and select the new one
        // if(row?.sensor !== 'HSI' && row?.key !== OPERATORS.AXELSPACE) 
        //   row.indices = [];
        row.indices.push(obj);
        obj.isIndices = true;

        // Remove all items with isIndices === true from AVAILABLESENSORS[idx].vadp
        // if(row?.sensor !== 'HSI' && row?.key !== OPERATORS.AXELSPACE) {
        //   this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(item => !item.isIndices);
        // }
        this.AVAILABLESENSORS[idx].vadp.push(obj);
    }
    this.calculateIndicesTotal(row.indices, idx);
  }
  calculateIndicesTotal(row: any[], idx: any) {
    if (!row || !row.length) {
      this.AVAILABLESENSORS[idx].TotalIndicesPrice = 0;
      this.AVAILABLESENSORS[idx].TotalIndicesPoint = 0;
      return;
    }
  
    // Calculate total price and points for the entire row
    const TotalIndicesPrice = row.reduce((total, curr) => total + Number(curr.cost), 0);
    const TotalIndicesPoint = this.currentUser.pointsEligible ?
      row.reduce((total, curr) => total + Number(curr.point), 0) : 0;
  
    // Push totals into this.AVAILABLESENSORS[idx]
    this.AVAILABLESENSORS[idx].TotalIndicesPrice = TotalIndicesPrice;
    this.AVAILABLESENSORS[idx].TotalIndicesPoint = TotalIndicesPoint;
  }

  displayVadpSelectTooltip(row:any)
  {
    if (this.isValueAddedDisabled(row)) {
      return 'The value-added data products (VADPs) are available only at certain imagery product levels or resolutions. Please select the supported imagery product level(s) or resolutions to enable the VADPs.';
    }
    
    if((row?.valueAddedOption && row?.valueAddedOption.length > 0) || row?.valueAddedAction.length > 0) {
      return '';
    }
    if((row.sensor === 'Stereo' || row.sensor === 'Tristereo') && (row.key == OPERATORS.AT21 || (row.key == OPERATORS.KOMPSAT &&  row.name != 'KOMPSAT-5'))) {
      if(row?.selectedResolution?.value == 'Bundle:0.5m PAN/2m MS' && row?.valueAddedAction.length == 0)
        return '';
      return 'Please select either panchromatic or bundle data products for value-added products.';
    }

    if (row.sensor === 'MSI' && row?.indicesArray?.length === 0 && (row.key === OPERATORS.AXELSPACE || 
      row.key === OPERATORS.AT21 || row.key === OPERATORS.STE || row.name === 'KOMPSAT-3' || row.key === OPERATORS.STE_TELEOS
    )) {
      return 'Indices products require multi-spectral data. Please choose the relevant resolution product meeting the requirement.';
    }
    else
    return '';
  }

  closeSelectDropdown(select: MatSelect) {
    select.close();
  }

  isOperatorWithSensor(row: any): boolean {
    const validOperators = [OPERATORS.CAPELLA, OPERATORS.UMBRA, OPERATORS.KOMPSAT, OPERATORS.STE, OPERATORS.ECURS, OPERATORS.STE_TELEOS, OPERATORS.ECURS_L, OPERATORS.ICEYE];
    return validOperators.includes(row.key) && (row.sensor === 'SAR' || row.sensor === 'InSAR'|| row.sensor === 'ScanSAR');
  }
  
  getTooltipText(row: any) {
    if(row.selectedModes[0]?.defaultPolarization) return 'Default polarisation is ' + row.selectedModes[0].defaultPolarization;
    else {
      switch (row.key) {
      case OPERATORS.CAPELLA:
          return 'Look Angle'+ '\n' + 'Default polarisation is ' + polarization[row.key];
      case OPERATORS.UMBRA:
          return 'Grazing Angle' + '\n' + 'Default polarisation is ' + polarization[row.key];
      default:
          return 'Default polarisation is ' + polarization[row.key];
      }
    }
  }
  
feasibleAIS() {
    return this.AVAILABLESENSORS.some(item => item.checked && item.sensor === 'AIS' && item.feasibility);
  }
  selectSROption(resolution: any, row: any, idx: number): void {
    if (!row.super_resolution) {
        row.super_resolution = [];
    }

    // Check if the resolution is already selected
    const isSelected = row.super_resolution.some(item => item === resolution);

    if (isSelected) {
        // If the resolution is already selected, unselect it by removing it from super_resolution
        row.super_resolution = row.super_resolution.filter(item => item !== resolution);
        resolution.isSR = false;

        // Remove it from AVAILABLESENSORS[idx].vadp as well
        this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(item => item !== resolution);
    } else {
        // If the resolution is not selected, clear any previous selections and select the new one
        row.super_resolution = [];
        row.super_resolution.push(resolution);
        resolution.isSR = true;

        // Remove all items with isSR === true from AVAILABLESENSORS[idx].vadp
        this.AVAILABLESENSORS[idx].vadp = this.AVAILABLESENSORS[idx].vadp.filter(item => !item.isSR);
        this.AVAILABLESENSORS[idx].vadp.push(resolution);
    }
    this.calculateSRTotal(row.super_resolution, idx);
  }
  calculateSRTotal(row: any[], idx: any) {
    if (!row || !row.length) {
      this.AVAILABLESENSORS[idx].TotalSRPrice = 0;
      this.AVAILABLESENSORS[idx].TotalSRPoint = 0;
      return;
    }
  
    // Calculate total price and points for the entire row
    const TotalSRPrice = row.reduce((total, curr) => total + Number(curr.cost), 0);
    const TotalSRPoint = this.currentUser.pointsEligible ?
      row.reduce((total, curr) => total + Number(curr.point), 0) : 0;
  
    // Push totals into this.AVAILABLESENSORS[idx]
    this.AVAILABLESENSORS[idx].TotalSRPrice = TotalSRPrice;
    this.AVAILABLESENSORS[idx].TotalSRPoint = TotalSRPoint;
  }
  onSelectionChange(event: any, row: any,  idx:any): void {
    this.calculateSRTotal(row.super_resolution, idx);
  }
  setSuperResolutions(sensor)
  {
    let options: any = [];
    if(sensor.valueAddedOption) {
      options = sensor.valueAddedOption.filter((i) => i.actionProvider === 'Super Resolution');
      options.forEach(item => {
        item.point = this.convertCostToPoints(item.cost, false);
      })
    }
    return options;
  }

  private getModeResolutionPrice(row: any, resolution?: any): number | null {
    if (row?.key !== (OPERATORS.ORBVIEW)) {
      return null;
    }

    const pricing = resolution?.pricing ?? row?.selectedResolution?.pricing ?? row?.selectedModes?.[0]?.pricing;
    if (!pricing || Array.isArray(pricing)) {
      return null;
    }

    const normalizedResolutionKey = this.normalizeOrbviewPricingKey(resolution?.value);

    if (Array.isArray(row?.latency)) {
      for (const latencyItem of row.latency) {
        latencyItem.unitcost = pricing[normalizedResolutionKey];
        latencyItem.cost = pricing[normalizedResolutionKey];
      }
    }

    const selectedLatencyKey = this.normalizeOrbviewPricingKey(row?.selectedLatencyKey?.key);
    if (
      selectedLatencyKey &&
      Object.prototype.hasOwnProperty.call(pricing, selectedLatencyKey)
    ) {
      const price = Number(pricing[selectedLatencyKey]);
      if (!Number.isNaN(price)) {
        row.unitcost = price;
        row.cost = price;
        return price;
      }
    }

    const resolutionKey = normalizedResolutionKey;
    if (
      resolutionKey &&
      Object.prototype.hasOwnProperty.call(pricing, resolutionKey)
    ) {
      const price = Number(pricing[resolutionKey]);
      if (!Number.isNaN(price)) {
        row.unitcost = price;
        row.cost = price;
        return price;
      }
    }

    return null;
  }

  private normalizeOrbviewPricingKey(value: any): string {
    return (value ?? '').toString().replace(/\./g, '_');
  }


  calculateUnitcost (indx,latencyIndx) {
    const row = this.AVAILABLESENSORS?.[indx];
    const strategy = this.operatorStrategyFactory.getStrategy(row?.key);
    if (strategy) {
      strategy.calculateUnitCost({ sensorRow: row, latencyIndx });
      return;
    }

    if (this.AVAILABLESENSORS[indx].ONAFactor == undefined) this.AVAILABLESENSORS[indx].ONAFactor = 1;
    if (this.AVAILABLESENSORS[indx].holdbackFactor == undefined) this.AVAILABLESENSORS[indx].holdbackFactor = 1;
    if (this.AVAILABLESENSORS[indx].cloudFactor == undefined) this.AVAILABLESENSORS[indx].cloudFactor = 1;

    const holdbackFactor = this.AVAILABLESENSORS[indx].holdbackFactor - 1;
    const cloudFactor = this.AVAILABLESENSORS[indx].cloudFactor - 1;
    const ONAFactor = this.AVAILABLESENSORS[indx].ONAFactor - 1;
    const resolutionFactor = this.AVAILABLESENSORS[indx].selectedResolution?.multiplier ?? 1;
    const modeResolutionPrice = this.getModeResolutionPrice(
      this.AVAILABLESENSORS[indx],
      this.AVAILABLESENSORS[indx].selectedResolution
    );
    
    const baseUnitCost = modeResolutionPrice ?? this.AVAILABLESENSORS[indx].latency[latencyIndx].unitcost;
    const baseCost = baseUnitCost * resolutionFactor;
    const holdbackValue = baseCost * holdbackFactor;
    const ccValue = baseCost * cloudFactor;
    const onaValue = baseCost * ONAFactor;

    this.AVAILABLESENSORS[indx].selectedCost = +baseCost + +holdbackValue + +ccValue + +onaValue;
    this.AVAILABLESENSORS[indx].unitcost = this.AVAILABLESENSORS[indx].selectedCost;

    if (
      this.AVAILABLESENSORS[indx].userCost > 0 &&
      this.AVAILABLESENSORS[indx].selectedCost > 0
    ) {
              this.AVAILABLESENSORS[indx].selectedCost = Number(
                (
                  this.AVAILABLESENSORS[indx].selectedCost *
                  this.AVAILABLESENSORS[indx].userCost
                ).toFixed(2)
              );
    }
    if(this.AVAILABLESENSORS[indx].key == OPERATORS.SATELLOGIC) {
      this.AVAILABLESENSORS[indx].minarea = this.extractAndCalculateValues(this.AVAILABLESENSORS[indx].minimumArea)
    }
  }

  getProductTooltip(row: any) {
    if (row.selectedModes && row.selectedModes[0]) {
      const captureMode = row.selectedModes[0].captureMode;
      const productLevel = row.selectedModes[0].productLevel;
      const isProductLevel = row.selectedModes[0].isProductLevel;
      const isCaptureMode = row.selectedModes[0].isCaptureMode;
  
      const tooltipText = isProductLevel && isCaptureMode
        ? `${captureMode} (${productLevel})` :
        isProductLevel && !isCaptureMode ? `${productLevel}`
        : captureMode;
  
      // Show tooltip only if the text length is greater than 10
      return tooltipText;
    }
  }
  setSignalOfInterest(signalOfInterest) {
    
    if(this.currentUser.pointsEligible) {
      signalOfInterest = signalOfInterest?.map((signal: any) => ({
        ...signal,
        point: this.convertCostToPoints(signal.cost, false),
        ...(signal.audioCost && { audioPoint: this.convertCostToPoints(signal.audioCost, false) }),
      }));
    }
    return signalOfInterest;
  }

  goNext(mySelect: MatSelect, event: Event,i,row): void {
    this.restoreMatSelectClose();
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
    this.openPopup(i,row);
  }
  
  close(mySelect: MatSelect, event: Event): void {
    this.restoreMatSelectClose();
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }

  openPopup(i,row) {
    let frequency = this.target.selectedOption;
      this.singleCircle = null;
      let numberOfRepeats = this.calculateRepeats(); 
      const startDate: any = new Date(
        moment(this.target.openWindow).utc().format()
      );
      const endDate: any = new Date(
        moment(this.target.closeWindow).utc().format()
      );
      const differenceInTime: number = endDate.getTime() - startDate.getTime();
      const differenceInDays: number = Math.floor(
        differenceInTime / (1000 * 60 * 60 * 24)
      );
    const dialog = this.dialog.open(OperatorPopupComponent, {
      minWidth: '50%',
      backdropClass: 'blurred',
      disableClose: true,
      data: {
        selectedRow: row,
        target:
          this.target?.multiTarget?.length > 0
            ? this.target?.multiTarget
            : [this.target.geoJSON],
        operatorKey: row?.key,
        frequency: frequency,
        repeatFrequency: this.target?.freqOption,
        differenceInDays: differenceInDays,
        numberOfRepeats: numberOfRepeats
      },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        this.AVAILABLESENSORS[i].siteData = result.siteData;
        this.AVAILABLESENSORS[i].noOfCollections = result?.numberOfCollections;

        if ((this.AVAILABLESENSORS[i].overlapPercentage > 50)) {
          const dialogRef = this.dialog.open(ConfirmPopupComponent, {
            width: '50%',
            backdropClass: 'blurred',
            disableClose: true,
            data: {message: 'overlapSignal'}
          });
    
          dialogRef.afterClosed().subscribe(async (result) => {
            if (result === 'yes') {
             this.singleCircle = true;
             this.AVAILABLESENSORS[i].checked = true;
             this.tipAndCueSelection(true, i);
             this.resetSensor();
            } else if (result === 'both') {
              this.singleCircle = false;
              this.AVAILABLESENSORS[i].checked = true;
              this.tipAndCueSelection(true, i);
              this.resetSensor();
            } else {
              this.singleCircle = null;
              if (this.AVAILABLESENSORS?.[i]) {
                // If we're in Tip-and-Cue, ensure we also remove the row from the
                // internal selection arrays (tipping/cueing). Otherwise the next
                // user click incorrectly hits the "already selected" validation.
                if (this.target?.taskStrategy === 'Tip-and-Cue') {
                  this.uncheckSensorInTipAndCue(i);
                } else {
                  this.AVAILABLESENSORS[i].checked = false;
                }

                this.AVAILABLESENSORS[i].signalOfInterest = [];
                this.AVAILABLESENSORS[i].signalsOfInterest = [];
                  this.rfSignals = false;
                  this.AVAILABLESENSORS[i].siteData = null;
                  this.AVAILABLESENSORS[i].noOfCollections = null;
                  this.resetRFData.emit();
                }
              this.resetSensor();
            }
          });
        } else {
          this.singleCircle = false;
          // Ensure the sensor gets properly selected after completing the site dialog
          this.AVAILABLESENSORS[i].checked = true;
          this.tipAndCueSelection(true, i);
          this.resetSensor();
        }
      } else {
        if (this.AVAILABLESENSORS?.[i]) {
          if (this.target?.taskStrategy === 'Tip-and-Cue') {
            this.uncheckSensorInTipAndCue(i);
          } else {
            this.AVAILABLESENSORS[i].checked = false;
          }

          this.AVAILABLESENSORS[i].signalOfInterest = [];
          this.AVAILABLESENSORS[i].signalsOfInterest = [];
            this.rfSignals = false;
            this.AVAILABLESENSORS[i].siteData = null;
            this.AVAILABLESENSORS[i].noOfCollections = null;
            this.resetRFData.emit();
          }
        this.resetSensor();
      }
    });
  }

  resetSensor() {
    this.selectedSensors = [];
    this.AVAILABLESENSORS.forEach((operator) => {
      if (operator.checked) this.selectedSensors.push(operator);
    });
    for (const sensors of this.selectedSensors) {
      if (!sensors.feasibility) {
        this.feasible = true;
      }
    }
    this.clickHandler();
  }

  onOpenedChange(isOpen: boolean) {
    if (isOpen) {
      this.preventMatSelectClose();
    }
  }

  // Override the close behavior of MatSelect to prevent closing
  private preventMatSelectClose() {
    if (this.mySelects && !this.originalClose) {
      // Save the original close method
      this.originalClose = this.mySelects.close;

      // Override the close method
      this.mySelects.close = () => {
      };
    }
  }

  // Restore the original close behavior
  private restoreMatSelectClose() {
    if (this.mySelects && this.originalClose) {
      this.mySelects.close = this.originalClose;
      this.originalClose = null;
    }
  }

  shouldDisableModes(row) {
    let capella = (row.prevent && row?.key != OPERATORS.CAPELLA) || (this.capellaEnable && row.sensor != 'SAR');

    return capella;
  }

  checkTargetLocation(): Promise<'water' | 'land' | 'both'> {
    if (this.target.area > 0) {      
      if (this.target.openWater) {
        return Promise.resolve('water');
      } else {
        return Promise.resolve('land');
      }
    }

    const pointsArray = this.target.geoJSON.split(',').map(point => point.trim());

    const pointPromises = pointsArray.map(point => {
      const coords = this.utilsService.extractCoordinates(point);
      const location = { longitude: coords.lng, latitude: coords.lat };

      return this.apiService.checkIsWater(location).toPromise()
        .then((res) => {
          const waterCheckResponse = res as WaterCheckResponse;
          if (!waterCheckResponse) {
            throw new Error('API response is undefined');
          }
          return { water: waterCheckResponse.water, latitude: waterCheckResponse.latitude, longitude: waterCheckResponse.longitude };
        })
        .catch(error => {
          return null;
        });
    });

    return Promise.all(pointPromises)
      .then(results => {
        const validResults = results.filter(res => res !== null) as WaterCheckResponse[];

        if (validResults.length === 0) {
          return 'both'; // Default case when no valid responses
        }

        const allWater = validResults.every(res => res.water);
        const allLand = validResults.every(res => !res.water);

        if (allWater) return 'water';
        if (allLand) return 'land';
        return 'both';
      })
      .catch(error => {
        return 'both'; // Default case on error
      });
  }
  getBandInfo(row: any) {
    this.openMenu();  
    let bandInfo = [];
    if (row.key === OPERATORS.WYVERN) {
      const key = `${row.key}_${row.numberOfBands}`;
      bandInfo = SENSOR_BAND_DATA[key] || [];
    } else if ((row.key === OPERATORS.ESPER) || row.key === OPERATORS.PIXXEL || row.sensorBands) bandInfo = row.sensorBands;
    else bandInfo = SENSOR_BAND_DATA[row.key] || [];
    this.bandInfoTooltip = bandInfo;
    this.selectedOperator = row.key;
  }
  openMenu() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      overlayContainer.classList.add('custom-menu-overlay');
    }
  }
  onMenuClosed(): void {    
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      overlayContainer.classList.remove('custom-menu-overlay');
    }
  }

  validateDates(startDate: Date, endDate: Date): boolean {
    const currentDate = new Date(); // Get current date
    // Minimum Start Date: 3 days after current date
    const minStartDate = new Date(currentDate);
    minStartDate.setDate(minStartDate.getDate() + 3);
  
    // Maximum End Date: 14 days after current date
    const maxEndDate = new Date(currentDate);
    maxEndDate.setDate(maxEndDate.getDate() + 14);
  
    return new Date(startDate) >= minStartDate && new Date(endDate) <= maxEndDate;
  }
  
  
  selectBandOption(band: any, indx: number, row: any) {
    if (band) {
      this.AVAILABLESENSORS[indx].numberOfBands = band.no_of_bands;
      if(band.tooltip) this.AVAILABLESENSORS[indx].sensorTooltip = band.tooltip;

      if (row.key === OPERATORS.ESPER) {
        this.bandPriceUpdate(row,indx,row.numberOfBands);
        this.AVAILABLESENSORS[indx].checked = false;
        this.selectedSensors = [];
        this.AVAILABLESENSORS.forEach((operator) => {
          if (operator.checked) this.selectedSensors.push(operator);
        });
      }
    }
  }

  bandPriceUpdate(row,i,band) {
    let priceArray = row?.pricing;
    let bands = band;

    if (priceArray) {
      for (const latencyItem of row.latency) {
        const key = latencyItem.key;                
        latencyItem.cost = priceArray[key][bands];
        latencyItem.unitcost = priceArray[key][bands];
        this.AVAILABLESENSORS[i].latency = row.latency;
        const selectedIndex = this.AVAILABLESENSORS[i].latency.findIndex(
          (item) => item.selected === true
        );
        this.taskingOption(row.latency[selectedIndex].name, i, row, 1);
    }            
  }
  }

  checkFeasible() {
    return this.AVAILABLESENSORS.some(item => item.checked && !item.feasibility);
  }

  private clearSelectedRowsForTaskTierChange(): void {
    const hadSelectedSensor = (this.AVAILABLESENSORS || []).some(
      (sensor: any) => sensor?.checked || sensor?.sensorSelected
    );

    (this.AVAILABLESENSORS || []).forEach((sensor: any) => {
      sensor.checked = false;
      sensor.sensorSelected = false;
      sensor.prevent = false;
      sensor.selectedTaskingTier = false;
      sensor.isUserSelection = false;
      sensor.tnqSensorDisabled = true;

      if (this.target?.taskStrategy !== 'Tip-and-Cue') {
        sensor.selectedTnqSensorType = '';
      }
    });

    this.selectedSensors = [];
    this.selectedTippingSensors = [];
    this.selectedCueingSensors = [];
    this.tipAndQSelectedRows = [];
    this.tipAndQSelected = false;
    this.feasible = false;
    this.warnReactionTimeVsToiForSelectedSensors();

    if (hadSelectedSensor) {
      this.popupService.openPopup(
        WarningPopup,
        'Please reselect the same or different sensor.',
        '',
        '50%'
      );
    }
  }


  onDropdownChange(event: any) {
    this.taskTierPref = event.value;
    this.clearSelectedRowsForTaskTierChange();
    this.initializeData(true);
  }

  isCueingTabDisabled(): boolean {
    if (this.target?.taskStrategy !== 'Tip-and-Cue') return false;
    return !(Array.isArray(this.selectedTippingSensors) && this.selectedTippingSensors.length > 0);
  }

  shouldHideRow(row: any): boolean {
    if (this.target.taskStrategy === 'Tip-and-Cue') {
      return row?.tabIndex !== this.selectedTabIndex;
    } else
    return false;
  }

  private clearTipAndCueSelectedRowsForType(tabIndex: number, sensorTypeValue: string): void {
    if (this.target?.taskStrategy !== 'Tip-and-Cue') return;
    if (!sensorTypeValue) return;

    // Uncheck matching rows in the table source
    if (Array.isArray(this.AVAILABLESENSORS)) {
      this.AVAILABLESENSORS.forEach((row: any) => {
        if (row?.tabIndex === tabIndex && row?.sensortype === sensorTypeValue) {
          row.checked = false;
        }
      });
    }

    // Remove matching rows from selected arrays
    if (tabIndex === 0 && Array.isArray(this.selectedTippingSensors)) {
      this.selectedTippingSensors = this.selectedTippingSensors.filter(
        (row: any) => row?.sensortype !== sensorTypeValue
      );
    }
    if (tabIndex === 1 && Array.isArray(this.selectedCueingSensors)) {
      this.selectedCueingSensors = this.selectedCueingSensors.filter(
        (row: any) => row?.sensortype !== sensorTypeValue
      );
    }

    this.selectedSensors = [
      ...(Array.isArray(this.selectedTippingSensors) ? this.selectedTippingSensors : []),
      ...(Array.isArray(this.selectedCueingSensors) ? this.selectedCueingSensors : []),
    ];
  }

  private clearTipAndCueTabSelections(tabIndex: number): void {
    if (this.target?.taskStrategy !== 'Tip-and-Cue') return;

    if (tabIndex === 0) {
      this.selectedTippingSensors = [];
      this.tippingSensorTypes = [];
    }
    if (tabIndex === 1) {
      this.selectedCueingSensors = [];
      this.cueingSensorTypes = [];
    }

    if (Array.isArray(this.AVAILABLESENSORS)) {
      this.AVAILABLESENSORS.forEach((row: any) => {
        if (row?.tabIndex === tabIndex) {
          row.checked = false;
        }
      });
    }

    this.selectedSensors = [
      ...(Array.isArray(this.selectedTippingSensors) ? this.selectedTippingSensors : []),
      ...(Array.isArray(this.selectedCueingSensors) ? this.selectedCueingSensors : []),
    ];
  }

  handleSensorSelectionChange(sensor: any) {
    if (this.target.taskStrategy != 'Tip-and-Cue') return;

    const selectedArray = this.selectedTabIndex === 0 ? this.tippingSensorTypes : this.cueingSensorTypes;
    if (sensor.selected) {
      if (!selectedArray.includes(sensor.value)) {
        selectedArray.push(sensor.value);
      }
    } else {
      const index = selectedArray.indexOf(sensor.value);
      if (index !== -1) {
        selectedArray.splice(index, 1);
      }

      // If a type is unchecked, clear any selected rows of that type.
      this.clearTipAndCueSelectedRowsForType(this.selectedTabIndex, sensor.value);

      // Tip-and-Cue dependency: cueing is only valid if a tipping sensor row is selected.
      if (this.selectedTabIndex === 0) {
        const hasTippingRowSelected =
          Array.isArray(this.selectedTippingSensors) &&
          this.selectedTippingSensors.length > 0;

        if (!hasTippingRowSelected) {
          this.clearTipAndCueTabSelections(1);
        }

        if (!Array.isArray(this.tippingSensorTypes) || this.tippingSensorTypes.length === 0) {
          this.clearTipAndCueTabSelections(0);
          this.clearTipAndCueTabSelections(1);
        }
      }
    }
  }
  getResolutionLabel(value: string): string {
    if (!value) return '';
    const match = value.match(/:(\S+)/); // get text after ":" up to next whitespace
    return match ? match[1] : value;
  }

  async loadTaskingSensors(taskDetails) {
    this.taskingSensors = await this.getSensors('all', taskDetails);
    this.loadTaskingSensorDetails(this.taskingSensors, 'all');
  }

  async loadTipAndCueingSensors(taskDetails) {
    this.tipAndCueSensorTypesLoading = true;
    try {
    this.selectedTabIndex = 0;
    this.tippingSensors = [];
    this.cueingSensors = [];
    this.SensorsTypes = [];
      if (this.tabGroup) {
    this.tabGroup.selectedIndex = 0;
      }
    this.AVAILABLESENSORS = [];
    this.selectedSensors = [];
    this.tippingSensorTypes = [];
    this.cueingSensorTypes = [];
    this.selectedTippingSensors = [];
    this.selectedCueingSensors = [];

    this.tippingSensors = await this.getSensors('Tipping', taskDetails);  
    this.cueingSensors = await this.getSensors('Cueing', taskDetails);
    this.loadTaskingSensorDetails(this.tippingSensors, 'Tipping');
    this.loadTaskingSensorDetails(this.cueingSensors, 'Cueing');

      // Populate sensor types for the first tab (even if empty)
      this.onTabChange({ index: 0 });
    } finally {
      this.tipAndCueSensorTypesLoading = false;
    }
  }

  async getSensors(type: string, target: any): Promise<any> {
    this.target = target;
    let userSubs = this.userDetails?.subscriptionType || 'standard';
    let useCaseId: any;

    if (target.taskStrategy !== "Help Select Sensor(s)") {
      useCaseId = null
    }
    else
      useCaseId = target.useCase?._id
    this.collectionTime = false;
    this.multiPointsCoveredArea = 0;
    this.getSensorObj = {
      rule: target?.rule,
      feeds: target?.feeds?._id,
      usecaseId: useCaseId,
      isOpenWater: this.target?.openWater,
      tnqSensorType: type,
      observation: target?.observation?._id,
      tnqCloudCover: target?.cloudCover,
      area: target?.area,
      frequency: target?.selectedOption,
      repeatFrequency: target?.freqOption,
      subDailyCount: target?.subDailyCount,
      openWindow : moment(target.openWindow)
            .utcOffset(0, true)
            .format(),
      closeWindow: moment(target.closeWindow)
            .utcOffset(0, true)
            .format(),
      aoiCountry: target?.country,
      countryCode: target?.countryCode,
      geoJSON: target?.geoJSON,
      polygon: target?.polygon,
      multiTarget: target?.multiTarget,
      taskStrategy: target?.taskStrategy,
      overOpenWater: target?.overOpenWater,
    };
    let intent = target?.intent?._id ? target?.intent._id : target?.intent;

    return await this.userService.getSensors(userSubs, this.currentUser?.id, intent, this.getSensorObj).toPromise();
  }

  onTabChange(event: any) {
    if (event?.index === 1 && this.isCueingTabDisabled()) {
      this.selectedTabIndex = 0;
      if (this.tabGroup) {
        this.tabGroup.selectedIndex = 0;
      }
      return;
    }

    this.selectedTabIndex = event.index;

    let currentSensorTypes: any[] = [];
    let filteredSensorTypes: any[] = [];

    if (this.selectedTabIndex === 0 && this.tippingSensors?.[0]?.operators?.length > 0) {
      currentSensorTypes = Array.from(new Set(this.tippingSensors[0].operators.map(item => item.sensortype)));
      filteredSensorTypes = this.apiService.SENSORSTYPE.filter(sensor => currentSensorTypes.includes(sensor.value));
      if (this.currentUser.allocated) {
        filteredSensorTypes = filteredSensorTypes.filter(sensor => sensor.name !== 'AIS');
      }

      // Restore previous selection
      filteredSensorTypes.forEach(sensor => {
        sensor.selected = this.tippingSensorTypes.includes(sensor.value);
        sensor.tnqType = 'Tipping';
      });   
    }
    else if (this.selectedTabIndex === 1 && this.cueingSensors?.[0]?.operators?.length > 0) {
      currentSensorTypes = Array.from(new Set(this.cueingSensors[0].operators.map(item => item.sensortype)));
      filteredSensorTypes = this.apiService.SENSORSTYPE.filter(sensor => currentSensorTypes.includes(sensor.value));
      if (this.currentUser.allocated) {
        filteredSensorTypes = filteredSensorTypes.filter(sensor => sensor.name !== 'AIS');
      }

      // Restore previous selection
      filteredSensorTypes.forEach(sensor => {
        sensor.selected = this.cueingSensorTypes.includes(sensor.value);
        sensor.tnqType = 'Cueing';
      });
    }
    

    // Deep copy so selections are isolated between tabs
    this.SensorsTypes = JSON.parse(JSON.stringify(filteredSensorTypes || []));
    this.dataSource = new MatTableDataSource(this.AVAILABLESENSORS);
        this.dataSource.sort = this.sort;   
  }

  loadTaskingSensorDetails(target, type) {    
    let result = target;
    this.rfSignals = false;
    if (result) {
      if (this.target?.multiTarget?.length > 2) {
        this.multiPointsCoveredArea = this.utilsService.calculateArea(this.target.multiTarget);
      }

      if (result[0].operators) {
        let allocatedSensorTypes ;
        this.SENSORS = result[0].operators;

        if (this.target?.taskStrategy != 'Tip-and-Cue') {
          allocatedSensorTypes  = Array.from(new Set(result[0].operators.map(item => item.sensortype)));
          // this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor => allocatedSensorTypes .includes(sensor.value));
          this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor => allocatedSensorTypes.includes(sensor.value)).map(sensor => ({ ...sensor }));
          if (this.currentUser.allocated) {
            this.SensorsTypes = this.SensorsTypes.filter(sensor => sensor.name !== 'AIS');
          }

        } else if (this.target?.taskStrategy === 'Tip-and-Cue') {
          // Combine both operators
          const cueingOps = (this.cueingSensors?.[0]?.operators || []).map(op => ({
            ...op,
            tipAndCueSensorType: 'Cueing',
            tabIndex: 1
          }));
          
          const tippingOps = (this.tippingSensors?.[0]?.operators || []).map(op => ({
            ...op,
            tipAndCueSensorType: 'Tipping',
            tabIndex: 0
          }));

          this.SENSORS = [...cueingOps, ...tippingOps];
        }
      }      

      this.noOfMonths = 1;
      let startdate = moment(this.target?.openWindow)
        .utcOffset(0, true)
        .format();
      let enddate = moment(this.target?.closeWindow)
        .utcOffset(0, true)
        .format();
      let time_difference =
        new Date(enddate).getTime() - new Date(startdate).getTime();
      let days_difference = Math.ceil(
        time_difference / (1000 * 60 * 60 * 24)
      );
      this.noOfMonths = Math.round(days_difference / 30);
      this.noOfWeeks = Math.round(days_difference / 7);

      this.childEvent.emit();
      this.resetData.emit();

      this.chkTaskInput(this.target);
      let selectedIndx = -1;
      if (this.SENSORS && this.target.taskStrategy === 'Tip-and-Cue') {
        this.isTipAndCue = true;
        this.isTipAndCueRule =
          this.target.tipAndCueBasedOn === 'Rules' &&
            this.target.rule === 'rule-1'
            ? true
            : false;

          this.selectedSensorTypes = '';
          this.isTipAndCueRule = false;
      }

      this.SensorsTypes.forEach((type, index) => {
        if (this.selectedSensorTypes) {
          if (this.selectedSensorTypes.includes(type.value)) {
            selectedIndx = index;
            this.SensorsTypes[index].selected = true;
          }
        } else {
          this.SensorsTypes[index].selected = false;
        }
      });
      this.dataSource = undefined;
      this.FILTEREDSENSORS = [];
      if (this.SENSORS) {
        this.SENSORS.forEach((sensor) => {
          if ((sensor.key === OPERATORS.STE || sensor.key === OPERATORS.STE_TELEOS) && sensor.sensor === 'SAR' && this.target.area > 0) {
            const order = {
              "PSTRIP": ["L1", "L3"],
              "PSPOT": ["L1", "L3"]
            };

            let reversedMode = sensor.collection_mode.sort((a, b) => {
              if (a.captureMode !== b.captureMode) {
                // Prioritize "Strip" over "Spot"
                return a.captureMode === "Strip" ? -1 : 1;
              }
              let normalizedMode = (mode: string) => {
                if (mode.includes("SPOT")) return "PSPOT";
                if (mode.includes("STRIP")) return "PSTRIP";
                return mode;
              };
              const modeA = normalizedMode(a.mode);
              const modeB = normalizedMode(b.mode);

              if (modeA !== modeB) {
                return modeA.localeCompare(modeB);
              }
              return order[modeA].indexOf(a.productLevel) - order[modeB].indexOf(b.productLevel);
            });
          } else if (sensor.key === OPERATORS.CAPELLA && this.target.area > 0 && sensor.collection_mode[0].captureMode === 'Strip') {
            sensor.collection_mode.reverse();
          }
          this.FILTEREDSENSORS.push(sensor);
        });
      }      

      this.dataSource = undefined;
      this.AVAILABLESENSORS = [];
      this.selectedSensors = [];
      if (selectedIndx > -1)
        this.updateAllComplete(
          this.SensorsTypes[selectedIndx],
          selectedIndx,
          1
        );
      else if(selectedIndx == -1 && this.isAllSensors){
        this.toggleAll();
      }
      else if (selectedIndx == -1 && this.isDailySubdaily){
        this.toggleDailySubdaily();
      }
      else if (selectedIndx == -1 && this.isOpportunitySensors){
        this.toggleOpportunitySensors();
      }
      else if (selectedIndx == -1 && this.isObfuscatedSensors){
        this.toggleObfuscatedSensors();
      }
      else if(this.isNightSensor){
        this.toggleNightSensors();
      }
      // if (this.FILTEREDSENSORS.length > 0) this.initializeData();
    }
  }

  checkForTOIRestriction() {
    let startDate = moment(this.target.openWindow).utcOffset(0, true).format();

    // Get current UTC time
    let currentUtc = moment.utc();

    // Parse startDate as a moment UTC object
    let start = moment.utc(startDate);

    // Get exact difference in days (including decimals)
    let diffInDays = start.diff(currentUtc, 'days', true); // true returns fractional days

    if (diffInDays > 10) return false;
    else return true;
  }

  getRestrictionMessage() {
    let toiRestriction = this.checkForTOIRestriction();

    if (this.target?.overOpenWater && this.target.country === 'South China Sea') {
      if (toiRestriction) return `As this task's area of interest (AOI) is the South China Sea, the time of interest (TOI) must be greater than 10 
      days from submission for additional licensing by the chosen operator. Once the authorities grant the license, the system will approve the task.`
      else return ` As the area of interest (AOI) is the South China Sea, a license is required from the chosen operator.
      Once the authorities grant the license, the system will approve the task.` 
    } else if (!this.target.overOpenWater) {
      if (toiRestriction) return `As this task's area of interest (AOI) is outside the country of registration, the time of 
      interest (TOI) must be greater than 10 days from submission for additional licensing by the chosen operator. 
      Once the authorities grant the license, the system will approve the task.`
      else return `The area of interest (AOI) is outside the registered country and is subject to additional 
      licensing by the chosen operator. Once the authorities grant the license, the system will approve the task.`
    }

    else return '';
  }

  checkSupportedTarget(sensor) {
  if (sensor.aoi && sensor.poi) return this.aoiAndPoi;
  else if (sensor.aoi) return this.aoiOnly;
  else if (sensor.poi) return this.poiOnly;
  else if (sensor.multi_poi) return "Multi-POI";
  else return null;
}

  OpenSatTracking(sensor) {
    const startDate = moment.utc(this.target.openWindow).toDate();
    const currentDate = new Date();
    const timeDifference = (startDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60);

    if (timeDifference > 72) {
      const message = `The start time of interest (TOI) is more than three days from the
       current time. Please change the start time to within the next 72 hours.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
    } else {
      this.dialog.open(PreviescreenComponent, {
        width: '50%',
        data: {
          sensor: {
            ...sensor,
            operatorKey: sensor?.operatorKey || sensor?.key,
          }, type: 'satelliteTracking', action: 'projectedData',
          target: this.target, user: this.currentUser
        },
        backdropClass: 'blurred',
        disableClose: true,
      });
    }
  }
  
  hasFeature(featureKey: string): boolean {
    return this.currentUser?.planDetails?.features?.some(feature => 
      feature.key.toLowerCase() === featureKey.toLowerCase()
    ) || false;
  }

  getFeedsData(row) {
    this.openMenu();
    this.feedInfoTooltip = row;
  }

  isBandIconPresent(row: any): boolean {
    let marginvalue = row.sensortype === 'HSI' || row?.key === OPERATORS.STE_TELEOS;
    if (marginvalue) {
      this.marginValueExist = true;
    }
    if (this.marginValueExist && (row.sensortype === 'HSI' || row?.key === OPERATORS.STE_TELEOS))
      return true;
    else if (!!document.querySelector('.bandIcon'))
      return false;
    else
      return true;
  }

  isOpenWaterArea() {
    if(this.isCueing)
      return this.target?.openWaterCue;
    else
      return this.target?.openWater;
  }
  getArea(row: any = '', checkedInterest:string ='') {
    if((this.isCueing || row.tabIndex === 1)  && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation)) {
      let locationType = '';
      if (checkedInterest == 'POI')
        locationType = 'Point';
      else if(checkedInterest == 'AOI')
        locationType = 'Polygon';
      if(this.target.observationTypeCue != locationType || CAPELLA_MODES[row?.selectedModes[0]?.mode_type] !== checkedInterest){
        return this.target.derivedArea;
      } else {
        return this.target?.areaCue;
      }
      return this.target?.areaCue;
    } else {
      return this.target?.area;
    }
  }
  async getCueingTarget(row, minimumArea,status:any = false) {
    this.target.derivedArea = '';
    this.derivedMinArea = minimumArea;
    let supportedTarget = 'Both';
    if (row.supportedTarget == this.poiOnly)
      supportedTarget = 'Point'
    else if(row.supportedTarget == this.aoiOnly)
      supportedTarget = 'Polygon'
    let observationInterest = this.target.observationTypeCue == "Point" ? 'POI' : 'AOI';
    let modeSelected = row?.selectedModes[0];
    if (status === 'mode') {
      modeSelected = row?.modeResetValue;
    }
    if((this.target.observationTypeCue != supportedTarget && supportedTarget !== 'Both' && row?.key !== OPERATORS.CAPELLA) ||
       (row?.key === OPERATORS.CAPELLA && CAPELLA_MODES[modeSelected?.mode_type] !== observationInterest)
    ) {
      let obj = { target: geoParse(this.target.geoJSONCue), targetType: this.target.observationTypeCue , minArea: minimumArea };
      try {
        const res = await firstValueFrom(this.apiService.getCueingSensorTarget(obj)) as any;
        this.target.derivedCordinate = res?.geoJSONValue;
        if (res.geoJSONValue.type == 'Polygon') {
          let numberPoints: [number, number][] = res?.geoJSONValue.coordinates[0];
          const first = numberPoints[0];
          const last = numberPoints[numberPoints.length - 1];

          if (first[0] === last[0] && first[1] === last[1]) {
            numberPoints = numberPoints.slice(0, -1);
          }
          let derivedArea = this.utilsService.calculateAreaUsingTurf(numberPoints);
          this.target.derivedArea = (derivedArea/ 1e6).toFixed(2);
          this.target.derviedGeoJSON = this.utilsService.getGeoJsonData(res?.geoJSONValue.coordinates[0]);
          if( row?.key === OPERATORS.CAPELLA && modeSelected?.mode_type === this.stripHundred && this.target.observationTypeCue === 'Point') {
            let derivedDefaultArea = this.target.derivedArea
            this.target.derivedArea = row.minimumAreaSize ?? derivedDefaultArea;
          }
        } else {
          this.target.derivedArea = 0;
          this.target.derviedGeoJSON = this.utilsService.getGeoJsonData(res?.geoJSONValue.coordinates);
        }
      } catch (err) {
        console.error('Error:', err);
      }
    }
  }

  getGeoJson() {
    if(this.isCueing && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation))
      return this.target.geoJSONCue;
    else
      return this.target.geoJSON;
  }

  getOverOpenWater() {
    if(this.isCueing && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation))
      return this.target.overOpenWaterCue;
    else
      return this.target.overOpenWater;
  }

  getCountry() {
    if(this.isCueing && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation))
      return this.target.countryCue;
    else
      return this.target.country;
  }

  private isUmbraScanSarSensor(sensor?: any): boolean {
    if (!sensor) {
      return false;
    }

    if (sensor?.key === OPERATORS.UMBRA && isUmbraScanMode(sensor)) {
      return true;
    }

    if (sensor?.operatorKey === OPERATORS.UMBRA) {
      return isUmbraScanMode({ key: sensor?.operatorKey }, sensor?.collectionMode);
    }

    return false;
  }

  getAreaInSubmit(sensor) {
    if(((sensor?.tabIndex && sensor?.tabIndex === 1) || this.isCueing) && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation)) {
      return this.cueingArea;
    } else if (isUmbraScanMode(sensor)) {
      return this.target?.scanArea ?? 0;
    } else {
      return this.target.area;
    }
  }

  getCalculatedArea(sensor) {
    if(this.target?.area > 0 && sensor?.tabIndex === 0){
     // A sensor with no minimum area — AIS, weather — leaves minimumAreaSize
     // undefined, and `1300.54 > undefined` is FALSE, so this used to return
     // undefined. JSON.stringify then dropped `areacalc` from the sensor
     // payload entirely and the /task page area column rendered blank.
     // Spire and ClydeSpace never showed it because they build their sensor
     // object in their own branches, with `areacalc: this.target.area`.
     const minimumArea = Number(sensor?.minimumAreaSize);
     if (!Number.isFinite(minimumArea)) {
       return this.target.area;
     }
     return this.target.area > minimumArea
      ? this.target.area
      : minimumArea;
    }
    if(((sensor?.tabIndex && sensor?.tabIndex === 1) || this.isCueing) && (this.target.observation?.name == this.vesselLocation || this.target.observation?.name == this.rfLocation)) {
      return this.derivedAreaCalc;
    } else {
      return this.target.area;
    }
  }

  getMinimumArea(row) {
    if ((row.unit.includes('scene') || row.unit === 'week' || row.unit === 'day') && row.key != OPERATORS.BLACKSKY) {
      if (row.tooltipValue) {
        return this.extractAndCalculateValues(row.tooltipValue);
      } else if (row.minimumArea) {
        return this.extractAndCalculateValues(row.minimumArea);
      }
    } else {
      return row.minarea;
    }
  }

  taskingTierChange(selectedValue: string, row: any, index: number) {
    if (row?.key === OPERATORS.AT21) {
      const blockedTierSelection = this.AVAILABLESENSORS[index]?.blockedAt21TierSelection;

      if (blockedTierSelection) {
        this.AVAILABLESENSORS[index].selectedTaskingTierPrefrence =
          this.AVAILABLESENSORS[index].selectedLatency;
        this.AVAILABLESENSORS[index].blockedAt21TierSelection = null;
        return;
      }

      this.AVAILABLESENSORS[index].blockedAt21TierSelection = null;
    }

    let selectedArea = Number(this.getArea(row));
    if (row?.key === OPERATORS.WYVERN) {
      if (((selectedValue === 'standard' && selectedArea < 100) || (selectedValue === 'priority' && selectedArea < 50)) && this.target?.area > 0) {
      let defaultArea = selectedValue === 'standard' ? 100 : 50;
      const areaMessage =  `The area of interest (AOI) requested is smaller than the ${defaultArea} sqkm set by the operator for the selected ${selectedValue}. Please increase the task size to more than ${defaultArea} sqkm or choose an alternative provider.`;
      const areaDialogRef = this.popupService.openPopup(WarningPopup, areaMessage, '', '50%');
      areaDialogRef.afterClosed().subscribe(() => {
        this.uncheckSensorInTipAndCue(index);
        this.AVAILABLESENSORS[index].prevent = true;
        this.clickHandler();
        });
        return;
      } else if (this.target?.area === 0) {
        if (selectedValue === 'standard') {
          this.AVAILABLESENSORS[index].minimumAreaSize = 100;
        } else if (selectedValue === 'priority') {
          this.AVAILABLESENSORS[index].minimumAreaSize = 50;
        }
        this.unsetAndResetSelectedSensors(this.AVAILABLESENSORS[index]);
      }
    }
  }

  private getAt21ToiDurationHours(): number {
    const startTime = moment(this.target.openWindow).utcOffset(0, true);
    const endTime = moment(this.target.closeWindow).utcOffset(0, true);
    return endTime.diff(startTime, 'hours', true);
  }

  private getResolvedAt21LatencyOption(row: any, latencyOption: any): any {
    const tierName = latencyOption?.name;
    const tierKey = latencyOption?.key;

    if (!Array.isArray(row?.latency)) {
      return latencyOption;
    }

    return (
      row.latency.find((item: any) => item?.name === tierName || item?.key === tierKey) ||
      latencyOption
    );
  }

  private getAt21TierWarningMessage(row: any, latencyOption: any): string | null {
    const resolvedLatencyOption = this.getResolvedAt21LatencyOption(row, latencyOption);
    const tierName = String(
      resolvedLatencyOption?.name || resolvedLatencyOption?.key || ''
    )
      .trim()
      .toLowerCase();
    const toiDurationHours = this.getAt21ToiDurationHours();

    if (tierName === 'rush' && toiDurationHours > 24) {
      return 'The Rush task uses the passes on the first day. No subsequent attempts are made.';
    }

    if (tierName === 'priority' && toiDurationHours < 14 * 24) {
      return 'The priority tasking tier requires a minimum collection window of 14 days. Any lesser time may be accepted for partial collection.';
    }

    if (tierName === 'standard' && toiDurationHours < 30 * 24) {
      return 'The standard tasking tier requires a minimum collection window of 30 days. Any lesser time may be accepted for partial collection. If you need a full collection, please cancel and either select the priority tasking tier or increase the time of interest (TOI) to 30 days.';
    }

    return null;
  }

  private isAt21FrequencySelectionBlocked(row: any): boolean {
    return (
      row?.key === OPERATORS.AT21 &&
      (this.target.selectedOption === 1 ||
        this.target.selectedOption === 0 ||
        this.target.selectedOption === 3)
    );
  }

  private async shouldProceedWithAt21TierWarning(
    row: any,
    latencyOption: any
  ): Promise<boolean> {
    if (this.isAt21FrequencySelectionBlocked(row)) {
      return true;
    }

    const message = this.getAt21TierWarningMessage(row, latencyOption);

    if (!message) {
      return true;
    }

    const dialogRef = this.popupService.openPopup(
      WarningPopup,
      message,
      'warning',
      '50%',
      'Ok',
      true,
      'Cancel'
    );
    const result = await firstValueFrom(dialogRef.afterClosed());

    return result !== false && result !== 'cancel';
  }

  unsetAndResetSelectedSensors(row, index = false) {
    this.selectedSensors = [];
    this.AVAILABLESENSORS.forEach((operator, idx) => {
      if (operator.checked) {
        this.selectedSensors.push(operator);
      }
    });  
  }

  private getLicenseOptionsFromResponse(result: any): any[] {
    const licenses = result?.success && Array.isArray(result?.data) && result.data.length > 0
      ? result.data[0]?.licenses
      : [];

    if (!Array.isArray(licenses)) {
      return [];
    }

    return licenses.map((lic: any) => ({
      value: lic.licenseType,
      key: `${lic.value ?? ''}`,
    }));
  }

  getSensorLicense(sensorId: any) {
  return this.apiService.getSensorLicense(sensorId);
}

  openBROPopup(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: {
          message: 'BRO-AOI',
        }
      });

      dialogRef.afterClosed().subscribe((result) => {
        resolve(result === 'yes');
      });
    });
  }

  getDateDifferenceInDays(start: string | Date, end: string | Date): number {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = endDate.getTime() - startDate.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
  }

  calculateBroPrice(days: number, unit: number, resolutionKey?: number): number {
    const year = this.getYearFromDays(days);

    const match = this.broUnitCost.find(
      (item: any) => item.year === year && item.unit === unit
    );

    if (!match) return 0;

    // if resolutionKey not passed → default to rf_1_cost
    if (resolutionKey === 2) {
      return Number(match.rf_2_cost);
    }

    return Number(match.rf_1_cost);
  }

  getYearFromDays(days: number): number {
    if (days <= 730) return 1;
    if (days <= 1095) return 2;
    if (days <= 1460) return 3;
    return 4;
  }

  checkAcquisition(): boolean {
    const data = this.broUnitCost;

    const result = data.find((item: any) => item.unit == this.target.subDailyCount);

    return !!result;
  }

  checkTipCue(): boolean {
    return this.target?.taskStrategy === 'Tip-and-Cue';
  }
}

